export default {
  // 酒店知识库独立语言块，保留原有语言内容。
  hotelKnowledge: {
    "title": "ฐานความรู้ของโรงแรม",
    "tip": "จัดการคำถามและคำตอบของโรงแรมปัจจุบัน",
    "created": "เวลาที่สร้าง",
    "updated": "เวลาที่อัปเดต",
    "to": "ถึง",
    "startDate": "วันที่เริ่มต้น",
    "endDate": "วันที่สิ้นสุด",
    "question": "คำถาม",
    "answer": "คำตอบ",
    "tags": "แท็ก",
    "questionSearch": "ค้นหาคำถามด้วยคำสำคัญ",
    "tagSearch": "ค้นหาแท็กด้วยคำสำคัญ",
    "search": "ค้นหา",
    "reset": "รีเซ็ต",
    "create": "เพิ่ม",
    "batchDelete": "ลบรายการที่เลือก",
    "loadFailed": "โหลดไม่สำเร็จ โปรดลองอีกครั้ง",
    "notFilled": "ยังไม่ได้กรอก",
    "actions": "การดำเนินการ",
    "view": "ดูข้อความทั้งหมด",
    "edit": "แก้ไข",
    "delete": "ลบ",
    "details": "รายละเอียดความรู้",
    "missingTitle": "ข้อมูลเดิมไม่ครบถ้วน",
    "missingView": "รายการนี้ยังไม่ได้กรอกคำถามหรือคำตอบ กรุณากรอกให้ครบก่อนบันทึก",
    "missingForm": "ยังไม่ได้กรอกคำถามหรือคำตอบ กรุณากรอกให้ครบก่อนบันทึก",
    "noDetails": "ไม่มีรายละเอียด",
    "close": "ปิด",
    "enterQuestion": "กรุณากรอกคำถาม",
    "enterAnswer": "กรุณากรอกคำตอบ",
    "answerPlaceholder": "กรุณากรอกคำตอบ รองรับข้อความหลายบรรทัด",
    "tagPlaceholder": "ป้อนแท็กแล้วกด Enter เพื่อเพิ่ม",
    "tagTip": "กด Enter เพื่อเพิ่มแท็ก เครื่องหมายจุลภาคและช่องว่างจะไม่แยกแท็ก ความยาวรวมของแท็กต้องไม่เกิน 512 อักขระ",
    "cancel": "ยกเลิก",
    "save": "บันทึก",
    "chooseHotel": "กรุณาเลือกโรงแรมก่อน",
    "empty": "ไม่มีข้อมูล",
    "editTitle": "แก้ไขความรู้",
    "createTitle": "เพิ่มความรู้",
    "tagRequired": "กรุณาเพิ่มแท็กอย่างน้อยหนึ่งรายการ",
    "tagText": "แท็กต้องเป็นข้อความ กรุณาลบแล้วเพิ่มใหม่",
    "tagBlank": "แท็กต้องไม่เป็นข้อความว่าง กรุณาลบแล้วเพิ่มใหม่",
    "tagsTooLong": "แท็กยาวเกินไป กรุณาย่อแล้วลองอีกครั้ง",
    "questionTooLong": "คำถามต้องไม่เกิน 512 อักขระ",
    "answerTooLong": "คำตอบต้องไม่เกิน 5000 อักขระ",
    "invalidRecord": "ข้อมูลรายการไม่ถูกต้อง กรุณาเปิดแก้ไขใหม่อีกครั้ง",
    "editSuccess": "แก้ไขสำเร็จ",
    "createSuccess": "เพิ่มสำเร็จ",
    "deleteLimit": "ลบได้ครั้งละไม่เกิน 100 รายการ",
    "confirmBatch": "ยืนยันการลบ {count} รายการที่เลือกในหน้านี้หรือไม่ เมื่อลบแล้วจะไม่สามารถกู้คืนได้",
    "confirmOne": "ยืนยันการลบรายการนี้หรือไม่ เมื่อลบแล้วจะไม่สามารถกู้คืนได้",
    "deleteConfirm": "ยืนยันการลบ",
    "confirmDelete": "ยืนยันการลบ",
    "deleteSuccess": "ลบสำเร็จ",
    "dataChanged": "ข้อมูลมีการเปลี่ยนแปลง กรุณารีเฟรชรายการแล้วลองอีกครั้ง"
  },
  // 本次 AI 用量同步独立追加，保留原有语言块。
  aiUsageSync: {
    "beta": "Beta",
    "title": "สถิติการใช้งาน AI",
    "priceConfig": "การตั้งราคารูปแบบห้องพัก",
    "dateRange": "ช่วงวันที่",
    "startDate": "วันที่เริ่มต้น",
    "endDate": "วันที่สิ้นสุด",
    "scene": "ประเภทการแจ้งเตือน",
    "all": "ทั้งหมด",
    "callStatus": "สถานะการเรียกใช้งาน",
    "callStatusLabel": "ข้อมูลสถานะการเรียกใช้งาน",
    "running": "กำลังดำเนินการ",
    "success": "สำเร็จ",
    "failed": "ล้มเหลว",
    "tokenStatus": "ข้อมูลการใช้งาน",
    "tokenStatusLabel": "ข้อมูลเกี่ยวกับการใช้งาน",
    "known": "มีข้อมูล",
    "unknownUsage": "ไม่มีข้อมูล",
    "query": "ค้นหา",
    "reset": "รีเซ็ต",
    "categoryError": "โหลดประเภทการแจ้งเตือนไม่สำเร็จ",
    "retry": "โหลดใหม่",
    "chooseHotel": "โปรดเลือกโรงแรมก่อน",
    "dailyUsage": "การใช้งาน AI รายวัน",
    "noCallsFiltered": "ไม่พบการเรียกใช้งานตามตัวกรองที่เลือก",
    "statisticsError": "โหลดสถิติการใช้งานไม่สำเร็จ",
    "loadingTrend": "กำลังโหลดแนวโน้ม…",
    "details": "รายละเอียดการเรียกใช้งาน",
    "detailsError": "โหลดรายละเอียดการเรียกใช้งานไม่สำเร็จ",
    "loading": "กำลังโหลด…",
    "noCalls": "ไม่มีประวัติการเรียกใช้งาน",
    "waiting": "รอการค้นหา",
    "callTime": "เวลาเรียกใช้งาน",
    "usage": "การใช้งาน AI",
    "requestInfo": "ข้อมูลคำขอ",
    "requestId": "ID คำขอ: ",
    "requestDetails": "รายละเอียดคำขอ",
    "totalUsage": "การใช้งาน AI ทั้งหมด",
    "callCount": "จำนวนการเรียกใช้งาน",
    "successCount": "จำนวนการเรียกใช้งานที่สำเร็จ",
    "unknownCount": "จำนวนการเรียกใช้งานที่ไม่ทราบปริมาณ",
    "today": "วันนี้",
    "last7": "7 วันที่ผ่านมา",
    "last30": "30 วันที่ผ่านมา",
    "thisMonth": "เดือนนี้",
    "pending": "รอสถิติ",
    "unknown": "ไม่ทราบ",
    "usageLabel": "การใช้งาน: ",
    "callCountLabel": "การเรียกใช้งาน: ",
    "unknownCountLabel": "การเรียกใช้งานที่ไม่ทราบปริมาณ: ",
    "missingUsage": "บางรายการไม่มีข้อมูลการใช้งาน",
    "usageAxis": "การใช้งาน",
    "description": "สถิติครอบคลุมการเรียกใช้งาน AI ของโรงแรมปัจจุบัน ไม่รวมแชตที่ไม่เชื่อมโยงกับโรงแรม วันที่ใช้เวลาปักกิ่ง",
    "callStatusHelp": "กำลังดำเนินการ สำเร็จ และล้มเหลวหมายถึงสถานะการเรียกแพลตฟอร์ม สถานะสำเร็จไม่ได้หมายความว่าสร้างการแจ้งเตือนแล้ว",
    "usageHelp": "มีข้อมูล: ทราบปริมาณการใช้งาน รวมถึงศูนย์ ไม่มีข้อมูล: มีการเรียกใช้งานแต่ไม่ทราบปริมาณ จึงไม่นับรวม ไม่ขึ้นกับสถานะสำเร็จหรือล้มเหลว",
    "invalidDates": "โปรดเลือกช่วงวันที่ที่ถูกต้อง วันเริ่มต้นต้องไม่เกินวันสิ้นสุด และทั้งสองวันต้องไม่เกินวันนี้ตามเวลาปักกิ่ง"
  },
  navbar: {
    searchHotel: 'ค้นหาชื่อโรงแรม',
    nightAudit: 'ตรวจสอบกลางคืน',
    nightAuditWarning: 'โรงแรมกำลังทำการตรวจสอบกลางคืน กรุณาลองใหม่ภายหลัง',
    groupBooking: 'การจองแบบกลุ่ม',
  },
  common: {
    logo: 'Logo',
    bundleSale: 'ขายแบบแพ็กเกจ',
    splitTax: 'แยกภาษี',
    taxIncluded: 'รวมภาษี',
    taxExcluded: 'ไม่รวมภาษี',
    businessFeeUnit: 'หน่วยค่าธรรมเนียม',
    fixedAmount: 'จำนวนเงินคงที่',
    percentage: 'เปอร์เซ็นต์',
    pleaseEnter: 'กรุณากรอก',
    confirmCheckInOutTime: 'คุณได้จองห้องพักโดยเช็คอินวันที่ {checkIn} และเช็คเอาท์วันที่ {checkOut} กรุณายืนยันวันเข้าพักและวันออก',
    tax: 'ภาษี',
    expenseWithTax: 'ค่าใช้จ่าย (รวมภาษี)',
    totalProductPrice: 'ราคารวมสินค้า',
    expenseWithoutTax: 'ค่าใช้จ่าย (ไม่รวมภาษี)',
    roomFeeWithoutTax: 'ค่าห้องพัก (ไม่รวมภาษี)',
    salesAmountWithoutTax: 'ยอดขาย (ไม่รวมภาษี)',
    taxIncludedPrice: 'ราคารวมภาษี',
    title: 'ระบบจัดการโรงแรม EaseHUB',
    billingCycleType: 'ประเภทรอบการชำระเงิน',
    weeklySettlement: 'ชำระรายสัปดาห์',
    monthlySettlement: 'ชำระรายเดือน',
    accountReceivablePayment: 'ชำระบัญชีลูกหนี้ (AR)',
    noResults: 'ไม่พบข้อมูลโรงแรมที่เกี่ยวข้อง',
    shiftHandover: 'การส่งมอบกะ',
    salesClerk: 'พนักงานขาย',
    currentShift: 'กะปัจจุบัน',
    requestFailed: 'คำขอล้มเหลว',
    confirmModify: 'ยืนยันการแก้ไข',
    operationSuccess: 'ดำเนินการสำเร็จ!',
    individualBooking: 'การจองลูกค้าทั่วไป',
    longBooking: 'การจองระยะยาว',
    cashPay: 'ชำระเงินสด',
    cashPayment: 'บัญชีชำระเงินสด',
    doorCard: 'บัตรประตู',
    more: 'เพิ่มเติม',
    success: 'สำเร็จ',
    close: 'ปิด',
    loadingEllipsis: 'กำลังโหลด...',
    cancel: 'ยกเลิก',
    printReport: 'พิมพ์รายงาน',
    printTime: 'เวลาพิมพ์',
    businessDay: 'วันทำการ',
    operationDate: 'วันที่ดำเนินการ',
    subject: 'หมวดหมู่',
    amount: 'จำนวนเงิน',
    save: 'บันทึก',
    yuan: '',
    confirm: 'ยืนยัน',
    nextStep: 'ถัดไป',
    all: 'ทั้งหมด',
    immediateQuery: 'ค้นหาทันที',
    action: 'การดำเนินการ',
    pleaseSelect: 'กรุณาเลือก',
    pleaseInput: 'กรุณากรอก',
    inputYuan: 'กรุณากรอก',
    yes: 'ใช่',
    no: 'ไม่ใช่',
    remark: 'หมายเหตุ',
    delete: 'ลบ',
    oneHour: 'หนึ่งชั่วโมง',
    twoHours: 'สองชั่วโมง',
    threeHours: 'สามชั่วโมง',
    fourHours: 'สี่ชั่วโมง',
    fiveHours: 'ห้าชั่วโมง',
    sixHours: 'หกชั่วโมง',
    sevenHours: 'เจ็ดชั่วโมง',
    eightHours: 'แปดชั่วโมง',
    saveSuccess: 'บันทึกสำเร็จ',
    notice: 'แจ้งเตือน',
    status: 'สถานะ',
    cancelled: 'ยกเลิกแล้ว',
    booked: 'จองแล้ว',
    hardLoading: 'กำลังโหลดอย่างหนัก',
    startDate: 'วันที่เริ่มต้น',
    endDate: 'วันที่สิ้นสุด',
    Deadline: 'วันครบกำหนด',
    name2: 'ชื่อ',
    roomNumber: 'หมายเลขห้อง',
    checkInDate3: 'วันที่เข้าพัก',
    checkOutDate3: 'วันที่ออก',
    unitPrice3: 'ราคาต่อหน่วย',
    quantity: 'จำนวน',
    addBook: 'เพิ่มชุดบัญชี',
    bookName: 'ชื่อชุดบัญชี',
    accountOfConsumption: 'หมวดค่าใช้จ่าย',
    details3: 'รายละเอียด',
    id: 'รหัส',
    commodityDetail: 'รายละเอียดสินค้า',
    externalDocumentNumber: 'เลขที่เอกสารภายนอก',
    accountOfPayment2: 'หมวดการชำระเงิน',
    strikeABalance: 'ปรับยอด',
    pleaseFillInRemarks2: 'กรุณากรอกหมายเหตุ',
    search: 'ค้นหา',
    nationality: 'สัญชาติ',
    sex: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    nation: 'เชื้อชาติ',
    contactInformation2: 'ข้อมูลติดต่อ',
    dateOfBirth: 'วันเกิด',
    documentType: 'ประเภทเอกสาร',
    address2: 'ที่อยู่',
    documentNumber: 'หมายเลขเอกสาร',
    validityOfVisa: 'อายุวีซ่า',
    visaType: 'ประเภทวีซ่า',
    visaNumber: 'หมายเลขวีซ่า',
    pleaseEnterYourIdNumber: 'กรุณากรอกหมายเลขเอกสาร',
    pleaseEnterTheCorrectIdNumber4: 'กรุณากรอกหมายเลขเอกสารถูกต้อง',
    pleaseFillInYourName2: 'กรุณากรอกชื่อ',
    pleaseSelectDocumentType: 'กรุณาเลือกประเภทเอกสาร',
    dontWorryAboutGoldMembers2: 'สมาชิกทองของ Qingzhu',
    goEasyOnThePlatinumMembers2: 'สมาชิกแพลทินัมของ Qingzhu',
    lightOnDiamondMembers2: 'สมาชิกเพชรของ Qingzhu',
    unregisteredMember: 'ยังไม่ได้ลงทะเบียนสมาชิก',
    ok2: 'ตกลง',
    issuingAuthority: 'หน่วยงานผู้ออกเอกสาร',
    idPhoto: 'รูปบัตรประชาชน',
    qingzhuGroup: 'กลุ่มบริษัท Qingzhu',
    mobilePhoneNumber: 'เบอร์โทรศัพท์',
    view: 'ดู',
    activated: 'เปิดใช้งานแล้ว',
    nonmember: 'ไม่ใช่สมาชิก',
    coupon: 'คูปอง',
    ranking5: 'อันดับ',
    hotelName4: 'ชื่อโรงแรม',
    isNotSet: 'ยังไม่ได้ตั้งค่า',
    yu: 'คงเหลือ',
    noVacancy: 'ห้องเต็ม',
    consumption: 'การบริโภค',
    refund: 'คืนเงิน',
    iGotIt2: 'รับทราบแล้ว',
    startANightTrial: 'เริ่มการตรวจสอบกลางคืน',
    operator: 'ผู้ปฏิบัติการ',
    handledBy: 'ดำเนินการโดย',
    to: 'ถึง',
    currentBusinessDay: 'วันทำการปัจจุบัน',
    ok: 'ยืนยัน',
    morningShift2: 'กะเช้า',
    middleShift2: 'กะกลางวัน',
    nightShift2: 'กะกลางคืน',
    pleaseEnterYourName: 'กรุณากรอกชื่อ',
    selectAll: 'เลือกทั้งหมด',
    pleaseEnterContent: 'กรุณากรอกเนื้อหา',
    serialNumber: 'ลำดับ',
    address: 'ที่อยู่',
    signatureOfAuthorizer: 'ลายเซ็นผู้อนุมัติ',
    signature3: 'ลายเซ็น',
    roomType: 'ประเภมห้อง',
    dayRate: 'ราคาห้องต่อวัน',
    checkInTime: 'เวลาเข้าพัก',
    checkOutTime: 'เวลาออก',
    settlementAmount: 'ยอดชำระ',
    hotelAddress: 'ที่อยู่โรงแรม',
    selectDate: 'เลือกวันที่',
    selectionTime: 'เลือกเวลา',
    cancelCard: 'ยกเลิกบัตร',
    thisCardIsEmptyPleaseMakeABusinessCardFirst: 'บัตรนี้ว่าง กรุณาทำบัตรก่อน',
    logoutSuccessful: 'ยกเลิกสำเร็จ',
    cardCancellationFailure: 'ยกเลิกบัตรล้มเหลว',
    contactSupport: 'กรุณาติดต่อฝ่ายเทคนิคเพื่อตรวจสอบบริการฮาร์ดแวร์',
    submit: 'ส่ง',
    contactPerson6: 'ผู้ติดต่อ',
    contactNumber2: 'เบอร์โทรติดต่อ',
    merchant3: 'ร้านค้า',
    Submitsuccessfully: 'ส่งสำเร็จ',
    smallProgram: 'มินิโปรแกรม',
    technicalSupport: 'ฝ่ายเทคนิค',
    roomBillCheck: 'ตรวจสอบบิลค่าห้อง',
    financialAssistant: 'ผู้ช่วยการเงิน',
    settlementCycle: 'รอบการชำระเงิน',
    refundSuccessful: 'คืนเงินสำเร็จ',
    beingRefunded: 'กำลังคืนเงิน',
    refundFailure: 'การคืนเงินล้มเหลว',
    channel: 'ช่องทาง',
    cloakroom: 'ปิดห้อง',
    infiniteQuantity: 'ไม่จำกัดจำนวน',
    compute: 'คำนวณ',
    dateOfSale: 'วันที่ขาย',
    originalPrice: 'ราคาตั้งต้น',
    pleaseEnterTheOriginalPrice: 'กรุณากรอกราคาตั้งต้น',
    member: 'สมาชิก',
    salesAmount: 'ยอดขาย',
    amountOfConsumption: 'ยอดการบริโภค',
    protocolUnit: 'หน่วยงานตามสัญญา',
    subjectDesc: 'คำอธิบายหมวดหมู่',
    qzOrderNo: 'หมายเลขคำสั่งซื้อ Qingzhu',
    checkInType: 'ประเภทการเข้าพัก',
    checkInOutDate: 'วันเข้าพัก/ออก',
    channelOrderNo: 'เลขที่ออเดอร์ช่องทาง',
    pleaseEnterTheCorrectPhoneNumber3: 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
    logs: 'บันทึก',
    walkIn: 'ลูกค้า Walk-in',
    businessCardPrintingSuccess: 'ทำบัตรสำเร็จ',
    exportSuccessfully2: 'ส่งออกสำเร็จ',
    exportFailure: 'การส่งออกล้มเหลว',
    other: 'อื่นๆ',
    toBeProcessed: 'รอดำเนินการ',
    completed: 'เสร็จสิ้น',
    commonProduct: 'สินค้าทั่วไป',
    freeRoomProducts: 'สินค้าห้องฟรี',
    makeACard: 'ทำบัตร',
    day: 'วัน',
    points2: 'คะแนน',
    sunday: 'อาทิตย์',
    monday: 'จันทร์',
    tuesday: 'อังคาร',
    wednesday: 'พุธ',
    thursday: 'พฤหัสบดี',
    friday: 'ศุกร์',
    saturday: 'เสาร์',
    lose: 'ล้มเหลว',
    since: 'ตั้งแต่',
    amountTotal: 'รวม',
    total: 'ยอดรวม',
    tradeName: 'ชื่อสินค้า',
    itemType: 'ประเภทสินค้า',
    orderStatus: 'สถานะคำสั่งซื้อ',
    orderNumber: 'หมายเลขคำสั่งซื้อ',
    anonymousUser: 'ผู้ใช้ไม่ระบุชื่อ',
    commentTime: 'เวลาความคิดเห็น',
    merchantReply: 'การตอบกลับของร้านค้า',
    recoveryTime: 'เวลาตอบกลับ',
    recover: 'ตอบกลับ',
    pleaseWriteAResponseOfAtLeast10Words: 'กรุณาตอบกลับอย่างน้อย 10 ตัวอักษร',
    replyTextMinimum10Words: 'ข้อความตอบกลับต้องไม่น้อยกว่า 10 ตัวอักษร',
    negativeComment: 'รีวิวเชิงลบ',
    cancel2: 'ยกเลิก',
    commentTemplateManagement: 'การจัดการแม่แบบความคิดเห็น',
    modifiedSuccessfully: 'แก้ไขสำเร็จ',
    hygiene: 'ความสะอาด',
    service: 'การบริการ',
    facility: 'สิ่งอำนวยความสะดวก',
    position: 'ตำแหน่งที่ตั้ง',
    appeal: 'การอุทธรณ์',
    successfullyDeleted: 'ลบสำเร็จ',
    replySuccessfully2: 'ตอบกลับสำเร็จ',
    theMobilePhoneNumberFormatIsIncorrect5: 'รูปแบบเบอร์มือถือไม่ถูกต้อง',
    none4: 'ไม่มี',
    thisFunctionHasNotBeenOpenedIfYouNeedToOpenPleaseClickOpen:
      'ยังไม่เปิดใช้งาน ฟังก์ชันนี้ หากต้องการเปิด กรุณาคลิกเปิดใช้งาน',
    noCommentsYet: 'ยังไม่มีความคิดเห็น',
    picture: 'รูปภาพ',
    guestName: 'ชื่อลูกค้า',
    handle: 'จัดการ',
    edit: 'แก้ไข',
    type: 'ประเภท',
    salesman: 'พนักงานขาย',
    successfulOperation: 'ดำเนินการสำเร็จ',
    pleaseEnterTheCompanyName2: 'กรุณากรอกชื่อบริษัท',
    customerType: 'ประเภทลูกค้า',
    effective: 'มีผล',
    inVain: 'ไม่มีผล',
    valid: 'มีผล',
    forbidden: 'ถูกห้ามใช้',
    enable: 'เปิดใช้งาน',
    companyName2: 'ชื่อบริษัท',
    favorable2: 'ส่วนลด',
    day2: 'วัน',
    telephone: 'โทรศัพท์',
    pleaseEnterThePhoneNumber: 'กรุณากรอกหมายเลขโทรศัพท์',
    mailbox: 'อีเมล',
    accountName: 'ชื่อบัญชี',
    startTime: 'เวลาเริ่มต้น',
    endTime: 'เวลาสิ้นสุด',
    beingSubmitted: 'กำลังส่ง',
    pleaseSelectGender: 'กรุณาเลือกเพศ',
    confirmDeletion: 'ยืนยันการลบ',
    letMeThinkItOver: 'ขอฉันคิดดูก่อน',
    theSizeOfTheUploadedPictureCannotExceed: 'ขนาดรูปที่อัปโหลดต้องไม่เกิน',
    identificationCard2: 'บัตรประจำตัวประชาชน',
    editor: 'แก้ไข',
    topLine: 'ออนไลน์',
    downline: 'ออฟไลน์',
    validity: 'ระยะเวลาที่มีผล',
    fullDayRoom: 'ห้องพักรายวัน',
    hourlyRoom: 'ห้องพักรายชั่วโมง',
    append3: 'เพิ่ม',
    immediatelyReduce3: 'ลดทันที',
    activityName2: 'ชื่อกิจกรรม',
    sort: 'หมวดหมู่',
    on: 'เปิด',
    amountOfGift2: 'จำนวนเงินที่ให้',
    pleaseFillIn2: 'กรุณากรอก',
    pleaseSelectADate: 'กรุณาเลือกวันที่',
    roomFeeConsumption: 'ค่าใช้จ่ายค่าห้อง',
    selectFile: 'เลือกไฟล์',
    uploadFailure: 'อัปโหลดล้มเหลว',
    uploadSuccessfully: 'อัปโหลดสำเร็จ',
    print: 'พิมพ์',
    dateRange: 'ช่วงวันที่',
    reupload: 'อัปโหลดใหม่',
    printBill: 'พิมพ์บิล',
    cardNumber: 'หมายเลขบัตร',
    paymentMethod: 'วิธีชำระเงิน',
    payMethod: 'รูปแบบการชำระ',
    balance: 'ยอดคงเหลือ',
    membershipCardNumber: 'หมายเลขบัตรสมาชิก',
    birthday: 'วันเกิด',
    tradingHours: 'เวลาในการทำรายการ',
    enterAMaximumOf50Characters: 'กรอกได้สูงสุด 50 ตัวอักษร',
    membersMobileNumber: 'เบอร์สมาชิก',
    time: 'เวลา',
    modifyInformation: 'แก้ไขข้อมูล',
    lengthOfStay: 'จำนวนคืนที่พัก',
    roomListNumber: 'หมายเลขใบแจ้งห้อง',
    roomTypeName: 'ชื่อประเภมห้องพัก',
    settleAccounts: 'ชำระบัญชี',
    accountNumber: 'บัญชีเข้า',
    paymentRecord: 'บันทึกการชำระเงิน',
    paymentAmount: 'จำนวนเงินชำระ',
    paymentVerificationCode: 'รหัสยืนยันการชำระเงิน',
    enterInAnAccount: 'บันทึกบัญชี',
    pleaseSelectACollectionSet: 'กรุณาเลือกชุดบัญชีลูกหนี้',
    pleaseSelectTheAccountNumber: 'กรุณาเลือกบัญชีเข้า',
    pleaseSelectAPaymentMethod: 'กรุณาเลือกวิธีชำระเงิน',
    vipSignature: 'ลายเซ็น VIP',
    amountNotWrittenOff3: 'ยอดที่ยังไม่หักล้าง',
    availableCredit3: 'วงเงินที่ใช้ได้',
    maximumAmount4: 'วงเงินสูงสุด',
    whetherItIsValidOrNot: 'ใช้ได้หรือไม่',
    enabledSuccessfully: 'เปิดใช้งานสำเร็จ',
    disableSuccessfully: 'ปิดใช้งานสำเร็จ',
    roomNumberName: 'หมายเลขห้อง - ชื่อ',
    payment2: 'การชำระเงิน',
    operatingTime: 'เวลาทำรายการ',
    classes: 'กะงาน',
    transfer: 'โอน',
    accountOutstanding2: 'ยังไม่ได้ปิดบัญชี',
    accountClosed: 'ปิดบัญชีแล้ว',
    rolledOut: 'โอนออกแล้ว',
    haveStruckOff: 'หักล้างแล้ว',
    noRoomChargeIsGenerated: 'ไม่สร้างค่าห้อง',
    date3: 'วันที่',
    itemName4: 'ชื่อรายการ',
    pleaseEnterRemarks2: 'กรุณากรอกหมายเหตุ',
    entryAndDepartureTime: 'เวลาเข้าพักและออก',
    roomRate: 'ราคาห้องพัก',
    preAuthorizationAmount: 'จำนวนเงินที่กันวงเงินไว้',
    room: 'ห้อง',
    settlement: 'การชำระบัญชี',
    pleaseSelectMemberInformation: 'กรุณาเลือกข้อมูลสมาชิก',
    pleaseFillInThePaymentVerificationCode: 'กรุณากรอกรหัสยืนยันการชำระเงิน',
    accountNumber3: 'หมายเลขบัญชี',
    successfulEntry: 'บันทึกบัญชีสำเร็จ',
    externalOrderNumber: 'เลขออเดอร์ภายนอก',
    transferTo: 'โอนไปยัง',
    beAuthorized: 'มอบอำนาจแล้ว',
    haveAlreadySettled: 'ชำระเรียบร้อยแล้ว',
    authorizationMode: 'รูปแบบการมอบอำนาจ',
    authorizedAmount: 'จำนวนเงินที่มอบอำนาจ',
    authorizationTime: 'เวลามอบอำนาจ',
    productType: 'ประเภทสินค้า',
    pleaseEnterTheChannelNumber: 'กรุณากรอกเลขออเดอร์ช่องทาง',
    derive: 'ส่งออก',
    unwritten: 'ยังไม่หักล้าง',
    cancelled3: 'หักล้างแล้ว',
    lehuiScanTheCode: 'Lehui - สแกนโค้ด',
    amountOnAccount3: 'จำนวนเงินที่ค้างบัญชี',
    billingTime5: 'เวลาค้างบัญชี',
    nameOfGuest3: 'ชื่อผู้เข้าพัก',
    roomNumber3: 'หมายเลขห้อง',
    people: 'คน',
    nameOfExpenseItem: 'ชื่อค่าใช้จ่าย',
    viewDetails: 'ดูรายละเอียด',
    bankOfDeposit: 'ธนาคารที่เปิดบัญชี',
    bankCardNumber4: 'หมายเลขบัตรธนาคาร',
    toBeConfirmed2: 'รอยืนยัน',
    rejected: 'ถูกปฏิเสธ',
    adjustmentAmount: 'จำนวนเงินปรับปรุง',
    meituan: 'Meituan',
    totalOrderAmount: 'ยอดรวมคำสั่งซื้อ',
    lightSettlementWithMerchants: 'การชำระบัญชีกับร้านค้าของ Qingzhu',
    membershipDistribution: 'การแบ่งส่วนสมาชิก',
    crossStoreRebate: 'ส่วนลดข้ามร้าน',
    avoidCommissionSubsidies: 'เงินสนับสนุนค่าคอมมิชชั่นของ Qingzhu',
    membershipIncentiveSettlement: 'การชำระบัญชีแรงจูงใจสมาชิก',
    theUnitedStatesGroupDirectlyConnected: 'Meituan Direct Connect',
    flyingPigsConnectDirectly: 'Fliggy Direct Connect',
    fullNameOfTheBank4: 'ชื่อเต็มของธนาคาร',
    accountBankAbbreviation4: 'ชื่อย่อธนาคาร',
    theLocationOfTheBank4: 'ที่ตั้งธนาคาร',
    pleaseEnterYourFullBankName2: 'กรุณากรอกชื่อเต็มของธนาคาร',
    pleaseSelectBankAbbreviation2: 'กรุณาเลือกชื่อย่อธนาคาร',
    pleaseSelectYourBankLocation2: 'กรุณาเลือกที่ตั้งธนาคาร',
    pleaseEnterYourBankCardNumber2: 'กรุณากรอกหมายเลขบัตรธนาคาร',
    modificationTime2: 'เวลาแก้ไข',
    bankExample: 'ตัวอย่าง: สาขา XX ของธนาคารอุตสาหกรรมและพาณิชย์แห่งประเทศจีน',
    companyNameNote: 'หมายเหตุ: หากเป็นบัญชีนิติบุคคลให้กรอกชื่อบริษัท',
    causeOfFailure: 'สาเหตุที่ล้มเหลว',
    pleaseEnterYourPhoneNumber: 'กรุณากรอกหมายเลขโทรศัพท์',
    downloadStatement: 'ดาวน์โหลดใบกระทบยอด',
    operationLog: 'บันทึกการทำงาน',
    ctripDirectConnection: 'Ctrip Direct Connect',
    directConnectionInTheSameDirection: 'Tongcheng Direct Connect',
    flyingPig: 'Fliggy',
    ctrip: 'Ctrip',
    roomNight: 'คืนห้องพัก',
    pictureUpload: 'อัปโหลดรูปภาพ',
    aSinglePictureMustNotBeLargerThan: 'รูปภาพหนึ่งไฟล์ต้องไม่เกิน',
    checkInRoomType2: 'ประเภมห้องที่เข้าพัก',
    checkInPerson: 'ผู้เข้าพัก',
    hotelSellingPrice: 'ราคาขายของโรงแรม',
    effectiveDate3: 'วันที่มีผล',
    viewExamples: 'ดูตัวอย่าง',
    underReview: 'กำลังตรวจสอบ',
    billingType: 'ประเภทใบแจ้งหนี้',
    invoiceTitle2: 'หัวใบแจ้งหนี้',
    pleaseEnterTheInvoiceTitle2: 'กรุณากรอกหัวใบแจ้งหนี้',
    invoiceHasBeenIssued: 'ออกใบแจ้งหนี้แล้ว',
    haveBeenCancelled: 'ยกเลิกแล้ว',
    paymentStatus: 'สถานะการชำระเงิน',
    preferentialPrice: 'ราคาพิเศษ',
    gateRate: 'ราคาเต็มหน้าร้าน',
    availableRoom: 'ห้องว่าง',
    orderableNumber: 'จำนวนที่สามารถจองได้',
    numberOfRoomsReserved: 'จำนวนห้องที่จอง',
    breakfast: 'อาหารเช้า',
    copyOf: 'ชุด',
    dailyRate: 'ราคาห้องรายวัน',
    typeOfTouristSource3: 'ประเภทแหล่งลูกค้า',
    namephoneNumbermembershipNumber: 'ชื่อ/เบอร์โทร/หมายเลขสมาชิก',
    selectTimePoint5: 'เลือกจุดเวลา',
    externalChannel3: 'ช่องทางภายนอก',
    retentionTime3: 'เวลาเก็บการจอง',
    contactName2: 'ชื่อผู้ติดต่อ',
    numberOfDays: 'จำนวนวัน',
    pleaseSelectAProtocolUnit3: 'กรุณาเลือกหน่วยงานตามสัญญา',
    pleaseEnterTheNameOfTheExternalChannel2: 'กรุณากรอกชื่อช่องทางภายนอก',
    pleaseFillInTheMembershipInformation3: 'กรุณากรอกข้อมูลสมาชิก',
    pleaseFillInTheReservationName2: 'กรุณากรอกชื่อผู้จอง',
    pleaseFillInTheReservationNumber2: 'กรุณากรอกเบอร์โทรของผู้จอง',
    theAmountCanOnlyBeEnteredInNumbers2: 'จำนวนเงินกรอกได้เฉพาะตัวเลข',
    noMemberInformationFound: 'ไม่พบบข้อมูลสมาชิกที่เกี่ยวข้อง',
    noProtocolUnitIsQueried2: 'ไม่พบข้อมูลหน่วยงานตามสัญญา',
    bulkRepricing: 'ปรับราคาจำนวนมาก',
    totalRoomRate6: 'ราคารวมของห้อง',
    trialCalculationOfHousePrice3: 'คำนวณราคาห้องทดลอง',
    free: 'ฟรี',
    between: 'ห้อง',
    upgradeRoomType: 'อัปเกรดประเภมห้อง',
    printOrNot: 'พิมพ์หรือไม่',
    predepartureTime2: 'เวลาออกล่วงหน้า',
    rooms: 'จำนวนห้อง',
    averageHousePrice: 'ราคาห้องเฉลี่ย',
    arrivalTime: 'เวลาเข้าพักที่คาดหวัง',
    creationTime: 'เวลาสร้าง',
    advancedSearch: 'การค้นหาขั้นสูง',
    simpleSearch: 'ค้นหาแบบง่าย',
    price: 'ราคา',
    orderTaking: 'รับออเดอร์',
    sellingPrice: 'ราคาขาย',
    floorPrice: 'ราคาต่ำสุด',
    channelName2: 'ชื่อช่องทาง',
    bookingSuccessful2: 'จองสำเร็จ',
    checkedIn2: 'เข้าพักแล้ว',
    cancelSuccessfully2: 'ยกเลิกสำเร็จ',
    sorting: 'การจัดเรียง',
    invoiceNumber2: 'หมายเลขใบแจ้งหนี้',
    taxIdentificationNumber: 'เลขประจำตัวผู้เสียภาษี',
    emailAddress: 'อีเมล',
    eTicket: 'ใบแจ้งหนี้อิเล็กทรอนิกส์แบบพิเศษ',
    eTicket2: 'ใบแจ้งหนี้อิเล็กทรอนิกส์แบบธรรมดา',
    paperTicket: 'ใบแจ้งหนี้กระดาษแบบพิเศษ',
    paperTicket2: 'ใบแจ้งหนี้กระดาษแบบธรรมดา',
    void: 'ทำให้เป็นโมฆะ',
    teamType: 'ประเภททีม',
    teamName: 'ชื่อทีม',
    markUpAmount: 'จำนวนเงินเพิ่ม',
    productName: 'ชื่อสินค้า',
    lengthOfStay2: 'ระยะเวลาพัก',
    hours: 'ชั่วโมง',
    checkIn: 'เช็คอิน',
    changeRooms: 'เปลี่ยนห้อง',
    rowHouse: 'จัดเรียงห้อง',
    printCheckInSlip: 'พิมพ์ใบเช็คอิน',
    proceedWith: 'ดำเนินการต่อ',
    rowHouseSuccess2: 'จัดเรียงห้องสำเร็จ',
    toCheckIn: 'รอเช็คอิน',
    checkedOut: 'เช็คเอาต์แล้ว',
    onAccount: 'พักหนี้ในบัญชีแล้ว',
    basicInformation: 'ข้อมูลพื้นฐาน',
    prepayment: 'ชำระล่วงหน้า',
    originalHouseType: 'ประเภมห้องเดิม',
    seeMore: 'ดูเพิ่มเติม',
    thisRoomSupportsSmartDoorLocks: 'ห้องนี้รองรับประตูอัจฉริยะ',
    listingStatus: 'สถานะใบห้อง',
    checkin: 'เข้าพัก',
    preionization2: 'ออกล่วงหน้า',
    weekTitle: 'สัปดาห์',
    thePriceActuallyPaidByTheGuest: 'ราคาที่ลูกค้าจ่ายจริง',
    late3: 'คืน',
    late4: 'วัน',
    nonCancellable2: 'ไม่สามารถยกเลิกได้',
    one: 'หนึ่ง',
    two: 'สอง',
    three: 'สาม',
    four: 'สี่',
    five: 'ห้า',
    six: 'หก',
    lightweightDistribution: 'การกระจายสินค้าของ Qingzhu',
    liveAndTravelLightly: 'ธุรกิจท่องเที่ยวของ Qingzhu',
    jingdongDirectLink: 'JD Direct Connect',
    baiduMapDirectConnection: 'Baidu Maps Direct Connect',
    tiktokDirectConnection: 'Douyin Direct Connect',
    ctripSingleStore: 'Ctrip Single Store',
    agoda: 'Agoda',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    booking: 'Booking',
    expedia: 'Expedia',
    preCancelable: 'สามารถยกเลิกก่อนเข้าได้',
    partialWriteOff: 'หักล้างบางส่วน',
    tookEffect: 'มีผลแล้ว',
    loseEffectiveness: 'หมดผล',
    joinAHouse3: 'เข้าร่วมใบห้องเชื่อม',
    bookingInformation: 'ข้อมูลการจอง',
    pleaseSelectARoom3: 'กรุณาเลือกห้อง',
    houseInformation: 'ข้อมูลใบห้องเชื่อม',
    thereIsNoRowHouse: 'ยังไม่ได้จัดเรียงห้อง',
    reasonsForChangingRooms3: 'เหตุผลในการเปลี่ยนห้อง',
    numberOfRooms7: 'จำนวนห้องทั้งหมด',
    typeOfOperation3: 'ประเภทการดำเนินการ',
    exchangeAndUpgradeReport2: 'รายงานเปลี่ยนและอัปเกรดห้อง',
    noDataAvailable2: 'ยังไม่มีข้อมูล',
    pleaseSelectABusinessDayRange2: 'กรุณาเลือกช่วงวันทำการ',
    exportReport: 'ส่งออกรายงาน',
    accountName3: 'ชื่อหมวดบัญชี',
    aMaximumOf31DaysCanBeQueried: 'ช่วงค้นหาได้สูงสุด 31 วัน',
    naturalDay2: 'วันตามปฏิทิน',
    otherConsumption3: 'ค่าใช้จ่ายอื่นๆ',
    aggregateConsumption3: 'ยอดค่าใช้จ่ายรวม',
    aggregateConsumptionTaxIncluded: 'ยอดใช้จ่ายรวม (รวมภาษี)',
    materialType: 'ประเภทวัสดุ',
    materialName: 'ชื่อวัสดุ',
    storageTypeSell: 'ขาย',
    materialCode: 'รหัสวัสดุ',
    materialUnit: 'หน่วยมาตรฐาน',
    inStorageNum: 'จำนวนเข้าคลัง',
    outStorageNum: 'จำนวนออกคลัง',
    selectTime: 'กรุณาเลือกเวลา',
    floor: 'ชั้น',
    lumpSumPayment3: 'ยอดชำระรวม',
    ifTheRateIsGreaterThanHalfDayTheRateIsLessThanFullDay:
      'มากกว่าครึ่งวันแต่ไม่ถึงเต็มวัน คิดเป็นเต็มวัน',
    businessDate: 'วันทำการ',
    calculationFormula: 'สูตรคำนวณ',
    manualRoomFeeCalculationHalfDayRoomFee05BedNightFullDayRoomFee1BedNight:
      'คำนวณค่าห้องแบบกำหนดเอง: ห้องครึ่งวัน = 0.5 คืน, ห้องเต็มวัน = 1 คืน',
    halfDayRoomFeeTheAmountChargedIsLessThanOrEqualToHalfTheRoomRate:
      'ค่าห้องครึ่งวัน: จำนวนที่เรียกเก็บ ≤ ครึ่งหนึ่งของราคาห้อง',
    fullDayRoomFeeTheAmountChargedIsGreaterThanOrEqualToTheRoomRateAndTheAmountExceedsTheRoomRateBy2TimesRecord2BedNightsAndSoOn:
      'ค่าห้องเต็มวัน: จำนวนที่เรียกเก็บ ≥ ราคาห้อง หากเกิน 2 เท่า บันทึกเป็น 2 คืน และเพิ่มตามสัดส่วน',
    rentedBedNightsExcludeFreeRoomsAndSelfUsedRoomNights:
      'จำนวนคืนที่ปล่อยเช่า: ไม่รวมคืนห้องฟรีและห้องใช้เอง',
    subtotal: 'ยอดย่อย',
    totalOccupancy3: 'จำนวนห้องทั้งหมด',
    lettingRate: 'อัตราการปล่อยเช่า',
    inResidenceDate: 'วันที่พักอยู่',
    bookingDate: 'วันที่จอง',
    exposureNumber2: 'จำนวนการแสดงผล',
    numberOfVisitors3: 'จำนวนผู้เข้าชม',
    onlineChannel3: 'ช่องทางออนไลน์',
    reasonForDeactivation: 'เหตุผลในการปิดใช้งาน',
    downTime: 'เวลาปิดใช้งาน',
    enterAMaximumOf20Characters: 'กรอกได้ไม่เกิน 20 ตัวอักษร',
    checkInInformation: 'ข้อมูลการเข้าพัก',
    numberOfRooms6: 'จำนวนห้อง',
    totalPrice: 'ราคารวม',
    paymentInformation2: 'ข้อมูลการชำระเงิน',
    pleaseSelectAProduct: 'กรุณาเลือกสินค้า',
    viewOrderDetails: 'ดูรายละเอียดคำสั่งซื้อ',
    automaticallyJumpToOrderDetails: 'ไปยังรายละเอียดคำสั่งซื้ออัตโนมัติ',
    addHoming3: 'เพิ่มผู้เข้าพักร่วม',
    getVerificationCode: 'รับรหัสยืนยัน',
    pleaseSelectTheNumberOfRoomsFirst: 'กรุณาเลือกจำนวนห้องก่อน',
    theNumberOfReservedRoomsCannotBeGreaterThanTheNumberOfAvailableRooms:
      'จำนวนห้องที่จองต้องไม่เกินจำนวนห้องที่ว่าง',
    pleaseEnterAmount: 'กรุณากรอกจำนวนเงิน',
    makeAReservation: 'ทำการจอง',
    increaseRoomType: 'เพิ่มประเภมห้อง',
    deleteRoomType: 'ลบประเภมห้อง',
    store: 'สาขา',
    meituanDirectNew: 'Meituan Direct Connect (ใหม่)',
    outOfService: 'ปิดให้บริการ',
    smokeFreeOrNot: 'เป็นห้องปลอดบุหรี่หรือไม่',
    roomOrientation: 'ทิศทางห้อง',
    windowCondition: 'สภาพหน้าต่าง',
    windowed: 'มีหน้าต่าง',
    windowless: 'ไม่มีหน้าต่าง',
    innerFenestra: 'หน้าต่างภายใน',
    roomCharacteristics: 'ลักษณะห้อง',
    airAndClean: 'อากาศดีและสะอาด',
    airViscus: 'อากาศไม่สะอาด',
    dendrojing: 'สะอาด',
    astriction: 'ไม่สะอาด',
    continuousStaySpecial: 'โปรพักต่อเนื่อง',
    orderEarlyAndReduceMore: 'จองก่อนลดมาก',
    discountValue: 'ส่วนลด',
    select: 'เลือก',
    becameInvalid: 'หมดอายุ',
    dateOfOperation: 'วันที่ดำเนินการ',
    promotionalAllocation: 'การตั้งค่าโปรโมชั่น',
    promotionManagement: 'การจัดการโปรโมชั่น',
    operationContent2: 'เนื้อหาการดำเนินการ',
    turnOnAutomaticDeferral: 'เปิดการขยายราคาตามอัตโนมัติ',
    productSetup: 'ตั้งค่าสินค้า',
    thePriceShallNotBeLessThan20YuanAndShallNotBeHigherThan99998Yuan:
      'ราคาต้องไม่ต่ำกว่า 20 และไม่สูงกว่า 99998000',
    iKnow: 'รับทราบแล้ว',
    dataSpecification: 'คำอธิบายข้อมูล',
    settings: 'ตั้งค่า',
    restrictSales: 'จำกัดการขาย',
    pleaseEnterPrice: 'กรุณากรอกราคา',
    modificationFailure: 'การแก้ไขล้มเหลว',
    deletionFailure: 'การลบล้มเหลว',
    product: 'สินค้า',
    pleaseSelectChannel: 'กรุณาเลือกช่องทาง',
    standardProduct: 'สินค้ามาตรฐาน',
    bindingSuccessful: 'ผูกสำเร็จ',
    lobby: 'โถงกลาง',
    inventoryQuantity: 'ปริมาณสต็อก',
    uploadPictures: 'อัปโหลดรูปภาพ',
    currentlyLimitedTo10Images: 'จำกัดสูงสุด 10 รูปภาพ',
    pictureSizeMustBeLargerThan: 'ขนาดรูปต้องมากกว่า',
    warn3: 'คำเตือน',
    theInputContentOfTheCurrentPageDoesNotMeetTheSpecificationsPleaseCheck:
      'ข้อมูลที่กรอกไม่เป็นไปตามข้อกำหนด กรุณาตรวจสอบ',
    layer: 'ชั้น',
    untie: 'ยกเลิกการผูก',
    cipher5: 'รหัสผ่าน',
    pleaseEnterYourAccountNumber: 'กรุณากรอกบัญชี',
    pleaseEnterPassword4: 'กรุณากรอกรหัสผ่าน',
    obtainTheSmsVerificationCode: 'รับรหัสยืนยันทาง SMS',
    disposition: 'การตั้งค่า',
    // Part 4, lines 601 to 800
    passwordType: 'ประเภทรหัสผ่าน',
    setANewPassword: 'ตั้งรหัสผ่านใหม่',
    pleaseEnterYourNewPassword: 'กรุณากรอกรหัสผ่านใหม่',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    pleaseEnterYourPasswordAgain: 'กรุณากรอกรหัสผ่านอีกครั้ง',
    electronicPriceBoard: 'ป้ายราคาอิเล็กทรอนิกส์สำหรับห้องพัก',
    operationInstruction: 'คำแนะนำการใช้งาน',
    cardholder: 'ผู้ถือบัตร',
    contact: 'ผู้ติดต่อ',
    pleaseEnterTheCardholderName: 'กรุณากรอกชื่อผู้ถือบัตร',
    cardholderNameIsRequired: 'ต้องกรอกชื่อผู้ถือบัตร',
    theCardholderNameMustBe2To5CharactersLong: 'ชื่อผู้ถือบัตรต้องมีความยาว 2 ถึง 5 ตัวอักษร',
    remarksRequired: 'ต้องกรอกหมายเหตุ',
    selectCardType: 'เลือกประเภทบัตร',
    windowType2: 'ประเภทหน้าต่าง',
    suspensionOfSale: 'หยุดขาย',
    enterMaterialName: 'กรอกชื่อวัสดุ',
    modifyTarget: 'แก้ไขเป้าหมาย',
    theRecommendedTargetValueIsEstimatedBasedOnTheChangeTrendOfTheDataInTheSamePeriodLastYearAndTheActualDataOfLastMonth:
      'ค่าที่แนะนำถูกประเมินจากแนวโน้มของข้อมูลช่วงเวลาเดียวกันของปีที่แล้วและข้อมูลจริงของเดือนที่ผ่านมา',
    dayUnit: '{day} วัน',
    checkInOperator: 'เจ้าหน้าที่เช็คอิน',
    months: [
      'ม.ค.',
      'ก.พ.',
      'มี.ค.',
      'เม.ย.',
      'พ.ค.',
      'มิ.ย.',
      'ก.ค.',
      'ส.ค.',
      'ก.ย.',
      'ต.ค.',
      'พ.ย.',
      'ธ.ค.',
    ],
    week: {
      mon: 'วันจันทร์',
      tue: 'วันอังคาร',
      wed: 'วันพุธ',
      thu: 'วันพฤหัสบดี',
      fri: 'วันศุกร์',
      sat: 'วันเสาร์',
      sun: 'วันอาทิตย์',
    },
  },
  language: {
    zh: '中文',
    en: 'EN',
    zhHk: '繁体',
    th: 'ไทย',
    id: 'Indonesian',
    es: 'Español',
    vi: 'Tiếng Việt',
  },
  activitySign: {
    eventDate: 'วันที่จัดกิจกรรม',
    alreadyRegistered: 'ลงทะเบียนแล้ว',
    signUpActivity: 'กิจกรรมที่สามารถลงทะเบียนได้',
    noRegistrationIsAvailable: 'ยังไม่มีกิจกรรมให้ลงทะเบียน',
    registeredActivity: 'กิจกรรมที่ลงทะเบียนแล้ว',
    thereAreNoRegisteredActivities: 'ยังไม่มีกิจกรรมที่ลงทะเบียนไว้',
    thereAreNoCanceledEvents: 'ยังไม่มีกิจกรรมที่ถูกยกเลิก',
    signUp: 'ลงทะเบียน',
  },
  componentsCostprint8cmprint: {
    dateOfConsumption: 'วันที่บริโภค',
  },
  componentsCostprinta4template: {
    totalConsumption: 'ยอดใช้จ่ายรวม',
    dateOfConsumption: 'วันที่บริโภค',
    feeName: 'ชื่อค่าใช้จ่าย',
  },
  componentsCounter: {
    theGoodsAreOnlyInStock: 'จำนวนสินค้าคงเหลือเพียง',
    thereIsNotEnoughStockOfThisCommodity: 'จำนวนสินค้าไม่เพียงพอ',
  },
  componentsNowpayaccounthandle: {
    modifyTheBookSuccessfully: 'แก้ไขชุดบัญชีสำเร็จ',
    bookModification: 'แก้ไขชุดบัญชี',
    pleaseEnterABookName: 'กรุณากรอกชื่อชุดบัญชี',
    pleaseSelectTheConsumerCategory: 'กรุณาเลือกหมวดหมู่ค่าใช้จ่าย',
    newAccountSuccessfully: 'เพิ่มชุดบัญชีใหม่สำเร็จ',
  },
  componentsRecorddetail: {
    memberInfo: 'ชื่อสมาชิก/หมายเลขบัตร',
  },
  componentsRushbalance: {
    successfulWriteOff: 'หักล้างสำเร็จ',
  },
  componentsShoppinggoods: {
    onlyAvailable: 'แสดงเฉพาะสินค้าที่มีในสต็อก',
    commodityCategory: 'หมวดสินค้่า',
    pleaseEnterTheProductName: 'กรุณากรอกชื่อสินค้า',
    noDataIsQueried: 'ไม่พบข้อมูล',
    name3: 'ชื่อ',
    purchaseQuantity: 'จำนวนที่ซื้อ',
    vendibility: 'สามารถขายได้',
    allGoods: 'สินค้าทั้งหมด',
  },
  componentsAddroomer: {
    addLabel: 'เพิ่มป้ายกำกับ',
    noCustomerProfile: 'ไม่มีโปรไฟล์ลูกค้าสำหรับผู้เข้าพักรายนี้',
    guestSaveFailedRetry: 'บันทึกผู้เข้าพักไม่สำเร็จ โปรดลองอีกครั้ง',
    changeOccupancy: 'แก้ไขผู้เข้าพัก',
    increaseOccupancy: 'เพิ่มผู้เข้าพัก',
    validityPeriod: 'อายุการใช้งานของเอกสาร',
    startDate: 'วันที่เริ่มต้น',
    addGuest: 'เพิ่มผู้เข้าพัก',
    atLeastOneGuest: 'ต้องมีผู้เข้าพักอย่างน้อย 1 คน',
    guest: 'ผู้เข้าพัก',
    enterGuestName: 'กรุณากรอกชื่อของ {name}',
    enterValidPhone: 'กรุณากรอกเบอร์โทรของ {name} ให้ถูกต้อง',
    selectDocumentType: 'กรุณาเลือกประเภทเอกสารของ {name}',
    enterDocumentNumber: 'กรุณากรอกหมายเลขเอกสารของ {name}',
  },
  componentsAnnouncement: {
    noticeBoard: 'ป้ายประกาศ',
  },
  componentsIdentifyMembers: {
    memberInformation: 'ข้อมูลสมาชิก',
    pleaseFillInTheGuestMobilePhoneNumberQuickIdentificationInformation:
      'กรุณากรอกเบอร์โทรลูกค้าเพื่อระบุตัวตนอย่างรวดเร็ว',
    guestsCanUpgradeToAHigherLevelMembership: 'ลูกค้าสามารถอัปเกรดเป็นระดับสมาชิกที่สูงขึ้นได้',
    l: 'ระดับ',
    unnamed: 'ยังไม่ยืนยันตัวตน',
    inRealName: 'ยืนยันตัวตนแล้ว',
    points: 'คะแนน',
    memberRightsAndInterests: 'สิทธิประโยชน์สมาชิก',
    patron: 'ลูกค้า',
    unfold: 'แสดงเพิ่มเติม',
    unactivated: 'ยังไม่เปิดใช้งาน',
    membershipSalesCopy: 'ข้อความขายสมาชิก',
    bookingDiscount: 'ส่วนลดการจองห้อง',
    costPerformance: 'ความคุ้มค่าของการซื้อบัตร',
    memberPoints: 'คะแนนสมาชิก',
    lateCheckOut: 'เช็คเอาต์ล่าช้า',
    copywritingType: 'ประเภทข้อความ',
    afterTheGuestAuthenticatesThemselvesInThelightStayHotelReservationMiniProgramTheyCanReceiveA18YuanFreeBirthdayGiftCouponOrParticipateInExclusiveOffers:
      'เมื่อแขกทำการยืนยันตัวตนในมินิโปรแกรม “QingZhu การจองโรงแรม” แล้ว จะสามารถรับคูปองวันเกิดแบบไม่จำกัดเงื่อนไข หรือเข้าร่วมกิจกรรมสิทธิพิเศษได้',
    afterTheGuestLogsInForTheFirstTimeInThelightStayHotelReservationMiniProgramTheyCanActivateTheirMembershipAndEnjoyExclusiveMemberBenefits:
      'เมื่อแขกเข้าสู่ระบบมินิโปรแกรม “Qingzhu Hotel Reservation” ครั้งแรก จะเปิดใช้งานสถานะสมาชิกและเพลิดเพลินกับสิทธิพิเศษเฉพาะสมาชิก',
    lightStayMemberLevelNonMember: 'ระดับสมาชิก Qingzhu: ไม่ใช่สมาชิก',
    lightStayMembershipLevel: 'ระดับสมาชิก Qingzhu',
  },
  componentsSellcard: {
    employeeLastWeeksCardSalesList: 'พนักงาน · อันดับการขายบัตรสัปดาห์ที่แล้ว',
    dragLeftAndRightToViewTheTable: 'เลื่อนซ้ายขวาเพื่อดูตาราง',
    hotelLastWeeksCardSalesList: 'โรงแรม · อันดับการขายบัตรสัปดาห์ที่แล้ว',
    cardSalesRanking: 'อันดับการขายบัตร',
    employee2: 'พนักงาน',
    numberOfCardsSold: 'จำนวนบัตรที่ขาย',
    amountOfCommission: 'จำนวนค่าคอมมิชชั่น',
  },
  componentsoneCardDialog: {
    waitingForTheCustomerToSwipeTheirCard: 'รอให้ลูกค้ารูดบัตร',
    processingPayment: 'การชำระเงินอยู่ระหว่างดำเนินการ',
    customerPaymentSuccessful: 'การชำระเงินของลูกค้าสำเร็จ',
    customerPaymentFailed:
      'การชำระเงินของลูกค้าล้มเหลว กรุณาเริ่มต้นกระบวนการเรียกเก็บเงินอีกครั้ง',
  },
  customerPSearch: {
    singleStoreMembershipLevel: 'ระดับสมาชิกของร้านเดี่ยว',
    enterYourNamePhoneNumberAndCardNumber: 'กรอกชื่อ เบอร์โทร หรือหมายเลขบัตรเพื่อค้นหา',
  },
  customerPTable: {
    topUp: 'เติมเงิน',
    gift: 'ของแถม',
    viewMembers2: 'ดูข้อมูลสมาชิก',
    modifyMembership2: 'แก้ไขสมาชิก',
    storedValueDeduction: 'หักใช้ยอดเงินสะสม',
    integralChange2: 'การเปลี่ยนแปลงคะแนน',
    integralQuery2: 'ค้นหาคะแนน',
    storedValueQuery2: 'ค้นหายอดเงินสะสม',
    rechargeAllAccumulatedRechargeAmounts: 'เติมเงิน: ยอดเติมเงินสะสมทั้งหมด',
    giftAllAccumulatedGiftAmounts: 'ของแถม: ยอดของแถมสะสมทั้งหมด',
    consumptionAllAccumulatedConsumptionAmounts: 'ใช้จ่าย: ยอดใช้จ่ายสะสมทั้งหมด',
    refundAllAccumulatedRefundAmounts: 'คืนเงิน: ยอดคืนเงินสะสมทั้งหมด',
    distributionSettings: 'การตั้งค่าหนักขาย',
  },
  componentsNightaudit: {
    theCurrentBusinessDayIs: 'วันทำการปัจจุบันคือ',
    startTheNightTrial: 'เริ่มดำเนินการตรวจสอบกลางคืน',
    theNightTrialIsInProgressAndCannotBeClosed: 'กำลังตรวจสอบกลางคืน ไม่สามารถปิดได้',
    immediateFeedback: 'ส่งข้อคิดเห็นทันที',
    nightAuditCompleted: 'การตรวจสอบกลางคืนเสร็จสิ้น',
    nightTrialInProgress: 'กำลังตรวจสอบกลางคืน',
    nightTrialNewsNotice2: 'แจ้งเตือนการตรวจสอบกลางคืน',
    nightAuditFailedPleaseHandleAccordingToThePromptAndPerformTheNightAuditAgainIfYouEncounterAnyProblemsPleaseContactTechnicalSupport:
      'การตรวจสอบกลางคืนล้มเหลว กรุณาดำเนินการตามคำแนะนำ และทำการตรวจสอบใหม่ หากพบปัญหา กรุณาติดต่อฝ่ายสนับสนุน',
  },
  componentsNightauditGrayEnv: {
    nightTrialNewsNotice2: 'แจ้งเตือนการตรวจสอบกลางคืน',
    procedure: 'ขั้นตอน',
    mistake: 'ข้อผิดพลาด',
    carryOut: 'ดำเนินการ',
    nightAuditFailureToEncounterProblemsCanBeInTheMorningAfter8OclockAsSoonAsPossibleToContactTechnicalSupportToHelpSolve:
      'หากการตรวจสอบกลางคืนล้มเหลว สามารถติดต่อฝ่ายสนับสนุนหลัง 8 โมงเช้าเพื่อขอความช่วยเหลือ',
    whenAnErrorOccursTheNightAuditStopsPleaseConfirmItCarefully:
      'เมื่อเกิดข้อผิดพลาด การตรวจสอบจะหยุด กรุณาตรวจสอบอย่างรอบคอบ',
  },
  componentsOpenPageLayout: {
    backToHomePage: 'กลับสู่หน้าแรก',
  },
  componentsShiftchoose: {
    pleaseSelectFlightSchedule: 'กรุณาเลือกกะ',
    hello: '，สวัสดี!',
  },
  baseBasemultipleselect: {
    thisOptionWasNotFound: 'ไม่พบตัวเลือกนี้',
  },
  printsettingHalfprint: {
    test: 'ทดสอบ',
    print: 'พิมพ์',
    trisection: 'แบ่งสามส่วน',
    printInThirds: 'พิมพ์แบบสามส่วน',
    printInHalf: 'พิมพ์แบบสองส่วน',
  },
  printsettingPrint: {
    print: 'พิมพ์',
  },
  printsettingSmallprint: {
    feeName: 'ชื่อค่าใช้จ่าย',
    totalConsumption: 'ยอดใช้จ่ายรวม',
  },
  hardwareIdcardbtn: {
    readIdentityCard: 'อ่านบัตรประชาชน',
  },
  hardwareReaddoorcard: {
    pleasePlaceYourKeyCardOnTheCardReader: 'กรุณาวางบัตรห้องบนเครื่องอ่านบัตร',
    effectiveTime: 'เวลาเริ่มมีผล',
    failureTime: 'เวลาหมดอายุ',
    readCard: 'อ่านบัตร',
    failedToObtainTheLockInformationProcedure: 'ไม่สามารถดึงข้อมูลประตูได้',
    thisCardIsNotAGuestCardPleaseReBusinessCardPrinting:
      'บัตรนี้ไม่ใช่บัตรผู้เข้าพัก กรุณาทำบัตรใหม่',
    wheatDoorLockPlugInReadCard: 'Maitian Door Lock Plugin - อ่านบัตร',
    the: 'ของ',
    wheatDoorLockPlugInCancellationCard: 'Maitian Door Lock Plugin - ยกเลิกบัตร',
    cardReadingFailure: 'อ่านบัตรล้มเหลว',
  },
  componentsFeedback: {
    selectAttachment: 'เลือกไฟล์แนบ',
    viewFeedbackLog: 'ดูประวัติการแจ้งปัญหา',
    // Part 5, lines 801 to 1000
    commitFailure: 'ส่งข้อมูลล้มเหลว',
    problemFeedback3: 'แจ้งปัญหา',
    pleaseEnterTheContactName4: 'กรุณากรอกชื่อผู้ติดต่อ',
    pleaseEnterAContactNumber3: 'กรุณากรอกหมายเลขติดต่อ',
    uploadAttachment2: 'อัปโหลดไฟล์แนบ',
    pleaseEnterADetailedDescriptionOfTheProblem2: 'กรุณากรอกรายละเอียดของปัญหา',
    theUploadedFilesCannotExceed: 'ไฟล์ที่อัปโหลดต้องไม่เกิน',
    aMaximumOfFiveFilesCanBeUploaded2: 'สามารถอัปโหลดได้สูงสุด 5 ไฟล์',
    aMaximumOfFiveFilesCanBeUploadedTheSizeOfEachFileCannotExceed20Mb:
      'รองรับอัปโหลดสูงสุด 5 ไฟล์ ไฟล์เดี่ยวไม่เกิน 20MB',
    pleaseExplainTheProblemAndEnterTheQqNumberToFacilitateContact:
      'กรุณาอธิบายปัญหาและกรอกหมายเลข QQ เพื่อสะดวกในการติดต่อ',
  },
  componentsFeedjump: {
    lightWinTreasureSmallProgram: 'มินิโปรแกรม Qing Ying Bao',
    scanCodeUsingASmallProgram: 'สแกนโค้ดเพื่อใช้มินิโปรแกรม',
    realTimeControlOfRoomStatus: 'ควบคุมสถานะห้องแบบเรียลไทม์',
    onlineOneClickPriceAdjustment: 'ปรับราคาออนไลน์ด้วยคลิกเดียว',
    memberDevelopmentTools: 'เครื่องมือพัฒนาสมาชิก',
    moreFeaturesComingOnline: 'ฟีเจอร์เพิ่มเติมกำลังออนไลน์',
    hotelOperationCarefulAssistant: 'ผู้ช่วยดูแลการดำเนินงานโรงแรม',
  },
  componentsGethelp: {
    getHelp: 'ขอความช่วยเหลือ',
  },
  componentsGoappshop: {
    applicationMarket: 'ตลาดแอปพลิเคชัน',
  },
  componentsJointrain: {
    attendTraining: 'เข้าร่วมอบรม',
  },
  componentsLeftcontent: {
    hotelOperationsManager: 'ผู้จัดการปฏิบัติการโรงแรม',
    cityOperationsManager: 'ผู้จัดการปฏิบัติการประจำเมือง',
    customerServiceHotline: 'สายด่วนบริการลูกค้า',
  },
  componentsTrain: {
    trainingCoursesAreInFullSwing: 'หลักสูตรอบรมกำลังเปิดสอนอย่างเข้มข้น',
    getDetailedTrainingNoticesAndMaterials: 'รับประกาศอบรมและเอกสารประกอบอย่างละเอียด',
    followThelightStaySystemServicePublicAccount: 'ติดตามบัญชีทางการ “Qingzhu System Service”',
    basicCourseIntroductorySeries: 'คอร์สพื้นฐาน: แนะนำภาพรวม',
    mondayAndWednesday1430Start: 'เริ่มทุกวันจันทร์และพุธ เวลา 14:30',
    advancedCourseComplexScenesCommonQuestionsRecentNewFeatures:
      'คอร์สขั้นสูง: สถานการณ์ซับซ้อน + คำถามพบบ่อย + ฟีเจอร์ใหม่',
    friday1430Start: 'เริ่มทุกวันศุกร์ เวลา 14:30',
  },
  merchantPCtxTab: {
    oldFinancialReconciliationSystem: 'ระบบกระทบยอดการเงินรุ่นเก่า',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
      'เงินสนับสนุนค่าคอมมิชชั่นของ Qingzhu ถูกย้ายไปยัง “Member Incentive” กรุณาไปยืนยันใบแจ้งหนี้ที่เมนู Member Incentive',
  },
  merchantPCtxTab1: {
    oldFinancialReconciliationSystem: 'ระบบกระทบยอดการเงินรุ่นเก่า',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
      'เงินสนับสนุนค่าคอมมิชชั่นของ Qingzhu ถูกย้ายไปยัง “Member Incentive” กรุณาไปยืนยันใบแจ้งหนี้ที่เมนู Member Incentive',
  },
  merchantPSearchqu: {
    enterHotelName: 'กรอกชื่อโรงแรม',
  },
  payIndex: {
    toBePaid: 'รอการชำระเงิน',
    pleaseScanQrCodeToCompletePayment: 'กรุณาสแกน QR เพื่อชำระเงิน',
    canBeClosedAfter: 'สามารถปิดได้หลังจาก',
    paymentSuccess: 'ชำระเงินสำเร็จ',
    automaticShutdownInSeconds: 'ปิดอัตโนมัติภายในไม่กี่วินาที',
    automaticPageRefresh: 'รีเฟรชหน้าอัตโนมัติ',
    duringThePayment: 'กำลังชำระเงิน',
    paymentAnomaly: 'การชำระเงินผิดปกติ',
    ifThePaymentIsAbnormalContactTechnicalSupport: 'หากการชำระเงินผิดปกติ กรุณาติดต่อฝ่ายเทคนิค',
    paymentFailure: 'ชำระเงินล้มเหลว',
    payOff: 'ปิดการชำระเงิน',
    waitForTheUserToScanTheCode: 'รอผู้ใช้สแกนโค้ด',
    currentStatusOfLehuiPayment: 'สถานะปัจจุบันของการชำระเงิน Lehui',
    theGunScannedTheCodeSuccessfully: 'เครื่องยิงบาร์โค้ดสแกนสำเร็จ',
    theUserHasPaidSuccessfully: 'ผู้ใช้ชำระเงินสำเร็จ',
    ifTheUserDoesNotPayItCanBeReRecordedInTheFinancePage:
      'หากผู้ใช้ยังไม่ชำระ สามารถบันทึกใหม่ในหน้าไฟแนนซ์ได้',
  },
  sellCalctable: {
    maximumPromotion: 'ส่วนลดสูงสุด',
    nonMemberSellingPricebrestimatedSettlementPrice:
      'ราคาขายผู้ไม่เป็นสมาชิก<br>/ราคาชำระโดยประมาณ',
    ordinaryMemberSellingPricebrestimatedSettlementPrice:
      'ราคาขายสมาชิกทั่วไป<br>/ราคาชำระโดยประมาณ',
    goldMemberSellingPricebrestimatedSettlementPrice: 'ราคาขายสมาชิกทอง<br>/ราคาชำระโดยประมาณ',
    platinumMemberSellingPricebrestimatedSettlementPrice:
      'ราคาขายสมาชิกแพลตตินัม<br>/ราคาชำระโดยประมาณ',
    diamondMemberSellingPricebrestimatedSettlementPrice: 'ราคาขายสมาชิกเพชร<br>/ราคาชำระโดยประมาณ',
  },
  sellPTableTdNew: {
    noData: 'ไม่มีข้อมูล',
  },
  sellPricecalc: {
    channelSellingPriceCalculator: 'เครื่องคำนวณราคาขายช่องทาง',
    selectRoomType: 'เลือกประเภมห้อง',
    pleaseSelectRoomType: 'กรุณาเลือกประเภมห้อง',
    selectProduct: 'เลือกสินค้า',
    pleaseSelectAProductName: 'กรุณาเลือกชื่อสินค้า',
    selectSaleDate: 'เลือกวันที่ขาย',
    distributionChannel: 'ช่องทางจัดจำหน่าย',
    pleaseSelectTheDistributionChannelNamenotRequired: 'กรุณาเลือกช่องทางจำหน่าย (ไม่บังคับ)',
    canNotExceed: 'ต้องไม่เกิน',
    pleaseSelectASaleDate: 'กรุณาเลือกวันที่ขาย',
    figure: 'ตัวเลข',
  },
  filtersIndex: {
    all: 'ทั้งหมด',
    sinceThe: 'ตั้งแต่',
    free: 'ฟรี',
    group: 'กลุ่ม',
    association: 'สมาคม',
    theClock: 'รายชั่วโมง',
    long: 'ระยะยาว',
    inapplicability: 'ไม่สามารถใช้ได้',
    haveProcessed: 'ดำเนินการแล้ว',
    notProcessed: 'ยังไม่ดำเนินการ',
    averageSalesRate: 'ราคาเฉลี่ยขายห้อง',
    consumptionNight: 'จำนวนคืนที่ใช้บริการ',
    averageHousePriceOfConsumption: 'ราคาห้องเฉลี่ยของผู้ใช้บริการ',
    onlinePermeability: 'อัตราการเข้าถึงออนไลน์',
    cancelNight: 'คืนที่ถูกยกเลิก',
    rejectionNight: 'คืนที่ถูกปฏิเสธ',
    channelProvision: 'ช่องทางจัดให้',
    theHotelProvides: 'ทางโรงแรมเป็นผู้ให้บริการ',
  },
  jsonBookertypeoptions: {
    singleStoreMember: 'สมาชิกสาขาเดียว',
    lightLivingMember: 'สมาชิก Qingzhu',
  },
  layoutIndex: {
    collapseMenuBar: 'ยุบแถบเมนู',
  },
  componentsNavbar: {
    shiftManagement: 'จัดการกะงาน',
    helpCenter: 'ศูนย์ช่วยเหลือ',
    logout: 'ออกจากระบบ',
    reportTitle: 'รายงานสรุปการส่งเวรกะ',
    headers: {
      income: 'รายรับ',
      expend: 'รายจ่าย',
      total: 'ยอดรวม',
    },
  },
  componentsSidemessage: {
    orderNotice: 'การแจ้งเตือนคำสั่งซื้อ',
    orderMessageReceivedNotification: 'ได้รับการแจ้งเตือนคำสั่งซื้อแล้ว',
    youDoNotHaveOrderManagementPermission: 'คุณยังไม่มีสิทธิ์จัดการคำสั่งซื้อ',
    ignore: 'ละเว้นข้อความ',
    order: 'ข้อความคำสั่งซื้อ',
    noData: 'ยังไม่มีข้อความใหม่',
    system: 'ข้อความระบบ',
    settlement: 'ข้อความชำระบัญชี',
    dynamic: 'ข้อความอัปเดต',
    serviceManagement: 'จัดการใบงานบริการ',
    roomService: 'บริการห้องพัก',
    itemBorrow: 'ยืมอุปกรณ์',
    extendStay: 'ต่ออายุการพัก',
    manualEntry: 'บันทึกคำสั่งเอง',
    confirmOrder: 'ยืนยันรับงาน',
    viewOrder: 'ดูคำสั่งซื้อ',
    youDoNotHaveAccessToEbkOrderManagement: 'คุณยังไม่ได้เปิดสิทธิ์การจัดการคำสั่งซื้อ EBK',
    youReceive: 'คุณได้รับ',
    aNewMessage: 'ข้อความใหม่',
    have: 'มี',
    orderMessage: 'ข้อความคำสั่งซื้อ',
    aNewSystemMessage: 'ข้อความระบบใหม่',
    aNewSettlementMessage: 'ข้อความชำระบัญชีใหม่',
  },
  componentsSoundnotice: {
    playOut: 'เล่นจบแล้ว',
    theVoicePromptsThatAMessageIsReceived: 'เสียงแจ้งเตือนเมื่อได้รับข้อความ',
  },
  nightcheckNightStart: {
    nightTrialSequence: 'ลำดับการตรวจสอบกลางคืน',
    nightAuditInstructions2: 'คำอธิบายการตรวจสอบกลางคืน',
  },
  nightcheckNightTip: {
    theHotelHasNotBeenAuditedAtNightInOrderToAvoidAffectingTheHotelsRevenueDataPleaseStartTheNightAuditAsSoonAsPossible:
      'โรงแรมยังไม่ได้ตรวจสอบกลางคืน เพื่อไม่ให้กระทบต่อรายได้ กรุณาเริ่มตรวจสอบโดยเร็ว',
    nightAuditInstructions2: 'คำอธิบายการตรวจสอบกลางคืน',
    beforeTheNightAuditPleaseBeSureToCheckWhetherTheHotelsAccountingDataIsCorrectInAdvanceToAvoidAffectingTheHotelsRevenue:
      'ก่อนตรวจสอบกลางคืน กรุณาตรวจสอบข้อมูลบัญชีให้ถูกต้องเพื่อหลีกเลี่ยงผลกระทบต่อรายได้',
    pleaseConfirmThatAllCheckInAndCheckOutOrdersForTheCurrentBusinessDayHaveBeenProcessed:
      'กรุณายืนยันว่าการเข้าพักและเช็คเอาต์ของวันทำการนี้ได้ดำเนินการครบแล้ว',
    youHaveSetUpANightAuditToAutomaticallyCancelTheStoreOrdersThatHaveNotArrived:
      'คุณได้ตั้งค่าการตรวจสอบกลางคืนให้ยกเลิกคำสั่งจองของร้านค้าที่ยังไม่เช็คอินโดยอัตโนมัติ',
    preArrivalAutoCheckIn: 'คุณได้ตั้งค่าให้เช็คอินอัตโนมัติสำหรับคำสั่งจองก่อนเข้าพักระหว่างการตรวจสอบกลางคืน',
    preArrivalAutoNoshow: 'คุณได้ตั้งค่าให้ทำเครื่องหมาย no-show อัตโนมัติสำหรับคำสั่งจองก่อนเข้าพักระหว่างการตรวจสอบกลางคืน',
    preDepartureAutoCheckOut: 'คุณได้ตั้งค่าให้เช็คเอาท์อัตโนมัติสำหรับคำสั่งจองก่อนออกระหว่างการตรวจสอบกลางคืน',
    preDepartureAutoExtendStay: 'คุณได้ตั้งค่าให้ต่ออายุการเข้าพักอัตโนมัติสำหรับคำสั่งจองก่อนออกระหว่างการตรวจสอบกลางคืน',
    theEarliestTimeForManualNightAuditIs: 'เวลาเริ่มต้นตรวจสอบกลางคืนแบบแมนนวลเร็วสุดคือ',
    nightAuditProcess: 'ขั้นตอนการตรวจสอบกลางคืน',
    hotelBusinessDaysAreNowGreaterThanNaturalDays: 'วันทำการโรงแรมมากกว่าวันปฏิทิน',
    nightAuditReminder: 'เตือนการตรวจสอบกลางคืน',
    hotelBusinessDay: 'วันทำการโรงแรม',
    currentNaturalDay: 'วันตามปฏิทินปัจจุบัน',
    viewLogs: 'ดูบันทึก',
    theNightTrialWasCompleted: 'ตรวจสอบกลางคืนเสร็จสมบูรณ์',
    nightAuditStartTimeCanNotBeEarlierThan21OclockCanNotPerformNightAuditOperationOh:
      'เวลาเริ่มตรวจสอบกลางคืนต้องไม่เร็วกกว่า 21:00 ไม่สามารถดำเนินการได้',
    thereIsAnOngoingNightTrialPleaseDoNotRepeatTheProcedure:
      'มีการตรวจสอบกลางคืนกำลังดำเนินอยู่ กรุณาอย่าทำซ้ำ',
  },
  nightcheckNightTipGrayEnv: {
    theCurrentBusinessDayOfTheHotelIsLongerThanTheNaturalDayOrTheNightAuditCanNotStartEarlierThan21OclockCanNotPerformTheNightAuditOperation:
      'วันทำการของโรงแรมมากกว่าวันปฏิทิน หรือเวลาเริ่มตรวจสอบกลางคืนยังไม่ถึง 21:00 ไม่สามารถดำเนินการได้',
    theNightTrialHasNotBeenCompletedPleaseExecuteTheNightTrialAsSoonAsPossible:
      'ยังไม่ดำเนินการตรวจสอบกลางคืนเสร็จ กรุณาดำเนินการโดยเร็ว',
  },
  globalMethodsmixin: {
    hotelChangeAlert: 'การแจ้งเตือนการสลับโรงแรม',
    theHotelIsCurrentlyFrom: 'โรงแรมปัจจุบันจาก',
    switchTo: 'สลับไปที่',
  },
  regularIndex: {
    pleaseEnterTheCorrectEmailAddress: 'กรุณากรอกอีเมลให้ถูกต้อง',
    pleaseEnterTheCorrectIdNumber: 'กรุณากรอกหมายเลขบัตรประชาชนที่ถูกต้อง',
    pleaseEnterTheCorrectIdNumber2: 'กรุณากรอกหมายเลขเอกสารที่ถูกต้อง',
  },
  sidebarLogo: {
    helpCenter2: 'ศูนย์ช่วยเหลือ',
  },
  modulesMember: {
    drench: 'Drench',
  },
  modulesUser: {
    client: 'ลูกค้า',
    membershipManagement: 'จัดการสมาชิก',
    singleStoreMemberManagement: 'จัดการสมาชิกประจำสาขา',
    storeValueManagement: 'จัดการมูลค่าฝากประจำสาขา',
    singleStorePointsSetting: 'ตั้งค่าคะแนนประจำสาขา',
    storeValueReport: 'รายงานมูลค่าฝากประจำสาขา',
    failedToObtainOperationInformationProcedure: 'ดึงข้อมูลการดำเนินงานล้มเหลว',
    billReconciliation: 'ตรวจสอบใบแจ้งหนี้',
    paymentRecord: 'บันทึกการโอนเงิน',
    expenseStatement: 'รายการค่าใช้จ่าย',
  },
  utilsAddroute: {
    initializesTheReceivableFinancialMenu: 'เริ่มต้นเมนูการเงินบัญชีลูกหนี้',
  },
  utilsDoorcard: {
    initializationFailure: 'เริ่มต้นระบบล้มเหลว',
    noKeyCardReaderPlugInFound: 'ไม่พบปลั๊กอินเครื่องอ่านบัตร',
    cardReadingError: 'เกิดข้อผิดพลาดในการอ่านบัตร',
    plugIn: 'ปลั๊กอิน',
    cardReadingResult: 'ผลการอ่านบัตร',
    cardReadingFailure: 'อ่านบัตรล้มเหลว',
    businessCardWriteData: 'เขียนข้อมูลลงบัตร',
    businessCardPrintingResult: 'ผลการทำบัตร',
    businessCardFailure: 'ทำบัตรล้มเหลว',
    logoutStatusCode: 'รหัสสถานะการยกเลิก',
    logoutFailure: 'ยกเลิกล้มเหลว',
  },
  utilsDoorcardmaitian: {
    noKeyCardReaderPlugInFound: 'ไม่พบปลั๊กอินเครื่องอ่านบัตร',
    cancelTheCardSuccessfully: 'ยกเลิกบัตรสำเร็จ',
    readTheCardSuccessfully: 'อ่านบัตรสำเร็จ',
  },
  utilsEnum: {
    roomInNeedOfRepair: 'ห้องต้องการซ่อมแซม',
    guestRequest: 'คำขอของผู้เข้าพัก',
    hotelRowRoomDemand: 'ความต้องการจัดห้องของโรงแรม',
    inProcess: 'กำลังดำเนินการ',
    alreadyEnded: 'เสร็จสิ้นแล้ว',
    storeOrderPreArrivalHasNotBeenChecked: 'คำสั่งซื้อที่ยังไม่เช็คอินของร้านต้องตรวจสอบ',
    leaveTheRoomForInspectionToday: 'ตรวจสอบห้องที่จะออกวันนี้',
    generateRoomChargesInTheRoom: 'สร้างค่าห้องสำหรับการพัก',
    cleanRoomToDirtyRoom: 'เปลี่ยนสถานะห้องจากสะอาดเป็นสกปรก',
    switchingDay: 'สลับวันทำการ',
    preArrivalNoShowRoomListPending: 'รายการห้องที่ยังไม่เข้าพัก รอเช็คอิน',
    preSeparationIsNotSeparated: 'ยังไม่เช็คเอาต์ตามกำหนด',
    allRoomChargesAreGeneratedAndRecordedInTheAccount: 'สร้างค่าห้องทั้งหมดและบันทึกเข้าบัญชีแล้ว',
    roomChange: 'เปลี่ยนสถานะห้อง',
    generateCureReport: 'สร้างรายงานสรุป',
    shopHourRoom: 'ห้องรายชั่วโมง (หน้าร้าน)',
    onlineHourRoom: 'ห้องรายชั่วโมง (ออนไลน์)',
    presaleFullDayRoomProduct: 'สินค้าห้องแบบทั้งวัน (พรีเซล)',
    presaleClockRoomProduct: 'สินค้าห้องรายชั่วโมง (พรีเซล)',
  },
  utilsFreego: {
    theCardReaderIsNotConnectedToTheComputer: 'เครื่องอ่านบัตรไม่ได้เชื่อมต่อกับคอมพิวเตอร์',
    checkValueError: 'ค่าตรวจสอบผิดพลาด',
    passwordError: 'รหัสผ่านไม่ถูกต้อง',
    readCard: 'อ่านบัตร',
    cardReaderCommunicationIsNormal: 'การสื่อสารกับเครื่องอ่านบัตรปกติ',
    businessCardPrintingSoftwareIsNotOpened: 'โปรแกรมทำบัตรยังไม่ได้เปิด',
    theReaderIsNotConnectedOrTheSoftwareIsNotOpen:
      'เครื่องอ่านบัตรไม่ได้เชื่อมต่อหรือโปรแกรมไม่ได้เปิด',
    sorryYourBrowserDoesNotSupportCardReaderPleaseUseChrome:
      'ขออภัย เบราว์เซอร์ของคุณไม่รองรับการอ่านบัตร กรุณาใช้ Chrome',
  },
  utilsIdcard: {
    idCardReaderIsConnectedToScanYourIdCardConnectTheIdCardScannerToYourComputerAndRefreshThePage:
      'เครื่องอ่านบัตรประชาชนเชื่อมต่อแล้ว หากต้องการสแกนบัตร กรุณาเชื่อมต่อเครื่องสแกนเข้ากับคอมพิวเตอร์แล้วรีเฟรชหน้า',
    toScanDocumentsInstallTheIdCardReaderControl:
      'หากต้องการสแกนเอกสาร กรุณาติดตั้งคอนโทรลของเครื่องอ่านบัตรประชาชน',
    abnormalReadingIdCardPleaseRefreshAndTryAgain: 'อ่านบัตรผิดปกติ กรุณารีเฟรชและลองใหม่',
    noIdInformationIsReadPleaseCheckWhetherTheIdCardIsPlacedOrPlacedInTheCorrectPosition:
      'ไม่พบข้อมูลบัตร กรุณาตรวจสอบตำแหน่งการวางบัตรให้ถูกต้อง',
  },
  utilsIndex: {
    justNow: 'เมื่อสักครู่',
    aMinuteAgo: 'นาทีที่แล้ว',
    hoursAgo: 'ชั่วโมงที่แล้ว',
    month: 'เดือน',
    when: 'เวลา',
    connectionSuccessful: 'เชื่อมต่อสำเร็จ',
    theGlobalConnectionIsClosed: 'การเชื่อมต่อทั้งหมดถูกปิด',
    yourBrowserDoesNotSupportIt: 'เบราว์เซอร์ของคุณไม่รองรับ',
  },
  utilsLinktopage: {
    contactTheAdministratorToEnableIt: 'กรุณาติดต่อผู้ดูแลระบบเพื่อเปิดใช้งาน',
    noCorrespondingLedgerFound: 'ไม่พบชุดบัญชีที่เกี่ยวข้อง',
    accountReceivable: 'บัญชีลูกหนี้',
    administrativeAuthority: 'สิทธิ์การจัดการ',
  },
  utilsRequest: {
    doNotRepeatRequests: 'กรุณาอย่าส่งคำขอซ้ำ',
    noFlightFoundPleaseSelectAgain: 'ไม่พบกะงาน กรุณาเลือกใหม่',
    systemErrorPleaseContactTechnicalSupport: 'ระบบผิดพลาด กรุณาติดต่อฝ่ายเทคนิค',
    networkException: 'เครือข่ายผิดปกติ',
    requestTimedOutPleaseRefreshThePage: 'คำขอหมดเวลา กรุณารีเฟรชหน้า',
    requestTimeout: 'คำขอหมดเวลา',
    requestFailed: 'คำขอล้มเหลว',
  },
  utilsSharestorage: {
    putInTheInitialMarker: 'ใส่เครื่องหมายเริ่มต้นลงไป',
  },
  appdetailIndex: {
    specification: 'สเปก',
    contactBusinessManager: 'ติดต่อผู้จัดการฝ่ายธุรกิจ',
    buyNow: 'ซื้อทันที',
    applicationIntroduction: 'แนะนำแอปพลิเคชัน',
    workingHours: 'เวลาทำงาน',
    pleaseSelectProductSpecifications: 'กรุณาเลือกสเปกสินค้า',
  },
  applistIndex: {
    fullApplication: 'แอปทั้งหมด',
    haveOpened: 'เปิดใช้งานแล้ว',
    haveNotOpened: 'ยังไม่เปิดใช้งาน',
    inService: 'กำลังเปิดใช้งาน',
    contactBusinessManager: 'ติดต่อผู้จัดการฝ่ายธุรกิจ',
    workingHours: 'เวลาทำงาน',
    openImmediately: 'เปิดใช้งานทันที',
    immediateRenewal: 'ต่ออายุทันที',
    expiredDays: 'หมดอายุแล้ว {days} วัน',
    daysLeftToExpire: 'เหลือ {days} วันจะหมดอายุ',
  },
  createorderIndex: {
    goToPay: 'ไปชำระเงิน',
    remaining: 'คงเหลือ',
    orderProduct2: 'สินค้าที่สั่งซื้อ',
    purchaser2: 'ผู้สั่งซื้อ',
    specification: 'สเปก',
    successfulCustomsOrder2: 'ปิดคำสั่งซื้อสำเร็จ',
  },
  createorderPay: {
    amountPaid: 'ยอดที่ต้องชำระ',
    paymentCountdown: 'นับเวลาชำระเงิน',
    qrCodeHasExpired: 'QR โค้ดหมดอายุ',
    updateNow: 'อัปเดตทันที',
    payment3: 'ชำระเงิน',
    scanQRCode: 'กรุณาใช้ WeChat/Alipay สแกน QR เพื่อชำระเงิน',
  },
  orderlistIndex: {
    orderDate: 'วันที่สั่งซื้อ',
    product: 'สินค้า',
    toBePaid: 'รอชำระเงิน',
    paymentSuccess: 'ชำระเงินสำเร็จ',
    paymentFailure: 'ชำระเงินล้มเหลว',
    refunded: 'คืนเงินแล้ว',
    partialRefund: 'คืนเงินบางส่วน',
    goToPay: 'ไปชำระเงิน',
    orderTime: 'เวลาสั่งซื้อ',
    orderProduct2: 'ผลิตภัณฑ์ที่สั่งซื้อ',
    orderSpecification: 'สเปกที่สั่งซื้อ',
    refundAmount: 'ยอดเงินคืน',
    orderEffectiveTime: 'เวลาที่ออเดอร์มีผล',
    purchaser2: 'ผู้สั่งซื้อ',
    orderOperation: 'การดำเนินการคำสั่งซื้อ',
    successfulCustomsOrder2: 'ปิดคำสั่งซื้อสำเร็จ',
  },
  commentChannelComment: {
    modifyReply: 'แก้ไขการตอบกลับ',
    setAsTemplate: 'ตั้งเป็นเทมเพลต',
    selectRecommendedTemplate: 'เลือกเทมเพลตแนะนำ',
    inputReplyContentNoMoreThan10WordsAndNoMoreThan500Words: 'กรอกเนื้อหาตอบกลับ 10–500 ตัวอักษร',
    theMaximumResponseTextIs500Characters: 'ข้อความตอบกลับสูงสุด 500 ตัวอักษร',
    areYouSureYouWantToDeleteReplies: 'ยืนยันการลบการตอบกลับหรือไม่?',
  },
  commentCommentTempManage: {
    newTemplate: 'สร้างเทมเพลตใหม่',
    goodReputation: 'รีวิวดี',
    delete2: 'ลบ',
    templateName: 'ชื่อเทมเพลต',
    replyClassification: 'ประเภทการตอบกลับ',
    replyContent2: 'เนื้อหาตอบกลับ',
    pleaseEnterAtLeast10Characters: 'กรุณากรอกอย่างน้อย 10 ตัวอักษร',
    keyword: 'คีย์เวิร์ด',
    pleaseEnterTheKeywordsThatYouWantToMatchTheCommentsSeparatedByCommas:
      'กรุณากรอกคีย์เวิร์ดที่ต้องการจับคู่รีวิว ใช้จุลภาคคั่น',
    pleaseEnterATemplateName: 'กรุณากรอกชื่อเทมเพลต',
    theValueCanContainNoMoreThan15Characters: 'ความยาวต้องไม่เกิน 15 ตัวอักษร',
    pleaseSelectAReplyCategory: 'กรุณาเลือกประเภทการตอบกลับ',
    pleaseEnterTheReplyContent: 'กรุณากรอกเนื้อหาตอบกลับ',
    '10To500CharactersInLength': 'ความยาว 10–500 ตัวอักษร',
    theValueContainsAMaximumOf50Characters: 'ความยาวต้องไม่เกิน 50 ตัวอักษร',
    definitiveDeletion: 'ยืนยันการลบ',
    deletingATemplateSucceeded: 'ลบเทมเพลตสำเร็จ',
    creatingATemplateSucceeded: 'สร้างเทมเพลตสำเร็จ',
  },
  commentComment: {
    reasonForNotPassing: 'reasonForNotPassing',
    setAsTemplate: 'ตั้งเป็นเทมเพลต',
    replyAgain: 'ตอบกลับอีกครั้ง',
    reappeal: 'ยื่นอุทธรณ์อีกครั้ง',
    // Part 7, lines 1201 to 1400
    inComplaint: 'อยู่ระหว่างการอุทธรณ์',
    typeOfAppeal: 'ประเภทคำอุทธรณ์',
    statementOfAppeal: 'คำอธิบายการอุทธรณ์',
    selectRecommendedTemplate: 'เลือกแม่แบบที่แนะนำ',
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
      'กรอกเนื้อหาการตอบกลับ ความยาวมากกว่า 10 ตัวอักษรและไม่เกิน 300 ตัวอักษร',
    theMaximumResponseTextIs500Characters: 'ข้อความตอบกลับอนุญาตสูงสุด 500 ตัวอักษร',
    areYouSureYouWantToDeleteReplies: 'คุณแน่ใจหรือไม่ว่าต้องการลบการตอบกลับ',
  },
  commentComplain: {
    onceYourComplaintHasBeenReviewedTheCommentWillBeAutomaticallyDeleted:
      'เมื่อคำอุทธรณ์ของคุณผ่านการตรวจสอบ ความคิดเห็นจะถูกลบโดยอัตโนมัติ',
    youCanUploadUpToFivePictures: 'สามารถอัปโหลดภาพได้สูงสุด 5 ภาพ',
    launchAComplaint: 'ส่งคำอุทธรณ์',
    typeOfAppeal: 'ประเภทคำอุทธรณ์',
    statementOfAppeal: 'คำอธิบายการอุทธรณ์',
    uploadCredentials: 'อัปโหลดหลักฐาน',
    pleaseFillInTheContact: 'กรุณากรอกข้อมูลผู้ติดต่อ',
    pleaseEnterTheCorrectName: 'กรุณากรอกชื่อที่ถูกต้อง',
    pleaseSelectTheAppealType: 'กรุณาเลือกประเภทการอุทธรณ์',
    theCauseOfTheComplaintMustBeAtLeast10Words: 'สาเหตุการอุทธรณ์ต้องไม่น้อยกว่า 10 ตัวอักษร',
    theMaximumCauseOfAppealIs300Words: 'สาเหตุการอุทธรณ์ต้องไม่เกิน 300 ตัวอักษร',
    underAppeal: 'กำลังส่งคำอุทธรณ์',
    addAppealSuccess: 'เพิ่มคำอุทธรณ์สำเร็จ',
  },
  commentIndex: {
    totalEvaluation: 'การประเมินทั้งหมด',
    waitForReply: 'รอตอบกลับ',
    appealed: 'ได้อุทธรณ์แล้ว',
    allRoomTypes: 'ประเภทห้องทั้งหมด',
    noReplyYet: 'ยังไม่มีการตอบกลับ',
    toBeReviewed: 'รอตรวจสอบ',
    notPass: 'ไม่ผ่านการตรวจสอบ',
    alreadyPassed: 'ผ่านการตรวจสอบแล้ว',
  },
  commentMain: {
    deleteReplySucceeded: 'ลบการตอบกลับสำเร็จ',
    modifiedReplySucceeded: 'แก้ไขการตอบกลับสำเร็จ',
  },
  commentPreview: {
    viewPicture: 'ดูรูปภาพ',
  },
  commentReplyList: {
    replyDate: 'วันที่ตอบกลับ',
    commentChannel: 'ช่องทางแสดงความคิดเห็น',
    review2: 'ความคิดเห็น',
    replyContent2: 'เนื้อหาการตอบกลับ',
    commentReply: 'การตอบกลับความคิดเห็น',
    modifyReply: 'แก้ไขการตอบกลับ',
    deleteReply: 'ลบการตอบกลับ',
    meituanReview: 'รีวิว Meituan',
    ctripReview: 'รีวิว Ctrip',
    whereToComment: 'รีวิว Qunar',
    sameTripReview: 'รีวิว Tongcheng Travel',
    dianpingReviews: 'รีวิว Dianping',
    flyingPigReview: 'รีวิว Fliggy',
    parallelComment: 'รีวิว Tongcheng',
  },
  commentScore: {
    renewal: 'อัปเดต',
    guestImpression: 'ความประทับใจของแขก',
    overallGuestRating: 'คะแนนรวมจากแขก',
  },
  complainDetail: {
    issueDetails: 'รายละเอียดปัญหา',
    processingDetails: 'รายละเอียดการดำเนินการ',
    serviceProblem: 'ปัญหาด้านบริการ',
    healthProblem: 'ปัญหาด้านความสะอาด',
    processor: 'ผู้ดำเนินการ',
    processingTime: 'เวลาในการดำเนินการ',
    communicationSituation: 'สถานการณ์การสื่อสาร',
  },
  complainHandle: {
    successfulProcessing: 'ดำเนินการสำเร็จ',
    problemHandling: 'การจัดการปัญหา',
    roomInformation: 'ข้อมูลห้องพัก',
    guestInformation: 'ข้อมูลผู้เข้าพัก',
    communicationSituation: 'สถานการณ์การสื่อสาร',
    enterAMaximumOf300Characters: 'กรอกได้สูงสุด 300 ตัวอักษร',
    pleaseEnterTheProcessingResult: 'กรุณากรอกผลการดำเนินการ',
  },
  complainIndex: {
    submissionDate: 'วันที่ส่งคำอุทธรณ์',
    processed: 'ดำเนินการแล้ว',
    submissionTime: 'เวลาที่ส่ง',
    feedbackProblem: 'ปัญหาที่แจ้ง',
    untreated: 'ยังไม่ได้ดำเนินการ',
    viewTheResults: 'ดูผลลัพธ์',
  },
  ebkComment: {
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
      'กรอกเนื้อหาการตอบกลับ ความยาวมากกว่า 10 ตัวอักษรและไม่เกิน 300 ตัวอักษร',
    theMaximumResponseTextIs300Characters: 'ข้อความตอบกลับอนุญาตสูงสุด 300 ตัวอักษร',
    modifiedReplySucceeded: 'แก้ไขการตอบกลับสำเร็จ',
  },
  ebkGrade: {
    guestImpression: 'ความประทับใจของแขก',
  },
  ebkIndex: {
    totalEvaluation: 'การประเมินทั้งหมด',
    waitForReply: 'รอตอบกลับ',
  },
  customerCompany: {
    new: 'เพิ่มใหม่',
    whetherToAllowHangingAccounts2: 'อนุญาตให้ตั้งหนี้หรือไม่',
    loginListHidesRates: 'ซ่อนราคาห้องในใบลงทะเบียน',
    confirmAction: 'คุณยืนยันที่จะ {action} ลูกค้าบริษัท “{name}” หรือไม่',
  },
  customerDialog: {
    whetherToAllowHangingAccounts2: 'อนุญาตให้ตั้งหนี้หรือไม่',
    theRegistrationFormHidesTheRoomRate: 'ซ่อนราคาห้องในใบลงทะเบียน',
    addACorporateClient: 'เพิ่มลูกค้าบริษัท',
    changeCorporateAccount: 'แก้ไขข้อมูลลูกค้าบริษัท',
    companyInformation: 'ข้อมูลบริษัท',
    forShort: 'ชื่อย่อ',
    pleaseEnterCompanyAbbreviation: 'กรุณากรอกชื่อย่อบริษัท',
    code: 'รหัส',
    pleaseEnterTheCode: 'กรุณากรอกรหัส',
    legalPerson: 'ผู้รับผิดชอบตามกฎหมาย',
    pleaseEnterTheLegalPersonName: 'กรุณากรอกชื่อผู้รับผิดชอบตามกฎหมาย',
    fax: 'แฟกซ์',
    pleaseEnterTheFaxNumber: 'กรุณากรอกหมายเลขแฟกซ์',
    city: 'เมือง',
    postcode: 'รหัสไปรษณีย์',
    pleaseEnterPostalCode: 'กรุณากรอกรหัสไปรษณีย์',
    pleaseEnterDiscountRatio: 'กรุณากรอกอัตราส่วนส่วนลด',
    enterAMaximumOf100Characters: 'กรอกได้สูงสุด 100 ตัวอักษร',
    contactInformation: 'ข้อมูลผู้ติดต่อ',
    pleaseEnterTheContactNumber: 'กรุณากรอกเบอร์โทรติดต่อ',
    pleaseEnterEmail: 'กรุณากรอกอีเมล',
    setUp: 'ตั้งค่าบัญชีแขวนหนี้',
    pleaseEnterYourAccountName: 'กรุณากรอกชื่อบัญชี',
    accountType: 'ประเภทบัญชี',
    maximumAmount: 'วงเงินสูงสุด',
    pleaseEnterDiscount: 'กรุณากรอกส่วนลด',
    pleaseEnterAnIntegerBetween0And100: 'กรุณากรอกจำนวนเต็มระหว่าง 0 - 100',
    pleaseEnterTheCorrect11DigitMobileNumber: 'กรุณากรอกเบอร์มือถือ 11 หลักที่ถูกต้อง',
    pleaseEnterName: 'กรุณากรอกชื่อ',
    pleaseEnterTheContactName3: 'กรุณากรอกชื่อผู้ติดต่อ',
    creditAccount: 'บัญชีเครดิต',
    theCreditLimitCannotBeExceeded: 'ไม่สามารถเกินวงเงินเครดิตได้',
    enterRange: 'กรุณากรอกช่วง 1～365',
  },
  customerIndex: {
    protocolUnitToBeDeveloped: 'หน่วยงานตามสัญญา - รอพัฒนา',
  },
  heavenlyEyeCallThePolice: {
    alarmEvent: 'เหตุการณ์แจ้งเตือน',
    shootingTime: 'เวลาถ่ายภาพ',
    theFollowingGuestsHaveNotBeenAddedToTheWhiteListSelectTheGuestsThatMatchThePhoto:
      'ผู้เข้าพักต่อไปนี้ยังไม่อยู่ในรายการไวท์ลิสต์ กรุณาเลือกผู้ที่ตรงกับภาพ',
    stranger: 'บุคคลแปลกหน้า',
    whiteAdded: 'เพิ่มในไวท์ลิสต์แล้ว',
    ignored: 'ละเว้นแล้ว',
    whitelist: 'เพิ่มเข้าไวท์ลิสต์',
    environmentalPhotograph: 'ภาพสภาพแวดล้อม',
    facePhoto: 'ภาพใบหน้า',
    pleaseSelectUser: 'กรุณาเลือกผู้ใช้',
  },
  heavenlyEyeWhiteList: {
    personnelType: 'ประเภทบุคลากร',
    addStaff: 'เพิ่มพนักงาน',
    pleaseEnterTheRoomNumber: 'กรุณากรอกหมายเลขห้อง',
    employee2: 'พนักงาน',
    dweller: 'ผู้พักอาศัย',
    avatar: 'รูปโปรไฟล์',
    photograph: 'ภาพถ่าย',
    pleaseSelectEnterName: 'กรุณาเลือกหรือกรอกชื่อ',
    pleaseCompleteTheFormBeforeSubmitting: 'กรุณากรอกข้อมูลให้ครบก่อนส่ง',
    inputLabelDuplication: 'ป้ายกำกับซ้ำ',
    pleaseEnterTheLabelContent: 'กรุณากรอกเนื้อหาป้ายกำกับ',
    doNotEnterLabelsInMoreThan10Words: 'ป้ายกำกับต้องไม่เกิน 10 ตัวอักษร',
    whetherToDeleteTheWhitelist: 'ยืนยันลบออกจากไวท์ลิสต์หรือไม่',
    uploadImageFormat: 'ไฟล์รูปภาพต้องเป็น JPG หรือ PNG เท่านั้น!',
  },
  hicList: {
    dateOfPresentation: 'วันที่กรอกข้อมูล',
    dataExport: 'ส่งออกข้อมูล',
    bookingChannel: 'ช่องทางการจอง',
    bodyTemperature: 'อุณหภูมิร่างกาย',
    healthStatus: 'สถานะสุขภาพ',
    theHealthInformationCollectionReportIsSuccessfullyExportedProcedure:
      'ส่งออกแบบรายงานข้อมูลสุขภาพสำเร็จ',
    failedToExportTheHealthInformationCollectionReportProcedure:
      'ส่งออกแบบรายงานข้อมูลสุขภาพล้มเหลว',
  },
  hicQrCode: {
    downloadPicture: 'ดาวน์โหลดรูปภาพ',
  },
  marketActivity: {
    couponType: 'ประเภทคูปอง',
    couponName: 'ชื่อคูปอง',
    beOffline: 'ออฟไลน์แล้ว',
    terminated: 'ยุติแล้ว',
    full: 'ครบ',
    reduction: 'ลด',
    fromTheDateOfReceipt: 'นับจากวันที่ได้รับคูปอง',
    withinDays: 'มีผลภายใน {days} วัน',
    thisParameterIsValidWithinAFixedPeriod: 'ใช้ได้เฉพาะช่วงเวลาที่กำหนด',
    restrictedRoomNight: 'จำกัดจำนวนคืน',
    unlimited: 'ไม่จำกัด',
    oneNight: 'หนึ่งคืน',
    discountType: 'ประเภทส่วนลด',
    validForTimePeriod: 'ใช้ได้ภายในช่วงเวลา',
    instructionsForUse: 'ข้อควรรู้ในการใช้งาน',
    // Part 8, lines 1401 to 1600
    selectionOfParticipatingGoods: 'เลือกสินค้าที่เข้าร่วม',
    allGoods: 'สินค้าทั้งหมด',
    platform: 'แพลตฟอร์ม',
    theNameOfTheCouponWillBeDisplayedToTheUserPleaseFillItInCarefully:
      'ชื่อคูปองจะแสดงให้ผู้ใช้เห็น โปรดกรอกอย่างรอบคอบ',
    denomination: 'มูลค่า',
    fillInTheCouponAmountdiscountAmount: 'กรอกจำนวนเงินคูปอง (จำนวนส่วนลด)',
    pleaseSelectTheYearMonthAndDay2: 'โปรดเลือกปี เดือน และวัน',
    instructionsWillBeDisplayedToTheUserPleaseFillInCarefully:
      'ข้อควรรู้เกี่ยวกับการใช้จะแสดงให้ผู้ใช้เห็น โปรดกรอกอย่างรอบคอบ',
    viewActivity: 'ดูกิจกรรม',
    maxOut: 'ส่วนลดแบบเต็มจำนวน',
    availableForBooking1Room1NightOnly: 'ใช้ได้เฉพาะการจอง 1 ห้อง 1 คืนเท่านั้น',
    events: 'กิจกรรม',
    orderNeedsToBeFull: 'ยอดสั่งซื้อจำเป็นต้องถึง',
    issued: 'แจกแล้ว',
    haveBeenUsed: 'ใช้แล้ว',
    expired2: 'หมดอายุแล้ว',
    editCoupon: 'แก้ไขคูปอง',
    addCoupon: 'เพิ่มคูปอง',
    pleaseSelectTheOfferType: 'โปรดเลือกประเภทส่วนลด',
    pleaseEnterExpiryDate2: 'โปรดกรอกวันที่หมดอายุ',
    pleaseSelectExpirationDate: 'โปรดเลือกวันหมดอายุ',
    pleaseEnterTheCouponName2: 'โปรดกรอกชื่อคูปอง',
    amountCanOnlyBeEnteredInPositiveIntegersPleaseReEnter:
      'จำนวนเงินต้องเป็นจำนวนเต็มบวกเท่านั้น โปรดกรอกใหม่',
    successfulActivation: 'เปิดใช้งานสำเร็จ',
    deactivated: 'ยกเลิกการเปิดใช้งานแล้ว',
    pleaseConfirmWhetherYouWantToTerminate: 'โปรดยืนยันว่าต้องการสิ้นสุดหรือไม่',
    terminationSuccess: 'สิ้นสุดสำเร็จ',
    cancelledTermination: 'ยกเลิกการสิ้นสุดแล้ว',
    pleaseEnterTheValidityPeriod: 'โปรดกรอกข้อมูลช่วงเวลาที่ใช้ได้',
    createACoupon: 'สร้างคูปอง',
    unedited: 'ยกเลิกการแก้ไขแล้ว',
    discountTemplate: 'ลดทันที { money } บาท',
    fullReductionTemplate: 'ส่วนลดเมื่อครบ { minAmount } บาท',
    validityDaysTemplate: 'มีผลภายใน { day } วันนับจากวันที่ได้รับคูปอง',
    activationConfirmation:
      'เมื่อคูปองถูกเปิดใช้งานแล้วจะไม่สามารถแก้ไขได้ โปรดยืนยันว่าต้องการเปิดใช้งานหรือไม่?',
    importValidationWarning: 'การตรวจสอบบางโรงแรมที่นำเข้าอยู่ผิดปกติ ต้องการดำเนินการต่อหรือไม่?',
  },
  marketActivitydata: {
    classificationSpecification: 'คำอธิบายการแบ่งประเภท',
    data: 'ข้อมูล',
    marketingRevenue: 'รายได้จากการตลาด',
    marketingExpenses: 'ค่าใช้จ่ายด้านการตลาด',
    numberOfContacts: 'จำนวนผู้ถูกเข้าถึง',
    numberOfVisitors: 'จำนวนผู้เข้าชม',
    numberOfTransactions: 'จำนวนการทำรายการ',
    revenueDescription: 'รายได้ที่ผู้ใช้ที่ถูกเข้าถึงสร้างขึ้นภายใน 30 วัน (บาท)',
    costDescription: 'ค่าใช้จ่ายทางการตลาดที่เกิดขึ้นภายใน 30 วัน (บาท)',
    reachCountDescription: 'จำนวนผู้ใช้ที่การตลาดเข้าถึงภายใน 30 วัน (คน)',
    visitCountDescription: 'จำนวนผู้ใช้ที่ถูกเข้าถึงและเข้าชมร้านภายใน 30 วัน (คน)',
    orderCountDescription: 'จำนวนผู้ใช้ที่ถูกเข้าถึงและสั่งซื้อภายใน 30 วัน (คน)',
  },
  marketCrowddata: {
    subdivide: 'แบ่งย่อย',
    classificationSpecification: 'คำอธิบายการแบ่งประเภท',
    numberOfPeople: 'จำนวนคน',
    membersWhoHaveStayedAtThisStore: 'สมาชิกที่เคยเข้าพักที่ร้านนี้',
    allMembers: 'สมาชิกทั้งหมด',
    usersWhoHaveStayedInThisStoreInThePast1Year: 'ผู้ใช้ที่เข้าพักในร้านนี้ภายใน 1 ปีที่ผ่านมา',
    lowFrequencyMember: 'สมาชิกเข้าพักน้อย',
    usersWhoHaveStayedInTheLast1YearButHaveNotStayedInTheLast3Months:
      'ผู้ใช้ที่เข้าพักใน 1 ปีที่ผ่านมา แต่ไม่เข้าพักใน 3 เดือนล่าสุด',
    loyalUser: 'ผู้ใช้ประจำ',
    usersWhoHaveStayedAtLeast3TimesInTheLast1Year:
      'ผู้ใช้ที่เข้าพัก 3 ครั้งขึ้นไปภายใน 1 ปีที่ผ่านมา',
    lostUsers: 'ผู้ใช้ที่หายไป',
    usersWhoHaveStayedInThePast2YearsAndHaveNotStayedInThePast1Year:
      'ผู้ใช้ที่เข้าพักใน 2 ปีที่ผ่านมา แต่ไม่เข้าพักในปีล่าสุด',
    interestedMember: 'สมาชิกที่สนใจ',
    interestedUserGroupsOfThisStore: 'กลุ่มผู้ใช้ที่สนใจร้านนี้',
    inThePast7DaysTheUserHasEnteredTheHomepageOfTheMiniProgramOfTheHotelAndHasNotPlacedAnOrder:
      'ใน 7 วันที่ผ่านมา ผู้ใช้นี้เข้าหน้าแรกมินิโปรแกรมโรงแรม แต่ไม่ได้สั่งซื้อ',
    localInterestUserGroups: 'กลุ่มผู้ใช้ที่สนใจในเมืองเดียวกัน',
    inThePast7DaysIHaveSearchedTheCityAndHotelWhereTheHotelIsLocated:
      'ใน 7 วันที่ผ่านมา ค้นหาเมืองหรือโรงแรมที่ตั้งของโรงแรมนี้',
    orEnteredOtherHotelsInTheCityButDidNotPlaceAnOrder:
      'หรือเข้าโรงแรมอื่นในเมืองเดียวกันแต่ไม่ได้สั่งซื้อ',
    intraCityUserGroup: 'กลุ่มผู้ใช้ในเมืองเดียวกัน',
    usersWhoHaveStayedInTheCityInTheLast30DaysAreNotUsersOfThisStore:
      'ผู้ใช้ที่เข้าพักในเมืองนี้ใน 30 วันที่ผ่านมา แต่ไม่ใช่ผู้ใช้ของร้านนี้',
    createActivity: 'สร้างกิจกรรม',
    lowFrequencyUser: 'ผู้ใช้เข้าพักน้อย',
    marketingSuggestion: 'คำแนะนำ: ควรสร้างกิจกรรมการตลาดเพื่อรักษาผู้ใช้และเพิ่มยอดการสั่งซื้อ！',
  },
  marketDatakb: {
    crowdDataBulletinBoard: 'กระดานข้อมูลกลุ่มผู้ใช้',
    activityDataKanban: 'กระดานข้อมูลกิจกรรม',
  },
  marketDistribution: {
    releaseTime: 'เวลาการแจก',
    events: 'กิจกรรม',
    releaseMode: 'วิธีการแจก',
    smsSending: 'ส่ง SMS',
    publicAccount: 'บัญชีทางการ',
    stopSmsPlatformPush: 'หยุดการส่ง SMS จากแพลตฟอร์ม',
    stopThePublicAccountPush: 'หยุดการส่งจากบัญชีทางการ',
    iHaveReadAndAgree: 'ฉันได้อ่านและยอมรับ',
    precisionMarketingRules: 'กฎการตลาดเชิงเจาะจง',
    pleaseReadAndAgree: 'โปรดอ่านและยอมรับ',
    warmReminder: 'เตือนความจำอย่างอบอุ่น',
    issue: 'แจก',
    couponName: 'ชื่อคูปอง',
    pleaseEnterTheCouponName2: 'โปรดกรอกชื่อคูปอง',
    sendingCrowd: 'กลุ่มผู้รับ',
    pleaseSelectTheSender: 'โปรดเลือกกลุ่มผู้รับ',
    quantityIssued: 'จำนวนการแจก',
    pleaseFillInTheNumberOfIssuedCards: 'โปรดกรอกจำนวนที่แจก',
    sendingMode: 'วิธีการส่ง',
    notificationTemplate: 'แม่แบบการแจ้งเตือน',
    pleaseSelectANotificationTemplate: 'กรุณาเลือกแม่แบบการแจ้งเตือน',
    projectedCost: 'ค่าใช้จ่ายที่คาดการณ์',
    allUsers: 'ผู้ใช้ทั้งหมด',
    interestedUsersOfThisStore: 'ผู้ใช้ที่สนใจร้านนี้',
    lostUsers: 'ผู้ใช้ที่หายไป',
    loyalUser: 'ผู้ใช้ประจำ',
    lowFrequencyUser: 'ผู้ใช้เข้าพักน้อย',
    interestedUsersInTheSameCity: 'ผู้ใช้ที่สนใจในเมืองเดียวกัน',
    localUser: 'ผู้ใช้ท้องถิ่น',
    unactivated: 'ยังไม่เปิดใช้งาน',
    terminated: 'สิ้นสุดแล้ว',
    voucherInformation: 'ข้อมูลคูปองที่แจก',
    issuer: 'ผู้แจก',
    pleaseEnterTheReleaseQuantity: 'โปรดกรอกจำนวนการแจก',
    couponIssuedSuccessfully: 'แจกคูปองสำเร็จ',
    pleaseEnterCoupon: 'โปรดกรอกคูปอง',
    sendBatch: 'รอบการส่ง',
    pleaseEnterTheCorrectCoupon: 'โปรดกรอกคูปองที่ถูกต้อง',
    perPersonUnit: 'ใบ/คน',
    rule1:
      '1. ไม่ควรสร้างกิจกรรมการตลาดบ่อยจนเกินไป ระบบผู้ใช้ของ Qingzhu มีมาตรการป้องกันความล้า ในช่วงเวลาหนึ่ง ผู้ใช้จะได้รับการแจ้งเตือน/ข้อความจำนวนจำกัด',
    rule2:
      '2. เพื่อป้องกันการรบกวนผู้ใช้จากการแจ้งเตือนมากเกินไป ฟังก์ชันนี้จำกัดให้ผู้ใช้ได้รับการแจ้งเตือนแต่ละช่องทางเพียง 1 ครั้งใน 7 วัน',
    rule3: '3. การแจ้งเตือนไม่รับประกันว่าจะส่งสำเร็จทั้งหมด ให้ยึดตามผลการเข้าถึงจริง',
    rule4: '4. การแจ้งเตือนที่ส่งไม่สำเร็จจะคืนค่าใช้จ่ายและต้องแสดงบันทึกว่าสำเร็จหรือไม่',
  },
  marketRules: {
    rulesRulesRules: 'กฎระเบียบ',
  },
  memberActivityManage: {
    longTerm: 'ระยะยาว',
    customInterval: 'กำหนดช่วงเวลาเอง',
    activeTime: 'ระยะเวลากิจกรรม',
    addActivity: 'เพิ่มกิจกรรม',
    editingActivity: 'แก้ไขกิจกรรม',
    editGear: 'แก้ไขระดับ',
    addGear: 'เพิ่มระดับ',
    unlimited: 'ไม่จำกัด',
    rechargeAmount2: 'จำนวนเงินเติม',
    enabledState: 'สถานะเปิดใช้งาน',
    activeState: 'สถานะกิจกรรม',
    pleaseEditTheAddedGears: 'โปรดแก้ไขระดับที่เพิ่มแล้ว',
  },
  memberIntegralSetting: {
    integralRatioSetting: 'ตั้งค่าสัดส่วนแต้ม',
    points: 'แต้ม',
    automaticCumulativePointSetting: 'ตั้งค่าการสะสมแต้มอัตโนมัติ',
    storedValueConsumption: 'การใช้เงินสะสม',
    nonCumulativeIntegral: 'ไม่สะสมแต้ม',
    pleaseFillInThePointsRatioSetting: 'โปรดกรอกการตั้งค่าสัดส่วนแต้ม',
    pleaseSelectTheAutomaticAccumulationPointSetting: 'โปรดเลือกการตั้งค่าสะสมแต้มอัตโนมัติ',
    roomAndStoredConsumption: 'ค่าห้อง + การใช้เงินสะสม',
    integralRatioLimit: 'สัดส่วนแต้มต้องอยู่ระหว่าง 0.01~1000',
  },
  memberMemberManage: {
    pleaseArrangeMemberInformationAccordingToTheRequirementsInTheTemplate:
      'กรุณาจัดระเบียบข้อมูลสมาชิกตามข้อกำหนดในแม่แบบ',
    downloadTemplate: 'ดาวน์โหลดแม่แบบ',
    freeCommissionPolicyTips: 'คำแนะนำเกี่ยวกับนโยบายฟรีค่าคอมมิชชัน',
    downloadFailureData: 'ดาวน์โหลดข้อมูลที่ล้มเหลว',
    normal: 'ปกติ',
    registrationTime: 'เวลาลงทะเบียน',
    entryTime: 'เวลาบันทึกข้อมูล',
    augment: 'เพิ่ม',
    decrease: 'ลด',
    singleStoreStoredValueBillPrinting: 'พิมพ์บิลเงินสะสมของร้านเดี่ยว',
    theAmountOfMemberStoredValueIsOnlyAvailableInThisStoreAndIsNotAvailableInOtherStores:
      'ยอดเงินสะสมของสมาชิกใช้ได้เฉพาะร้านนี้ ร้านอื่นไม่สามารถใช้ได้',
    currentMembersHaveUnusedBalancesOrPointsPleaseConfirmWhetherToDisable:
      'สมาชิกปัจจุบันมียอดเงินหรือแต้มที่ยังไม่ใช้ โปรดยืนยันว่าต้องการปิดการใช้งานหรือไม่',
    lightLivingMember: 'สมาชิก Light Living',
    startOfEntryDate: 'วันที่บันทึกข้อมูลเริ่มต้น',
    dateOfEntry: 'วันที่บันทึกข้อมูลสิ้นสุด',
    membershipIntroduction: 'นำเข้าสมาชิก',
    memberExport: 'ส่งออกสมาชิก',
    newMember: 'เพิ่มสมาชิกใหม่',
    viewGrade: 'ดูระดับ',
    viewMembers2: 'ดูสมาชิก',
    storedValueQuery2: 'สอบถามเงินสะสม',
    transactionType: 'ประเภทธุรกรรม',
    registered: 'ลงทะเบียนแล้ว',
    unregistered: 'ยังไม่ลงทะเบียน',
    theAmountOfThisStoredValue: 'จำนวนเงินสะสมครั้งนี้',
    storedValueActivity: 'กิจกรรมเติมเงิน',
    eventGiftAmount: 'จำนวนเงินของขวัญกิจกรรม',
    currentStoredValueBalance: 'ยอดเงินสะสมปัจจุบัน',
    storageTime: 'เวลาการเติมเงินสะสม',
    currentBalance: 'ยอดปัจจุบัน',
    topUpTheTotalAmount: 'จำนวนเงินเติมทั้งหมด',
    totalGiftAmount: 'จำนวนเงินของแถมทั้งหมด',
    totalPayment: 'ยอดชำระทั้งหมด',
    totalRefundAmount: 'ยอดคืนเงินทั้งหมด',
    singleStoreMembershipLevel: 'ระดับสมาชิกของร้านเดี่ยว',
    storePoints: 'แต้มร้านเดี่ยว',
    storedValueAccumulation: 'ยอดสะสมเงินสะสม',
    incorrectEmailFormat: 'รูปแบบอีเมลไม่ถูกต้อง',
    membershipLevel: 'ระดับสมาชิก',
    occupation: 'อาชีพ',
    pleaseEnterOccupation: 'โปรดกรอกอาชีพ',
    salespersonName: 'ชื่อพนักงานขาย',
    salespersonId: 'รหัสพนักงานขาย',
    pleaseEnterSalespersonId: 'โปรดกรอกรหัสพนักงานขาย',
    pleaseEnterTheSalespersonsName: 'โปรดกรอกชื่อพนักงานขาย',
    // Part 9, lines 1601 to 1800
    pleaseSelectTheYearMonthAndDay2: 'โปรดเลือกปี เดือน และวัน',
    detailedAddress: 'ที่อยู่โดยละเอียด',
    lv: 'ระดับ',
    gradeName: 'ชื่อระดับ',
    variableIntegral: 'แต้มที่เปลี่ยนแปลง',
    pointBalance: 'ยอดคงเหลือแต้ม',
    transactionAmount: 'ยอดธุรกรรม',
    changeType: 'ประเภทยอดเปลี่ยนแปลง',
    changeOfAmount: 'จำนวนที่เปลี่ยนแปลง',
    pleaseEnterAnInteger: 'โปรดกรอกจำนวนเต็ม',
    topUpActivity: 'กิจกรรมเติมเงิน',
    pleaseSelectAnActivity: 'โปรดเลือกกิจกรรม',
    activeGear: 'ระดับกิจกรรม',
    rechargeAmount2: 'จำนวนเงินเติม',
    pleaseEnterTheRechargeAmount: 'โปรดกรอกจำนวนเงินเติม',
    amountReceivable: 'จำนวนเงินที่ต้องรับ',
    printDocuments: 'พิมพ์เอกสาร',
    deductionAmount: 'จำนวนเงินหักลด',
    pleaseEnterTheAmountOfDeduction: 'โปรดกรอกจำนวนเงินหักลด',
    increaseTheIntegral: 'เพิ่มแต้ม',
    reduceIntegral: 'ลดแต้ม',
    filling: 'เติม',
    send: 'แถม',
    pleaseEnterTheCorrectIdNumber: 'โปรดกรอกหมายเลขบัตรประชาชนที่ถูกต้อง',
    pleaseEnterTheCorrectIdNumber2: 'โปรดกรอกหมายเลขเอกสารที่ถูกต้อง',
    pleaseFillInTheIdNumber: 'โปรดกรอกหมายเลขเอกสาร',
    operationFailure: 'การดำเนินการล้มเหลว',
    youDoNotHaveAccessRightsPleaseContactLightLiveOperationsToAddPermissions:
      'คุณไม่มีสิทธิ์เข้าถึง กรุณาติดต่อฝ่ายปฏิบัติการของ Qingzhu เพื่อเพิ่มสิทธิ์',
    currentLimitSelect1FilePleaseRemoveAndAdd:
      'ขณะนี้จำกัดให้เลือกได้ 1 ไฟล์ โปรดลบออกแล้วเพิ่มใหม่',
    memberDataIsExportedSuccessfullyProcedure: 'ส่งออกข้อมูลสมาชิกสำเร็จ',
    memberDataFailedToBeExportedProcedure: 'ส่งออกข้อมูลสมาชิกล้มเหลว',
    noDataAvailableAtThisTime: 'ขณะนี้ยังไม่มีข้อมูล',
    memberImportTemplateDownloadedSuccessfully: 'ดาวน์โหลดแม่แบบนำเข้าสมาชิกสำเร็จ',
    failedToDownloadTheMemberImportTemplate: 'ดาวน์โหลดแม่แบบนำเข้าสมาชิกล้มเหลว',
    modifyMembership2: 'แก้ไขสมาชิก',
    addAMemberSuccessfully: 'เพิ่มสมาชิกสำเร็จ',
    renewMemberSuccessfully: 'ต่ออายุสมาชิกสำเร็จ',
    integralChange2: 'การเปลี่ยนแปลงแต้ม',
    memberRecharge: 'เติมเงินสมาชิก',
    deductionOfStoredValue: 'หักลดเงินสะสม',
    scoreChangeSuccess: 'เปลี่ยนแต้มสำเร็จ',
    memberRechargeSuccessfully: 'เติมเงินสมาชิกสำเร็จ',
    theDeductionOfStoredValueIsSuccessful: 'หักลดเงินสะสมสำเร็จ',
    integralQuery2: 'สอบถามแต้ม',
    pleaseEnterSalesman: 'โปรดกรอกพนักงานขาย',
    definitiveRemoval: 'ยืนยันการลบ',
    derivedInformation: 'ข้อมูลการส่งออก',
    memberDataExportInformation: 'ข้อมูลส่งออกสมาชิก.xlsx',
    memberImportTemplate: 'แม่แบบนำเข้าสมาชิก',
    totalMembers: 'มีสมาชิกทั้งหมด {memberTotal} คน',
    xlsFormatOnly: 'รองรับเฉพาะไฟล์รูปแบบ XLS',
    commissionRefundNotice:
      'ตั้งแต่วันที่ 1 ก.พ. 2021 เป็นต้นไป สมาชิกที่นำเข้าเป็นครั้งแรกด้วยฟังก์ชัน “นำเข้าสมาชิก” หากจองและเข้าพักโรงแรมนี้ผ่านมินิโปรแกรม 轻住 ค่าคอมมิชชันที่เกิดขึ้นจะคืนให้เต็มจำนวน!',
    idTypeAndNumber: 'ประเภทเอกสาร/หมายเลขเอกสาร',
    distributionSettings: 'การตั้งค่าหนักขาย',
    setAsAPromotionalUser: 'ตั้งเป็นผู้ขายโปรโมชั่น',
    enabled: 'ใช้งาน',
    disabled: 'ไม่ใช้งาน',
  },
  memberMemberReport: {
    ordinaryMember: 'สมาชิกทั่วไป',
    goldMember: 'สมาชิกทอง',
    platinumMember: 'สมาชิกแพลทินัม',
    diamondMember: 'สมาชิกเพชร',
    enterYourNamePhoneNumberAndIdNumber: 'กรอกชื่อ เบอร์มือถือ และหมายเลขเอกสาร',
    membership: 'สถานะสมาชิก',
    activateStore: 'ร้านที่เปิดใช้งาน',
    ourStore: 'ร้านนี้',
    otherStores: 'ร้านอื่น',
    sourceOfDevelopment: 'แหล่งที่มา',
    activationDate: 'วันที่เปิดใช้งาน',
    dateOfPurchase: 'วันที่ซื้อ',
    purchaseTime: 'เวลาซื้อ',
    memberNickname: 'ชื่อเล่นสมาชิก',
    memberName: 'ชื่อสมาชิก',
    membershipIdNumber: 'หมายเลขเอกสารสมาชิก',
    activationTime: 'เวลาเปิดใช้งาน',
    currentLevelDevelopmentSource: 'แหล่งที่มาระดับปัจจุบัน',
    currentLevelPurchaseTime: 'เวลาซื้อระดับปัจจุบัน',
  },
  memberSaveReport: {
    downloadReport: 'ดาวน์โหลดรายงาน',
    totalAmountOfStoredValue: 'ยอดรวมเงินสะสม',
    totalGiftAmount: 'ยอดรวมเงินของแถม',
    totalConsumptionAmount: 'ยอดรวมจำนวนเงินใช้จ่าย',
    totalAmountOfRefund: 'ยอดรวมเงินคืนจากการใช้จ่าย',
    user: 'ผู้ใช้',
    transactionType: 'ประเภทธุรกรรม',
    storedValue: 'เงินสะสม',
    consumptionRefund: 'คืนเงินการใช้จ่าย',
    membershipLevel: 'ระดับสมาชิก',
    storedValueAmount: 'จำนวนเงินสะสม',
    amountOfRefund: 'จำนวนเงินคืนการใช้จ่าย',
    memberStoredValueReport: 'รายงานเงินสะสมของสมาชิก.xlsx',
    theMemberStoredValueReportIsSuccessfullyExported: 'ส่งออกรายงานเงินสะสมสมาชิกสำเร็จ',
    failedToExportTheMemberStoredValueReport: 'ส่งออกรายงานเงินสะสมสมาชิกล้มเหลว',
    searchPlaceholder: 'เบอร์มือถือ/เอกสาร/ชื่อ/หมายเลขบัตร',
  },
  clientClient: {
    guestTag: 'ป้ายกำกับแขก',
    pleaseEnterYourContactInformation: 'โปรดกรอกข้อมูลติดต่อ',
    pleaseEnterYourNationality: 'โปรดกรอกสัญชาติ',
    pleaseEnterNationality: 'โปรดกรอกเชื้อชาติ',
    pleaseEnterAddress: 'โปรดกรอกที่อยู่',
    age: 'อายุ',
    customerLabel: 'ป้ายกำกับลูกค้า',
    modifyGuestInformation: 'แก้ไขข้อมูลแขก',
    inputLabelDuplication: 'ป้ายกำกับที่กรอกซ้ำกัน',
    pleaseEnterTheLabelContent: 'โปรดกรอกเนื้อหาป้ายกำกับ',
    doNotEnterLabelsInMoreThan10Words: 'ป้ายกำกับที่กรอกต้องไม่เกิน 10 ตัวอักษร',
  },
  financeIndex: {
    pleaseCancelRenewFirst: 'โปรดยกเลิกการต่อพักก่อน แล้วจึงดำเนินการเช็คเอาต์',
    addAnotherItem: 'เพิ่มรายการอื่น',
    checkInOrderNumber: 'หมายเลขใบเข้าพัก',
    adjustFinance: 'ปรับปรุงบัญชีการเงิน',
    batchTransfer: 'โอนเป็นชุด',
    checkOut: 'เช็คเอาต์แบบพักหนี้ในบัญชี',
    pleaseEnterTheRoomNumber: 'โปรดกรอกหมายเลขห้อง',
    pleaseEnterRoomTypeName: 'โปรดกรอกชื่อประเภทห้อง',
    pleaseEnterChannel: 'โปรดกรอกช่องทาง',
    pleaseEnterCheckInTime: 'โปรดกรอกเวลาเช็คอิน',
    pleaseEnterYourDepartureTime: 'โปรดกรอกเวลาเช็คเอาต์',
    pleaseEnterAccount: 'โปรดกรอกหัวข้อบัญชี',
    entryTime2: 'เวลาบันทึกบัญชี',
    pleaseEnterTheCreditDate: 'โปรดกรอกเวลาบันทึกบัญชี',
    consumptionAmountyuan: 'ยอดใช้จ่าย ',
    pleaseEnterTheAmountSpent: 'โปรดกรอกยอดใช้จ่าย',
    paymentAmountyuan: 'ยอดชำระ ',
    pleaseEnterThePaymentAmount: 'โปรดกรอกยอดชำระ',
    editBill: 'แก้ไขบิล',
    checkOut2: 'เช็คเอาต์ชำระเงิน',
    cancelAccount: 'ยกเลิกการปิดบัญชี',
    partialClosing: 'ปิดบัญชีบางส่วน',
    accountAdjustment: 'ปรับบัญชี',
    smallGoodsAreAccountedFor: 'บันทึกบัญชีสินค้าชิ้นเล็ก',
    pleaseSelectAPaymentHistory: 'โปรดเลือกรายการชำระเงิน',
    pleaseFillInTheAmountOfPayment: 'โปรดกรอกยอดชำระ',
    yourAccountInformationIsEmptyPleaseEnterTheAccountBeforePrinting:
      'ข้อมูลบัญชีของคุณว่างอยู่ โปรดบันทึกบัญชีก่อนจึงจะพิมพ์ได้',
    theRoomNumberCannotBeEmptyPleaseCheckWhetherThePagePathIsCorrect:
      'หมายเลขใบห้องต้องไม่เว้นว่าง โปรดตรวจสอบว่าเส้นทางหน้าเว็บถูกต้องหรือไม่',
    smallwares: 'สินค้าชิ้นเล็ก',
    creditOrdersDoNotSupportPartialCheckout: 'ออเดอร์เครดิตเข้าพักไม่รองรับการปิดบัญชีบางส่วน',
    pleaseSelectTheOrderYouWantToCheckOut: 'โปรดเลือกออเดอร์ที่ต้องการปิดบัญชี',
    creditBookingIsNotSupportedPleaseCheckOutDirectly:
      'ออเดอร์เครดิตเข้าพักไม่รองรับการพักหนี้ในบัญชี โปรดเช็คเอาต์ชำระเงินโดยตรง',
    pleaseSelectACover: 'โปรดเลือกรายชุดบัญชี',
    unionpayScanCode: 'UnionPay-สแกนโค้ด',
    checkOutSuccessfully: 'เช็คเอาต์สำเร็จ',
    securityDeposit: 'เงินมัดจำ',
    warmReminder: 'เตือนความจำอย่างอบอุ่น',
    signOut: 'ยกเลิกการใช้งาน',
    cancelled: 'ยกเลิกการใช้งานแล้ว',
    the: 'ของ',
    wheatDoorLockPlugInCancellationCard: 'Maitian Door Lock Plugin - ยกเลิกบัตร',
    whetherTheKeyCardHasBeenCancelled: 'ได้ยกเลิกบัตรกุญแจแล้วหรือไม่',
    selectUnsettledAccountsWarning: 'โปรดเลือกบัญชีที่ “ยังไม่ปิดบัญชี”',
    feizhuRoomFeeValidation:
      'จำนวนเงินค่าห้องของ Fliggy ต้อง ≥ 0 ขณะนี้ค่าห้องที่ใช้ในการชำระคือ: {roomRateFees}',
    feizhuNonRoomFeeValidation:
      'จำนวนเงิน “ค่านอกห้อง” ของ Fliggy ต้อง ≥ 0 ขณะนี้ค่านอกห้องที่ใช้ในการชำระคือ: {fees}',
    pleaseSelectUnsettledAccounts: 'โปรดเลือกบัญชีที่ยังไม่ปิดบัญชี',
    additionalChargeAmountEmpty: 'จำนวนเงินที่คิดเพิ่มว่างอยู่ โปรดดำเนินการอีกครั้ง',
  },
  financeMangementOld: {
    accountType: 'ประเภทบัญชี',
    creditAccount: 'บัญชีเครดิต',
    prepaidAccount: 'บัญชีเติมล่วงหน้า',
    settlementPeriod: 'รอบการชำระบัญชี',
    maximumAmount: 'วงเงินสูงสุด',
    theMaximumMustBeGreaterThanZero: 'วงเงินสูงสุดต้องมากกว่า 0',
    theMaximumAmountCannotBeGreaterThan100Million: 'วงเงินสูงสุดต้องไม่เกินหนึ่งร้อยล้าน',
    theStartTimeCannotBeEqualToTheEndTime: 'เวลาเริ่มต้นต้องไม่เท่ากับเวลาสิ้นสุด',
    theStartTimeCannotBeLaterThanTheEndTime: 'เวลาเริ่มต้นต้องไม่มากกว่าวลาสิ้นสุด',
    pleaseSelectAnEndTime: 'โปรดเลือกเวลาสิ้นสุด',
    theEndTimeCannotBeEqualToTheStartTime: 'เวลาสิ้นสุดต้องไม่เท่ากับเวลาเริ่มต้น',
    theEndTimeCannotBeLaterThanTheStartTime: 'เวลาสิ้นสุดต้องไม่น้อยกว่าเวลาเริ่มต้น',
    pleaseEnterTheBillingPeriod: 'โปรดกรอกรอบการชำระบัญชี',
    settlementPeriodCanOnlyBeEnteredInNumbers: 'รอบการชำระบัญชีต้องกรอกเป็นตัวเลขเท่านั้น',
    newAccount: 'เพิ่มบัญชีใหม่',
    pleaseFillInTheAccountName: 'โปรดกรอกชื่อบัญชี',
    pleaseFillInTheCompanyName: 'โปรดกรอกชื่อบริษัท',
    pleaseSelectAnAccountType: 'โปรดเลือกประเภทบัญชี',
    pleaseSelectAChannelName: 'โปรดเลือกชื่อช่องทาง',
  },
  financeMangement: {
    creditAccount: 'บัญชีเครดิต',
    prepaidAccount: 'บัญชีเติมล่วงหน้า',
    enableConfirmation:
      'เมื่อเปิดใช้งานสำเร็จ หน่วยงานตามสัญญานี้จะรองรับการพักหนี้ในบัญชี ต้องการเปิดใช้งานหรือไม่?',
    disableConfirmation:
      'เมื่อปิดใช้งานสำเร็จ หน่วยงานตามสัญญานี้จะไม่รองรับการพักหนี้ในบัญชีอีกต่อไป ต้องการปิดใช้งานหรือไม่?',
  },
  foodRoomAccountFinance: {
    foodSource: 'แหล่งที่มาของอาหาร',
    foodRoomAccountLabel: 'บัญชีห้องอาหาร',
    foodOrderNo: 'เลขที่คำสั่งซื้อ Food',
    fmisAccountSerialNo: 'เลขที่รายการบัญชี FMIS',
    chargedAmount: 'จำนวนเงินค้างชำระ',
    notAllowedSplit: 'บัญชีห้องอาหารไม่สามารถแยกบิลได้',
    notAllowedRush: 'บัญชีห้องอาหารไม่สามารถกลับรายการได้',
    notAllowedTransfer: 'บัญชีห้องอาหารไม่สามารถโอนได้',
    notAllowedPartialSettlement: 'บัญชีห้องอาหารไม่รองรับการชำระบางส่วน',
  },
  financeMixin: {
    onlinePaymentAccountsAreNotAllowedToOpen: 'หัวข้อบัญชีการชำระเงินออนไลน์ไม่อนุญาตให้แยกบัญชี',
    smallCommodityAccountsCanNotBeDismantled: 'หัวข้อบัญชีสินค้าชิ้นเล็กไม่อนุญาตให้แยกบัญชี',
    negativeDebtCannotBeBroken: 'บัญชีติดลบไม่สามารถแยกบัญชีได้',
    accountsReceivableAreNotAllowedToBeDebunked: 'หัวข้อบัญชีลูกหนี้ไม่อนุญาตให้แยกบัญชี',
    debitsAreNotAllowedInThisAccount: 'หัวข้อบัญชีนี้ไม่อนุญาตให้แยกบัญชี',
    onlinePaymentRefundAccountDoesNotAllowForChargebacks:
      'บัญชีคืนเงินการชำระออนไลน์ไม่อนุญาตให้ทำรายการตัดล้าง',
    theAccountHasBeenRefundedAndCannotBeCharged: 'บัญชีนี้ได้ถูกคืนเงินแล้ว ไม่สามารถตัดล้างได้',
    refundedAccountsCannotBeCharged: 'บัญชีที่คืนเงินแล้วไม่สามารถตัดล้างได้',
    thisAccountIsNotAllowedToBeCharged: 'หัวข้อบัญชีนี้ไม่อนุญาตให้ตัดล้าง',
    businessDayHasBeenSwitchedNoChargeIsAllowed: 'วันทำการถูกสลับแล้ว ไม่อนุญาตให้ตัดล้าง',
    borrow: 'แยกบัญชี',
    transfer: 'โอนบัญชี',
    offset: 'ตัดล้างบัญชี',
    refund: 'คืนเงินมัดจำ',
  },
  detailcomponentsAccountlisttable: {
    // Part 10, lines 1801 to 2000
    onAccount: 'พักหนี้ในบัญชีแล้ว',
  },
  detailcomponentsAddjudge: {
    theRoomChargeIsExcessive: 'ค่าห้องที่คิดเพิ่มสูงเกินไป',
    chargeJudgment: 'การพิจารณาการคิดเพิ่ม',
    addOnOption: 'ตัวเลือกการคิดเพิ่ม',
    generatedRoomCharge: 'สร้างค่าห้อง',
    pleaseFillInTheAdditionalRoomCharge: 'โปรดกรอกค่าห้องที่คิดเพิ่ม',
    theAdditionalAmountCannotBe0: 'จำนวนเงินที่คิดเพิ่มต้องไม่เป็น 0',
  },
  detailcomponentsAdjustaccounts: {
    reconciliationSuccess: 'ปรับบัญชีสำเร็จ',
    accountAdjustment: 'ปรับบัญชี',
    accountOfReconciliation: 'หัวข้อบัญชีที่ปรับ',
    incorrectTransferAmountFormatupToTwoDecimalPlaces:
      'รูปแบบจำนวนเงินที่ปรับไม่ถูกต้อง (ทศนิยมได้ไม่เกินสองตำแหน่ง)',
    theTransferAmountCannotBe: 'จำนวนเงินที่ปรับต้องไม่เป็น',
    theTransferAmountCannotBeGreaterThan100Million: 'จำนวนเงินที่ปรับต้องไม่เกินหนึ่งร้อยล้าน',
  },
  detailcomponentsArsuitselect: {
    receivableSet: 'ชุดบัญชีลูกหนี้',
    creditOrderCheckoutTip: 'คำสั่งซื้อเครดิตสเตย์ต้องบันทึกเป็นลูกหนี้เมื่อเช็คเอาต์',
    nonProtocolOrderArTip: 'คำสั่งซื้อที่ไม่ใช่หน่วยงานตามสัญญาไม่สามารถบันทึกเป็นลูกหนี้ได้',
  },
  detailcomponentsBackout: {
    closedSuccessfully: 'ยกเลิกการปิดบัญชีสำเร็จ',
    cancelAccount: 'ยกเลิกการปิดบัญชี',
    confirmationRevocation: 'ยืนยันการยกเลิก',
    pleaseSelectTheBillYouWantToCancel: 'โปรดเลือกบิลที่ต้องการยกเลิกการปิดบัญชี',
  },
  detailcomponentsBorrow: {
    return: 'ส่งคืน',
    itemBorrowingReminder: 'การแจ้งเตือนการยืมของ',
    borrowARoom: 'ยืมห้อง',
    quantityBorrowed: 'จำนวนที่ยืม',
    returnQuantity: 'จำนวนที่คืน',
    loanDate2: 'วันที่ยืม',
    returnOrNot: 'คืนหรือไม่',
    whetherToReturnAll: 'คืนทั้งหมดหรือไม่',
    amountOfCompensation: 'จำนวนเงินชดใช้',
    onlyNumbersGreaterThan0CanBeEntered: 'กรอกได้เฉพาะตัวเลขที่มากกว่า 0',
    partOfTheReturnCanOnlyBeLessThanTheAmountBorrowed: 'จำนวนที่คืนบางส่วนต้องน้อยกว่าจำนวนที่ยืม',
    returned: 'คืนแล้ว',
    noReturn: 'ยังไม่คืน',
    returnSuccessfully: 'คืนสำเร็จ',
  },
  detailcomponentsColorblock: {
    financialType: 'ประเภทธุรกรรมการเงิน',
    accountingType: 'ประเภทรายการบัญชี',
    orderForGoods: 'ออเดอร์',
  },
  detailcomponentsCommon: {
    unionpayScanCode: 'UnionPay-สแกนโค้ด',
    insufficientMemberBalance: 'ยอดคงเหลือสมาชิก {balance}  โปรดเลือกผู้รับเงินรายอื่น',
  },
  detailcomponentsCreditsettletip: {
    creditSettleAlert:
      'แจ้งเตือน: ออเดอร์เครดิตเข้าพักของ 飞猪 ค่าห้องที่ปิดบัญชีจริง {roomRate}  และยอดที่ไม่ใช่ค่าห้อง {nonRoomRate}  โปรดตรวจสอบจำนวนเงินให้ถูกต้องก่อนส่งปิดบัญชีเช็คเอาต์',
  },
  detailcomponentsDivideaccounts: {
    additionalDebits: 'เพิ่มการแยกบัญชี',
    totalAmount: 'ยอดรวม',
    totalDebitsTaken: 'ยอดที่แยกบัญชีแล้วรวม',
    totalUndismantledLoans: 'ยอดที่ยังไม่ได้แยกบัญชีรวม',
    successfulDismantling: 'แยกบัญชีสำเร็จ',
    borrowMoney: 'แยกบัญชี',
    loanAmount: 'จำนวนเงินที่แยกบัญชี',
    upTo150Words: 'ได้สูงสุด 150 ตัวอักษร',
    closedAccount: 'แยกบัญชีแล้ว',
    tenAtMost: 'แยกบัญชีได้ไม่เกินสิบรายการ',
    theAmountOfDebitsIsNotEqualToTheTotalAmount: 'ยอดเงินที่แยกบัญชีไม่เท่ากับยอดรวม',
    theDebitAmountMustBeFilledInAndGreaterThan: 'ยอดเงินที่แยกบัญชีต้องกรอกและต้องมากกว่า',
  },
  detailcomponentsEnteraccount: {
    breakfastType: 'ประเภทอาหารเช้า',
    includedBreakfast: 'อาหารเช้ารวมในค่าห้อง',
    purchasedBreakfast: 'อาหารเช้าที่ซื้อเพิ่ม',
    unitPrice: 'ราคาต่อหน่วย',
    servings: 'จำนวนชุด',
    mealDate: 'วันที่รับประทาน',
    selectMultipleDates: 'เลือกหลายวัน',
    selectedDays: 'จำนวนวันทั้งหมด: {count}',
    cashCnyReceipt: 'รับเงินสดสกุลเงิน',
    accountEntry: 'หัวข้อบัญชีที่บันทึก',
    amountRecorded: 'จำนวนเงินที่บันทึก',
    pleaseFillInTheAmountOfPayment: 'โปรดกรอกจำนวนเงินที่บันทึก',
    pleaseSelectAPaymentMethod: 'โปรดเลือกวิธีการชำระเงิน',
    entriesCannotBeEmpty: 'หัวข้อบัญชีที่บันทึกต้องไม่เว้นว่าง',
    theAmountRecordedCannotBe: 'จำนวนเงินที่บันทึกต้องไม่เป็น 0',
    pleaseFillInUnitPrice: 'โปรดกรอกราคาต่อหน่วย',
    unitPriceCannotBeZero: 'ราคาต่อหน่วยต้องไม่เป็น 0',
    pleaseFillInServings: 'โปรดกรอกจำนวนชุด/ที่',
    servingsCannotBeZero: 'จำนวนชุด/ที่ต้องไม่เป็น 0',
    pleaseSelectMealDate: 'โปรดเลือกวันที่รับประทาน',
    ArRefundCannotExceedBalance: 'จำนวนเงินคืน Ar ต้องไม่มากกว่ายอดคงเหลือ Ar',
  },
  detailcomponentsExpandcolumn: {
    memberName: 'ชื่อสมาชิก',
    receivableSet: 'ชุดบัญชีลูกหนี้',
    from: 'จาก',
    orderForGoods: 'ออเดอร์',
    rollOutTo: 'โอนไปยัง',
    refundedAmount: 'คืนแล้ว: {amount} ',
  },
  detailcomponentsHangaccounts: {
    checkOut: 'เช็คเอาต์พักหนี้ในบัญชี',
    reasonForPayment: 'เหตุผลการพักหนี้ในบัญชี',
  },
  detailcomponentsHourroomfeeconfirm: {
    roomRateConfirmation: 'ยืนยันค่าห้อง',
    roomRate2: 'จำนวนเงินค่าห้อง',
  },
  detailcomponentsPartsettle: {
    partialClosing: 'ปิดบัญชีบางส่วน',
    pleaseFillInTheAmountOfPayment: 'โปรดกรอกจำนวนเงินที่ชำระ',
    pleaseSelectAPaymentHistory: 'โปรดเลือกรายการชำระเงิน',
  },
  detailcomponentsPreauthcheck: {
    authorizedSettlement: 'การชำระเงินแบบได้รับอนุมัติ',
  },
  detailcomponentsPreauthtemplate: {
    cancelAuthorizationPleaseWait: 'กำลังยกเลิกการอนุมัติ โปรดรอสักครู่',
    succeededInCancelingAuthorization: 'ยกเลิกการอนุมัติสำเร็จ',
    thereIsAnOutstandingPreAuthorizationRecordInTheRoom:
      'มีรายการพรีออธอไรซ์ที่ยังไม่ชำระในห้องนี้',
    confirmThatYouWantToCancelAuthorization: 'ยืนยันว่าต้องการยกเลิกการอนุมัติหรือไม่',
    roomPaymentRequired: 'ห้องพักต้อง{action} จำนวนเงิน:',
    orderCanceledWarning: 'ออเดอร์ถูกยกเลิกแล้ว ไม่สามารถ{action}ได้',
    roomCheckedInWarning: 'ห้องอยู่ในสถานะ “เข้าพักแล้ว” ไม่สามารถ{action}ได้',
    roomCheckedOutWarning: 'สถานะห้องเป็น “เช็คเอาต์แล้ว” ไม่สามารถ{action}ได้',
  },
  detailcomponentsRefundtip: {
    refundReminder: 'การแจ้งเตือนการคืนเงิน',
    whenUsingAnOnlineRefundTheAmountWillBeRefundedToTheAccountFromWhichTheGuestPaid:
      'เมื่อใช้การคืนเงินแบบออนไลน์ จำนวนเงินจะถูกคืนไปยังบัญชีที่แขกใช้ชำระเงิน',
    whenUsingAOneCardRefundSystem:
      'เมื่อดำเนินการคืนเงินโดยใช้บัตรเติมเงิน จำนวนเงินจะถูกคืนเข้าบัญชีการชำระเงินของลูกค้า',
  },
  detailcomponentsSmallwarecost: {
    smallwares: 'สินค้าชิ้นเล็ก',
    smallGoodsEnteredTheAccountSuccessfully: 'บันทึกบัญชีสินค้าชิ้นเล็กสำเร็จ',
    smallGoodsAreAccountedFor: 'บันทึกบัญชีสินค้าชิ้นเล็ก',
    payOrNot: 'ชำระเงินหรือไม่',
    pleaseEnterTheExternalOrderNumber: 'โปรดกรอกหมายเลขออเดอร์ภายนอก',
    pleaseSelectASmallItem: 'โปรดเลือกสินค้าชิ้นเล็ก',
    insufficientMemberBalance: 'ยอดคงเหลือสมาชิก {balance}  โปรดเลือกผู้รับเงินรายอื่น',
  },
  detailcomponentsTransferaccounts: {
    transferMoney: 'โอนบัญชี',
    transferToAccount: 'โอนไปยังบัญชี',
    pleaseSelectValidTransferAccount: 'โปรดเลือกบัญชีปลายทางที่ใช้ได้',
    transferSuccess: 'โอนบัญชีสำเร็จ',
    batchTransferSuccess: 'โอนบัญชีแบบกลุ่มสำเร็จ',
  },
  mangementMember: {
    orderType: 'ประเภทรายการสั่งซื้อ',
    receivableOrders: 'ออเดอร์บัญชีลูกหนี้',
    totalAmountNotApproved: 'ยอดรวมที่ยังไม่ตรวจสอบ',
    approvedTotalAmount: 'ยอดรวมที่ตรวจสอบแล้ว',
    amountAvailable: 'ยอดที่ใช้ได้',
    amountSpent: 'ยอดที่ใช้ไปแล้ว',
    whetherToWriteOffAllTheReceivables: 'ต้องการหักล้างบัญชีลูกหนี้ทั้งหมดหรือไม่',
    whetherToReverseWriteOffAllTheReceivables: 'ต้องการหักล้างกลับบัญชีลูกหนี้ทั้งหมดหรือไม่',
    cancelAfterVerification: 'หักล้าง',
    reverseWriteOff: 'หักล้างกลับ',
    depositInAdvance: 'เงินมัดจำล่วงหน้า',
    dateOfPosting: 'วันที่พักหนี้ในบัญชี',
    pleaseEnterTheOrderNumber: 'โปรดกรอกหมายเลขออเดอร์',
    completeWriteOff: 'หักล้างทั้งหมด',
    completeReverseWriteOff: 'หักล้างทั้งหมดกลับ',
    batchWriteOff: 'หักล้างแบบกลุ่ม',
    records: 'บันทึก',
    advanceCredit: 'บันทึกเงินมัดจำ',
    thePrepaidAmountMustBeGreaterThanZero: 'จำนวนเงินมัดจำต้องมากกว่า 0',
    theAmountInAdvanceCannotBeGreaterThan100Million: 'จำนวนเงินมัดจำต้องไม่เกินหนึ่งร้อยล้าน',
    checkTheDepartureDateUpToOneMonth: 'วันที่เช็คเอาต์สามารถค้นหาได้สูงสุดหนึ่งเดือน',
    noAccountPleaseCreateANewOne: 'ยังไม่มีชุดบัญชี โปรดสร้างใหม่',
    allWereSuccessfullyWrittenOff: 'หักล้างทั้งหมดสำเร็จ',
    allWriteOffsFailed: 'หักล้างทั้งหมดล้มเหลว',
    noWriteOffIsAllowedOnTheDayReceivableIsGenerated:
      'ไม่อนุญาตให้หักล้างในวันที่สร้างบัญชีลูกหนี้',
    pleaseSelectTheItemsYouWantToWriteOff: 'โปรดเลือกโครงการที่ต้องการหักล้าง',
    listOfAccountsReceivable3XLS: 'รายชื่อบัญชีลูกหนี้.xls',
    prepaymentAmountRequired: 'โปรดกรอกจำนวนเงินมัดจำ',
    prepaymentAmountFormatError: 'รูปแบบจำนวนเงินมัดจำไม่ถูกต้อง (ทศนิยมได้ไม่เกินสองตำแหน่ง)',
  },
  mangementTablerow: {
    paidInAmount: 'ยอดที่รับจริง',
  },
  mangementVerificatemodal: {
    successfulWriteOff: 'หักล้างสำเร็จ',
    cancelAfterVerification: 'หักล้าง',
    reverseWriteOff: 'หักล้างกลับ',
    generationTime: 'เวลาที่สร้าง',
    amountWrittenOff2: 'จำนวนเงินที่หักล้าง',
    pleaseFillInTheWriteOffAmount: 'โปรดกรอกจำนวนเงินที่หักล้าง',
    theAmountToBeWrittenOffCannotBeGreaterThanTheAmountThatCanBeWrittenOff:
      'จำนวนเงินที่หักล้างต้องไม่มากกว่ายอดที่หักล้างได้',
  },
  mangementVerifyrecordsmodal: {
    records: 'บันทึก',
    lot: 'รอบที่',
  },
  merchantChargeList: {
    accumulatedUncreditedNightsInArrearsDuringTheContractPeriod:
      'จำนวนคืนห้องค้างหักสะสมในช่วงอายุสัญญา',
    hideZeroAmounts: 'ไม่แสดงรายการที่เป็น 0 ทั้งหมด',
  },
  merchantCheckBill: {
    confirmationCheck: 'ยืนยันการตรวจสอบ',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
      'หลังยืนยันแล้วจะทำการชำระบัญชีตามบิลนี้',
    appealChannel: 'ช่องทางการอุทธรณ์',
    causeOfAppeal: 'เหตุผลการอุทธรณ์',
    youCanEnterUpTo150Words: 'กรอกได้สูงสุด 150 ตัวอักษร',
    accountName: 'ชื่อบัญชีธนาคาร',
    roomBillCheck: 'ตรวจสอบบิลค่าห้อง',
    memberIncentiveCheck: 'ตรวจสอบแรงจูงใจสมาชิก',
    confirmed: 'ยืนยันแล้ว',
    reasonForAdjustment: 'เหตุผลการปรับ',
    deductibleTarget: 'เป้าหมายที่นำไปหักล้าง',
    currentDeduction: 'ยอดหักล้างรอบนี้',
    deductible: 'ยอดที่หักล้างแล้ว',
    confirmationTime: 'เวลายืนยัน',
    rejectionTime: 'เวลาปฏิเสธ',
    // Part 11, lines 2001 to 2200
    liveLightlyInTheDirectCamp: 'ดำเนินการโดยตรงของ Qingzhu',
    new: 'เพิ่มใหม่',
    appealSuccessfully: 'อุทธรณ์สำเร็จ',
    checkSuccessfully: 'ตรวจสอบสำเร็จ',
    currDeductionDesc:
      '1. ยอดหักลบงวดนี้เป็นบวก หมายถึง Qingzhu หักเงินจากร้านค้า 2. ถ้าเป็นลบ หมายถึงคืนเงินให้ร้านค้า',
    qzMerchantSettleDesc: 'การชำระบัญชีกับร้านค้า Qingzhu = ยอดคำสั่งซื้อทั้งหมด - ยอดหักลบงวดนี้',
  },
  merchantInfoManage: {
    changeLetter: 'หนังสือเปลี่ยนแปลง',
    note: 'หมายเหตุ',
    paymentCanOnlyBeMadeAfterTheModificationOfTheReceivingAccountIsApprovedIfTheCurrentSettlementPaymentIsToBePaidThePaymentWillStillBeMadeAccordingToTheOriginalAccount:
      'บัญชีรับเงินต้องผ่านการตรวจสอบก่อนจึงจะสามารถโอนเงินได้ หากมียอดที่ต้องโอนอยู่ในปัจจุบัน จะยังโอนเข้าบัญชีเดิม',
    groundsForRejection: 'เหตุผลการปฏิเสธ',
    downloadTheAttachmentTemplate2: 'ดาวน์โหลดแม่แบบไฟล์แนบ',
    viewingModificationLogs2: 'ดูบันทึกการแก้ไข',
    thisSettlementInformationIsUsedForRoomFeeSettlementAndCanOnlyBeModifiedByTheHotelOwnerPleaseAddItWithCaution:
      'ข้อมูลการชำระบัญชีนี้ใช้สำหรับการ结算ค่าห้อง สามารถแก้ไขได้เฉพาะเจ้าของโรงแรม โปรดเพิ่มอย่างระมัดระวัง',
    thisAccountIsUsedForTheSettlementOfRoomChargesAndCanOnlyBeModifiedByTheHotelOwnerPleaseModifyItCarefullyUploadTheChangeLetterAndAffixTheOfficialSealAsRequired:
      'บัญชีรับเงินนี้ใช้สำหรับการ结算ค่าห้อง สามารถแก้ไขได้เฉพาะเจ้าของโรงแรม โปรดแก้ไขอย่างระมัดระวัง อัปโหลดหนังสือเปลี่ยนแปลงพร้อมประทับตราตามข้อกำหนด',
    modifyLog2: 'บันทึกการแก้ไข',
    beforeModification3: 'ก่อนแก้ไข',
    receivablesAccountManagement2: 'การจัดการบัญชีรับเงิน',
    bankAccountName4: 'ชื่อบัญชีธนาคาร',
    letterOfRequestForChange2: 'หนังสือขอเปลี่ยนแปลง',
    pleaseEnterYourBankName2: 'โปรดกรอกชื่อบัญชีธนาคาร',
    pleaseUploadTheRequestForChange2: 'โปรดอัปโหลดหนังสือขอเปลี่ยนแปลง',
    afterModification2: 'หลังแก้ไข',
    afterDownloadingTheApplicationChangeLetterYouNeedToPrintItOutSignAndSealItAndThenUploadThePictureOrPdfFile:
      'หลังดาวน์โหลดหนังสือขอเปลี่ยนแปลงแล้ว โปรดพิมพ์ออกมา ลงนาม ประทับตรา แล้วอัปโหลดเป็นรูปภาพหรือไฟล์ PDF',
    onlyJpgPngAndPdfFilesCanBeUploaded: 'รองรับเฉพาะไฟล์ jpg, png, pdf',
  },
  merchantMerchantHelper: {
    smallProgramSettlementRules: 'ปัญหากฎการชำระบัญชีของมินิโปรแกรม',
    settlementOfPaymentProblems: 'ปัญหาการโอนเงินชำระบัญชี',
    smallProgramSettlementRulesCommonProblems: 'คำถามพบบ่อยเกี่ยวกับกฎการชำระบัญชีมินิโปรแกรม',
    frequentlyAskedQuestionsAboutSettlementPayments: 'คำถามพบบ่อยเกี่ยวกับการโอนเงิน',
    q1SettlementCriteria: 'Q1: ใบแจ้งหนี้แบบใดสามารถชำระบัญชีได้?',
    a1SettlementCriteria: 'ใบแจ้งหนี้จะชำระได้เมื่อคำสั่งซื้อเสร็จสมบูรณ์และลูกค้าเช็คเอาต์แล้ว',
    q2PmsCancellation: 'Q2: หากบิล PMS ถูกยกเลิกต้องทำอย่างไร?',
    a2PmsCancellation:
      'หาก PMS อยู่ในสถานะยกเลิก และต้องคืนเงินให้ลูกค้า กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อตามขั้นตอนการคืนเงิน',
    q1AuditTime: 'Q1: เวลาการตรวจสอบใบแจ้งหนี้คือเมื่อไหร่?',
    a1AuditTime:
      'ก่อนวันศุกร์ของแต่ละสัปดาห์ จะอัปโหลดใบแจ้งหนี้เชื่อมต่อโดยตรงของสัปดาห์ถัดไป ร้านค้าสามารถยืนยันได้ในวันพฤหัสบดีเพื่อดำเนินการโอนได้',
    q2PaymentTime: 'Q2: ร้านค้ายืนยันใบแจ้งหนี้แล้ว จะโอนเงินเมื่อไหร่?',
    a2PaymentTime:
      'ร้านค้าที่ได้ยืนยันจะโอนเงินในวันพฤหัสบดี หากโอนล้มเหลวจะโอนซ้ำในวันพฤหัสบดี–ศุกร์',
    q3CheckPayment: 'Q3: ตรวจสอบได้อย่างไรว่ามีการโอนเงินแล้ว?',
    a3CheckPayment: 'ร้านค้าสามารถตรวจสอบได้ในหน้า "ประวัติการโอนเงิน"',
    q4RejectedStatement: 'Q4: หากใบแจ้งหนี้ถูกปฏิเสธ จะทำอย่างไร? โอนเมื่อไหร่?',
    a4RejectedStatement:
      'ใบแจ้งหนี้ที่ถูกปฏิเสธจะตรวจสอบใหม่โดยสำนักงานใหญ่ หากร้านค้ายืนยันก่อนวันพฤหัสบดี จะโอนในวันพฤหัสบดี ถ้าไม่ยืนยันจะเลื่อนไปงวดถัดไป',
  },
  merchantRemitRecord: {
    roomChargePaymentRecords: 'ประวัติการโอนค่าห้อง',
    memberIncentiveRecord: 'ประวัติเงินจูงใจสมาชิก',
    fundsToBeRemitted: 'รอโอนเงิน',
    remitting: 'กำลังโอน',
    remittedMoney: 'โอนแล้ว',
    paymentFailure2: 'โอนเงินล้มเหลว',
    collectionAccount: 'บัญชีรับเงิน',
    payee: 'ผู้รับเงิน',
    statusUpdateTime: 'เวลาที่อัปเดตสถานะ',
    paymentTime: 'เวลาโอนเงิน',
    timeToInitiateAPayment: 'เวลาเริ่มต้นการโอนเงิน',
  },
  merchantSettleInfo: {
    pleaseScanTheQrCodeOfYourCloudAccountToBindYourBankCard:
      'โปรดสแกน QR โค้ดบัญชี Cloud เพื่อผูกบัตรธนาคาร',
    bindBankCard: 'ผูกบัตรธนาคาร',
    completeInformation: 'ข้อมูลส่วนบุคคล',
    bankAccountName4: 'ชื่อบัญชีธนาคาร',
    idNumber: 'หมายเลขบัตรประชาชน',
    pleaseEnterYourBankName2: 'โปรดกรอกชื่อบัญชีธนาคาร',
    pleaseEnterYourIdNumber2: 'โปรดกรอกหมายเลขบัตรประชาชน',
    idNumberFormatIsIncorrectPleaseReEnter: 'รูปแบบหมายเลขบัตรประชาชนไม่ถูกต้อง โปรดกรอกใหม่',
    phoneNumberFormatIsIncorrectPleaseReEnter: 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง โปรดกรอกใหม่',
    pleaseUpload: 'โปรดอัปโหลด',
    internalUserHidden: 'ซ่อนไม่ให้ผู้ใช้ภายในเห็น',
    amountPendingPayment: 'จำนวนเงิน {amount} จะถูกโอนในภายหลัง',
  },
  billCheckBillDetails: {
    channelDetails: 'รายละเอียดช่องทาง',
    whereToConnectDirectly: 'Qunar Direct Connect',
    drench: 'Qingzhu',
    cityWide: 'ภายในเมืองเดียวกัน',
    whereToGo: 'Qunar',
    distribution: 'การกระจาย',
    tradeCaravan: 'ธุรกิจท่องเที่ยว',
    statementOfAccount: 'ใบแจ้งยอดบัญชี',
    qzSettleFormula:
      'การชำระบัญชีกับร้านค้า Qingzhu = ยอดชำระคำสั่งซื้อ + ยอดคืนเงินที่ร้านค้ารับผิดชอบ + ส่วนลดที่ร้านค้ารับผิดชอบ + เงินกิจกรรมสาธารณะของร้านค้า',
    merchantDiscountNote: 'เมื่อมีการคืนเงินในรอบนี้ ร้านค้ารับภาระส่วนลด = 0',
  },
  billCheckBill: {
    turnDown: 'ปฏิเสธ',
    ticketReceived: 'รับใบเสร็จแล้ว',
    forThePublic: 'บัญชีบริษัท',
    forPrivacy: 'บัญชีส่วนตัว',
    expenseDetail: 'รายละเอียดค่าใช้จ่าย',
    confirmationCheck: 'ยืนยันการตรวจสอบ',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
      'เมื่อยืนยันแล้ว จะชำระบัญชีตามใบแจ้งหนี้นี้',
    perfectInformation: 'กรอกข้อมูลให้สมบูรณ์',
    causeOfAppeal: 'เหตุผลการอุทธรณ์',
    youCanEnterUpTo150Words: 'กรอกได้สูงสุด 150 ตัวอักษร',
    creditDetails: 'รายละเอียดการหักล้าง',
    roomNightCreditDetails: 'รายละเอียดการหักล้างจำนวนคืนห้อง',
    invoiceManagement: 'การจัดการใบกำกับภาษี',
    sellersName: 'ชื่อผู้ขาย',
    invoiceNumber: 'หมายเลขใบกำกับภาษี',
    invoiceDate: 'วันที่ออกใบกำกับภาษี',
    invoiceAmount2: 'จำนวนเงินใบกำกับภาษี',
    electronicInvoiceOrNot: 'เป็นใบกำกับภาษีอิเล็กทรอนิกส์หรือไม่',
    invoiceFile: 'ไฟล์ใบกำกับภาษี',
    reasonForRejectingInvoice: 'เหตุผลการปฏิเสธใบกำกับภาษี',
    theTotalAmountOfTheOrderIncludesTheAmountOfThePreviousBillAndTheMerchantSettlementAmountLessThan0:
      'ยอดรวมคำสั่งซื้อรวมยอดติดลบของงวดก่อนที่ Qingzhu ชำระให้ร้านค้าแล้ว',
    quantityDueForTheCurrentPeriod: 'จำนวนที่ควรหักล้างในรอบนี้',
    actualAmountOfDeductionForTheCurrentPeriod: 'จำนวนที่หักล้างจริงในรอบนี้',
    amountDeductedForTheNightOfThePeriod: 'จำนวนเงินหักล้างคืนห้องในรอบนี้',
    uncreditedQuantityForTheCurrentPeriod: 'จำนวนที่ยังไม่หักล้างในรอบนี้',
    pleaseEnter150WordsOrLess: 'โปรดกรอกไม่เกิน 150 ตัวอักษร',
    pleaseEnterTheInvoiceHoldersInformation: 'โปรดกรอกข้อมูลผู้ออกใบกำกับภาษี',
    pleaseEnterTheInvoiceNumber: 'โปรดกรอกหมายเลขใบกำกับภาษี',
    pleaseEnterExpiryDate2: 'โปรดกรอกวันที่หมดอายุ',
    pleaseSelectTheInvoiceType: 'โปรดเลือกประเภทใบกำกับภาษี',
    pleaseSelectWhetherToEInvoice: 'โปรดเลือกว่าเป็นใบกำกับภาษีอิเล็กทรอนิกส์หรือไม่',
    pleaseUploadTheInvoicePhoto: 'โปรดอัปโหลดรูปภาพใบกำกับภาษี',
    pleaseFillInTheAmount: 'โปรดกรอกจำนวนเงิน',
    specialTicket: 'ใบกำกับภาษีเฉพาะ',
    ordinaryTicket: 'ใบกำกับภาษีทั่วไป',
    expenseItem: 'รายการค่าใช้จ่าย',
    amountIncurred: 'ยอดที่เกิดขึ้น',
    source: 'แหล่งที่มา',
    instructions: 'คำอธิบาย',
    confirmationTime: 'เวลายืนยัน',
    groupReceiptStatus: 'สถานะการรับใบเสร็จของกลุ่ม',
    rejectionTime: 'เวลาปฏิเสธ',
    whetherTheInvoiceHasBeenEntered: 'ใบกำกับภาษีบันทึกแล้วหรือไม่',
    feeDetails: 'รายละเอียดค่าใช้จ่าย',
    fileUpload: 'อัปโหลดไฟล์',
    uploadAMaximumOf5Images: 'อัปโหลดภาพได้สูงสุด 5 ภาพ',
    appealSuccessfully: 'อุทธรณ์สำเร็จ',
    checkSuccessfully: 'ตรวจสอบสำเร็จ',
    theSizeOfTheUploadedCompressedPackageCannotExceed: 'ขนาดไฟล์บีบอัดที่อัปโหลดต้องไม่เกิน',
    onlyTheUploadFormatIsSupported: 'รองรับเฉพาะรูปแบบไฟล์',
    theCompressedPackageFileCannotBeLargerThan: 'ไฟล์บีบอัดต้องมีขนาดไม่เกิน',
    amountOfDeductionForTheCurrentPeriod: 'จำนวนเงินหักล้างรอบนี้',
    theMerchantNeedsToInvoiceTheAmount: 'จำนวนเงินที่ร้านค้าต้องออกใบกำกับภาษี',
    billingDetails: 'รายละเอียดใบแจ้งหนี้',
    currentAdrAmount: 'จำนวน ADR รอบนี้',
    settlementSystemUpgrade:
      'เพื่อให้เป็นไปตามข้อกำหนดของธนาคารในการชำระเงิน และเพื่อเพิ่มประสิทธิภาพการชำระบัญชี กลุ่มบริษัทได้อัปเกรดระบบชำระบัญชี และจำเป็นต้องให้ร้านค้าอัปโหลดข้อมูลคุณสมบัติตามที่ธนาคารกำหนดเพิ่มเติม',
    confirmPreviousBills:
      'กรุณายืนยันใบแจ้งหนี้งวดก่อน มิฉะนั้นใบแจ้งหนี้งวดใหม่จะไม่สามารถแสดงได้',
    paperInvoiceInstructions:
      'ใบกำกับภาษีแบบกระดาษ การจัดส่งต้องเป็นผู้ส่งออกค่าใช้จ่าย หากเป็นพัสดุปลายทางชำระจะถูกปฏิเสธทั้งหมด ผู้รับใบกำกับภาษี: Qingzhu Distribution E-Invoice; โทรศัพท์: 15901580289 หากเป็นใบกำกับภาษีแบบกระดาษ จะตรวจสอบหลังจาก Qingzhu ได้รับใบภาษีแล้ว',
    uploadFormatRestrictions:
      'รองรับรูปแบบ pdf, รูปภาพ, word, 压缩包, ofd อย่างใดอย่างหนึ่งเท่านั้น pdf และ ofd สูงสุด 5 ไฟล์ ไฟล์ละไม่เกิน 3MB; รูปภาพสูงสุด 5 ไฟล์ ไฟล์ละไม่เกิน 3MB รองรับ jpg, jpeg, png; word รองรับสูงสุด 1 ไฟล์ 20MB; 压缩包 รองรับ 1 ไฟล์ สูงสุด 20MB รองรับ rar、zip、7z',
    cumulativeUndeductedNights: 'จำนวนคืนห้องค้างหักสะสมภายในสัญญา (ก่อนหักล้างรอบนี้)',
    invoiceDuplicate:
      'หมายเลขใบกำกับภาษีซ้ำ โปรดตรวจสอบ หากถูกต้อง โปรดระบุเหตุผลการใช้ซ้ำในหมายเหตุ',
    pdfSizeExceeded: 'ขนาด pdf ที่อัปโหลดต้องไม่เกิน 3MB!',
    ofdSizeExceeded: 'ขนาด ofd ที่อัปโหลดต้องไม่เกิน 3MB!',
    wordSizeExceeded: 'ขนาด word ที่อัปโหลดต้องไม่เกิน 20MB!',
    singleFormatOnly: 'รองรับเพียง 1 รูปแบบไฟล์เท่านั้น!',
  },
  billCheckMemberDetails: {
    memberIncentiveDetails: 'รายละเอียดเงินจูงใจสมาชิก',
    memberIncentiveStatement: 'ใบแจ้งยอดสิ่งจูงใจสมาชิก',
  },
  billDeductionDetails: {
    feeDetails: 'รายละเอียดค่าใช้จ่าย',
    statementDetailsSheet: 'รายการรายละเอียดใบแจ้งยอด',
  },
  billRemitRecord: {
    collectionAccount: 'บัญชีรับเงิน',
    payee: 'ผู้รับเงิน',
    statusUpdateTime: 'เวลาที่อัปเดตสถานะ',
    timeToInitiateAPayment: 'เวลาเริ่มต้นการโอนเงิน',
    paymentTime: 'เวลาโอนเงิน',
  },
  billCheckDetails: {
    channelOrderDetails: 'รายละเอียดออเดอร์ช่องทาง',
    merchantRefunds: 'ร้านค้ารับภาระคืนเงิน',
    merchantConcession: 'ร้านค้ารับภาระส่วนลด',
    channelOrderNumber: 'หมายเลขออเดอร์ช่องทาง',
    reasonForAdjustment3: 'เหตุผลการปรับ',
    adjustmentType: 'ประเภทการปรับ',
    originalOrderPrice: 'ราคาออเดอร์เดิม',
    memberDiscount: 'ส่วนลดสมาชิก',
    skimpingOnCommission: 'ค่าคอมมิชชั่นของ Qingzhu',
    payChannelCommission: 'ค่าคอมมิชชันช่องทางชำระเงิน',
    amountOfMerchantWelfare: 'ยอดสาธารณประโยชน์ร้านค้า',
    refundNight: 'จำนวนคืนห้องที่คืนเงิน',
    totalRefundAmount: 'ยอดคืนเงินรวม',
    stayEasyAndRefundCommission: 'ค่าคอมมิชชั่นคืนเงินของ Qingzhu',
    subsidy: 'เงินอุดหนุน',
    saleCardOrderNumber: 'หมายเลขออเดอร์ขายบัตร',
    membershipLevel: 'ระดับสมาชิก',
    dateOfRegistration: 'วันที่ลงทะเบียน',
    referrer: 'ผู้แนะนำ',
    amountPaid: 'ยอดชำระ',
    merchantsShareTheAmount: 'ยอดแบ่งกำไรร้านค้า',
    employeeShareAmount: 'ยอดแบ่งกำไรพนักงาน',
    shareAmount: 'ยอดแบ่งกำไร',
    rebateRatio: 'อัตราการคืนค่าคอมมิชชั่น',
    // Part 12, lines 2201 to 2400
    commissionRebate: 'จำนวนเงินคืนค่าคอมมิชชั่น',
    distributionSubchannel: 'ช่องทางย่อยการกระจาย',
    channelCost: 'ราคาต้นทางของช่องทาง',
    lightSettlementWithMerchantsOrder: 'การชำระบัญชีกับร้านค้า Qingzhu (คำสั่งซื้อ)',
    lightUndertakeDiscounts: 'ส่วนลดที่ Qingzhu รับผิดชอบ',
  },
  billDedetails: {
    currentAmountReceivable: 'ยอดที่ต้องรับรอบนี้',
    amountOfDeductionForTheCurrentPeriod: 'จำนวนเงินหักล้างรอบนี้',
    remainingAmountOfDeduction: 'ยอดหักล้างที่เหลือ',
    pleasureManagementFee: 'ค่าบริหาร Enjoy',
    brandManagementFee: 'ค่าบริหารแบรนด์',
    mastersCommission: 'ค่าผู้จัดการร้าน',
    otherExpenses: 'ค่าใช้อื่น ๆ',
    openingDate: 'วันที่เปิดกิจการ',
    preferentialPolicy: 'นโยบายส่วนลด',
    managementFeeStartDate: 'วันที่เริ่มเก็บค่าบริหาร',
    thisPeriodOfBusinessSelfPromotion: 'ยอดโปรโมตเองของร้านค้ารอบนี้',
    enjoyCommissionRate: 'อัตราค่าคอมมิชชั่น Enjoy',
    enjoyManagementFeeForThisPeriod: 'ค่าบริหาร Enjoy งวดนี้',
    currentAdjustmentExpense: 'ค่าใช้จ่ายที่ปรับรอบนี้',
    reasonsForAdjustingExpensesInTheCurrentPeriod: 'เหตุผลการปรับค่าใช้จ่ายรอบนี้',
    notPaidInThePreviousPeriod: 'ยอดค้างชำระรอบก่อน',
    currentReceivable: 'ยอดที่ต้องรับรอบนี้',
    currentPaid: 'ยอดที่ชำระแล้วรอบนี้',
    balanceDue: 'ยอดคงค้างต้องชำระ',
    brandCommissionRate: 'อัตราค่าคอมมิชชันแบรนด์',
    currentBrandManagementFee: 'ค่าบริหารแบรนด์รอบนี้',
    monthlyRate: 'อัตราค่าบริหารรายเดือน',
    currentObjective: 'เป้าหมายรอบนี้',
    totalPmsRevenueForThePeriod: 'รายรับรวม PMS รอบนี้',
    totalPmsReceivableForThePeriod: 'ยอดต้องรับรวม PMS รอบนี้',
  },
  chargeIndex: {
    expenseItem: 'รายการค่าใช้จ่าย',
    totalAmountPayable: 'ยอดที่ต้องชำระรวม',
    cashPayable: 'ยอดเงินสดที่ต้องชำระ',
    creditPayable: 'ยอดหักล้างที่ต้องชำระ',
    deductionAdjustment: 'การปรับยอดหักล้าง',
    deductible: 'ยอดที่หักล้างแล้ว',
    residualCredit: 'ยอดหักล้างที่เหลือ',
    managementFeeStartDate: 'วันที่เริ่มเก็บค่าบริหาร',
    currentObjective: 'เป้าหมายรอบนี้',
    currentPeriodAdjustment: 'การปรับรอบนี้',
    notPaidInThePreviousPeriod: 'ยอดค้างชำระรอบก่อน',
    currentReceivable: 'ยอดที่ต้องรับรอบนี้',
    currentPaid: 'ยอดที่ชำระแล้วรอบนี้',
    balanceDue: 'ยอดคงค้างต้องชำระ',
  },
  commonIndex: {
    accountName: 'ชื่อบัญชี',
    collectionAccountType: 'ประเภทบัญชีรับเงิน',
    distributionRoomBillReconciliation: 'ตรวจสอบบิลค่าห้องของช่องทางการกระจาย',
    memberIncentiveCheck: 'ตรวจสอบเงินจูงใจสมาชิก',
    directSellingRoomFeePaymentRecords: 'ประวัติการโอนค่าห้องของการขายตรง',
    distributeRoomChargePaymentRecords: 'ประวัติการโอนค่าห้องของการกระจาย',
    memberIncentiveRecord: 'ประวัติเงินจูงใจสมาชิก',
    confirmed: 'ยืนยันแล้ว',
    reasonForAdjustment: 'เหตุผลการปรับ',
    settlementGrounds: 'เหตุผลในการชำระบัญชี',
    operationDetails: 'รายละเอียดการดำเนินการ',
    merchantRefunds: 'ร้านค้ารับภาระคืนเงิน',
    merchantConcession: 'ร้านค้ารับภาระส่วนลด',
    amountOfMerchantWelfare: 'ยอดสาธารณประโยชน์ร้านค้า',
    americanOrder: 'คำสั่งซื้อ Meituan',
    flyingPigOrder: 'คำสั่งซื้อ Fliggy',
    lightLiveMiniProgramOrder: 'คำสั่งซื้อจากมินิโปรแกรม Qingzhu',
    memberShareAmount: 'ยอดแบ่งกำไรสมาชิก',
    theAmountOfCrossStoreRefund: 'จำนวนเงินคืนค่าคอมมิชชั่นข้ามสาขา',
    lightlyAdjustTheAmount: 'จำนวนเงินปรับปรุงของ Qingzhu',
    reasonForAdjustment3: 'เหตุผลการปรับ',
    fundsToBeRemitted: 'รอโอนเงิน',
    remitting: 'กำลังโอนเงิน',
    remittedMoney: 'โอนเงินแล้ว',
    paymentFailure2: 'โอนเงินล้มเหลว',
    lightSettlementWithMerchantsOrder: 'การชำระบัญชีกับร้านค้า Qingzhu (คำสั่งซื้อ)',
  },
  infoInfoManage: {
    note: 'หมายเหตุ',
    theApplicationChangeLetterNeedsToBePrintedOutAndSignedWithTheOfficialSealAfterDownloadingIfThePrintIs2PagesPleaseAffixTheSealAndUploadThePicture:
      'หนังสือขอเปลี่ยนแปลงต้องพิมพ์ออกมา เซ็นชื่อ ประทับตรา หากมี 2 หน้าให้ประทับตราคั่น แล้วอัปโหลดรูปภาพ',
    submitAndModifyTheAuditProcessOfTheReceivingAccountOnlyAfterTheAuditIsPassedCanThePaymentBeMadeTheRejectedAccountWillNotBeMade:
      'การยื่นแก้ไขบัญชีรับเงินต้องผ่านการตรวจสอบก่อนจึงจะโอนได้ บัญชีที่ถูกปฏิเสธจะไม่ถูกโอน',
    beforeModification3: 'ก่อนแก้ไข',
    pleaseBePatientWhileTheInformationIsBeingReviewed: 'กำลังตรวจสอบข้อมูล โปรดรอ',
    groundsForRejection: 'เหตุผลการปฏิเสธ',
    downloadTheAttachmentTemplate2: 'ดาวน์โหลดแม่แบบไฟล์แนบ',
    forPrivacy: 'บัญชีส่วนบุคคล',
    forThePublic: 'บัญชีองค์กร',
    auditStatus: 'สถานะการตรวจสอบ',
    viewingModificationLogs2: 'ดูบันทึกการแก้ไข',
    pleaseUploadYourBankCardInformationAsSoonAsPossibleToAvoidAffectingYourPaymentProgress:
      'กรุณาอัปโหลดข้อมูลบัตรธนาคารโดยเร็วที่สุด เพื่อไม่ให้กระทบต่อความคืบหน้าการชำระเงิน',
    modifyLog2: 'บันทึกการแก้ไข',
    receivablesAccountManagement2: 'การจัดการบัญชีรับเงิน',
    collectionAccountType: 'ประเภทบัญชีรับเงิน',
    pleaseSelectACollectionAccountType: 'โปรดเลือกประเภทบัญชีรับเงิน',
    bankAccountName5: 'ชื่อบัญชีธนาคาร',
    recipientsCellPhoneNumber: 'เบอร์มือถือตัวรับเงิน',
    pleaseEnterTheRecipientsMobilePhoneNumber: 'โปรดกรอกเบอร์มือถือผู้รับเงิน',
    payeeIdNumber: 'หมายเลขบัตรประชาชนผู้รับเงิน',
    pleaseEnterThePayeeIdNumber: 'โปรดกรอกหมายเลขบัตรประชาชนผู้รับเงิน',
    payeeIdCardFront: 'ด้านหน้าบัตรประชาชนผู้รับเงิน',
    reverseOfPayeeIdCard: 'ด้านหลังบัตรประชาชนผู้รับเงิน',
    uploadContractAttachment: 'อัปโหลดไฟล์สัญญา',
    letterOfRequestForChange2: 'หนังสือขอเปลี่ยนแปลง',
    pleaseEnterTheBankAccountName: 'โปรดกรอกชื่อบัญชีธนาคาร',
    pleaseEnterTheLegalPersonName: 'โปรดกรอกชื่อผู้มีอำนาจ',
    legalPersonNameCanOnlyBeEnteredInChineseCharactersPleaseReEnter:
      'ชื่อผู้มีอำนาจต้องเป็นภาษาจีนเท่านั้น โปรดกรอกใหม่',
    phoneNumberFormatIsIncorrectPleaseReEnter: 'รูปแบบเบอร์มือถือไม่ถูกต้อง โปรดกรอกใหม่',
    pleaseEnterYourIdNumber2: 'โปรดกรอกหมายเลขบัตรประชาชน',
    idNumberFormatIsWrongCanOnlyEnterNumbersAndUppercaseLettersPleaseReEnter:
      'รูปแบบหมายเลขบัตรประชาชนผิด ต้องเป็นตัวเลขหรืออักษรตัวใหญ่เท่านั้น',
    pleaseEnterAUnifiedSocialCreditCode: 'โปรดกรอกรหัสสังคมเครดิตแบบรวม',
    onlyNumbersAndLettersAreSupportedPleaseReEnter: 'รองรับเฉพาะตัวเลขและตัวอักษร โปรดกรอกใหม่',
    pleaseUploadTheRequestForChange2: 'โปรดอัปโหลดหนังสือขอเปลี่ยนแปลง',
    frontOfIdentityCard: 'ด้านหน้าบัตรประชาชน',
    reverseOfIdCard: 'ด้านหลังบัตรประชาชน',
    businessLicense: 'ใบอนุญาตประกอบธุรกิจ',
    pleaseUploadTheContractAttachment: 'โปรดอัปโหลดไฟล์สัญญา',
    afterModification2: 'หลังแก้ไข',
    corporateName: 'ชื่อผู้มีอำนาจ',
    unifyTheSocialCreditCode: 'รหัสสังคมเครดิตแบบรวม',
    legalPersonMobilePhoneNumber: 'เบอร์มือถือตัวแทนนิติบุคคล',
    pleaseEnterTheFrenchPhoneNumber: 'โปรดกรอกเบอร์มือถือของผู้มีอำนาจ',
    legalPersonIdNumber: 'หมายเลขบัตรประชาชนของผู้มีอำนาจ',
    pleaseEnterTheCorporateIdNumber: 'โปรดกรอกหมายเลขบัตรประชาชนของผู้มีอำนาจ',
    corporateIdentityCardFront: 'ด้านหน้าบัตรประชาชนของผู้มีอำนาจ',
    reverseOfCorporateIdentityCard: 'ด้านหลังบัตรประชาชนของผู้มีอำนาจ',
    pleaseUpload: 'โปรดอัปโหลด',
    fileUpload: 'อัปโหลดไฟล์',
    uploadAMaximumOf2Images: 'อัปโหลดรูปได้สูงสุด 2 รูป',
    theSizeOfTheUploadedProfilePictureCannotExceed: 'ขนาดรูปโปรไฟล์ต้องไม่เกิน',
    uploadPictureFormatOnlySupported: 'รองรับเฉพาะรูปแบบ',
    onlyJpgJpegAndPngFilesCanBeUploaded: 'อัปโหลดได้เฉพาะไฟล์ jpg, jpeg, png',
    onlyJpgJpegPngFilesCanBeUploadedPleaseUploadTheChangeLetterAsAPhoto:
      'รองรับเฉพาะไฟล์ jpg, jpeg, png โปรดอัปโหลดภาพถ่ายของหนังสือขอเปลี่ยนแปลง',
    pleaseWaitFileUploadIsNotComplete: 'โปรดรอ การอัปโหลดไฟล์ยังไม่เสร็จสมบูรณ์',
    contractStampPageRequired: 'หน้าประทับตราของสัญญา (จำเป็น)',
    otherPagesOptional: 'หน้าอื่น ๆ (อัปโหลดได้สูงสุด 2 หน้า)',
    contractStampInstructions:
      '2. หน้าประทับตราสัญญา: ต้องมีหน้าข้อมูลบัญชีรับเงินของฝั่ง B และประทับตราออฟฟิเชียล',
    individualMobileNote:
      'หมายเหตุ: หากเป็นผู้ประกอบการส่วนบุคคล ให้กรอกเบอร์มือถือของผู้ประกอบการ',
    individualNameNote: 'หมายเหตุ: หากเป็นผู้ประกอบการส่วนบุคคล ให้กรอกชื่อผู้ประกอบการ',
    individualIdNote:
      'หมายเหตุ: หากเป็นผู้ประกอบการส่วนบุคคล ให้กรอกหมายเลขบัตรประชาชนของผู้ประกอบการ',
    individualRegNumberNote: 'หมายเหตุ: หากเป็นผู้ประกอบการส่วนบุคคล ให้กรอกหมายเลขทะเบียน',
    maxTwoImages: 'อัปโหลดได้สูงสุด 2 รูป',
    recipientLegalMobile: 'เบอร์มือถือผู้รับเงิน/ผู้มีอำนาจ',
    recipientLegalIdNumber: 'หมายเลขบัตรประชาชนผู้รับเงิน/ผู้มีอำนาจ',
  },
  invoicingAddInvoicingApplication: {
    billingApplication: 'คำขอออกใบกำกับภาษี',
    expenseType: 'ประเภทรายจ่าย:',
    totalAmountApplied: 'ยอดเงินที่ขอรวม',
    theApplicationAmountIsIncorrect: 'จำนวนเงินที่กรอกไม่ถูกต้อง',
    status: 'สถานะ:',
    causeOfRejection: 'เหตุผลการปฏิเสธ:',
    billingInformation: 'ข้อมูลการออกใบกำกับภาษี:',
    pleaseEnterPhoneNumber: 'โปรดกรอกเบอร์โทรศัพท์',
    dutyNumber: 'เลขประจำผู้เสียภาษี',
    pleaseEnterYourTaxId: 'โปรดกรอกเลขประจำผู้เสียภาษี',
    pleaseEnterYourAccountBank: 'โปรดกรอกชื่อธนาคาร',
    pleaseEnterTheAddress: 'โปรดกรอกที่อยู่',
    openABankAccount: 'หมายเลขบัญชีธนาคาร',
    pleaseEnterYourBankAccountNumber: 'โปรดกรอกหมายเลขบัญชี',
    pleaseEnterEmail: 'โปรดกรอกอีเมล',
    pickUpTelephone: 'เบอร์โทรรับเอกสาร',
    pleaseEnterTheReceivingPhoneNumber: 'โปรดกรอกเบอร์รับเอกสาร',
    mailingAddress: 'ที่อยู่จัดส่ง',
    pleaseEnterYourMailingAddress: 'โปรดกรอกที่อยู่จัดส่ง',
    addressee: 'ผู้รับ',
    pleaseEnterTheRecipient: 'โปรดกรอกชื่อผู้รับ',
    repudiationPeriod: 'งวดที่ถูกปฏิเสธ:',
    claimPeriod: 'งวดที่ยื่นขอ:',
    pleaseEnterTheAmountRequested: 'โปรดกรอกจำนวนเงินที่ต้องการออกใบกำกับ',
    theNumberCannotExceed15Digits: 'หมายเลขต้องไม่เกิน 15 หลัก',
    pleaseEnterTheCorrectNumber: 'โปรดกรอกหมายเลขที่ถูกต้อง',
    paymentPeriod: 'งวดบัญชี',
    availableAmount: 'ยอดที่ออกได้',
    amountApplied2: 'ยอดที่ขอ',
    pleaseSelectTheBillingType5: 'โปรดเลือกประเภทการออกใบกำกับ',
    receipt: 'ใบเสร็จรับเงิน',
    pleaseEnterTitle: 'โปรดกรอกหัวข้อใบกำกับภาษี',
    theCurrentlySelectedFeeTypeDoesNotHaveBillingDataPleaseSelectAgain:
      'ไม่มีข้อมูลออกใบกำกับสำหรับประเภทรายจ่ายที่เลือก โปรดเลือกใหม่',
    theTotalApplicationAmountNeedsToBeGreaterThan: 'ยอดเงินที่ขอรวมต้องมากกว่า',
    invoicingTypeAndFeeTypeDoNotCorrespondTheReceiptCanOnlyMatchTheDepositAndQualityDeposit:
      'ประเภทใบกำกับไม่ตรงกับประเภทรายจ่าย ใบเสร็จรับเงินใช้ได้เฉพาะกับเงินมัดจำและเงินประกันคุณภาพ',
    thePageIsAutomaticallyClosed5SecondsAfterSubmission: 'ส่งคำขอสำเร็จ หน้าจะปิดภายใน 5 วินาที',
    generalInvoice: 'ใบกำกับภาษีทั่วไป (อิเล็กทรอนิกส์)',
    specialInvoice: 'ใบกำกับภาษีพิเศษ (อิเล็กทรอนิกส์)',
  },
  invoicingInvoicingApplication: {
    applicationDate: 'วันที่ยื่นคำขอ',
    billingApplication: 'คำขอออกใบกำกับภาษี',
    expenseType: 'ประเภทรายจ่าย',
    amountApplied2: 'ยอดที่ขอ',
    expressNumber: 'หมายเลขพัสดุ',
    alreadyRequested: 'ร้องขอแล้ว',
  },
  preauthorizationIndex: {
    turn: 'โอน',
    // Part 13, lines 2401 to 2600
    increaseAuthorization: 'เพิ่มวงเงินอนุมัติ',
    authorizationFailure: 'อนุมัติล้มเหลว',
    settlementTime: 'เวลาชำระบัญชี',
    preAuthorizationDetailsLightWinTreasureHotelManagementSystem:
      'รายละเอียดการกันวงเงิน - ระบบจัดการโรงแรม Qing Ying Bao',
    declined: 'ถูกปฏิเสธแล้ว',
    flyingPigCreditDoesNotSupportPreAuthorization: 'Fliggy Credit Stay ยังไม่รองรับการกันวงเงิน',
    newAuthorization: 'เพิ่มการอนุมัติใหม่',
    cancelAuthorizationPleaseWait: 'กำลังยกเลิกการอนุมัติ โปรดรอสักครู่',
    succeededInCancelingAuthorization: 'ยกเลิกการอนุมัติสำเร็จ',
    pleaseWaitForTheSettlementAuthorization: 'กำลังอนุมัติการชำระบัญชี กรุณารอสักครู่',
    confirmThatYouWantToCancelAuthorization: 'ยืนยันว่าต้องการยกเลิกการอนุมัติหรือไม่',
    orderStatusWarning: 'คำสั่งซื้อ {status} ไม่สามารถ{action}ได้',
    roomStatusWarning: 'ห้องอยู่ในสถานะเข้าพักแล้ว ไม่สามารถ{action}ได้',
    roomCheckoutWarning: "สถานะห้องเป็น 'เช็คเอาต์แล้ว' ไม่สามารถ{action}ได้",
  },
  componentsAuthsettle: {
    payment3: 'ชำระเงิน',
    paidInAmount: 'ยอดที่รับจริง',
    settlementSuccess: 'ชำระบัญชีสำเร็จ',
    authorizedSettlement: 'การชำระบัญชีด้วยการอนุมัติ',
    accountEntry: 'หัวข้อบัญชีที่บันทึก',
    pleaseFillInTheAuthorizedAmount: 'โปรดกรอกจำนวนเงินที่อนุมัติ',
    theActualAmountReceivedMustBeGreaterThan0: 'ยอดที่รับจริงต้องมากกว่า 0',
    theActualAmountReceivedCannotBeGreaterThanTheAuthorizedAmount:
      'ยอดที่รับจริงต้องไม่มากกว่ายอดที่อนุมัติ',
  },
  componentsBanklist: {
    bankOfChina: 'ธนาคารแห่งประเทศจีน (Bank of China)',
    industrialAndCommercialBankOfChina: 'ธนาคารอุตสาหกรรมและพาณิชย์แห่งประเทศจีน (ICBC)',
    industrialAndCommercialBankOfChina3: 'ICBC',
    agriculturalBankOfChina: 'ธนาคารเพื่อการเกษตรแห่งประเทศจีน (ABC)',
    agriculturalBankOfChina3: 'ABC',
    chinaConstructionBank: 'ธนาคารก่อสร้างแห่งประเทศจีน (CCB)',
    chinaConstructionBank3: 'CCB',
    postalSavingsBankOfChina: 'ธนาคารออมสินไปรษณีย์แห่งประเทศจีน (PSBC)',
    postalSavingsBank: 'PSBC',
    bankOfCommunications: 'ธนาคารเจียวทง (Bank of Communications)',
    chinaMerchantsBank: 'China Merchants Bank',
    shanghaiPudongDevelopmentBank: 'Shanghai Pudong Development Bank (SPDB)',
    shanghaiPudongDevelopmentBank3: 'SPDB',
    chinaCiticBank: 'CITIC Bank',
    everbrightBank: 'China Everbright Bank',
    chinaMinshengBank: 'China Minsheng Bank',
    minshengBank: 'Minsheng Bank',
    guangdongDevelopmentBank: 'Guangdong Development Bank',
    guangfaBank: 'Guangfa Bank (CGB)',
    pingAnBank: 'Ping An Bank',
    industrialBank: 'Industrial Bank',
    huaxiaBank: 'Huaxia Bank',
    bankOfShanghai: 'Bank of Shanghai',
    bankOfBeijing: 'Bank of Beijing',
    bohaiBank: 'Bank of Bohai',
    zheshangBank: 'China Zheshang Bank',
    huishangBank: 'Huishang Bank',
    hsbc: 'HSBC',
    hangSengBank: 'Hang Seng Bank',
    hengfengBank: 'Hengfeng Bank',
  },
  componentsExpandcolumn: {
    bankName: 'ชื่อธนาคาร',
    authorizationCode: 'รหัสอนุมัติ',
    from: 'จาก',
    rollOutTo: 'โอนไปยัง',
  },
  componentsTransferaccounts: {
    transferMoney: 'โอนบัญชี',
    transferToAccount: 'โอนไปยังบัญชี',
    authorizationFailure: 'อนุมัติล้มเหลว',
  },
  componentsUpdateauthorization: {
    automaticSettlementAfterExpiration: 'ชำระบัญชีอัตโนมัติหลังจากหมดอายุ',
    authorizationCode: 'รหัสอนุมัติ',
    bankName: 'ชื่อธนาคาร',
    pleaseFillInTheAuthorizedAmount: 'โปรดกรอกจำนวนเงินที่อนุมัติ',
    newAuthorization: 'เพิ่มการอนุมัติใหม่',
    modifyAuthorization: 'แก้ไขการอนุมัติ',
    renewal: 'ต่ออายุ',
  },
  componentsCancelorder: {
    reminderThisOrderIsAnEbOrderPleaseVerifyTheOtaOrderStatusBeforeCancellation:
      'แจ้งเตือน: คำสั่งซื้อนี้เป็นคำสั่งซื้อ EB กรุณาตรวจสอบสถานะ OTA ก่อนยกเลิก',
    orderCancelledSuccessfully: 'ยกเลิกออเดอร์สำเร็จ',
    cancelAnOrder2: 'ยกเลิกออเดอร์',
    cancellationReason: 'เหตุผลการยกเลิก',
    remarks5100Words: 'หมายเหตุ (5-100 ตัวอักษร)',
    replyTextMinimum5Words: 'ข้อความตอบกลับต้องอย่างน้อย 5 ตัวอักษร',
    pleaseSelectACancellationReason: 'โปรดเลือกเหตุผลการยกเลิก',
    originalStayWillBeCancelled: 'คำสั่งขยายเวลาพักเดิมจะถูกยกเลิกโดยอัตโนมัติ',
    cancellationRules: 'กฎการยกเลิก',
    channelDescription: 'คำอธิบายช่องทาง',
    refundScore: 'คืนคะแนนหรือไม่',
    refundCoupon: 'คืนคูปองหรือไม่',
    orderMessage: 'ข้อความคำสั่งซื้อ',
    pleaseEnterOrderMessage: 'โปรดกรอกข้อความคำสั่งซื้อ',
    directCancelSuccessComment: 'ยกเลิกออเดอร์สำเร็จ',
  },
  componentsEditcontactinfo: {
    modifyAContact: 'แก้ไขข้อมูลผู้ติดต่อ',
    pleaseEnterThe11DigitPhoneNumber: 'โปรดกรอกเบอร์มือถือ 11 หลัก',
  },
  componentsEditorder: {
    modifyTheOrder2: 'แก้ไขออเดอร์',
    selectDate1: 'เลือกวันที่ 1',
    selectDate2: 'เลือกวันที่ 2',
    contactNumber4: 'เบอร์โทรผู้ติดต่อ',
    theRetentionTimeMustNotBeLessThanTheCurrentTime: 'เวลาจองคงไว้ต้องไม่ก่อนเวลาปัจจุบัน',
    theRetentionTimeShallNotBeLessThanTheEstimatedArrivalTime:
      'เวลาจองคงไว้ต้องไม่ก่อนเวลาที่คาดว่าจะมาถึง',
    theRetentionTimeMustNotBeLongerThanThePreDepartureTime:
      'เวลาจองคงไว้ต้องไม่เกินเวลาที่คาดว่าจะออก',
    doNotRepeatThisOperationWhileSubmittingChanges: 'กำลังส่งการแก้ไข โปรดอย่าทำซ้ำ',
    orderModificationSuccessful: 'แก้ไขออเดอร์สำเร็จ',
  },
  componentsEditOrderV2: {
    addedRoomsOverAvailability: 'จำนวนห้องที่เพิ่มต้องไม่เกินจำนวนห้องที่ว่าง',
    arrivalBeforeToday: 'วันที่เข้าพักของรายการห้องใหม่ต้องไม่ก่อนวันที่ปัจจุบัน',
    assignedRoom: 'จัดห้องแล้ว {room}',
    availabilityLoading: 'กำลังโหลดจำนวนห้องว่างของประเภทห้องนี้ โปรดลองอีกครั้งภายหลัง',
    availableCount: 'ห้องว่าง: {count}',
    checkedInRoom: 'เช็กอินแล้ว {room}',
    checkedOutRoom: 'เช็กเอาต์แล้ว {room}',
    chooseArrivalTime: 'เลือกเวลาเข้าพัก',
    chooseDepartureTime: 'เลือกเวลาออก',
    detailLoadFailed: 'โหลดข้อมูลการแก้ไขคำสั่งซื้อเวอร์ชันใหม่ไม่สำเร็จ',
    detailLoadRetry: 'โหลดข้อมูลการแก้ไขคำสั่งซื้อเวอร์ชันใหม่ไม่สำเร็จ โปรดลองอีกครั้ง',
    discountLabel: 'ส่วนลด {discount}% จากราคาหน้าเคาน์เตอร์',
    invalidStay: 'โปรดเลือกเวลาเข้าพักและเวลาออกที่ถูกต้อง',
    keepOneRoom: 'หลังแก้ไขต้องเหลือรายการห้องที่ใช้ได้อย่างน้อยหนึ่งรายการ',
    latestPriceFailed: 'โหลดราคาล่าสุดไม่สำเร็จ โปรดปรับวันเข้าพักและลองอีกครั้ง',
    latestPriceLoading: 'กำลังโหลดราคาล่าสุด โปรดส่งข้อมูลภายหลัง',
    longStayAtLeastTenDays: 'การจองระยะยาวต้องมีช่วงเข้าพักอย่างน้อย 10 วัน',
    longStayAtMostOneYear: 'การจองระยะยาวต้องมีช่วงเข้าพักไม่เกินหนึ่งปี',
    longStayNoMorning: 'การจองระยะยาวไม่รองรับห้องช่วงเช้ามืด',
    markedCancelled: 'ทำเครื่องหมายยกเลิกแล้ว',
    newRoomOrder: 'รายการห้องใหม่',
    newRoomPriceLoading: 'กำลังโหลดวันเข้าพักและราคาของรายการห้องใหม่ โปรดส่งข้อมูลภายหลัง',
    noReducibleRoom: 'ไม่มีรายการห้องชั่วคราวหรือรอเข้าพักที่สามารถลดได้สำหรับประเภทห้องนี้',
    otherStatus: 'สถานะอื่น',
    phonePlaceholder: 'กรอกหมายเลขโทรศัพท์มือถือ',
    productPriceFailed: 'โหลดผลิตภัณฑ์และราคาของโรงแรมไม่สำเร็จ โปรดลองอีกครั้ง',
    roomNumberValue: 'ห้อง {room}',
    roomOrderDetails: 'รายละเอียด',
    roomTypeInfo: 'ข้อมูลประเภทห้อง',
    roomTypeNoProduct: 'ไม่มีผลิตภัณฑ์โรงแรมที่ใช้ได้สำหรับประเภทห้องนี้',
    stayChangedClearRoom: 'วันเข้าพักเปลี่ยนแล้ว การจัดห้องเดิมถูกล้าง โปรดจัดห้องใหม่',
    stayPriceRefreshFailed: 'โหลดราคาหลังเปลี่ยนวันเข้าพักไม่สำเร็จ โปรดลองอีกครั้ง',
    stayProductPriceFailed: 'โหลดผลิตภัณฑ์และราคาสำหรับช่วงเข้าพักที่เลือกไม่สำเร็จ โปรดลองอีกครั้ง',
    stayProductUnavailable: 'ไม่มีผลิตภัณฑ์โรงแรมที่ใช้ได้สำหรับประเภทห้องนี้ในช่วงที่เลือก',
    storeProductMissing: 'ไม่พบผลิตภัณฑ์โรงแรม',
    temporaryRoomOrder: 'รายการห้องชั่วคราว',
    unassignedSummary: 'รอจัดห้อง {count} ห้อง',
  },
  componentsEditroomorder: {
    modifyingTheAgreedUnitInformationWillRecalculateAllRoomRatesInTheOrder:
      'การแก้ไขข้อมูลหน่วยงานตามสัญญาจะทำให้ระบบคำนวณราคาห้องทั้งหมดในออเดอร์ใหม่',
    modifyRoomList: 'แก้ไขใบห้อง',
  },
  componentsEditroomprice: {
    modifyTheHousePrice: 'แก้ไขราคาห้อง',
    theCurrentPriceCalendarCannotBeModified: 'ปฏิทินราคาในปัจจุบันไม่สามารถแก้ไขได้',
    updatePriceCalendarSuccessfully: 'อัปเดตปฏิทินราคาสำเร็จ',
  },
  componentsLevelup: {
    payTheBill: 'ชำระเงิน',
    partUpgrade: 'ชุดการอัปเกรด',
    confirmTheUpgrade: 'ยืนยันการอัปเกรด',
    currentRoomType: 'ประเภทห้องปัจจุบัน',
    reselection: 'เลือกใหม่',
    chargeOrNot: 'คิดค่าบริการหรือไม่',
    currentTotalHousePrice: 'ราคารวมปัจจุบัน',
    totalRateAfterUpgrade: 'ราคารวมหลังอัปเกรด',
    priceDifference: 'ส่วนต่างราคา',
    upgradeCause: 'เหตุผลการอัปเกรด',
    enterAMaximumOf150Words: 'กรอกได้สูงสุด 150 ตัวอักษร',
    pleaseChooseWhetherToCharge: 'โปรดเลือกว่าจะคิดค่าบริการหรือไม่',
    pleaseEnterTheUpgradeReason: 'โปรดกรอกเหตุผลการอัปเกรด',
    inTheCaseOfPaymentTheSpreadCannotBeLessThanOrEqualTo0:
      'หากมีการเก็บเงิน ส่วนต่างราคาต้องมากกว่า 0',
    reminderIfYouUpgradeTheRoomTypeBetweenTheNightAuditAnd0600PleaseManuallyHandleTheRoomRateDifference:
      'แจ้งเตือน: หากอัปเกรดประเภทห้องหลังการตรวจสอบกลางคืนจนถึงเวลา 06:00 กรุณาจัดการส่วนต่างค่าห้องด้วยตนเอง',
  },
  componentsSeeroomprice: {
    viewRoomRates: 'ดูราคาห้อง',
  },
  componentsStay: {
    theCurrentRoomTypeIsSoldOutPleaseSelectAnotherDate:
      'ประเภทห้องปัจจุบันขายหมดแล้ว โปรดเลือกวันที่อื่น',
    existingRoomSingleChargeCheckOut: 'ใบห้องปัจจุบันเช็คเอาต์พักหนี้ในบัญชี',
    theAccountOfTheExistingHouseBillIsTransferredToTheNewHouseBill:
      'โอนบัญชีของใบห้องปัจจุบันไปยังใบห้องใหม่แล้วจึงเช็คเอาต์',
    promptTheCurrentRoomIsALinkedRoomBillAfterExtendingTheStayYouNeedToManuallyAddTheNewRoomBillToTheLinkedRooms:
      'เตือน: ห้องปัจจุบันเป็นใบห้อง联房 หลัง续住แล้วต้องเพิ่มใบห้องใหม่เข้ารายการ联房ด้วยตนเอง',
    nonStoreSingleCanNotSustain: 'คำสั่งซื้อที่ไม่ใช่คำสั่งร้านค้าไม่รองรับการขยายเวลาพัก',
    youCannotRenewYourStayUntilTheCheckOutDate: 'ยังไม่ถึงวันเช็คเอาต์ ไม่สามารถขยายเวลาพักได้',
    extendStayadvance: 'ต่ออายุ/ล่วงหน้า',
    originalOrder2: 'ออเดอร์เดิม',
    continuationPrice: 'ราคาต่ออายุ',
    changeTheCheckOutTime: 'เปลี่ยนเวลาเช็คเอาต์',
    selectDateTime: 'เลือกวันเวลา',
    continuationPriceRule: 'กฎราคาต่ออายุ',
    swapOrder: 'เปลี่ยนคำสั่งซื้อ',
    nameAndMobilePhoneNumberOfThePersonWhoMadeTheReservation: 'ชื่อและเบอร์มือถือของผู้จอง',
    subscriber: 'ผู้จอง',
    roomAccountProcessing: 'การจัดการใบห้อง',
    pleaseSelectTheRenewalPriceRule: 'กรุณาเลือกราคาต่ออายุ',
    checkOutTimeCannotBeLessThanTheCurrentTime: 'เวลาเช็คเอาต์ต้องไม่ก่อนเวลาปัจจุบัน',
    theRenewalOfStayIsSuccessful: 'ดำเนินการต่ออายุสำเร็จ',
    pleaseSelectANewOrder: 'โปรดเลือกออเดอร์ใหม่',
    theRenewalOfTheOrderDoesNotSupportTheFlyingPigCreditOrder:
      'คำสั่งเปลี่ยนห้องไม่รองรับ Fliggy Credit Stay',
    extendStayadvanceSuccess: 'ต่ออายุ/เช็คเอาท์ก่อนกำหนดสำเร็จ',
    roomNumber: 'หมายเลขห้อง',
    checkInPerson: 'ผู้เข้าพัก',
    checkOutTime: 'เวลาเช็คเอาท์',
    makeCard: 'ทำบัตร',
    booked: 'บันทึกบัญชี',
    close: 'ปิด',

  },
  componentsTools: {
    pendingClosing: 'รอการขอปิดบัญชี',
    closingSuccessful: 'ขอปิดบัญชีสำเร็จ',
    failedToApplyForClosing: 'ขอปิดบัญชีล้มเหลว',
    firstNightRate: 'ราคาคืนแรก',
    lateNightRate: 'ราคาคืนสุดท้าย',
    maximumHousePrice: 'ราคาห้องสูงสุด',
    minimumRoomRate: 'ราคาห้องต่ำสุด',
  },
  ebkorderIndex: {
    priceDescription: 'คำอธิบายราคา',
    merchantPromotionTotalAmountBorneByTheMerchant:
      'โปรโมชั่นของร้านค้า = ยอดเงินที่ร้านค้ารับผิดชอบรวม',
    totalSellingPriceTotalOrderAmountMerchantPromotion:
      'ราคาขายรวม = ยอดคำสั่งซื้อ - โปรโมชั่นของร้านค้า',
    totalCommissionTotalSellingPriceCommissionRate:
      'ยอดค่าคอมมิชชันรวม = ยอดราคาขายรวม * อัตราค่าคอมมิชชัน',
    totalBasePriceTotalSellingPriceTotalCommission: 'ราคาพื้นฐานรวม = ราคาขายรวม - ค่าคอมมิชชั่น',
    userPaymentAmountActuallyPaidByTheUser: 'ยอดชำระของผู้ใช้ = จำนวนเงินที่ผู้ใช้ชำระจริง',
    totalOrder: 'ยอดออเดอร์รวม',
    totalSellingPrice: 'ยอดราคาขายรวม',
    userPayment: 'ยอดชำระของผู้ใช้',
    totalCommission: 'ยอดค่าคอมมิชชันรวม',
    totalFloorPrice: 'ราคาพื้นฐานรวม',
    merchantPromotion: 'โปรโมชั่นของร้านค้า',
    viewOrder: 'ดูออเดอร์',
    orderTransferMethod: 'วิธีโอนคำสั่งซื้อ',
    removalOfOrder: 'โอนคำสั่งซื้อ',
    contactAndMobilePhoneNumber: 'ชื่อผู้ติดต่อและเบอร์มือถือ',
    channelOrderStatus: 'สถานะออเดอร์ช่องทาง',
    orderStatus: 'สถานะการโอนคำสั่งซื้อ',
    channelOrderNumber: 'หมายเลขออเดอร์ช่องทาง',
    channelType: 'ประเภทห้องของช่องทาง',
    expectedArrivalexpectedDeparture: 'เวลาเช็คอิน/เช็คเอาต์ตามที่คาดไว้',
    bookingType: 'ประเภทการจอง',
    estimatedTimeOfArrival: 'เวลาที่คาดว่าจะมาถึง',
    orderCreationTime: 'เวลาสร้างออเดอร์',
    inBooking: 'กำลังจอง',
    bookingFailed: 'จองไม่สำเร็จ',
    bookingException: 'การจองผิดปกติ',
    initialRejection: 'ปฏิเสธครั้งแรก',
    canceling: 'กำลังยกเลิก',
    otherStates: 'สถานะอื่น',
    movedOrder: 'โอนแล้ว',
    unmovedOrder: 'ยังไม่โอน',
    // Part 14, lines 2601 to 2800
    createTimeDesc: 'เวลาสร้างล่าสุด → เก่าสุด',
    createTimeAsc: 'เวลาสร้างเก่าสุด → ล่าสุด',
    arriveTimeDesc: 'เวลามาถึงล่าสุด → เก่าสุด',
    arriveTimeAsc: 'เวลามาถึงเก่าสุด → ล่าสุด',
    ebkOrderCheckMsg: 'ไม่มีข้อมูล คลิกเพื่อบันทึกเพิ่มเติม',
  },
  ebkorderUnbindtip: {
    youDoNotHaveAMeituanAccount: 'คุณยังไม่ได้เชื่อมบัญชี Meituan',
    pleaseSetItInmoresystemSettingsebAccountAuthorization:
      'กรุณาตั้งค่าในเมนู “เพิ่มเติม” - “การตั้งค่าระบบ” - “การกำหนดสิทธิ์บัญชี EB”',
    clickToGo: 'คลิกเพื่อไป',
  },
  invoiceInvoiceDetail: {
    personage: 'บุคคลธรรมดา',
    firm: 'นิติบุคคล',
    headerType: 'ประเภทหัวใบกำกับ',
    invoiceAmount2: 'จำนวนเงินใบกำกับภาษี',
    pleaseEnterTheInvoiceAmount: 'โปรดกรอกจำนวนเงินใบกำกับภาษี',
    pleaseEnterTheInvoiceNumber2: 'โปรดกรอกหมายเลขใบกำกับภาษี',
    invoiceGroup: 'กลุ่มใบกำกับภาษี',
    selectRoomList: 'เลือกใบห้อง',
    orderAmount: 'ยอดคำสั่งซื้อ',
    pleaseEnterTheInvoiceTitleToSearch: 'โปรดกรอกหัวใบกำกับเพื่อค้นหา',
    pleaseEnterYourTaxIdentificationNumber: 'โปรดกรอกหมายเลขประจำตัวผู้เสียภาษี',
    unitAddress: 'ที่อยู่หน่วยงาน',
    pleaseEnterTheAddressOfTheUnit: 'โปรดกรอกที่อยู่หน่วยงาน',
    telephoneNumber: 'หมายเลขโทรศัพท์',
    bankOfDeposit2: 'ธนาคารที่เปิดบัญชี',
    pleaseEnterYourBank: 'โปรดกรอกธนาคารที่เปิดบัญชี',
    bankAccount: 'เลขบัญชีธนาคาร',
    pleaseEnterYourBankAccount: 'โปรดกรอกเลขบัญชีธนาคาร',
    pleaseEnterYourEmailAddress: 'โปรดกรอกอีเมล',
    invoiceMailingAddress: 'ที่อยู่จัดส่งใบกำกับภาษี',
    pleaseEnterTheInvoiceMailingAddress: 'โปรดกรอกที่อยู่จัดส่งใบกำกับภาษี',
    billingNote: 'หมายเหตุการออกใบกำกับ',
    pleaseEnterYourBillingRemarks: 'โปรดกรอกหมายเหตุการออกใบกำกับ',
    pleaseSelectTheBillingType5: 'โปรดเลือกประเภทการออกใบกำกับ',
    pleaseSelectAHeaderType: 'โปรดเลือกประเภทหัวใบกำกับ',
    fillInAtLeastOneEMailAndMailingAddress:
      'ต้องกรอกอย่างน้อยหนึ่งรายการระหว่างอีเมล หรือ ที่อยู่จัดส่ง',
  },
  invoiceInvoiceList: {
    toBeInvoiced: 'รอออกใบกำกับ',
    pleaseEnterYourTaxIdentificationNumber: 'โปรดกรอกหมายเลขผู้เสียภาษี',
    pleaseEnterTheInvoiceNumber2: 'โปรดกรอกหมายเลขใบกำกับภาษี',
    newInvoice: 'สร้างใบกำกับใหม่',
    invoiceType: 'ประเภทใบกำกับ',
    invoiceAmount: 'ยอดใบกำกับ',
    billingTime: 'เวลาออกใบกำกับ',
  },
  invoiceRoomInvoiceAssociationSearch: {
    roomListInvoiceList2: 'รายการใบกำกับของใบห้อง',
    namePhoneNumberRoomNumber: 'ชื่อผู้เข้าพัก / เบอร์โทร / หมายเลขห้อง',
  },
  invoiceRoomInvoiceList: {
    roomListInvoiceList2: 'รายการใบกำกับของใบห้อง',
    accumulatedInvoiceAmount: 'ยอดใบกำกับสะสม',
    toBeInvoiced: 'รอออกใบกำกับ',
    newInvoice: 'สร้างใบกำกับใหม่',
    invoiceType: 'ประเภทใบกำกับ',
    invoiceAmount: 'ยอดใบกำกับ',
    billingTime: 'เวลาออกใบกำกับ',
  },
  orderListBaseinfo: {
    getThePhoneNumber: 'รับเบอร์โทร',
    preSaleVoucherNumber: 'หมายเลขคูปองพรีเซลล์',
    contractNumber: 'หมายเลขสัญญา',
    invoice: 'ใบกำกับภาษี',
    promotionalActivity: 'กิจกรรมส่งเสริมการขาย',
    estimatedSettlementAmount: 'จำนวนเงินชำระบัญชีโดยประมาณ',
    pack: 'แพ็กเกจ',
    selfServiceReservation: 'จองผ่านตู้บริการตนเอง',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
      'ใบกำกับภาษีสำหรับคำสั่งซื้อนี้ออกโดยช่องทางการขาย',
    thisOrderIsInvoicedByYourHotelToTheGuest: 'คำสั่งซื้อนี้ออกใบกำกับภาษีโดยโรงแรมของคุณ',
    theAmountIsForReferenceOnlyTheSpecificSettlementAmountIsSubjectToTheBill:
      'จำนวนเงินนี้ใช้เพื่ออ้างอิงเท่านั้น ยอดชำระจริงให้ยึดตามใบแจ้งหนี้',
    systemRemark: 'หมายเหตุระบบ',
    sellerRemark: 'หมายเหตุร้านค้า',
  },
  orderListCheckIn: {
    handleSuccessfully: 'ดำเนินการสำเร็จ',
    viewCheckInInformation: 'ดูข้อมูลการเข้าพัก',
    handleAgain: 'ดำเนินการอีกครั้ง',
    handlingFailure: 'ดำเนินการล้มเหลว',
    theNameCannotBeBlank2: 'ชื่อต้องไม่ว่างเปล่า',
    theIdTypeCannotBeEmpty: 'ประเภทเอกสารต้องไม่ว่างเปล่า',
    theIdNumberCannotBeEmpty: 'หมายเลขเอกสารต้องไม่ว่างเปล่า',
    pleaseArrangeTheRoomFirst: 'โปรดจัดห้องก่อน',
    checkInData: 'ข้อมูลแบบฟอร์มเข้าพัก',
  },
  orderListDetail: {
    checkInStatus: 'สถานะการเข้าพัก',
    total: 'รวม',
    chargedToAccount: 'พักหนี้',
    natureTraffic: 'ทราฟฟิกธรรมชาติ',
    natureOrderTip: 'คำสั่งซื้อนี้มาจากช่องทางจองตรงของ Qingzhu',
    preCheckInForm: 'แบบฟอร์มเข้าพักล่วงหน้า',
    continuationOrder: 'คำสั่งขยายเวลาพัก',
    liveOnCredit: 'พักแบบเครดิต',
    preSaleVoucherReservationForm: 'แบบฟอร์มจองคูปองพรีเซลล์',
    meituanEbOrder: 'คำสั่ง EB ของ Meituan',
    ctripEbOrder: 'คำสั่ง EB ของ Ctrip',
    flash: 'Flash Stay',
    fullGuarantee: 'การรับประกันเต็มจำนวน',
    roomListInformation: 'ข้อมูลใบห้อง',
    automaticRowHouse: 'จัดห้องอัตโนมัติ',
    bulkCheckIn: 'เช็คอินแบบกลุ่ม',
    unterracedHouse: 'ยังไม่จัดห้อง',
    upgrades: 'อัปเกรด',
    prefabricatedKeyCard: 'ทำบัตรล่วงหน้า',
    modifyTheOrder2: 'แก้ไขออเดอร์',
    cancelAnOrder2: 'ยกเลิกออเดอร์',
    rejectAnOrder: 'ปฏิเสธออเดอร์',
    pleaseArrangeTheRoomBeforePreformingTheKeyCard: 'โปรดจัดห้องก่อนจึงทำบัตรได้',
    theListingHasBeenCancelled: 'ใบห้องนี้ถูกยกเลิกแล้ว',
    noRoomingAllowedAfterThePreDepartureTime: 'เลยเวลาที่กำหนด ไม่สามารถจัดห้องได้',
    allListingsAreAlreadyFurnished: 'ใบห้องทั้งหมดจัดห้องเรียบร้อยแล้ว',
    theAutomaticPlatoonSucceeded: 'จัดห้องอัตโนมัติสำเร็จ',
    someRowhousesAreSuccessful: 'บางใบห้องจัดสำเร็จ',
    smartCheckInBusinessHasNotOpenedTheFunction: 'ระบบสมาร์ทเช็คอินยังไม่ได้เปิดใช้งาน',
    thisOrderIsARenewalOrderCheckInMayAffectTheOriginalRoomRenewal:
      'คำสั่งนี้เป็นการขยายเวลาพัก การเช็คอินอาจมีผลต่อการขยายเวลาพักของห้องเดิม',
    thisOrderIsARenewalOrderWhichMayAffectTheContinuationOfTheOriginalRoom:
      'คำสั่งนี้เป็นการขยายเวลาพัก การดำเนินการต่ออาจมีผลต่อการขยายเวลาห้องเดิม',
    exceedDepartureDate: 'เกินวันที่เช็คเอาท์ที่กำหนด ไม่อนุญาตให้อัปเกรดประเภทห้อง',
    theCurrentTimeHasExceededTheCheckOutTimeCannotUpgradeTheRoom:
      'เลยเวลาเช็คเอาต์ ไม่สามารถอัปเกรดห้องได้',
    cancelingTheCurrentRowSucceededProcedure: 'ยกเลิกการจัดห้องสำเร็จ',
    orderAcceptedSuccessfully: 'รับออเดอร์สำเร็จ',
    successfulRejection: 'ปฏิเสธออเดอร์สำเร็จ',
    thisActionWillCancelTheListingWhetherToContinue:
      'การดำเนินการนี้จะยกเลิกใบห้อง ต้องการดำเนินการต่อหรือไม่',
  },
  orderListGiftinfodetail: {
    packageName: 'ชื่อแพ็กเกจ',
    packageValue: 'มูลค่าแพ็กเกจ',
    wayOfGiving: 'วิธีการมอบ',
    dateOfPresentation2: 'วันที่มอบ',
    packageDetails: 'รายละเอียดแพ็กเกจ',
    oneDeliveryPerRoom: 'ให้หนึ่งครั้งต่อหนึ่งห้อง',
    complimentaryOnceADayPerRoom: 'ให้ฟรีวันละครั้งต่อห้อง',
  },
  orderListOrderDetail: {
    orderDetails: 'รายละเอียดคำสั่งซื้อ',
    finance3: 'การเงิน',
    preAuthorizationDetail: 'รายละเอียดการพรีออธอไรซ์',
  },
  orderListOrderList: {
    durationOfResidence: 'ระยะเวลาพัก',
    bookingTime: 'เวลาจอง',
    preCheckInForm: 'แบบฟอร์มเข้าพักล่วงหน้า',
    housePig: 'Fang Xiaozhu',
    presaleTicket: 'คูปองพรีเซลล์',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery:
      'ชื่อ/เบอร์โทร/หมายเลขออเดอร์/หมายเลขออเดอร์ช่องทาง',
    multipleSearch: 'ค้นหาแบบหลายเงื่อนไข',
    selfServiceReservation: 'จองผ่านตู้บริการตนเอง',
    rejectAnOrder: 'ปฏิเสธออเดอร์',
    individualTraveler: 'ลูกค้าเดี่ยว',
    team2: 'กรุ๊ปทัวร์',
    estimate: 'คาดว่าจะเข้า',
    firstDayPrice: 'ราคาวันแรก',
    areYouSureYouWantToTakeTheOrder: 'ยืนยันรับออเดอร์หรือไม่',
    orderAcceptedSuccessfully: 'รับออเดอร์สำเร็จ',
    booked: 'จองแล้ว',
    refused: 'ปฏิเสธแล้ว',
    extendStayCheckInImpact:
      'คำสั่งนี้เป็นการขยายเวลาพัก การเช็คอินอาจมีผลต่อการขยายเวลาพักของห้องเดิม',
    exceededDepartureCannotUpgrade: 'เลย 6 โมงของวันออกพัก ไม่สามารถอัปเกรดได้',
    exceededCheckoutCannotUpgrade: 'เลยเวลาเช็คเอาต์ ไม่สามารถอัปเกรดได้',
    exceededDepartureCannotArrangeRoom: 'เลยเวลาจัดห้อง ไม่สามารถจัดได้',
    preArrivalNotArrived: 'ยังไม่มาถึงตามกำหนด',
    noshow: 'No-show',
  },
  orderListNoShow: {
    title: 'No-show',
    noshowReason: 'เหตุผล no-show',
    remarkPlaceholder: 'หมายเหตุ (5-100 ตัวอักษร)',
    remarkMinLength: 'หมายเหตุต้องมีอย่างน้อย 5 ตัวอักษร',
    pleaseSelectNoshowReason: 'กรุณาเลือกเหตุผล no-show',
  },
  orderListPricedetail: {
    channelCost: 'ราคาต้นทางช่องทาง',
    eventDiscount: 'ส่วนลดกิจกรรม',
    guestActivityDiscount: 'ส่วนลดกิจกรรมของผู้เข้าพัก',
    memberDiscount: 'ส่วนลดสมาชิก',
    guestMembershipDiscount: 'ส่วนลดสมาชิกของผู้เข้าพัก',
    sameTripExclusiveOffer: 'ส่วนลดพิเศษของ Tongcheng',
    guestTongchengExclusiveDiscount: 'ส่วนลดพิเศษ Tongcheng สำหรับแขก',
    guestPurchasePrice: 'ราคาที่ผู้เข้าพักชำระ',
    activityDiscountAndHotelSellingPriceExplanationThereWillBeADifferenceBetweenTheGuestsOfThisChannelAndTheSettlementBillYouCanClickpricePromptToViewTheActualAmountPaidByTheGuests:
      'คำอธิบายส่วนลดกิจกรรมและราคาขายโรงแรม: ราคาที่ผู้เข้าพักเห็นอาจต่างจาก账单结算 คลิก “提示价格” เพื่อดูยอดที่ผู้เข้าพักชำระจริง',
    priceDetails: 'รายละเอียดราคา',
    memberBenefits: 'สิทธิประโยชน์สมาชิก',
    jointMemberBenefits: 'สิทธิพิเศษสมาชิกแบบร่วม',
  },
  orderListPromotiondetail: {
    eventDetails2: 'รายละเอียดกิจกรรม',
    preferentialRules: 'กฎส่วนลด',
  },
  orderListPromotiondetailnew: {
    eventDetails2: 'รายละเอียดกิจกรรม',
    dateCondition: 'เงื่อนไขวันที่',
    bookingConditions: 'เงื่อนไขการจอง',
    preferentialRules: 'กฎส่วนลด',
    participationDate: 'วันที่เข้าร่วม',
  },
  orderListRefuse: {
    areYouSureYouWantToDeclineThisOrder: 'ยืนยันปฏิเสธคำสั่งซื้อนี้หรือไม่',
    confirmationRejection: 'ยืนยันการปฏิเสธ',
    successfulRejection: 'ปฏิเสธสำเร็จ',
    theOrderWillBeClosedAtTheSameTime: 'หลังปฏิเสธ คำสั่งซื้อจะถูกปิดพร้อมกัน',
    overbookingSetup: 'ตั้งค่าวางขายเกินจำนวน',
  },
  orderListTip: {
    useWechatToScanThecheckInQrCodeAtTheFrontDeskToOpenTheOrderInquiryPage:
      'ใช้ WeChat สแกน “QR เช็คอิน” ที่หน้าเคาน์เตอร์เพื่อเปิดหน้าค้นหาออเดอร์',
    fillInTheBookingPersonsNameMobilePhoneNumberAndCheckInDateToCheckTheBookingForm:
      'กรอกชื่อผู้จอง เบอร์โทร และวันที่เข้าพัก เพื่อค้นหาแบบฟอร์มการจอง',
    // Part 15, lines 2801 to 3000
    '填写预订人姓名、手机号、入住日期查询预订单':
      'กรอกชื่อผู้จอง เบอร์โทร และวันที่เข้าพัก เพื่อค้นหาใบจอง',
    selectTheBookingFormThatNeedsToBeCheckedInAndSelectTheRoomWhereYouWantToAddPeopleToFillInTheInformation:
      'เลือกใบจองที่ต้องการเช็คอิน และเลือกห้องที่ต้องการเพิ่มผู้เข้าพักเพื่อกรอกข้อมูล',
    atThisPointYouCanViewTheRoomAlertInThePreOrderDetailsAfterFillingInTheInformationOfAllTheGuestsClickThecheckInButtonToCheckInTheGuests:
      'ขณะนี้คุณสามารถดูสถานะห้องในรายละเอียดใบจองได้ หลังกรอกข้อมูลผู้เข้าพักครบแล้ว ให้กดปุ่ม “เช็คอิน” เพื่อดำเนินการ',
    atThisPointYouCanSeeInTheListDetailsThatThePersonHasBeenAddedSuccessfully:
      'ขณะนี้ คุณสามารถเห็นในรายละเอียดใบห้องว่าผู้เข้าพักถูกเพิ่มสำเร็จแล้ว',
    off: 'ปิด',
    theUserHasCompletedTheProcedure: 'ผู้ใช้ดำเนินการเสร็จสิ้นแล้ว',
    pleaseGuideTheGuestsTocheckInInTheFollowingWay: 'โปรดแนะนำแขกให้ “เช็คอิน” ตามขั้นตอนดังนี้',
    afterTheGuestsFillInAndSubmitThePageWillDisplaypleaseBringYourIdToTheFrontDeskForVerification:
      'หลังจากแขกกรอกและส่งข้อมูล หน้าเว็บจะแสดงข้อความ “โปรดนำเอกสารไปยืนยันตัวตนที่เคาน์เตอร์”',
    pleaseGuideTheGuestsToAddAdditionalGuestsAsFollows:
      'โปรดแนะนำแขกให้ “เพิ่มผู้เข้าพัก” ตามขั้นตอนดังนี้',
  },
  groupOrderAddroomer: {
    validityPeriod: 'ระยะเวลาที่ใช้ได้',
    addmodifyCheckInGuests: 'เพิ่ม/แก้ไขผู้เข้าพัก',
    pleaseEnterAddress: 'กรุณากรอกที่อยู่',
    startDate: 'วันที่เริ่มต้น',
    currentSubscript: 'ดัชนีปัจจุบัน',
  },
  groupOrderIndex: {
    bulkCheckIn: 'เช็คอินแบบกลุ่ม',
    automaticRowHouse: 'จัดห้องอัตโนมัติ',
    checkInAddition: 'เพิ่มผู้เข้าพัก',
    pleaseSelectTheRoomYouWantToCheckIn: 'โปรดเลือกห้องที่ต้องการเช็คอิน',
    theEmptyAndDirtyRoomYouSelectedIsConfirmedToCheckIn:
      'คุณเลือกห้องว่าง-สกปรก ต้องการเช็คอินหรือไม่',
    checkInSuccessful: 'เช็คอินสำเร็จ',
    roomNoLongerAvailablePleaseChangeToAnotherRoomNumber:
      'ห้องไม่สามารถใช้งานได้ โปรดเปลี่ยนหมายเลขห้อง',
    theRoomIsOccupiedPleaseChangeToAnotherRoomNumber: 'ห้องมีผู้เข้าพักอยู่ โปรดเปลี่ยนหมายเลขห้อง',
    pleaseArrangeTheRoomBeforeChoosing: 'โปรดจัดห้องก่อนจึงจะสามารถเลือกได้',
    allListingsAreAlreadyFurnished: 'ใบห้องทั้งหมดถูกจัดเรียบร้อยแล้ว',
    theAutomaticPlatoonSucceeded: 'จัดห้องอัตโนมัติสำเร็จ',
    pleaseListTheRoomFirstAndThenAddTheGuest: 'โปรดจัดห้องก่อนแล้วจึงเพิ่มผู้เข้าพัก',
    succeededInCancelingTheRowHouse: 'ยกเลิกการจัดห้องสำเร็จ',
  },
  presalecouponsPredetail: {
    ticketName: 'ชื่อคูปองพรีเซลล์',
    presaleTicket: 'คูปองพรีเซลล์',
    saleOrderNumber: 'หมายเลขคำสั่งซื้อ',
    purchaseTime: 'เวลาซื้อ',
    advanceOrder: 'คำสั่งจองล่วงหน้า',
    availableProduct: 'สินค้าที่ใช้ได้',
    commodityContent: 'รายละเอียดสินค้า',
    ruleInformation: 'ข้อมูลกติกา',
    availableTime: 'เวลาที่สามารถจองได้',
    checkInTime2: 'เวลาที่สามารถเข้าพักได้',
    markUpRule: 'กติกาการเพิ่มราคา',
    cancellationRules: 'กติกาการยกเลิกการจอง',
    paymentInformation: 'ข้อมูลการชำระเงิน',
    crossedPrice: 'ราคาเดิม (ขีดฆ่า)',
    chineseFood: 'อาหารจีน',
    dinner2: 'อาหารเย็น',
    bookedBedtotalBedHours: 'จำนวนคืนที่จองแล้ว / รวมจำนวนคืน (ชั่วโมง)',
    raiseAPrice: 'เพิ่มราคา',
    meituanDirectNew: 'Meituan Direct (ใหม่)',
    officialWebsiteDirect: 'เว็บทางการ',
    ctripSingleStore: 'Ctrip Single Store',
    agoda: 'Agoda',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    booking: 'Booking',
    expedia: 'Expedia',
  },
  presalecouponsPrelist: {
    dateOfPayment: 'วันที่ชำระเงิน',
    productId: 'สินค้า ID',
    sellOrderNumber: 'หมายเลขคำสั่งขาย',
    noAppointment: 'ยังไม่จอง',
    completeWriteOff: 'ใช้สิทธิ์ทั้งหมด',
    completeReverseWriteOff: 'ใช้สิทธิ์ทั้งหมดกลับ',
    refunded: 'ขอเงินคืนแล้ว',
    orderNumber2: 'หมายเลขคำสั่งซื้อ',
    timeOfPayment: 'เวลาชำระเงิน',
    bookedBedtotalBedHours: 'จำนวนคืนที่จองแล้ว / รวมจำนวนคืน (ชั่วโมง)',
  },
  hardwareParking: {
    parkingLotManagement: 'การจัดการลานจอดรถ',
    parkingLotDescription: 'รองรับการจดจำป้ายทะเบียนอัตโนมัติสำหรับเข้าและออก',
    settings: 'ตั้งค่า',
    parkingLotConfig: 'ตั้งค่าลานจอดรถ',
    currentDevice: 'อุปกรณ์ปัจจุบัน',
    unboundDeviceTip: 'โรงแรมปัจจุบันยังไม่ได้ผูกอุปกรณ์ลานจอดรถ',
    sidPlaceholder: 'โปรดกรอก SID',
    secretKeyPlaceholder: 'โปรดกรอก SecretKey',
    enableStatus: 'สถานะเปิดใช้งาน',
    hotelNotBoundWarning: 'โรงแรมปัจจุบันยังไม่ได้ผูกอุปกรณ์ลานจอดรถ',
    enterSidAndSecretKey: 'โปรดกรอก SID และ SecretKey',
    saveSuccess: 'บันทึกสำเร็จ',
    saveFailed: 'บันทึกล้มเหลว',
    configFailed: 'ตั้งค่าล้มเหลว',
    parkingDeviceEnabled: 'เปิดใช้งานอุปกรณ์ลานจอดรถแล้ว',
    parkingDeviceDisabled: 'ปิดใช้งานอุปกรณ์ลานจอดรถแล้ว',
    fetchHardwareRelationFailed: 'ดึงข้อมูลการผูกอุปกรณ์ฮาร์ดแวร์ล้มเหลว',
    fetchConfigFailed: 'ดึงข้อมูลตั้งค่าลานจอดรถล้มเหลว',
  },
  roomOrderListVehicleDialog: {
    title: 'หมายเลขป้ายทะเบียน',
    platePlaceholder: 'โปรดกรอกหมายเลขป้ายทะเบียน',
    add: 'เพิ่ม',
    plateNo: 'หมายเลขป้ายทะเบียน',
    enterPlateWarning: 'โปรดกรอกหมายเลขป้ายทะเบียน',
    enterPlateFormatWarning: 'รูปแบบป้ายทะเบียนไม่ถูกต้อง',
    addSuccess: 'เพิ่มสำเร็จ',
    deleteConfirm: 'ยืนยันลบหมายเลขป้ายทะเบียนนี้หรือไม่?',
    deleteSuccess: 'ลบสำเร็จ',
  },
  roomOrderListDetail: {
    vehiclePlateNo: 'หมายเลขป้ายทะเบียน',
    saveFailed: 'บันทึกล้มเหลว',
    cancelStay: 'ยกเลิกการขยายเวลาพัก',
    enterRemarkContent: 'โปรดกรอกเนื้อหาหมายเหตุ',
    systemRemark: 'หมายเหตุระบบ',
    merchantRemark: 'หมายเหตุร้านค้า',
    originalStayOrder: 'คำสั่งขยายเวลาพักเดิม',
    newStayOrder: 'คำสั่งขยายเวลาพักใหม่',
    continued: 'ต่อ',
    downloadIdPhoto: 'ดาวน์โหลดรูปบัตร',
    uploadedToPolice: 'อัปโหลดเข้าสู่ระบบตำรวจแล้ว',
    reuploadToPolice: 'อัปโหลดเข้าสู่ระบบตำรวจอีกครั้ง',
    cancelStaySuccess: 'ยกเลิกการขยายเวลาพักสำเร็จ',
    enterNumber: 'โปรดกรอกจำนวน',
    liveOnCredit: 'พักแบบเครดิต',
    duration: 'ระยะเวลา',
    invoice: 'ใบกำกับภาษี',
    roomInformation2: 'ข้อมูลห้องพัก',
    numberOfGuests: 'จำนวนผู้เข้าพัก',
    doorLockCode: 'รหัสกุญแจประตู',
    generatePassword: 'สร้างรหัสผ่าน',
    resetPassword: 'รีเซ็ตรหัสผ่าน',
    passwordInvalidation: 'ทำให้รหัสผ่านเป็นโมฆะ',
    idNumber2: 'หมายเลขเอกสาร',
    guestAddress: 'ที่อยู่แขก',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
      'คำสั่งซื้อนี้ออกใบกำกับภาษีโดยช่องทางการขาย',
    thisOrderIsInvoicedByYourHotelToTheGuest: 'คำสั่งซื้อนี้ออกใบกำกับภาษีโดยโรงแรมของคุณ',
    originalOrder2: 'ออเดอร์เดิม',
    swapOrder: 'เปลี่ยนคำสั่งซื้อ',
    faceCollection: 'เก็บข้อมูลใบหน้า',
    invoice2: 'ออกใบกำกับ',
    sendPassword: 'ส่งรหัสผ่าน',
    upgradeTheRoom: 'อัปเกรดห้อง',
    extendStayadvance: 'ต่ออายุ/ล่วงหน้า',
    transferToFullDayRoom: 'เปลี่ยนเป็นห้องเต็มวัน',
    decamping: 'ลดผู้ร่วมพัก',
    increaseCohabitation: 'เพิ่มผู้ร่วมพัก',
    checkInSlip4: 'ใบลงทะเบียนเข้าพัก',
    reinstatement: 'กู้คืนการเข้าพัก',
    renewalOrder2: 'คำสั่งขยายเวลาพัก',
    roomChangeConfirmationForm3: 'ใบยืนยันการเปลี่ยนห้อง',
    conferenceCorps: 'กรุ๊ปประชุม',
    tourParty: 'กรุ๊ปทัวร์',
    confirmNeedToResumeCheckIn: 'ยืนยันต้องการกู้คืนการเข้าพักหรือไม่',
    operationReminder: 'คำเตือนการดำเนินการ',
    reinstatedCheckInSuccessful: 'กู้คืนการเข้าพักสำเร็จ',
    fullDayRoomTransfersAreNotSupportedForOnlineOrders:
      'ออเดอร์ออนไลน์ไม่รองรับการเปลี่ยนเป็นห้องเต็มวัน',
    whetherToCancelTheRowRoomAndTransferToTheFullDay:
      'ยกเลิกการจัดห้องและเปลี่ยนเป็นห้องเต็มวันหรือไม่',
    areYouSureYouWantToChangeToAFullDayRoom: 'ยืนยันเปลี่ยนเป็นห้องเต็มวันหรือไม่',
    checkOutTimeWillBeChangedTo2: 'เปลี่ยนเป็นห้องเต็มวันแล้ว เวลาเช็คเอาต์จะถูกปรับเป็น',
    theRoomIsIn: 'ห้องอยู่ใน',
    existingRowHouse: 'มีการจัดห้องอยู่แล้ว',
    conversionToFullDayRoomSuccessful: 'เปลี่ยนเป็นห้องเต็มวันสำเร็จ',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2:
      'คำสั่ง Fliggy Credit Stay ไม่รองรับห้องเชื่อม',
    generatePassword2: 'กำลังสร้างรหัสผ่าน',
    passwordGeneratedSuccessfully: 'สร้างรหัสผ่านสำเร็จ',
    areYouSureYouWantToResetYourCurrentPassword: 'ยืนยันรีเซ็ตรหัสผ่านปัจจุบันหรือไม่',
    resetPassword2: 'กำลังรีเซ็ตรหัสผ่าน',
    resetPasswordSuccessfully: 'รีเซ็ตรหัสผ่านสำเร็จ',
    areYouSureYouWantToInvalidateYourCurrentPassword: 'ยืนยันทำให้รหัสผ่านเป็นโมฆะหรือไม่',
    thePasswordIsInvalid: 'กำลังทำให้รหัสผ่านเป็นโมฆะ',
    thePasswordIsInvalidProcedure: 'ทำให้รหัสผ่านเป็นโมฆะสำเร็จ',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
      'เลยเวลาเช็คเอาต์แล้ว ไม่สามารถเปลี่ยนห้องได้',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
      'เลยเวลาเช็คเอาต์แล้ว ไม่สามารถอัปเกรดห้องได้',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
      'เลยเวลา 6 โมงของวันเข้าพัก ไม่สามารถอัปเกรดห้องได้',
    theGuestHasAppliedForOnlineRenewalAndMayNotBeAbleToRenewTheOrder:
      'แขกได้ยื่นคำขอต่ออายุออนไลน์แล้ว การดำเนินการต่ออาจไม่สามารถเปลี่ยนคำสั่งขยายเวลาพักได้',
    flyingPigCreditOrdersCanNotBeSustained2: 'คำสั่ง Fliggy Credit Stay ไม่รองรับการขยายเวลาพัก',
    itHasPassedTheCheckOutDateAndCannotBeExtended2: 'เกินวันที่เช็คเอาต์ ไม่สามารถขยายเวลาพักได้',
    successfulRoomExchange2: 'เปลี่ยนห้องสำเร็จ',
    upgradedRoomTypeData: 'ข้อมูลห้องที่อัปเกรด',
    theOtherRoomsInTheOrderHaveCheckedOutAndThecustomerTypeCannotBeModified:
      'ห้องอื่นในคำสั่งซื้อนี้เช็คเอาต์แล้ว ไม่สามารถแก้ไข “ประเภทลูกค้า” ได้',
    theGuestHasAppliedForOnlineRenewalAndConfirmedTheNeedToContinueChangingRooms:
      'แขกได้ยื่นคำขอต่ออายุออนไลน์แล้ว ยืนยันว่าต้องการเปลี่ยนห้องต่อไปหรือไม่?',
  },
  roomOrderListGroupRoomDetail: {
    contactNumber4: 'เบอร์ผู้ติดต่อ',
    aTotalOf: 'รวม',
    occupancyStatus: 'สถานะการเข้าพัก',
    onAccount2: 'พักหนี้',
    rollOut: 'โอนออก',
    setAsMaster: 'ตั้งเป็นใบหลัก',
    rescission: 'ยกเลิกห้องเชื่อม',
    teamRegistrationSheet: 'แบบฟอร์มลงทะเบียนทีม',
    numberOfRooms: 'จำนวนห้อง',
    confirmToCancelTheHouseRelationship: 'ยืนยันการยกเลิกห้องเชื่อม',
    successfullyDisconnectingTheHouse: 'ยกเลิกห้องเชื่อมสำเร็จ',
    rollOutSuccess: 'โอนออกสำเร็จ',
    setTheMasterOrderToSucceed: 'ตั้งเป็นใบหลักสำเร็จ',
  },
  roomOrderListMinusroomer: {
    residentGuest: 'ผู้เข้าพักปัจจุบัน',
    reduceRoommateSuccess: 'ลดผู้ร่วมพักสำเร็จ',
    decamping: 'ลดผู้ร่วมพัก',
    pleaseSelectTheNumberOfPeopleYouWantToReduce: 'โปรดเลือกจำนวนผู้ที่ต้องการลบ',
    keepAtLeastOneOccupantInTheRoom: 'ต้องมีอย่างน้อย 1 ผู้เข้าพักในห้อง',
  },
  roomOrderListRelativeRoom: {
    roomOrder: 'รายการห้องพัก',
    reservationOrder: 'รายการจอง',
    pendingCheckIn: 'รอเช็คอิน',
    pleaseSelectARoomOrder: 'กรุณาเลือกรายการห้องพัก',
    linkRoomNumber: 'หมายเลขห้องเชื่อม',
    inTheRoom: 'ห้องที่พักอยู่',
    residentialTeam: 'ทีมที่พักอยู่',
    flyingPigCreditDoesNotSupportHousing: 'Fliggy Credit Stay ไม่รองรับห้องเชื่อม',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
      'ช่องทางเชื่อมต่อโดยตรงไม่รองรับการทำห้องเชื่อมกับช่องทางร้านค้า',
    guestsNameMobilePhoneNumberAndRoomNumber: 'ชื่อผู้เข้าพัก เบอร์โทร หมายเลขห้อง',
    teamNameBookingPersonNameMobilePhoneNumber: 'ชื่อทีม ชื่อผู้จอง เบอร์โทร',
    pleaseSelectATeam: 'โปรดเลือกทีม',
    joinTheTeamSuccessfully: 'เข้าร่วมทีมสำเร็จ',
    joinTheRoomSuccessfully: 'เข้าร่วมห้องสำเร็จ',
  },
  roomOrderListRollin: {
    flyingPigCreditDoesNotSupportHousing: 'Fliggy Credit Stay ไม่รองรับห้องเชื่อม',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
      'ช่องทางเชื่อมต่อโดยตรงไม่รองรับการทำห้องเชื่อมกับช่องทางร้านค้า',
    transferIn: 'โอนเข้าห้องเชื่อม',
    namePhoneNumberRoomNumber2: 'ชื่อผู้เข้าพัก เบอร์โทร หมายเลขห้อง',
    succeededInJoiningTheHouse: 'เข้าร่วมห้องเชื่อมสำเร็จ',
  },
  roomOrderListRoomOrderDetail: {
    twinRooms: 'ห้องเชื่อม',
    roomList: 'รายการใบห้อง',
    noRoomListingInformationAvailable: 'ไม่มีข้อมูลใบห้อง',
    manage: 'จัดการ',
    fullState: 'สถานะทั้งหมด',
    finance3: 'การเงิน',
    preAuthorizationDetail: 'รายละเอียดพรีออธอไรซ์',
    houseDetails: 'รายละเอียดห้องเชื่อม',
    listingDetails: 'รายละเอียดใบห้อง',
    thereAreNoOccupants: 'ไม่มีผู้เข้าพัก',
  },
  roomOrderListRoomOrderList: {
    durationOfResidence: 'เวลาเข้าพัก',
    // Part 16, lines 3001 to 3200
    bookingTime: 'เวลาจอง',
    room2: 'ห้อง',
    doNotGift: 'ไม่มอบให้',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery:
      'ชื่อ/เบอร์โทร/หมายเลขออเดอร์/หมายเลขออเดอร์ช่องทาง',
    multipleSearch: 'ค้นหาแบบหลายเงื่อนไข',
    bonusPoints: 'มอบแต้ม',
    subscriber: 'ผู้จอง',
    subscriberNumber: 'เบอร์โทรผู้จอง',
    areYouSureYouWantToGiveAwayPoints: 'ยืนยันว่าจะมอบแต้มใช่หรือไม่',
    rewardPointsSuccessfully: 'มอบแต้มสำเร็จ',
    guestphone: 'ผู้เข้าพัก/โทรศัพท์',
    actualCheckoutTime: 'เวลาเช็คเอาท์จริง',
  },
  faceFacedialog: {
    faceCollection: 'เก็บข้อมูลใบหน้า',
    faceCollectionSuccess: 'เก็บข้อมูลใบหน้าสำเร็จ',
    faceCollectionFailure: 'เก็บข้อมูลใบหน้าล้มเหลว',
    takeAPicture: 'ถ่ายรูป',
    upload: 'อัปโหลด',
    upCross: 'กำลังอัปโหลด',
    uploadingPhotosPleaseCloseLater: 'กำลังอัปโหลดรูปภาพ โปรดปิดภายหลัง',
    pleaseTakeAPictureFirst: 'โปรดถ่ายรูปก่อน',
    collectionSuccess: 'เก็บข้อมูลสำเร็จ',
    collectionFailedPleaseTryAgain: 'เก็บข้อมูลล้มเหลว โปรดลองอีกครั้ง!',
  },
  printtemplateChangeroom: {
    theOriginal: 'เดิม',
    changeDate: 'วันที่เปลี่ยนห้อง',
    roomRateUpgrade: 'ปรับราคาห้องเพิ่ม:',
    roomRate: 'ราคาห้อง:',
  },
  printtemplateChangeroomprintsmall: {
    changeDate: 'วันที่เปลี่ยนห้อง',
    checkOutTime: 'เวลาเช็คเอาต์',
    theOriginal: 'เดิม',
  },
  printtemplateGroupordertableprint: {
    position: 'ตำแหน่ง',
  },
  printtemplateStayinprint: {
    confidentiality: 'เป็นความลับ',
  },
  printtemplateStaymore: {
    departureDate: 'วันที่ออกพักเดิม',
    newDepartureDate: 'วันที่ออกพักใหม่',
  },
  printtemplateStaymoreprint: {
    departureDate: 'วันที่ออกพักเดิม',
    newDepartureDate: 'วันที่ออกพักใหม่',
  },
  noticeOrdernotice: {
    messageCenter: 'ศูนย์ข้อความ',
    orderInformation: 'ข้อมูลคำสั่งซื้อ',
    dynamic: 'ข้อความเคลื่อนไหว',
    settlement: 'ข้อความเกี่ยวกับการชำระบัญชี',
    system: 'ข้อความระบบ',
    noData: 'ยังไม่มีข้อความใหม่',
    dynamicInformation: 'ข้อมูลข้อความเคลื่อนไหว',
    systemInformation: 'ข้อมูลข้อความระบบ',
    nightTrialFailTitle: 'Night Audit ล้มเหลว',
    nightTrialFailContent: 'Night Audit ล้มเหลว กรุณาดำเนินการโดยเร็ว',
  },
  noticeServicemanage: {
    serviceManagement: 'การจัดการใบงานบริการ',
    roomService: 'บริการห้องพัก',
    itemBorrow: 'การยืมของ',
    extendStay: 'บริการต่ออายุการเข้าพัก',
  },
  operatelogLog: {
    nightAuditLog: 'บันทึก Night Audit',
    downloadLog: 'ดาวน์โหลดบันทึก',
    downloadSuccessfully: 'ดาวน์โหลดสำเร็จ',
  },
  operatelogNightauditlog: {
    nightTrialMethod: 'วิธี Night Audit',
    nightTrialResult: 'ผล Night Audit',
    manualNightAudit: 'Night Audit แบบทำด้วยตนเอง',
    automaticNightAudit: 'Night Audit อัตโนมัติ',
    nightAuditFailure: 'Night Audit ล้มเหลว',
    successfulNightAudit: 'Night Audit สำเร็จ',
    nightTrialDate: 'วันที่ Night Audit',
    nightAuditRecord: 'ประวัติ Night Audit',
  },
  operatelogWorkingday: {
    variableMode: 'วิธีการเปลี่ยนแปลง',
  },
  financeAccountsreceivableaging: {
    bookName: 'ชื่อชุดบัญชี',
    totalAmountReceivable: 'ยอดต้องรับรวม',
    amountPayable030Days: 'ยอดต้องรับ (0–30 วัน)',
    amountPayable3160Days: 'ยอดต้องรับ (31–60 วัน)',
    amountPayable6190Days: 'ยอดต้องรับ (61–90 วัน)',
    amountToBeCollected91DaysOrMore: 'ยอดต้องรับ (91 วันขึ้นไป)',
    typeOfExchange: 'ประเภทการเปลี่ยนห้อง',
    originalRoomNumber: 'หมายเลขห้องเดิม',
    existingRoomNumber: 'หมายเลขห้องปัจจุบัน',
    currentHouseType: 'ประเภทห้องปัจจุบัน',
    roomChangeTime: 'เวลาเปลี่ยนห้อง',
    changeRoomsAfterCheckIn: 'เปลี่ยนห้องหลังเช็คอิน',
    originalRoomRate: 'ราคาห้องเดิม',
    spotRate: 'ราคาห้องปัจจุบัน',
  },
  financeAdjustmentCash: {
    financialStatement: 'รายการเคลื่อนไหวการเงิน',
    occurrenceTime: 'เวลาที่เกิดรายการ',
    reconciliationStatement: 'รายงานปรับบัญชี',
  },
  financeAr: {
    channelReconciliationReport: 'รายงานกระทบยอดช่องทาง',
    writeOffStatus: 'สถานะหักล้าง',
    amountOnCredit: 'ยอดพักหนี้',
    estimatedSettlementPrice: 'ราคาชำระบัญชีโดยประมาณ',
    unapprovedAmount: 'ยอดยังไม่ตรวจสอบ',
    guestInvoiceRequirement: 'ความต้องการใบกำกับภาษีของแขก',
    roomNumbername: 'หมายเลขห้อง/ชื่อ',
  },
  financeBreakfastStatistic: {
    flatBreakfast: 'ห้องรวมอาหารเช้า',
    advancePurchase: 'ซื้ออาหารเช้าล่วงหน้า',
    availableBreakfasts: 'จำนวนอาหารเช้าที่ใช้ได้',
    verifiedBreakfasts: 'อาหารเช้าที่ตรวจแล้ว',
    breakfastAmount: 'ยอดเงินอาหารเช้า',
    breakfastStatisticsReport: 'รายงานสถิติอาหารเช้า',
    breakfastStatisticsReportxls: 'รายงานสถิติอาหารเช้า.xls',
  },
  financeChannelConsume: {
    typeOfCompany: 'ประเภทธุรกิจ',
    roomNights: 'จำนวนห้อง-คืน',
  },
  financeCheckout: {
    checkOutBusinessDay: 'วันทำการของวันเช็คเอาต์',
    helpOneself: 'ใช้เอง',
    team2: 'กรุ๊ป',
    checkOutStatement: 'รายงานเช็คเอาต์และชำระเงิน',
  },
  financeCreatedCompanyAccountOfAge: {
    scale: 'สัดส่วน',
    aged180DaysOrMore: 'อายุบัญชีเกิน 180 วัน',
    agingStatementOfCreditCompany: 'รายงานอายุบัญชีบริษัทเครดิต',
    accountAge030Days: 'อายุบัญชี 0–30 วัน',
    accountAge3160Days: 'อายุบัญชี 31–60 วัน',
    accountAge6190Days: 'อายุบัญชี 61–90 วัน',
    accountAge91180Days: 'อายุบัญชี 91–180 วัน',
  },
  financeDemandAccount: {
    collectTheRoomChargeInAdvance: 'เก็บค่าห้องล่วงหน้า',
    estimatedArrears: 'หนี้คาดการณ์',
    collectionStatement: 'รายงานทวงหนี้',
  },
  financeHangAccount: {
    accountStatus: 'สถานะบัญชี',
    businessDayOfHangingAccount: 'วันทำการของการพักหนี้',
    hangTheAccountOperator: 'ผู้ดำเนินการพักหนี้',
    currentBalance: 'ยอดคงเหลือปัจจุบัน',
    closingTime: 'เวลาเช็คเอาต์/ปิดบัญชี',
    noteOfHangingAccount: 'หมายเหตุการพักหนี้',
    temporaryDebitStatement: 'รายงานพักหนี้ชั่วคราว',
    membercompany: 'สมาชิก/บริษัท',
  },
  financeInventoryInOut: {
    inOutDate: 'วันที่รับ-จ่ายสต็อก',
    storageType: 'วิธีรับ-จ่ายสต็อก',
    storageTypeOut: 'จ่ายออก',
    fileName: 'รายงานรับ-จ่ายสต็อก',
    columns: {
      inStoragePrice: 'ยอดรับเข้า',
      outStoragePrice: 'ยอดจ่ายออก',
    },
  },
  financeHousekeeping: {
    cleaningDate: 'วันที่ทำความสะอาด',
    cleanType: 'ประเภทการทำความสะอาด',
    cleaner: 'พนักงานทำความสะอาด',
    status: 'สถานะใบงาน',
    dailyCleaningAndLinen: 'ทำความสะอาดประจำวัน + เปลี่ยนชุดเครื่องนอน',
    dailyCleaning: 'ทำความสะอาดประจำวัน',
    dispatchTime: 'เวลาส่งงาน',
    cleanTime: 'เวลาทำความสะอาด',
    checkRoomTime: 'เวลาเช็กห้อง',
    recleaningReason: 'เหตุผลที่ต้องทำความสะอาดซ้ำ',
    checkerName: 'หัวหน้าตรวจห้อง',
    statuses: {
      toBeCleared: 'รอทำความสะอาด',
      finishCleaning: 'ทำความสะอาดเสร็จ',
      noCleaning: 'ไม่ต้องทำความสะอาด',
      cancelOrder: 'ยกเลิกใบงาน',
      unauditedRoom: 'รอตรวจห้อง',
      wardRoundRejection: 'ตรวจห้องไม่ผ่าน',
    },
  },
  settingHousekeeping: {
    cleaners: 'พนักงานทำความสะอาด',
    selectCleaners: 'โปรดเลือกพนักงานทำความสะอาด',
    onDutyConfig: 'ตั้งค่าเวลาปฏิบัติงานของพนักงานทำความสะอาด',
    roomAssign: 'การจัดสรรห้อง',
    assignMode: {
      free: 'จัดสรรอิสระ',
      byFloor: 'จัดสรรตามชั้น',
      byRoom: 'จัดสรรตามห้อง',
    },
    viewAssign: 'ดูการจัดสรร',
    cleanerPrefix: 'ทำความสะอาด:',
    autoDispatchConfig: 'ตั้งค่าการส่งใบงานทำความสะอาดอัตโนมัติ',
    autoDispatch: {
      off: 'ปิดการส่งใบงานอัตโนมัติ',
      // Part 17, lines 3201 to 3400
      on: 'เปิดการมอบหมายงานอัตโนมัติ',
    },
    autoDispatchRoomType: 'ประเภทห้องสำหรับมอบหมายงานอัตโนมัติ',
    leaveRoom: 'ห้องเช็คเอาต์',
    stayRoom: 'ห้องพักอยู่',
    dispatchRule: 'กฎการจัดสรรงานทำความสะอาด',
    rules: {
      byTotal: 'แบ่งจำนวนใบงานที่ต้องทำต่อคนแบบเฉลี่ย',
      byPending: 'แบ่งจำนวนใบงานค้างต่อคนแบบเฉลี่ย',
    },
    leaveCleanType: 'ประเภทการทำความสะอาดห้องเช็คเอาต์ของระบบอัตโนมัติ',
    stayCleanType: 'ประเภทการทำความสะอาดห้องพักอยู่ของระบบอัตโนมัติ',
    dispatchTimeForStay: 'เวลาส่งงานสำหรับห้องพักอยู่',
    afterCleanCheck: 'ต้องตรวจห้องหลังทำความสะอาดหรือไม่',
    needCheck: {
      no: 'ไม่ต้องการ',
      yes: 'ต้องการ',
    },
    dialog: {
      assignRelation: 'ความสัมพันธ์การจัดสรร',
      selectFloor: 'โปรดเลือกชั้น',
    },
    messages: {
      selectCleaners: 'โปรดเลือกพนักงานทำความสะอาด',
      dutyTimeInvalid: 'เวลาสิ้นสุดของกะทำงานต้องไม่ก่อนเวลาเริ่มต้น',
    },
  },
  financeBreakfastDetails: {
    mealDate: 'วันที่รับประทาน',
    includeWaitingForCheckIn: 'รวมถึงห้องที่รอเช็คอินหรือไม่',
    title: 'รายงานรายละเอียดอาหารเช้า',
    columns: {
      guestNum: 'จำนวนคน',
      roomContainsBreakfastNum: 'ห้องรวมอาหารเช้า',
      buyBreakfastNum: 'ซื้ออาหารเช้า',
      useBreakfastNum: 'จำนวนใช้จริง',
    },
  },
  breakfastVerification: {
    checkedInRoomList: 'รายการห้องที่เข้าพักอยู่',
    roomNo: 'เลขห้อง',
    breakfastCount: 'จำนวนอาหารเช้า',
    verified: 'ตรวจแล้ว',
    buyBreakfast: 'ซื้ออาหารเช้า',
    verificationRecord: 'บันทึกการตรวจ',
    verificationTime: 'เวลาตรวจ',
    cardReading: 'กำลังอ่านบัตร',
    swipeCardVerification: 'แตะบัตรเพื่อตรวจ',
    breakfastVerification: 'ตรวจอาหารเช้า',
    pendingBreakfast: 'อาหารเช้ารอตรวจ',
    verificationCount: 'จำนวนที่ตรวจ',
    confirmVerification: 'ยืนยัน',
    noRoomRead: 'ไม่พบข้อมูลห้อง',
    cardReadFailed: 'อ่านบัตรไม่สำเร็จ โปรดตรวจสอบบัตรห้องหรือเครื่องอ่านบัตร',
    noPendingBreakfast: 'ห้องนี้ไม่มีอาหารเช้ารอตรวจ',
    verificationCountPositive: 'จำนวนที่ตรวจต้องมากกว่า 0',
    verificationCountExceedsPending: 'จำนวนที่ตรวจต้องไม่เกินจำนวนอาหารเช้ารอตรวจ',
    verificationSuccess: 'ตรวจสำเร็จ',
  },
  buyBreakfastDialog: {
    title: 'ซื้ออาหารเช้า',
    entryAccount: 'บัญชีลงรายการ',
    count: 'จำนวน',
    totalAmount: 'ยอดรวม',
    payVerificationCode: 'รหัสยืนยันการชำระเงิน',
    positiveMoney: 'กรุณาใส่จำนวนเงินมากกว่า 0 และทศนิยมไม่เกิน 2 ตำแหน่ง',
    positiveInteger: 'กรุณาใส่จำนวนเต็มมากกว่า 0',
    priceRequired: 'กรุณาใส่ราคาต่อหน่วย',
    countRequired: 'กรุณาใส่จำนวน',
    roomOrderNoMissing: 'ไม่พบเลขคำสั่งห้อง ไม่สามารถซื้ออาหารเช้าได้',
    selectAccountSet: 'กรุณาเลือกชุดบัญชี',
    onlinePaymentFailed: 'รับชำระออนไลน์ไม่สำเร็จ',
    paymentIncomplete: 'การชำระเงินยังไม่เสร็จ จึงยังไม่สร้างรายการอาหารเช้า',
    buySuccess: 'ซื้ออาหารเช้าสำเร็จ',
  },
  financeBreakfastVerificateDetail: {
    title: 'รายงานรายละเอียดการตรวจอาหารเช้า',
  },
  readDoorCardRoom: {
    lockNotConfigured: 'ยังไม่ได้ตั้งค่าหรือเปิดใช้งานกลอนประตู',
    getLockInfoFailed: 'รับข้อมูลกลอนประตูไม่สำเร็จ',
    readCardTimeout: 'อ่านบัตรหมดเวลา โปรดตรวจสอบเครื่องอ่านบัตร',
    emptyCard: 'บัตรนี้เป็นบัตรว่าง โปรดออกบัตรก่อน',
    notGuestCard: 'บัตรนี้ไม่ใช่บัตรผู้เข้าพัก โปรดออกบัตรใหม่',
    readCardServiceFailed: 'อ่านบัตรไม่สำเร็จ โปรดติดต่อฝ่ายสนับสนุนเพื่อตรวจสอบบริการฮาร์ดแวร์',
    readCardFailed: 'อ่านบัตรไม่สำเร็จ โปรดตรวจสอบบัตรห้องหรือเครื่องอ่านบัตร',
    noRoomInfo: 'ไม่พบข้อมูลห้อง',
    unsupportedLockReadMode: 'ยังไม่รองรับวิธีอ่านบัตรของกลอนประตูปัจจุบัน',
  },
  financePreauth: {
    authorizationStatus: 'สถานะการอนุมัติ',
    authorizationDate: 'วันที่อนุมัติ',
    settlementDate: 'วันที่ชำระบัญชี',
    expirationDate: 'วันที่หมดอายุ',
    preAuthorizationStatement: 'รายงานการอนุมัติวงเงิน',
    settlementTime: 'เวลาชำระบัญชี',
  },
  financeRedeemDetail: {
    dateType: 'ประเภทรายการวันที่',
    writeOffDate: 'วันที่หักล้าง',
    dateOfPosting: 'วันที่พักหนี้',
    dateOfEntry2: 'วันที่บันทึกบัญชี',
    bookType: 'ประเภทบัญชี',
    businessDayOfHangingAccount: 'วันทำการของการพักหนี้',
    hangTheAccountOperator: 'ผู้ดำเนินการพักหนี้',
    theRoomNumberIsCharged: 'หมายเลขห้องที่พักหนี้',
    writeOffTheAmountCredited: 'ยอดเงินหักล้างที่บันทึก',
    writeOffTheEntryTime: 'เวลาบันทึกการหักล้าง',
    writeOffTheAccountOperator: 'ผู้ดำเนินการบันทึกการหักล้าง',
    amountWrittenOff2: 'ยอดหักล้าง',
    writeOffTime: 'เวลาหักล้าง',
    writeOffTheOperator: 'ผู้ดำเนินการหักล้าง',
    channelWriteOffDetailReport: 'รายงานรายละเอียดการหักล้างของช่องทาง',
  },
  financeRushCash: {
    financialStatement: 'รายการเคลื่อนไหวการเงิน',
    occurrenceTime: 'เวลาที่เกิดรายการ',
    debitStatement: 'รายงานการตัดบัญชี',
  },
  financeSellRank: {
    agreementUnitConsumptionRankingTable: 'ตารางจัดอันดับการบริโภคของหน่วยงานข้อตกลง',
  },
  financeTodayGuestBalance: {
    roomFee3: 'ค่าห้อง',
    balanceSheetForGuestsInResidence: 'รายงานยอดคงเหลือของแขกที่พักอยู่',
  },
  financeTransferCash: {
    turnOutOfRoom: 'โอนออกจากห้อง',
    bookkeepingTime: 'เวลาบันทึกบัญชี',
    turnIntoARoom: 'โอนเข้าห้อง',
    transferTime: 'เวลาโอน',
    transferStatement: 'รายงานการโอน',
  },
  financeZeroRoomFee: {
    zeroRoomRateReport: 'รายงานห้องฟรี',
  },
  incomeBaseprice: {
    totalRevenue: 'รายได้รวม',
    roomNight: 'จำนวนห้อง-คืนรวม',
    storeRevenue: 'รายได้ร้าน',
    interstoreNight: 'จำนวนห้อง-คืนของร้าน',
    directRevenuebasePrice: 'รายได้ช่องทางตรง (ราคาพื้นฐาน)',
    straightInternight: 'จำนวนห้อง-คืนช่องทางตรง',
    miniProgramRevenuebasePrice: 'รายได้มินิโปรแกรม (ราคาพื้นฐาน)',
    smallProgramNight: 'จำนวนห้อง-คืนมินิโปรแกรม',
    xinmeituanDirectRevenuebasePrice: 'รายได้ Meituan ตรงใหม่ (ราคาพื้นฐาน)',
    newUnitedStatesGroupStraightInternight: 'จำนวนห้อง-คืน Meituan ตรงใหม่',
    ctripDirectRevenuebasePrice: 'รายได้ Ctrip ตรง (ราคาพื้นฐาน)',
    ctripDirectConnectionBetweenNight: 'จำนวนห้อง-คืน Ctrip ตรง',
    directRevenuebasePrice2: 'รายได้ Tongcheng ตรง (ราคาพื้นฐาน)',
    theSameJourneyDirectlyConnectedToTheNight: 'จำนวนห้อง-คืน Tongcheng ตรง',
    qunarDirectRevenuebasePrice: 'รายได้ Qunar ตรง (ราคาพื้นฐาน)',
    whereToGoStraightToTheNight: 'จำนวนห้อง-คืน Qunar ตรง',
    tiktokDirectRevenuebasePrice: 'รายได้ Douyin ตรง (ราคาพื้นฐาน)',
    tiktokStraightBetweenNight: 'จำนวนห้อง-คืน Douyin ตรง',
    flyingPigDirectRevenuebasePrice: 'รายได้ Feizhu ตรง (ราคาพื้นฐาน)',
    flyingPigsStraightInternight: 'จำนวนห้อง-คืน Feizhu ตรง',
    baiduMapRevenuebasePrice: 'รายได้ Baidu Maps (ราคาพื้นฐาน)',
    baiduMapNight: 'จำนวนห้อง-คืน Baidu Maps',
    jingdongDirectRevenuebasePrice: 'รายได้ JD ตรง (ราคาพื้นฐาน)',
    jingdongDirectConnectionBetweenNight: 'จำนวนห้อง-คืน JD ตรง',
    lightResidentialAndCommercialTravelRevenuebasePrice:
      'รายได้ท่องเที่ยวธุรกิจ LightStay (ราคาพื้นฐาน)',
    lightStayBusinessNights: 'จำนวนห้อง-คืนท่องเที่ยวธุรกิจ LightStay',
    lightHomeDistributionRevenuebasePrice: 'รายได้จัดจำหน่าย LightStay (ราคาพื้นฐาน)',
    lightNightInTheDistributionRoom: 'จำนวนห้อง-คืนจัดจำหน่าย LightStay',
    storeAdr: 'ADR ร้าน',
    usGroupEbRevenue: 'รายได้ Meituan EB',
    usGroupEbNight: 'ห้อง-คืน Meituan EB',
    meituanEbadr: 'ADR Meituan EB',
    ctripEbRevenue: 'รายได้ Ctrip EB',
    ctripEbNight: 'ห้อง-คืน Ctrip EB',
    ctripEbadr: 'ADR Ctrip EB',
    flyingPigEbRevenue: 'รายได้ Feizhu EB',
    flyingPigEbNight: 'ห้อง-คืน Feizhu EB',
    ebadrTheFlyingPig: 'ADR Feizhu EB',
    douyinGroupPurchaseEbRevenue: 'รายได้ Douyin Group EB',
    douyinGroupPurchaseEbNight: 'ห้อง-คืน Douyin Group EB',
    douyinGroupPurchaseEbadr: 'ADR Douyin Group EB',
    directAdrbasePrice: 'ADR ช่องทางตรง (ราคาพื้นฐาน)',
    miniProgramAdrbasePrice: 'ADR มินิโปรแกรม (ราคาพื้นฐาน)',
    newMeituanDirectAdrbasePrice: 'ADR Meituan ตรงใหม่ (ราคาพื้นฐาน)',
    directRouteAdrbasePrice: 'ADR Ctrip ตรง (ราคาพื้นฐาน)',
    sameRouteDirectAdrbasePrice: 'ADR Tongcheng ตรง (ราคาพื้นฐาน)',
    whereToDirectAdrbasePrice: 'ADR Qunar ตรง (ราคาพื้นฐาน)',
    tiktokDirectAdrbasePrice: 'ADR Douyin ตรง (ราคาพื้นฐาน)',
    flyingPigDirectAdrbasePrice: 'ADR Feizhu ตรง (ราคาพื้นฐาน)',
    baiduMapAdrbasePrice: 'ADR Baidu Maps (ราคาพื้นฐาน)',
    jingdongDirectLinkAdrbasePrice: 'ADR JD ตรง (ราคาพื้นฐาน)',
    lightResidentialAndBusinessAdrbasePrice: 'ADR ธุรกิจ LightStay (ราคาพื้นฐาน)',
    lightLiveDistributionAdrbasePrice: 'ADR จัดจำหน่าย LightStay (ราคาพื้นฐาน)',
  },
  incomeExpense: {
    consumptionAccountStatisticsReport: 'รายงานสถิติการใช้จ่าย',
    accountId: 'รหัสบัญชี',
    roomNumbername: 'ห้อง/ชื่อ',
  },
  incomeGuestSourceDetail: {
    selfUseRoom: 'ห้องใช้ภายใน',
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
      'ข้อมูลจำนวนห้อง-คืนอิงตามวันทำการที่ค้นหา',
    calculationMode: 'วิธีการคำนวณ',
    guestCheckInDetailsReport: 'รายงานรายละเอียดการเข้าพักของแขก',
    freeRoom: 'ห้องฟรี',
    teamRoom: 'ห้องกรุ๊ป',
    singleRoom: 'ห้องแบบสัญญารายเดือน',
    roomRate2: 'ยอดค่าห้อง',
  },
  incomeHandleover: {
    shiftSummaryStatisticsReport: 'รายงานสรุปการส่งกะ',
    income: 'รายรับ',
    disburse: 'รายจ่าย',
    totalAmount: 'ยอดรวม',
    shiftSummaryReport: 'รายงานสรุปการส่งกะ',
  },
  incomeManageSingle: {
    category: 'หมวดหมู่',
    today: 'วันนี้',
    accumulatedThisMonth: 'สะสมเดือนนี้',
    lastMonthCumulative: 'สะสมเดือนที่แล้วช่วงเดียวกัน',
    monthlyGrowthRate: 'อัตราการเติบโตประจำเดือน',
    currentYearAccumulation: 'สะสมปีนี้',
    accumulatedInTheSamePeriodOfLastYear: 'สะสมช่วงเดียวกันปีที่แล้ว',
    annualGrowthRate: 'อัตราการเติบโตประจำปี',
    operatingStatementsingleDay: 'รายงานการดำเนินงาน (รายวัน)',
    operatingStatementOneDayxlsx: 'รายงานการดำเนินงานรายวัน.xlsx',
    orderSourceBedNightsIncludeFreeRoomsAndSelfUsedRoomNights:
      'จำนวนห้อง-คืนจากแหล่งที่มาของออเดอร์: รวมถึงห้องฟรีและห้องใช้เอง',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
      'อัตราการเช่า (ไม่รวมใช้เองและห้องฟรี) = จำนวนห้อง-คืนที่เช่า (ไม่รวมใช้เอง/ฟรี) ÷ จำนวนห้องทั้งหมด',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
      'รายได้ค่าห้องรวม (รวมคอมมิชชั่น): ไม่รวมใช้เอง/ห้องฟรี',
    youHaveNotOpenedThecustomerCheckInDetailsReportViewingPermission:
      'คุณยังไม่ได้เปิดสิทธิ์ดูรายงานรายละเอียดแขกเข้าพัก',
    averageRoomRate:
      'ราคาห้องเฉลี่ย (ไม่รวมใช้เอง/ฟรี) = รายได้ค่าห้องรวม ÷ จำนวนห้อง-คืนที่เช่า (ไม่รวมใช้เอง/ฟรี)',
    revparFormula: 'RevPAR = รายได้ค่าห้องรวม ÷ จำนวนห้องทั้งหมด',
    totalRevenueFormula:
      'รายได้รวม = รายได้ค่าห้องรวม + รายได้อื่นๆ ทั้งหมด (รวมคอมมิชชั่น ไม่รวมยอดเติมเงินสมาชิก)',
  },
  incomeManageTotal: {
    generalLedger: 'บัญชีแยกประเภท',
    totalAverageRoomRateyuan: 'ราคาห้องเฉลี่ยรวม ',
    rentalTotalRoomNightroom: 'จำนวนห้อง-คืนเช่ารวม',
    fullDayRoomNightroom: 'จำนวนห้อง-คืนห้องเต็มวัน',
    longBagRoomNightroom: 'จำนวนห้อง-คืนห้องแบบสัญญารายเดือน',
    hourRoomNightroom: 'จำนวนห้อง-คืนห้องรายชั่วโมง',
    teamRoomNightroom: 'จำนวนห้อง-คืนห้องกรุ๊ป',
    freeRoomNightroom: 'จำนวนห้อง-คืนห้องฟรี',
    privateRoomNightroom: 'จำนวนห้อง-คืนห้องใช้เอง',
    // Part 18, lines 3401 to 3600
    totalRoomRateyuan: 'ค่าห้องรวม ',
    smallCommoditiesyuan: 'สินค้าชิ้นเล็ก ',
    mealFeeyuan: 'ค่าอาหาร ',
    serviceChargeyuan: 'ค่าบริการ ',
    membershipFeermb: 'ค่าสมาชิก ',
    otherExpensesyuan: 'ค่าใช้จ่ายอื่น ๆ ',
    totalRevenue: 'รายได้รวมจากการดำเนินงาน ',
    totalRevenueWithTax: 'รายได้รวม (รวมภาษี)',
    roomNightsroom: 'จำนวนห้อง-คืน (ห้อง)',
    averageRoomRateyuan: 'ราคาห้องเฉลี่ย ',
    totalRoomRateyuan2: 'รวมค่าห้อง ',
    operatingStatementcumulative: 'รายงานการดำเนินงาน (สะสม)',
    theQueryTimeRangeCannotBeLongerThanOneYear: 'ช่วงเวลาที่ค้นหาไม่สามารถเกินหนึ่งปีได้',
    totalOccupancyRate: 'อัตราการเข้าพักรวม (%)',
    fullDayOccupancyRate: 'อัตราการเข้าพักห้องเต็มวัน (%)',
    hourlyOccupancyRate: 'อัตราการเข้าพักห้องรายชั่วโมง (%)',
    lettingRate: 'อัตราการเช่า (%)',
    internightRatio: 'สัดส่วนห้อง-คืน (%)',
    totalRevpar: 'REVPAR รวม ',
    cumulativeOperatingStatementxls: 'รายงานการดำเนินงานแบบสะสม.xls',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
      'อัตราการเช่า (หักห้องใช้เอง/ห้องฟรี) = ห้อง-คืนที่เช่า (หักห้องใช้เอง/ห้องฟรี) ÷ จำนวนห้องทั้งหมด',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
      'รายได้ค่าห้องรวม (รวมค่าคอมมิชชั่น): ไม่รวมฟรี/ห้องใช้เอง',
    averageRoomRate:
      'ราคาห้องเฉลี่ย (หักห้องใช้เอง/ห้องฟรี) = รายได้ค่าห้องรวม ÷ ห้อง-คืนที่เช่า (หักห้องใช้เอง/ห้องฟรี)',
    totalRevenueFormula:
      'รายได้รวมจากการดำเนินงาน = รายได้ค่าห้องรวม + รายได้อื่นทั้งหมด (รวมคอมมิชชั่น ไม่รวมเติมเงินสมาชิก)',
  },
  incomeOperatingIncome: {
    yesterdaysBalance: 'ยอดคงเหลือเมื่อวาน',
    todaysBalance: 'ยอดคงเหลือวันนี้',
    statisticalStatementOfBusinessIncome: 'รายงานสถิติรายได้ธุรกิจ',
    totalconsumptionTotalPaymentTotal: 'รวม = ยอดใช้จ่ายรวม - ยอดชำระรวม',
    yesterdaysBalancetheHotelsCumulativeConsumptionTotalFromThePreviousBusinessDayMinusPaymentTotal:
      'ยอดคงเหลือเมื่อวาน = ยอดใช้จ่ายสะสมก่อนวันทำการที่ผ่านมา - ยอดชำระรวม',
    todaysBalancetotalyesterdaysBalance: 'ยอดคงเหลือวันนี้ = รวม + ยอดคงเหลือเมื่อวาน',
  },

  incomeBusinessIncomeDetail: {
    reportTitle: 'รายงานรายละเอียดรายได้จากการดำเนินงาน',
    consumeTotal: 'ยอดรวมการบริโภค',
    settleTotal: 'ยอดรวมการรับชำระ',
    roomFee: 'ค่าห้อง',
    mealFee: 'ค่าอาหาร',
    goodsFee: 'สินค้าเล็ก',
    serviceFee: 'ค่าบริการ',
    memberFee: 'ค่าสมาชิก',
    otherConsume: 'การบริโภคอื่นๆ',
    dailyBalance: 'ยอดคงเหลือประจำวัน',
    orderNo: 'เลขที่คำสั่งซื้อ',
    roomOrderNo: 'เลขที่ใบจองห้อง',
    roomNo: 'หมายเลขห้อง',
    guestName: 'ชื่อแขก',
    noData: 'ไม่มีข้อมูล',
  },

  incomeOverduty: {
    category: 'หมวดหมู่',
    firstLevelSubject: 'หมวดหลัก',
    description: 'คำอธิบาย',
    shiftStatisticsReport: 'รายงานสถิติการส่งกะ',
  },

  incomePayExpense: {
    cashPaymentStatement3: 'รายงานรายละเอียดการใช้จ่ายแบบชำระเงินสด',
    abstract: 'สรุปย่อ',
  },

  incomePayment: {
    paymentAccountStatisticsReport: 'รายงานสถิติหมวดการชำระเงิน',
    submitted: 'ส่งแล้ว',
    earlyMorningWatch: 'กะดึก',
    roomNumberName: 'หมายเลขห้อง - ชื่อ',
    dateRangeCannotExceedThreeMonths: 'ช่วงวันที่ค้นหาต้องไม่เกิน 3 เดือน',
  },

  incomeRoomTypeReport: {
    totalRoomRate: 'ค่าห้องรวม',
    numberOfOutages: 'จำนวนห้องปิดใช้',
    numberOfNightsForRent: 'จำนวนห้อง-คืนที่เช่า',
    roomTypeReport: 'รายงานประเภทย่อมห้อง',
    theEndTimeOfTheBusinessDayCannotExceedTheCurrentTime:
      'เวลาสิ้นสุดวันทำการต้องไม่เกินเวลาปัจจุบัน',
    theSelectionPeriodCannotBeLongerThan31Days: 'ช่วงเวลาที่เลือกต้องไม่เกิน 31 วัน',
  },

  incomeSellercount: {
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
      'ข้อมูลจำนวนห้อง-คืนอิงตามวันทำการที่ค้นหา',
    calculationMode: 'วิธีการคำนวณ',
    salesPerformanceStatement: 'รายงานผลการขาย',
    roomFee3: 'ค่าห้อง',
  },

  incomeSmallwaredetail: {
    detailedSalesReportOfSmallGoods: 'รายงานรายละเอียดการขายสินค้าชิ้นเล็ก',
  },

  incomeSmallwaresummary: {
    summaryReportOfSmallCommoditySales: 'รายงานสรุปการขายสินค้าชิ้นเล็ก',
    averageUnitPrice: 'ราคาเฉลี่ยต่อชิ้น',
  },

  kanbanIndex: {
    yesterday: 'เมื่อวาน',
    last7Days: '7 วันที่ผ่านมา',
    lastWeek: 'สัปดาห์ที่แล้ว',
    last30Days: '30 วันที่ผ่านมา',
    lastMonth: 'เดือนที่แล้ว',
    managementProfile: 'ภาพรวมการดำเนินงาน',
    flowConversion: 'การแปลงผลลัพธ์จากทราฟฟิก',
    serviceIndicator: 'ตัวชี้วัดบริการ',
    competitiveCircleAnalysis: 'การวิเคราะห์คู่แข่งในพื้นที่',
    writeAReport: 'เขียนรายงาน',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
      'มิติเวลาสอดคล้องกับวันที่คัดกรอง และจำนวนการจองคำนวณตามยอดชำระจริงของแขก',
    operationPersonnelManagementOverviewSuggestions2:
      'ข้อเสนอแนะด้านภาพรวมการดำเนินงานสำหรับผู้ปฏิบัติงาน',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
      'มิติเวลาตรงกับวันที่คัดกรอง รวมข้อมูลสรุปจากทุกแพลตฟอร์มของ Meituan, Ctrip, Feizhu',
    operationPersonnelFlowConversionSuggestions2: 'ข้อเสนอแนะด้านการแปลงผลลัพธ์ทราฟฟิก',
    theTimeDimensionIsTheEndDateAndTheDayBeforeTheStartDateOfTheCurrentSelectedDateIncludingTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
      'มิติเวลาเป็นวันที่สิ้นสุดที่เลือกและวันก่อนหน้าของวันเริ่มต้น รวมข้อมูลจาก Meituan, Ctrip, Feizhu',
    operationPersonnelServiceIndicatorsSuggestions2: 'ข้อเสนอแนะด้านตัวชี้วัดบริการ',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanAndCtrip:
      'มิติเวลาตรงกับวันที่คัดกรอง รวมข้อมูลจาก Meituan และ Ctrip',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
      'ข้อเสนอแนะด้านการวิเคราะห์คู่แข่งในพื้นที่',
    amountOfExposure: 'ปริมาณการมองเห็น (Exposure)',
    pageView: 'จำนวนการเข้าชม',
    orderQuantity: 'จำนวนคำสั่งซื้อ',
    myExposureCount: 'จำนวนผู้เห็นของฉัน',
    numberOfPeopleExposedInThePreviousIssue: 'จำนวนการเห็นในรอบก่อน',
    myExposureConversionRate2: 'อัตราการแปลงผลลัพธ์จากการเห็นของฉัน',
    previousExposureConversionRate2: 'อัตราการแปลงผลลัพธ์จากการเห็นของรอบก่อน',
    myNumberOfViewers: 'จำนวนผู้ชมของฉัน',
    numberOfVisitorsInTheLastIssue: 'จำนวนผู้ชมในรอบก่อน',
    myConversionRate2: 'อัตราการแปลงเป็นคำสั่งซื้อของฉัน',
    conversionRateOfLastPeriodTransaction2: 'อัตราการแปลงเป็นคำสั่งซื้อของรอบก่อน',
    paymentOrderNumber: 'จำนวนคำสั่งซื้อที่ชำระเงิน',
    myPaymentOrderNumber: 'จำนวนคำสั่งซื้อที่ชำระของฉัน',
    previousPaymentOrderNumber: 'จำนวนคำสั่งซื้อที่ชำระของรอบก่อน',
  },

  kanbanReportManage: {
    reportTitle: 'ชื่อรายงาน',
    reportWriter: 'ผู้เขียนรายงาน',
    reportDate: 'วันที่รายงาน',
    reportNumber: 'หมายเลขรายงาน',
    draft: 'ฉบับร่าง',
    haveReleased: 'เผยแพร่แล้ว',
    reportTime: 'เวลารายงาน',
    exportDaily: 'ส่งออกรายงานประจำวัน',
  },

  kanbanSeeKanban: {
    dataBoard: 'แดชบอร์ดข้อมูล',
    managementProfile: 'ภาพรวมการดำเนินงาน',
    operationPersonnelManagementOverviewSuggestions2: 'ข้อเสนอแนะภาพรวมการดำเนินงาน',
    flowConversion: 'การแปลงผลลัพธ์',
    operationPersonnelFlowConversionSuggestions2: 'ข้อเสนอแนะการแปลงผลลัพธ์',
    serviceIndicator: 'ตัวชี้วัดบริการ',
    operationPersonnelServiceIndicatorsSuggestions2: 'ข้อเสนอแนะตัวชี้วัดบริการ',
    competitiveCircleAnalysis: 'การวิเคราะห์คู่แข่งในพื้นที่',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
      'ข้อเสนอแนะการวิเคราะห์คู่แข่งในพื้นที่',
    theProportionOfSalesAmount: 'สัดส่วนยอดขาย',
    salesRoomNightProportion: 'สัดส่วนห้อง-คืนขาย',
    noProposal: 'ยังไม่มีข้อเสนอแนะ',
  },

  componentsDataReport: {
    compose: 'เขียน',
    dataReport: 'รายงานข้อมูล',
    reportType: 'ประเภทรายงาน',
    pleaseSelectAReportType: 'โปรดเลือกประเภทรายงาน',
    dailyOperationReport: 'รายงานปฏิบัติการรายวัน',
    weeklyOperationsReport: 'รายงานปฏิบัติการรายสัปดาห์',
    monthlyOperatingReport: 'รายงานปฏิบัติการรายเดือน',
    runCustomReports: 'รายงานแบบกำหนดเอง',
    reportTitle: 'ชื่อรายงาน',
    analysisDate: 'วันที่วิเคราะห์',
    businessDataAnalysisDimension: 'มิติวิเคราะห์ข้อมูลธุรกิจ',
    businessAnalysisAndSuggestion: 'วิเคราะห์ธุรกิจและข้อเสนอแนะ',
    trafficAnalysisSuggestion: 'ข้อเสนอแนะด้านการวิเคราะห์ทราฟฟิก',
    serviceIndicatorSuggestion: 'ข้อเสนอแนะด้านตัวชี้วัดบริการ',
    competitiveCircleAnalysisSuggestion: 'ข้อเสนอแนะด้านการวิเคราะห์คู่แข่ง',
    previewReport: 'แสดงตัวอย่างรายงาน',
    saveReport: 'บันทึกรายงาน',
    saveReleaseReport: 'บันทึกและเผยแพร่รายงาน',
    pleaseEnterTheTitleOfTheReport: 'โปรดกรอกชื่อรายงาน',
    pleaseEnterBusinessAnalysisSuggestions: 'โปรดกรอกข้อเสนอแนะด้านการวิเคราะห์ธุรกิจ',
    pleaseEnterTrafficAnalysisSuggestions: 'โปรดกรอกข้อเสนอแนะด้านการวิเคราะห์ทราฟฟิก',
    pleaseEnterTheServiceIndicatorSuggestion: 'โปรดกรอกข้อเสนอแนะด้านตัวชี้วัดบริการ',
    pleaseEnterTheCompetitionCircleAnalysisSuggestion: 'โปรดกรอกข้อเสนอแนะด้านการวิเคราะห์คู่แข่ง',
  },

  componentsFlowLine: {
    myExposureConversionRate2: 'อัตราการแปลงจากการเห็นของฉัน',
    previousExposureConversionRate2: 'อัตราการแปลงจากการเห็นของรอบก่อน',
    myConversionRate2: 'อัตราการแปลงคำสั่งซื้อของฉัน',
    conversionRateOfLastPeriodTransaction2: 'อัตราการแปลงคำสั่งซื้อของรอบก่อน',
    exposureToViewConversionRate: 'อัตราแปลงจากการเห็นสู่การชม',
    browseToTheConversionRateOfTheTransaction: 'อัตราแปลงจากการชมสู่การสั่งซื้อ',
  },

  componentsRatioPieChart: {
    directConnection3: 'เชื่อมตรง',
  },

  competeCChannelData: {
    lostOrders: 'จำนวนออเดอร์ที่สูญเสีย',
    single: 'ออเดอร์',
    numberOfLostNights: 'จำนวนห้อง-คืนที่สูญเสีย',
    lossAmount: 'ยอดสูญเสีย',
    distanceFromMe: 'ระยะทางจากฉัน',
    mark: 'คะแนน',
    startingPrice: 'ราคาเริ่มต้น',
    theProportionOfLostOrders: 'สัดส่วนออเดอร์ที่สูญเสีย',
    drainType: 'ประเภทย่อยที่สูญเสีย',
    orderConversionRate: 'อัตราการแปลงเป็นออเดอร์',
    viewTheProportionOfUsers: 'สัดส่วนผู้เข้าชม',
    finalPurchaseRatio: 'อัตราการซื้อสุดท้าย',
  },

  flowFChart: {
    browseToTheConversionRateOfTheTransaction: 'อัตราแปลงจากการชมสู่การสั่งซื้อ',
    exposureToViewConversionRate: 'อัตราแปลงจากการเห็นสู่การชม',
  },

  flowFTable: {
    myHotel: 'โรงแรมของฉัน',
    monthOnMonth: 'อัตราเทียบช่วงเดียวกัน',
    onlinePaymentSingular: 'จำนวนออเดอร์จ่ายออนไลน์',
    single: 'ออเดอร์',
  },

  flowFlowTable: {
    payForOrderQuantity: 'จำนวนออเดอร์ที่ชำระเงิน',
    exposureConversionRate: 'อัตราการแปลงจากการเห็น',
    transactionConversionRate: 'อัตราการแปลงเป็นการสั่งซื้อ',
  },

  reportManageLog: {
    dataReportOperationLogs: 'บันทึกการทำงานของรายงานข้อมูล',
    // Part 19, lines 3601 to 3800
    logNumber: 'หมายเลขบันทึก',
    operationName: 'ชื่อการดำเนินการ',
  },
  serveindexServeAnnularChart: {
    scoreDistributionGraph: 'กราฟการกระจายคะแนน',
    article: 'รายการ',
    numberOfCommentsWithChart: 'จำนวนรีวิวที่มีรูปภาพ',
    newBadReviewsThisPeriod: 'รายการ  รีวิวแย่ที่เพิ่มในรอบนี้: {num} รายการ',
    unrepliedBadReviews: '  จำนวนรีวิวแย่ที่ยังไม่ได้ตอบ: {num} รายการ',
  },
  serveindexServeRadarChart: {
    radarMap: 'แผนภาพเรดาร์',
  },
  serveindexServelist: {
    basicScore: 'คะแนนพื้นฐาน',
    awardPoints: 'คะแนนรางวัล',
    penaltyPoint: 'คะแนนหักโทษ',
  },
  situationSChannelTable: {
    salesNight: 'จำนวนห้อง-คืนที่ขาย',
    averageSalesRate: 'ราคาขายเฉลี่ยต่อห้อง',
    consumptionNight: 'จำนวนห้อง-คืนที่ใช้จริง',
    averageHousePriceOfConsumption: 'ราคาห้องเฉลี่ยของการใช้จริง',
    cancelNight: 'จำนวนห้อง-คืนที่ยกเลิก',
    cancellationRate: 'อัตราการยกเลิก',
    noSingleRoomNights: 'จำนวนห้อง-คืนที่ถูกปฏิเสธ',
    rejectRate: 'อัตราการปฏิเสธออเดอร์',
    onlinePermeability: 'อัตราการเจาะตลาดออนไลน์',
    channelOnlineStatus: 'สถานะออนไลน์ของช่องทาง',
    lightHoldTheDirectConnection: 'Qingzhu Direct Connect',
  },
  situationSGrid: {
    onAYearOnYearBasis: 'เทียบปีต่อปี',
    chainRatio: 'เทียบช่วงก่อนหน้า',
    cancellationRate: 'อัตราการยกเลิก',
    rejectRate: 'อัตราการปฏิเสธออเดอร์',
    theBookingAmountIncludesCancelledAndRejectedOrders:
      'ยอดการจองรวมคำสั่งซื้อที่ยกเลิกและถูกปฏิเสธ',
    reservationAmountCancelAndRejectOrders: 'ยอดการจองไม่รวมคำสั่งซื้อที่ยกเลิกและถูกปฏิเสธ',
    accessSource: 'แหล่งที่มาของการเข้าชม',
    onlineChannelConsumptionBedNightstotalAvailableInventory:
      'ห้อง-คืนที่ใช้จริงจากช่องทางออนไลน์ / สต็อกขายได้ทั้งหมด',
    advanceBookingBedNightstotalSalesBedNights: 'ห้อง-คืนที่จองล่วงหน้า / ห้อง-คืนที่ขายทั้งหมด',
    cancelBedNightssalesBedNights: 'ห้อง-คืนที่ยกเลิก / ห้อง-คืนที่ขาย',
    rejectBedNightssalesBedNights: 'ห้อง-คืนที่ถูกปฏิเสธ / ห้อง-คืนที่ขาย',
  },
  situationSalePieChart: {
    salesRoomNightProportion: 'สัดส่วนห้อง-คืนที่ขาย',
    theProportionOfSalesAmount: 'สัดส่วนยอดขาย',
  },
  orderDiscontinuedrooms: {
    operationalDowntime: 'เวลาที่เริ่มหยุดใช้งาน',
    disableStartEndTime: 'เวลาเริ่ม-สิ้นสุดการปิดใช้',
    releaseTime2: 'เวลายกเลิกการปิดใช้',
    inactiveRoomReport: 'รายงานห้องปิดใช้งาน',
    deactivationOperator: 'ผู้ปิดใช้งาน',
    releaseOperator: 'ผู้ยกเลิกการปิดใช้',
    normalExchange: 'เปลี่ยนห้องปกติ',
    freeUpgrade: 'อัปเกรดฟรี',
    chargeEscalation: 'อัปเกรดแบบมีค่าใช้จ่าย',
  },
  orderGuest: {
    reportType2: 'ประเภทรายงาน',
    sameDayCheckIn: 'เข้าพักวันเดียวกัน',
    sameDayCheckOut: 'ออกพักวันเดียวกัน',
    dailyArrivalsAndDepartures: 'เข้า-ออกในวันเดียวกัน',
    contractCompany: 'บริษัทตามสัญญา',
    firstDayRate: 'ราคาห้องคืนแรก',
    nation2: 'ประเทศ',
    roomListRemarks: 'หมายเหตุใบห้อง',
    guestStatement: 'รายงานการเข้าพักของแขก',
  },
  orderRoomChange: {
    unterracedHouse: 'ยังไม่จัดห้อง',
    typeOfExchange: 'ประเภทการเปลี่ยนห้อง',
    normalExchange: 'เปลี่ยนห้องปกติ',
    freeUpgrade: 'อัปเกรดฟรี',
    chargeEscalation: 'อัปเกรดแบบมีค่าใช้จ่าย',
    originalRoomNumber: 'หมายเลขห้องเดิม',
    existingRoomNumber: 'หมายเลขห้องปัจจุบัน',
    currentHouseType: 'ประเภทห้องปัจจุบัน',
    roomChangeTime: 'เวลาเปลี่ยนห้อง',
    changeRoomsAfterCheckIn: 'เปลี่ยนห้องหลังเช็คอิน',
    originalRoomRate: 'ราคาห้องเดิม',
    spotRate: 'ราคาห้องปัจจุบัน',
  },
  checkInIndex: {
    viewListingDetails: 'ดูรายละเอียดใบห้อง',
    message: 'ข้อความ',
    individualStepIntoSuccess: 'เช็คอินลูกค้าเดี่ยวสำเร็จ',
    automaticallyRedirectsToListingDetails: 'กำลังเปลี่ยนหน้าไปยังรายละเอียดใบห้องโดยอัตโนมัติ',
    successfulCodeScanning: 'สแกนคิวอาร์โค้ดสำเร็จ',
    thereIsNoCorrespondingProductForTheCurrentRoomType: 'ประเภทห้องนี้ยังไม่มีสินค้าในระบบ',
    memberBalanceIs: 'ยอดเงินสมาชิกคือ',
    pleaseSelectAnotherRecipient: ' โปรดเลือกผู้รับชำระรายอื่น',
  },
  checkInNewindex: {
    committedParameter: 'พารามิเตอร์ที่ส่ง',
    individualStepIntoSuccess: 'เช็คอินลูกค้าเดี่ยวสำเร็จ',
  },
  checkInRoomerItem: {
    moreInformation: 'ข้อมูลเพิ่มเติม',
    number: 'หมายเลข',
  },
  componentsBookertypesearch: {
    pleaseEnterTheMemberInformationYouWantToQuery: 'โปรดกรอกข้อมูลสมาชิกที่ต้องการค้นหา',
    enterTheInformationAboutTheProtocolUnitToBeQueried:
      'โปรดกรอกข้อมูลหน่วยงานตามสัญญาที่ต้องการค้นหา',
  },
  componentsDepositsection: {
    selectPaymentMethod: 'เลือกวิธีการชำระเงิน',
  },
  componentsOpenpagetemplate: {
    conditionOfTheHouse2: 'สถานะห้อง',
  },
  componentsProductsection: {
    noProductAvailableOnBookingDateForThisRoomType: 'ไม่พบสินค้าในวันที่จองสำหรับประเภทห้องนี้',
  },
  componentsRoomerItem: {
    moreInformation: 'ข้อมูลเพิ่มเติม',
    genderBirthday: 'เพศ - วันเกิด',
    nationalityNationality: 'สัญชาติ - เชื้อชาติ',
    pleaseEnterTheFullAddress2: 'กรุณากรอกที่อยู่โดยละเอียด',
    validityPeriod: 'ระยะเวลาที่ใช้ได้',
  },
  utilsLehuimixin: {
    viewListingDetails: 'ดูรายละเอียดใบห้อง',
    automaticallyRedirectsToListingDetails: 'เปลี่ยนหน้าไปยังรายละเอียดใบห้องโดยอัตโนมัติ',
    successfulCodeScanning: 'สแกนคิวอาร์โค้ดสำเร็จ',
    callbackRoute: 'เส้นทางที่เรียกกลับ',
    checkInSuccessful: 'เช็คอินสำเร็จ',
    listingDetails: 'รายละเอียดใบห้อง',
    orderDetails: 'รายละเอียดคำสั่งซื้อ',
  },
  utilsUtils: {
    noProductAvailableOnBookingDateForThisRoomType: 'ไม่พบสินค้าในวันที่จองสำหรับประเภทห้องนี้',
    thisRoomTypeIsSoldOutWithinTheBookingDate: 'ประเภทห้องนี้ขายหมดในช่วงวันที่จอง',
    noPriceIsSetForThisRoomTypeDuringTheBookingDate:
      'ประเภทห้องนี้ยังไม่ได้ตั้งราคาในช่วงวันที่จอง',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
      'ยอดเงินสมาชิกไม่พอ โปรดเลือกวิธีชำระเงินอื่น',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
      'ยอดเงินสมาชิกไม่พอ โปรดเลือกวิธีชำระเงินอื่น',
    theMembersMobilePhoneNumberIsIncorrectAndTheStoredValuePaymentCannotBeUsed:
      'เบอร์โทรสมาชิกไม่ถูกต้อง ไม่สามารถใช้ยอดเงินสะสมชำระได้',
    memberNamephoneNumbermembershipNumber: 'ชื่อสมาชิก/เบอร์โทร/หมายเลขบัตร',
  },
  componentsAuthcode: {
    laterOn: 'ภายหลัง',
    verificationCodeSentSuccessfullyPleaseNoteThatCheck: 'ส่งรหัสยืนยันสำเร็จ โปรดตรวจสอบ',
  },
  componentsBookingcommonmixin: {
    reset: 'รีเซ็ต',
  },
  componentsBookingmixin: {
    nineHours: 'เก้าชั่วโมง',
    tenHours: 'สิบชั่วโมง',
    elevenHours: 'สิบเอ็ดชั่วโมง',
    twelveHours: 'สิบสองชั่วโมง',
    hourStore: 'ชั่วโมง - สาขา',
    noRoomTypesAvailable: 'ยังไม่มีประเภทห้องให้จอง',
    houseList: 'รายการจัดห้อง',
    totalPrice: 'ราคารวม',
  },
  componentsLimitinput: {
    insufficientStock: 'สต็อกไม่เพียงพอ',
  },
  componentsMembersearch: {
    memberInformationDoesNotExistOrHasBeenDisabled: 'ข้อมูลสมาชิกไม่มีอยู่หรือถูกปิดใช้งาน',
    pleaseEnterTheMemberInformationYouWantToQuery3: 'โปรดกรอกข้อมูลสมาชิกที่ต้องการค้นหา',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
      'ยอดเงินสมาชิกไม่พอ โปรดเลือกวิธีชำระเงินอื่น',
    theMembersMobilePhoneNumberIsIncorrectAndTheStoredValuePaymentCannotBeUsed:
      'เบอร์โทรสมาชิกไม่ถูกต้อง ไม่สามารถใช้ยอดเงินสะสมชำระได้',
    memberNamephoneNumbermembershipNumber: 'ชื่อสมาชิก/เบอร์โทร/หมายเลขบัตร',
  },
  componentsPaytip: {
    memberPaymentFailure: 'ชำระเงินผ่านสมาชิกไม่สำเร็จ',
    pleaseReEnterTheAccount: 'โปรดบันทึกรายการใหม่',
  },
  futureIndex: {
    roomTypeSummary: 'สรุปประเภทห้อง',
    roomDetail: 'รายละเอียดห้อง',
  },
  futureSummary: {
    soldNumberavailableNumberoverSoldNumberdisabledNumber:
      'จำนวนขาย / จำนวนขายได้ (จำนวนขายเกิน) / จำนวนปิดใช้',
    totalNumberOfRoomsPhysicalTotalNumberOfRooms: 'จำนวนห้องทั้งหมด: จำนวนห้องจริงของโรงแรม',
    availableNumberTotalNumberOfRoomsSoldNumberDisabledNumberFullDayRoomOverSoldNumber:
      'จำนวนขายได้: จำนวนห้องทั้งหมด - จำนวนขายแล้ว - จำนวนปิดใช้ + จำนวนขายเกินของห้องเต็มวัน',
    disabledNumberNumberOfDisabledRoomsInTheHotel: 'จำนวนปิดใช้: จำนวนห้องที่ปิดใช้ในโรงแรม',
    soldNumberRoomsBookedOnTheDayRoomsCurrentlyOccupiedOnTheDayWithoutTodaysDepartureAndClockRoom:
      'จำนวนขาย: ห้องที่จองสำหรับวันนั้น + ห้องที่พักอยู่ในวันนั้น (ไม่รวมห้องที่ออกวันนี้และห้องชั่วโมง)',
  },
  groupbookingIndex: {
    pleaseEnterTeamName: 'โปรดกรอกชื่อทีม',
    memberBalanceNotEnough: 'ยอดเงินสมาชิกคือ {balance}  โปรดเลือกวิธีรับชำระอื่น',
    bookingRoomCannotBeZero: 'จำนวนห้องที่จองต้องไม่เป็น 0',
    roomTypeStockNotEnough: 'สต็อกประเภทห้องไม่เพียงพอ',
    pleaseEnterContractNo: 'โปรดกรอกเลขที่สัญญา',
    remarkPlaceholder: 'กรอกได้สูงสุด 150 ตัวอักษร',
    discountPricePlaceholder: 'โปรดกรอกราคาพิเศษ',
    leftRoomsTip: 'ยังมี {count} ห้องที่ยังไม่จัดห้อง',
    searchMemberPlaceholder: 'ชื่อ / เบอร์โทร / หมายเลขสมาชิก',
    groupBooking: 'การจองแบบกลุ่ม',
    contractNumber: 'เลขที่สัญญา',
    teamBookingSuccessful: 'จองทีมสำเร็จ',
  },
  longbookingIndex: {
    singleRoom: 'ห้องสัญญารายเดือน',
  },
  longbookingProductionlist: {
    houseList: 'รายการจัดห้อง',
    // Part 20, lines 3801 to 4000
    inAddition: 'ยังมี',
  },
  onlinedataIndex: {
    chainRatio: 'เทียบช่วงก่อนหน้า',
    onAYearOnYearBasis: 'เทียบปีต่อปี',
    theDirectConnectionChannelHasNotBeenOpenedInOrderToPreventTheLossOfOrdersPleaseContactTheOperationManagerAsSoonAsPossibleToOpenTheDirectConnectionChannel:
      'ช่องทางเชื่อมต่อโดยตรงยังไม่เปิดใช้งาน เพื่อป้องกันการสูญเสียคำสั่งซื้อ โปรดติดต่อผู้จัดการปฏิบัติการของ 轻住 เพื่อเปิดใช้งานโดยเร็ว',
    relevance: 'ความเชื่อมโยง',
    onlineRevenue: 'รายได้ออนไลน์',
    onlineNight: 'ห้อง-คืนออนไลน์',
    channelProportion: 'สัดส่วนช่องทาง',
    channelOnlineStatus: 'สถานะออนไลน์ของช่องทาง',
    directConnection3: 'เชื่อมตรง',
    temporarilyWithoutAuthority: 'ยังไม่มีสิทธิ์',
    totalOnlineRevenue: 'รายได้ออนไลน์รวม',
    onlineTotalNight: 'ห้อง-คืนออนไลน์รวม',
    online: 'ออนไลน์',
    thisEbAccountIsNotBoundPleaseBindEbAccountInEbAccountManagement:
      'บัญชี EB ยังไม่ผูก โปรดไปที่การจัดการบัญชี EB เพื่อผูกบัญชี',
  },
  realTimeIndex: {
    allBuildings: 'อาคารทั้งหมด',
    allFloors: 'ทุกชั้น',
    balanceShort: 'คงเหลือ',
    preAuthShort: 'พรีออธ',
    totalShort: 'รวม',
    depositShort: 'มัดจำ',
    roomRateShort: 'ราคา',
    powerOff: 'ตัดไฟ',
    powerOn: 'จ่ายไฟ',
    new2: 'ใหม่',
    al: 'เชื่อม',
    openChannelsForDirectConnection: 'เปิดช่องทางเชื่อมตรง',
    createRoomType: 'สร้างประเภทห้อง',
    createARoom: 'สร้างห้อง',
    renewalOrder2: 'ออเดอร์ต่ออายุเข้าพัก',
    roomChangeConfirmationForm3: 'แบบฟอร์มยืนยันการเปลี่ยนห้อง',
    checkInSlip4: 'ใบลงทะเบียนเข้าพัก',
    whenExtendingYourStayTheRoomPriceDisplayedIsForTheFirstDayOfTheExtendedStayWhenCheckingOutEarlyOrChangingTheExpectedDepartureTimeThePriceDisplayedIsForTheLastNight2:
      'เมื่อทำการต่ออายุเข้าพัก จะแสดงราคาของคืนแรกของการต่ออายุ เมื่อเช็คเอาต์ก่อนกำหนดหรือเปลี่ยนเวลาคาดว่าจะออก จะแสดงราคาคืนสุดท้าย',
    friendlyReminderPleaseMakeSureToDoubleCheckAllTheDetailsAndThenSignForConfirmationAfterChangingRoomsRememberToTakeYourPersonalBelongingsFromTheOriginalRoom3:
      'คำเตือนอย่างเป็นมิตร: โปรดตรวจสอบรายละเอียดให้ถูกต้องก่อนลงนามยืนยัน หลังจากเปลี่ยนห้องโปรดนำของใช้ส่วนตัวออกจากห้องเดิม',
    continuationRoomsShowTheFirstDayPrice2: 'ห้องต่ออายุแสดงราคาวันแรก',
    friendlyReminderPleaseDoubleCheckAllTheDetailsAndSignForConfirmationDontForgetToTakeYourPersonalBelongings3:
      'คำเตือนอย่างเป็นมิตร: โปรดตรวจสอบให้ครบถ้วนก่อนลงนามยืนยัน และอย่าลืมนำของส่วนตัวไปด้วย',
    liveLightlyInTheDirectCamp: 'Qingzhu Direct Operation',
    whereToConnectDirectly: 'Qunar Direct Connect',
    baiduMap: 'Baidu Maps',
    jingdong: 'JD',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2: 'Fliggy Credit Stay ไม่รองรับห้องเชื่อม',
    flyingPigCreditOrdersCanNotBeSustained2: 'Fliggy Credit Stay ไม่รองรับการขยายเวลาพัก',
    itHasPassedTheCheckOutDateAndCannotBeExtended2:
      'เกินวันที่เช็คเอาต์แล้ว ไม่สามารถต่ออายุเข้าพักได้',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
      'เลยเวลาเช็คเอาต์ปัจจุบัน ไม่สามารถอัปเกรดห้องได้',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
      'เลยเวลา 6:00 ของวันที่เข้าพัก ไม่สามารถอัปเกรดห้องได้',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
      'เลยเวลาเช็คเอาต์ปัจจุบัน ไม่สามารถเปลี่ยนห้องได้',
    successfulRoomExchange2: 'เปลี่ยนห้องสำเร็จ',
    successfulDisposal: 'ทำห้องสกปรกสำเร็จ',
    cleanAndSuccessful: 'ทำห้องสะอาดสำเร็จ',
    deactivateSuccessfully: 'ยกเลิกการปิดใช้สำเร็จ',
    temporaryPassword: 'รหัสชั่วคราว',
    thisPasswordIsValidFor30MinutesAndExpiresImmediatelyAfterUse:
      'รหัสนี้ใช้ได้ภายใน 30 นาที และหมดอายุทันทีหลังใช้งาน',
    quickSearch: 'ค้นหาอย่างรวดเร็วด้วยเลขห้องหรือชื่อ',
    batchModify: 'เปลี่ยนสถานะห้อง',
    ignore: 'ละเว้น',
    goAndOperate: 'ไปดำเนินการ',
    bookingInfo: 'ข้อมูลการจองที่รอเข้าพัก',
    orderNo: 'เลขที่คำสั่งซื้อ',
    channelName: 'ชื่อช่องทาง',
    bookerName: 'ชื่อผู้จอง',
    arrivalTime: 'เวลาที่คาดว่าจะมาถึง',
    roomRate: 'ราคาห้อง',
  },
  realTimeServicemsg: {
    dateOfService: 'วันที่ให้บริการ',
    applicationTime2: 'เวลาที่ขอ',
    serviceType: 'ประเภทบริการ',
    serviceTime: 'เวลาให้บริการ',
    serviceSuccess: 'ให้บริการสำเร็จ',
    serviceFailure: 'ให้บริการล้มเหลว',
    serviceCompletion: 'การให้บริการเสร็จสมบูรณ์',
    theRoomRequestHasBeenServiced: 'คำขอบริการห้องได้ดำเนินการเสร็จแล้ว',
  },
  componentsCommon: {
    roomBalance: 'ยอดคงเหลือของห้อง',
    depositWithPreAuth: 'มัดจำ (รวมพรีออธ)',
    madeCardCount: 'จำนวนบัตรที่ทำแล้ว',
    stayOver: 'ต่ออายุเข้าพัก',
    checkOut4: 'เช็คเอาต์',
    temporaryPassword: 'รหัสชั่วคราว',
    sendPassword: 'ส่งรหัส',
    muck: 'ทำห้องสกปรก',
    setAside: 'ทำห้องสะอาด',
    deactivate: 'ยกเลิกปิดใช้',
    faceEast: 'หันหน้าไปทางทิศตะวันออก',
    faceWest: 'หันหน้าไปทางทิศตะวันตก',
    faceSouth: 'หันหน้าไปทางทิศใต้',
    faceNorth: 'หันหน้าไปทางทิศเหนือ',
    decorativeFalseWindow: 'หน้าต่างตกแต่ง (ไม่จริง)',
    stayAwayFromElevators: 'อยู่ไกลจากลิฟต์',
    nearTheStairs: 'ใกล้บันได',
    closeToTheRoad: 'ใกล้ถนน',
    windowWall: 'ผนังด้านนอกติดหน้าต่าง',
    bedTypeDescription: 'คำอธิบายประเภทเตียง',
    guestControl: 'ควบคุมห้องพัก',
    latestCheckIn: 'การเข้าพักล่าสุด',
    noHistoricalCheckInInfo: 'ไม่มีข้อมูลประวัติการเข้าพักสำหรับห้องนี้',
    temporaryMakeCard: 'ออกบัตรชั่วคราว',
  },
  componentsEmpty: {
    searchNull: 'ไม่พบผลลัพธ์',
  },
  componentsGrouphandle: {
    batchModify: 'เปลี่ยนสถานะห้อง',
    pleaseSelectAnActiveArea: 'โปรดเลือกพื้นที่',
    selectStartDate: 'เลือกวันที่เริ่ม',
    selectEndDate: 'เลือกวันที่สิ้นสุด',
    emptyCleanToEmptyDirty: 'ห้องว่างสะอาด → ห้องว่างสกปรก',
    emptyDirtyToEmptyClean: 'ห้องว่างสกปรก → ห้องว่างสะอาด',
    stayCleanAndTurnDirty: 'ห้องมีผู้เข้าพักสะอาด → ห้องมีผู้เข้าพักสกปรก',
    stayDirtyAndTurnClean: 'ห้องมีผู้เข้าพักสกปรก → ห้องมีผู้เข้าพักสะอาด',
    batchOutage: 'ปิดใช้แบบกลุ่ม',
    batchDeactivation: 'ยกเลิกปิดใช้แบบกลุ่ม',
    pleaseEnterTheStartTime: 'โปรดกรอกเวลาเริ่ม',
    pleaseEnterTheEndTime: 'โปรดกรอกเวลาสิ้นสุด',
    pleaseSelectTheRoomForBatchOperation: 'โปรดเลือกห้องสำหรับการดำเนินการแบบกลุ่ม',
    batchOperationSuccessful: 'ดำเนินการแบบกลุ่มสำเร็จ',
    whetherToConfirmTheDeactivationBatchDeactivationIncludesrowRooms:
      'ยืนยันจะปิดใช้หรือไม่? การปิดใช้แบบกลุ่มรวมถึงห้องที่จัดไว้แล้วด้วย',
  },
  componentsHourcheckinconfirm: {
    checkInTimeConfirmation: 'ยืนยันเวลาเช็คอิน',
    continuousHousing: 'ดำเนินการจัดห้องต่อ',
    theArrivalTimeHasBeenExceededPleaseConfirmTheGuestCheckInTime:
      'เกินเวลาเข้าพักที่คาดไว้แล้ว โปรดยืนยันเวลาเช็คอินของลูกค้า',
    itHasBeenOccupiedPleaseManuallyArrangeTheRoomAfterFurtherProcessing:
      'ถูกใช้งานแล้ว ดำเนินการเสร็จแล้วโปรดจัดห้องด้วยตนเอง',
  },
  componentsOperationlog: {
    operationRecord: 'บันทึกการดำเนินการ',
  },
  componentsStopservice: {
    successfulDeactivation: 'ปิดใช้สำเร็จ',
    selectStartDate: 'เลือกวันที่เริ่ม',
    selectEndDate: 'เลือกวันที่สิ้นสุด',
    noteAtLeast3Words: 'หมายเหตุต้องมีอย่างน้อย 3 คำ',
    startMustAfterNow: 'วันที่เริ่มต้นต้องมากกว่าหรือเท่ากับวันที่ปัจจุบัน',
    endMustAfterStart: 'วันที่สิ้นสุดต้องมากกว่าวันที่เริ่มต้น',
  },
  serviceHandle: {
    accept: 'ยอมรับ',
    turnDown2: 'ปฏิเสธ',
    serviceProcessing: 'กำลังดำเนินการบริการ',
    whetherToProcess: 'ต้องการดำเนินการหรือไม่',
    reasonForRefusal: 'เหตุผลในการปฏิเสธ',
    pleaseEnterTheReasonForTheRejection: 'โปรดกรอกเหตุผลในการปฏิเสธ',
    accepted: 'ยอมรับแล้ว',
    denialOfService: 'ปฏิเสธการให้บริการ',
  },
  sankebookingArrangeroom: {
    noRoomAvailablePleaseConfirmAndTryAgain: 'ไม่มีห้องให้จัด โปรดตรวจสอบอีกครั้ง',
    upgradeNumberOfRooms: 'จำนวนห้องที่อัปเกรด',
    pleaseEnterRoomChangeRemarks: 'โปรดกรอกหมายเหตุการเปลี่ยนห้อง',
    conditionOfTheHouse2: 'สถานะห้อง',
    pleaseSelectTheRoomYouWantToUpgrade: 'โปรดเลือกห้องที่ต้องการอัปเกรด',
    thereAreCurrentlyNoRoomTypesAvailableForUpgrade: 'ยังไม่มีประเภทห้องที่สามารถอัปเกรดได้',
    theNumberOfRowRoomsCannotBeGreaterThanTheNumberOfReservedRooms:
      'จำนวนห้องที่จัดไม่สามารถมากกว่าห้องที่จองได้',
    thisRoomTypeIsNotOnline: 'ประเภทห้องนี้ยังไม่ออนไลน์',
    hourProductPleaseSelectAnotherRoomType: 'เป็นสินค้ารายชั่วโมง โปรดเลือกประเภทห้องอื่น',
    thisRoomType: 'ประเภทห้องนี้',
    productsAreSoldOutPleaseChooseAnotherRoomType:
      'สินค้ารายชั่วโมงขายหมดแล้ว โปรดเลือกประเภทห้องอื่น',
    noPriceIsSetForTheHourProductPleaseSelectAnotherRoomType:
      'สินค้ารายชั่วโมงยังไม่ได้ตั้งราคา โปรดเลือกประเภทห้องอื่น',
    yourUpgradedRoomTypeIsAllThatIsLeft: 'ประเภทห้องที่คุณอัปเกรดเหลือเพียง',
    pleaseChangeToAnotherRoomTypeOrReduceTheNumberOfRoomUpgrades:
      'ห้อง โปรดเลือกประเภทห้องอื่นหรือ ลดจำนวนการอัปเกรด',
  },
  sankebookingIndex: {
    channelOrderRoomType: 'ประเภทห้องตามช่องทาง',
    operationPrompt: 'คำแนะนำการดำเนินการ',
    furtherBooking: 'จองต่อ',
    thisOrderHasAlreadyBeenBookedPleaseDoNotRepeat: 'ออเดอร์นี้จัดการจองแล้ว โปรดอย่าทำซ้ำ',
    floorPriceModel: 'โหมดราคาต้นทุน',
    sellingPriceModel: 'โหมดราคาขาย',
    theNumberOfReservedRoomsCannotBe: 'จำนวนห้องจองต้องไม่เป็น',
    reservationNumber: 'จำนวนการจอง',
    inAddition: 'ยังมี',
    useEbInformation: 'ใช้ข้อมูล EB',
    useEbOrderInformation: 'ใช้ข้อมูลคำสั่งซื้อ EB',
    theNumberOfBookingRoomsIsInconsistentWithTheNumberOfChannelOrdersWhetherToContinueBooking:
      'จำนวนห้องที่จองไม่ตรงกับจำนวนออร์เดอร์ของช่องทาง ต้องการดำเนินการจองต่อหรือไม่',
    thisOrderCannotBeBooked: 'ออเดอร์นี้ไม่สามารถดำเนินการจองได้',
  },
  activityData: {
    dailySpecial: 'ดีลประจำวัน',
    keepPricesLow: 'รักษาราคาต่ำ',
    motivateUsersToBuyMore: 'กระตุ้นให้ลูกค้าซื้อเพิ่ม',
    earlyRush: 'ดึงลูกค้าก่อนเวลา',
  },
  componentsActivitydetail: {
    discount: 'ส่วนลด',
    promotionInfo:
      'หลังจากส่งการสมัครเข้าร่วมกิจกรรมสำเร็จแล้วจะมีผลทันที ระหว่างกิจกรรมโรงแรมสามารถแก้ไขหรือถอนตัวได้ แต่คำสั่งซื้อที่เสร็จสิ้นแล้วจะเป็นไปตามกฎเดิม ราคาก่อนโปรโมชันของประเภทห้องที่เข้าร่วมต้องไม่สูงกว่าช่องทางอื่น มิฉะนั้นอาจไม่แสดงผล',
    offerDetails:
      'ราคาก่อนโปรโมชันของประเภทห้องที่เข้าร่วมไม่สูงกว่าช่องทางอื่น จะได้รับโอกาสการแสดงผลมากขึ้น แนะนำให้เลือกประเภทห้องราคาต่ำสุดเข้าร่วมเพื่อเพิ่มโอกาสการเข้าถึง',
    backToActivityList: 'กลับไปยังรายการกิจกรรม',
    quantitySold: 'จำนวนที่ขาย',
    sellLowEachNight: 'ขายต่ำต่อคืน',
    pleaseSelectAnEventProduct: 'โปรดเลือกสินค้าที่เข้าร่วมกิจกรรม',
    noRoomTypeInformationAvailable: 'ไม่มีข้อมูลประเภทห้อง',
    productsHaveBeenSelectedForTheEvent: 'สินค้าเข้าร่วมกิจกรรมที่เลือกแล้ว',
    selectOffer: 'เลือกข้อเสนอ',
    iHaveReadAndAgree: 'ข้าพเจ้าได้อ่านและยอมรับ',
    activityRelatedClause: 'ข้อกำหนดที่เกี่ยวข้องกับกิจกรรม',
    selectedOffer: 'ข้อเสนอที่เลือกแล้ว',
    signUpNow: 'สมัครทันที',
    activeTime: 'ระยะเวลากิจกรรม',
    activityProfile: 'ข้อมูลกิจกรรม',
    activityRequirement: 'ข้อกำหนดกิจกรรม',
    preferentialDetails: 'รายละเอียดส่วนลด',
    specialSpecification: 'คำอธิบายพิเศษ',
    entryAndExitRules: 'กฎการเริ่มและออกจากกิจกรรม',
    costAttribution: 'การจัดสรรต้นทุน',
    midAutumnFestival: 'เทศกาลไหว้พระจันทร์',
    // Part 21, lines 4001 to 4200
    specialProduct: 'ผลิตภัณฑ์พิเศษ',
    areYouSureYouWantToCommitYourChanges: 'ยืนยันที่จะส่งการแก้ไขหรือไม่',
    pleaseSelectTheRoomTypeToParticipateInTheEvent: 'โปรดเลือกประเภทห้องที่เข้าร่วมกิจกรรม',
    pleaseSelectDiscount: 'โปรดเลือกส่วนลด',
    pleaseReadAndAgreeToTheTermsOfTheEvent: 'โปรดอ่านและยอมรับข้อกำหนดของกิจกรรม',
    successfulRegistration: 'ลงทะเบียนสำเร็จ',
  },
  componentsSelfactivitylist: {
    expired: 'หมดอายุ',
    copyPromotion: 'คัดลอกโปรโมชัน',
    promotionType: 'ประเภทโปรโมชัน',
    marginOfPreference: 'ช่วงส่วนลด',
    eventDate: 'วันที่จัดกิจกรรม',
    beOffline: 'ออฟไลน์แล้ว',
    merchantsPushThemselvesOffline: 'ผู้ประกอบการนำโปรโมชันลงเอง',
    offlineSuccess: 'นำออกจากระบบสำเร็จ',
    areYouSureYouWantToDeleteTheActivity: 'ยืนยันที่จะลบกิจกรรมหรือไม่',
  },
  componentsActivitycontent: {
    activityRequirement: 'ข้อกำหนดกิจกรรม',
    quantitySold: 'จำนวนที่ขาย',
    signUpNow: 'สมัครทันที',
    cancelRegistration: 'ยกเลิกการสมัคร',
    reEnroll: 'สมัครอีกครั้ง',
    areYouSureYouWantToCancelYourRegistration: 'ยืนยันที่จะยกเลิกการสมัครหรือไม่',
  },
  componentsSelfactivitylog: {
    inquire: 'ค้นหา',
    back: 'กลับ',
  },
  componentsDialog: {
    rule: 'กฎ',
    new: 'สร้างใหม่',
    content: 'เนื้อหา',
    activityRelatedClause: 'ข้อกำหนดของกิจกรรม',
  },
  componentsSelfactivitydetail: {
    discountInfo:
      'เมื่อเปิดการขยายอายุโปรโมชัน ระบบจะขยายโปรโมชันโดยอัตโนมัติ 30 วันก่อนวันสิ้นสุด และจะสร้างโปรโมชันใหม่ หากวันสิ้นสุดเหลือน้อยกว่า 30 วัน ระบบจะขยายให้ครบ 30 วันโดยอัตโนมัติ',
    chooseToParticipateInPromotionalProducts: 'เลือกสินค้าที่เข้าร่วมโปรโมชัน',
    noRoomTypeInformationAvailable: 'ไม่มีข้อมูลประเภทห้อง',
    selectedProductsForPromotion: 'สินค้าที่เลือกเข้าร่วมโปรโมชันแล้ว',
    selectTheChannelWhereThePromotionIsEffective: 'เลือกช่องทางที่โปรโมชันมีผล',
    allChannels: 'ทุกช่องทาง',
    designatedChannel: 'ช่องทางที่กำหนด',
    noEffectiveChannelInformationIsAvailable: 'ไม่มีข้อมูลช่องทางที่มีผล',
    youHaveSelectedTheChannelWhereThePromotionTakesEffect: 'ช่องทางที่เลือกให้โปรโมชันมีผล',
    activeConfiguration: 'การตั้งค่ากิจกรรม',
    setForAtLeast2Days: 'ตั้งค่าอย่างน้อย 2 วัน',
    setThisParameterForAtLeast1Day: 'ตั้งค่าอย่างน้อย 1 วัน',
    discount: 'ส่วนลด',
    theDiscountValueIsSetToAtLeast95Off: 'ค่าลดต้องตั้งอย่างน้อย 95% ของราคา',
    theMinimumAmountOfImmediateReductionIsSetAt5: 'จำนวนเงินลดต้องไม่น้อยกว่า 5 ',
    immediateReductionPromotionIsNotEffectiveForCtrip: 'โปรโมชั่นแบบลดทันทีไม่รองรับ Ctrip',
    thePromotionIsValidOnlyOnCtrip: 'โปรโมชั่นนี้ใช้ได้เฉพาะบน Ctrip',
    thePromotionIsOnlyEffectiveOnCtripAndTongcheng: 'โปรโมชั่นนี้ใช้ได้เฉพาะบน Ctrip และ Tongcheng',
    link: 'เข้าพักต่อเนื่อง',
    advanceBooking: 'จองล่วงหน้า',
    preferentialMode: 'รูปแบบส่วนลด',
    firstStayDiscount: 'ส่วนลดครั้งแรก',
    automaticExtension: 'ขยายอัตโนมัติ',
    saleTime: 'เวลาปล่อยขาย',
    theFollowingDay: 'วันถัดไป',
    theIntervalShallNotBeLessThan30Days: 'ช่วงวันห่างต้องไม่น้อยกว่า 30 วัน',
    areYouSureYouWantToCommitYourChanges: 'ยืนยันที่จะส่งการแก้ไขหรือไม่',
    pleaseSelectTheRoomTypeToParticipateInTheEvent: 'โปรดเลือกประเภทห้องที่เข้าร่วมกิจกรรม',
    pleaseSelectAnEventCheckInDate: 'โปรดเลือกวันที่เข้าพักของกิจกรรม',
    pleaseFillInTheDiscountAmount: 'โปรดกรอกจำนวนส่วนลด',
    atLeast95OffUpTo30Off: 'ส่วนลดต้องไม่น้อยกว่า 95% และไม่มากกว่า 30%',
    theDiscountAmountIsAtLeast5AndUpTo500: 'จำนวนเงินส่วนลดต้องไม่น้อยกว่า 5  และไม่เกิน 500 ',
    pleaseFillInTheNumberOfConsecutiveDays: 'โปรดกรอกจำนวนวันเข้าพักต่อเนื่อง',
    theNumberOfConsecutiveDaysMustBeGreaterThanOrEqualTo1DayAndLessThanOrEqualTo10Days:
      'จำนวนวันต้องมากกว่าหรือเท่ากับ 1 วัน และไม่เกิน 10 วัน',
    pleaseFillInTheAdvanceBookingDays: 'โปรดกรอกจำนวนวันจองล่วงหน้า',
    pleaseFillInTheSaleTime: 'โปรดกรอกเวลาปล่อยขาย',
    congratulationsOnYourPromotionCreation: 'สร้างโปรโมชันสำเร็จ',
    congratulationsOnYourSuccessfulCopyPromotion: 'คัดลอกโปรโมชันสำเร็จ',
    back: 'กลับ',
  },
  componentsSelfactivitytemp: {
    createNow: 'สร้างทันที',
  },
  productOversaleSetting: {
    timePeriod: 'ช่วงเวลา',
    numberSold: 'จำนวนที่ขาย',
    oversold: 'จำนวนที่ขายเกินได้',
    oversoldQuantity: 'จำนวนที่ขายเกิน',
    oversoldCannotBeGreaterThanTheRemainingPhysicalRoomCapacityOfTheHotelOnThatDay:
      'จำนวนขายเกินต้องไม่มากกว่าจำนวนห้องจริงที่เหลืออยู่ในวันนั้น',
    oversoldStockIsActivatedWhenTheActualPhysicalStockOfTheRoomTypeIsSoldOutForTheDay:
      'สต็อกขายเกินจะใช้งานเมื่อจำนวนห้องจริงของวันนั้นถูกขายหมด',
    pleaseOpenTheAutomaticOverbookingSettingInMoreSystemSettingsBasicSettingsDirectConnectionOrderToAvoidAutomaticRejectionOfOverbookingOrderTimeout:
      'โปรดเปิดการตั้งค่า “รับออเดอร์อัตโนมัติเมื่อขายเกิน” ใน (更多-系统设置-基础设置-直连接单) (专有名词无法翻译) เพื่อหลีกเลี่ยงการถูกปฏิเสธออเดอร์อัตโนมัติ',
    timeSelectionIsOutOfRange: 'การเลือกเวลาเกินช่วงที่กำหนด',
    configurationSuccessful: 'ตั้งค่าสำเร็จ',
    theSetOverbookingQuantityMustBeGreaterThanOrEqualTo: 'จำนวนขายเกินต้องมากกว่าหรือเท่ากับ',
  },
  productDelayprice: {
    holidayFactorRange: 'ช่วงค่าปรับวันหยุด: สามารถกรอก 1~5 พร้อมทศนิยม 1 ตำแหน่ง',
    holidayPricingRule:
      'เมื่อกำหนดค่าสัมประสิทธิ์วันหยุด ราคาวันหยุดในจีนแผ่นดินใหญ่จะเป็นราคาวันปกติคูณค่าสัมประสิทธิ์ เช่น ค่าสัมประสิทธิ์ = 2 ราคาปกติ = 100 ราคาวันหยุด = 200',
    holidayFactor:
      'หลังตั้งค่าสัมประสิทธิ์วันหยุด ราคาวันหยุดในจีนแผ่นดินใหญ่จะเป็นราคาวันปกติคูณด้วย',
    priceCopy: 'คัดลอกราคา 2 เดือน',
    open: 'เปิดแล้ว',
    deferredProduct: 'ผลิตภัณฑ์เลื่อนราคา',
    allDayRoomProducts: 'สินค้าแบบพักทั้งวัน',
    deferralOnlyAppliesToProductsWithFullDayOccupancyType:
      'ใช้ได้เฉพาะสินค้าที่เป็นแบบเข้าพักทั้งวัน',
    priceExtensionTime: 'ระยะเวลาขยายราคา',
    holidayCoefficient: 'ค่าสัมประสิทธิ์วันหยุด',
    statutoryHolidayPricesAreWeekdays: 'ราคาวันหยุดเป็นราคาวันปกติคูณด้วย',
    times: 'เท่า',
    automaticDeferralDescription: 'คำอธิบายการขยายราคาอัตโนมัติ',
    theSystemCopiesThePriceOfTheMostRecentWeekToAFutureDateWithoutAPriceAndDatesThatAlreadyHaveAPriceWillNotBeOverwrittenByTheSystem:
      'ระบบจะคัดลอกราคาสัปดาห์ล่าสุดไปยังวันที่อนาคตที่ยังไม่มีราคา วันที่มีราคาแล้วระบบจะไม่เขียนทับ',
    thePriceSourceOfTheAutomaticPriceExtensionIsThePriceOfTheWeekBeforeTheAutomaticPriceExtensionDateInCaseOfHolidaysItIsSkippedAndThePriceOfThePreviousWeekIsTaken:
      'แหล่งราคาของการขยายราคาอัตโนมัติคือราคาของสัปดาห์ก่อนหน้า หากเป็นวันหยุดจะข้ามไปและใช้ราคาของสัปดาห์ก่อนหน้านั้น',
    turnOffAutomaticDeferral: 'ปิดการขยายราคาอัตโนมัติ',
  },
  productManageSetting: {
    advanceSale: 'การขายล่วงหน้า',
    needChannelConnection: 'สินค้านี้ต้องเปิดเชื่อมต่อช่องทางก่อน จึงจะสร้างได้ ต้องการเปิดหรือไม่',
    confirmChangeProductType:
      'การเปลี่ยนประเภทสินค้า จะล้างช่องทางเผยแพร่และกฎของสินค้า ต้องการดำเนินการหรือไม่',
    limitSale: 'จำกัดการขาย (ห้อง)',
    checkInDay: 'วันเข้าพัก',
    beforeCheckIn: 'ก่อนเข้าพัก',
    atLatest: 'ไม่เกิน',
    theHourlyIncreaseCannotBeGreaterThanThePrice: 'ค่าบริการเพิ่มรายชั่วโมงต้องไม่มากกว่าราคาห้อง',
    physicalRoomType: 'ประเภทห้องจริง',
    earliestCheckInTime: 'เวลาเข้าพักเร็วสุด',
    latestCheckOutTime: 'เวลาออกช้าที่สุด',
    howLongNoAdditionalRoomChargeminutes: 'ขยายเวลาได้กี่นาทีโดยไม่คิดค่าห้องเพิ่ม',
    howLongIsTheFullDayRoomChargehours: 'เกินกี่ชั่วโมงจึงคิดค่าห้องเต็มวัน',
    cancelRule: 'กฎการยกเลิก',
    paymentPolicy: 'นโยบายการชำระเงิน',
    validForOnlineSalesOnly: 'มีผลเฉพาะการขายออนไลน์',
    releaseChannel: 'ช่องทางเผยแพร่',
    productRegulation: 'กฎของสินค้า',
    effectiveChannel: 'ช่องทางที่มีผล',
    priceyuan: 'ราคา ',
    inputPrice: 'กรอกราคา',
    extraChargePerHourrmb: 'คิดเพิ่มต่อชั่วโมง ',
    forSaleOnly: 'จำกัดขาย (ห้อง)',
    inputSpace: 'กรอกจำนวนห้อง',
    enjoyHotelStayLight: 'โรงแรม Qingzhu Enjoy',
    pleaseEnterTheNumberOfRooms: 'โปรดกรอกจำนวนห้อง',
    additionalRule: 'เพิ่มกฎ',
    found: 'สร้าง',
    containing: 'รวม',
    pleaseEnterTheNumberOfRestrictedRooms: 'โปรดกรอกจำนวนห้องที่จำกัด',
    nonDeletable: 'ไม่สามารถลบได้',
    early: 'เช้า',
    withoutBreakfast: 'ไม่รวมอาหารเช้า',
    liveLightAndEnjoy: 'Qingzhu Premium Stay',
    confirmToDeleteThisRule: 'ยืนยันการลบกฎนี้',
    areYouSureToKeepItForSale: 'ยืนยันที่จะบันทึกการขายหรือไม่',
    areYouSureToCreateASale: 'ยืนยันที่จะสร้างการขายหรือไม่',
    areYouSureYouWantToLeave: 'ยืนยันที่จะออกจากหน้านี้หรือไม่',
  },
  productPriceCalendar: {
    is: 'หรือไม่?',
    confirmDeleteWarning:
      'โปรดตรวจสอบว่าสินค้ามีคำสั่งเข้าพักที่ยังไม่เช็คเอาต์หรือไม่ เพื่อหลีกเลี่ยงผลกระทบต่อการต่ออายุ หากยืนยันการลบ โปรดกดปุ่ม “ยืนยันลบ” ด้านล่าง',
    totalAvailableRooms: 'ห้องขายได้ทั้งหมด 10 ห้อง/(รวมขายเกิน 3 ห้อง)',
    limitZeroFull: 'หากจำกัดขายเป็น 0 = เต็มแล้ว ปิดการขายคือไม่ขายบนช่องออนไลน์',
    openRoomAvailable: 'เมื่อเปิดขายจะขายในช่องออนไลน์ ถ้าปิดจะไม่ขายออนไลน์',
    allProducts3: 'สินค้าทั้งหมด',
    onlineProduct2: 'สินค้าออนไลน์',
    offLineProduct2: 'สินค้าออฟไลน์',
    theReckoner: 'เครื่องคำนวณ',
    preSaleFullDayRoom: 'ขายล่วงหน้า-ห้องเต็มวัน',
    presaleHourRoom: 'ขายล่วงหน้า-ชั่วโมง',
    viewIsNotSupported: 'ยังไม่รองรับการดู',
    channelPricesCannotBeSet: 'ไม่สามารถตั้งราคาช่องทางได้',
    smallProgramChannelPriceCanBeAdjustedToUpdate: 'สามารถปรับราคาช่องทางมินิโปรแกรมเพื่ออัปเดตได้',
    switchRoom: 'เปิด/ปิดการขายห้อง',
    limitedSalesNumber: 'จำนวนจำกัดขาย',
    unlimitedSale: 'ไม่จำกัดขาย',
    packUpAllProducts: 'ยุบแสดงสินค้าทั้งหมด',
    expandAllProducts: 'ขยายแสดงสินค้าทั้งหมด',
    modifyProductPrice: 'แก้ไขราคาสินค้า',
    extraChargeForMoreThan1Hour: 'เกิน 1 ชั่วโมงคิดเพิ่ม',
    enjoyHotelStayLight: 'โรงแรม Qingzhu Enjoy',
    pleaseEnterLimitedNumber: 'โปรดกรอกจำนวนจำกัดขาย',
    maintenancePrice: 'ราคาที่ดูแล',
    priceNotMaintained: 'ยังไม่ได้ตั้งราคา',
    amendTheSalesRestrictionRules: 'แก้ไขกฎจำกัดขาย',
    confirmOrNot: 'ยืนยันหรือไม่',
    areYouSureYouWantToContinue: 'ต้องการดำเนินการต่อหรือไม่',
    theCurrentRateExceedsTheThresholdSetByTheHotel5: 'ราคาปัจจุบันเกินกว่าค่าที่โรงแรมกำหนด',
    definiteModification: 'ยืนยันการแก้ไข',
  },
  productPriceCalendarNew: {
    open: 'เปิดแล้ว',
    iss: 'หรือไม่?',
    remainingContractReservedRooms: 'จำนวนห้องสำรองตามสัญญาที่เหลือ',
    roomsCannotBeLower: 'ห้อง จำนวนสำรองต้องไม่ต่ำกว่าค่านี้',
    confirmDeleteWarning:
      'โปรดยืนยันว่าสินค้ามีออเดอร์ที่ยังไม่เช็คเอาต์หรือไม่ เพื่อหลีกเลี่ยงผลกระทบ หากยืนยันลบ โปรดคลิก “ยืนยันลบ”',
    Thenumberofremainingcontractreservedroomsforthisproduct:
      'สินค้านี้มีจำนวนห้องสำรองตามสัญญาไม่เป็น 0 มีการส่งคำขอปิดการขายแล้ว โปรดรอการตรวจสอบ',
    cannotCloseRoom:
      'สินค้านี้มีจำนวนห้องสำรองตามสัญญาไม่เป็น 0 ไม่สามารถปิดการขายได้ โปรดติดต่อผู้จัดการช่องทางเพื่อปิดห้อง',
    confirmModification: 'ยืนยันการแก้ไข',
    // Part 22, lines 4201 to 4400
    EBDeepOperationFailed: 'การดำเนินงาน EB แบบเชิงลึกล้มเหลว',
    syncCurrentPageEBData: 'ซิงค์ข้อมูล EB ของหน้าปัจจุบัน',
    previousTwoWeeks: 'สองสัปดาห์ก่อน',
    nextTwoWeeks: 'สองสัปดาห์ถัดไป',
    batchChangeInventory: 'แก้ไขสต็อกแบบกลุ่ม',
    theReckoner: 'เครื่องคำนวณ',
    preSaleFullDayRoom: 'พรีเซลห้องพักเต็มวัน',
    presaleHourRoom: 'พรีเซลห้องพักรายชั่วโมง',
    underRevision: 'กำลังแก้ไข',
    viewIsNotSupported: 'ยังไม่รองรับการดู',
    dataSynchronizationIsUnderwayPleaseQueryTheDataAgainAfter1Minute:
      'กำลังซิงค์ข้อมูล โปรดสอบถามอีกครั้งหลังจาก 1 นาที',
    lightLiveDistributionChannelPriceCannotBeSet: 'ไม่สามารถตั้งราคาช่องทางกระจายของ Qingzhu ได้',
    smallProgramChannelPriceCanBeAdjustedToUpdate: 'สามารถปรับราคาช่องทางมินิโปรแกรมเพื่ออัปเดตได้',
    switchRoomSetup: 'ตั้งค่าการเปิด/ปิดห้อง',
    notModify: 'ไม่แก้ไข',
    roomSetting: 'การตั้งค่าห้อง',
    unlimitedSale: 'ไม่จำกัดขาย',
    reserveRoomSetup: 'ตั้งค่าห้องสำรอง',
    pleaseSelectRoomType: 'โปรดเลือกประเภทห้อง',
    pleaseSelectCheckInType: 'โปรดเลือกประเภทการเข้าพัก',
    notShowPreSaleProduct: 'ไม่แสดงสินค้าพรีเซล',
    showPreSaleProduct: 'แสดงสินค้าพรีเซล',
    notShowEbProduct: 'ไม่แสดงสินค้า EB',
    showEbProduct: 'แสดงสินค้า EB',
    allCheckInTypes: 'ประเภทการเข้าพักทั้งหมด',
    holiday: 'วันหยุด',
    packItAllUp: 'ยุบทั้งหมด',
    expandAll: 'ขยายทั้งหมด',
    extraChargeForMoreThan1Hour: 'เกิน 1 ชั่วโมงคิดเพิ่ม',
    theNumberOfReservedRoomsCanBeIncreasedAtMostNotMoreThanTheCurrentInventoryAtLeastNotLessThanTheNumberOfRemainingContractedReservedRooms:
      'จำนวนห้องสำรองสามารถเพิ่มได้สูงสุดไม่เกินสต็อกปัจจุบัน และต้องไม่ต่ำกว่าจำนวนห้องสำรองตามสัญญาที่เหลือ',
    offLineProduct2: 'สินค้าที่ออฟไลน์',
    onlineProduct2: 'สินค้าออนไลน์',
    allProducts3: 'สินค้าทั้งหมด',
    showFloor: 'แสดงราคาต่ำสุด',
    theReservePriceIsNotDisplayed: 'ไม่แสดงราคาต่ำสุด',
    directChannel4: 'ช่องทางเชื่อมตรง',
    goWhereTheDirectConnection: 'Qunar Direct Connect',
    unboundChannel: 'ยังไม่ได้ผูกช่องทาง',
    synchronizationFailure: 'ซิงค์ล้มเหลว',
    theStartDateOfTheLastTwoWeeksCannotBeLessThanTheCurrentDate:
      'วันที่เริ่มต้นของสองสัปดาห์ก่อนต้องไม่ก่อนวันปัจจุบัน',
    pleaseSelectTheCurrentStartEndDate: 'โปรดเลือกวันเริ่มต้นและสิ้นสุด',
    pleaseEnterTheNumberOfReservedRooms: 'โปรดกรอกจำนวนห้องสำรอง',
    pleaseEnterLimitedNumber: 'โปรดกรอกจำนวนจำกัดขาย',
    maintenancePrice: 'ราคาที่ดูแล',
    priceNotMaintained: 'ยังไม่ได้ดูแลราคา',
    modifyProductPrice: 'แก้ไขราคาสินค้า',
    modifyProductInventory: 'แก้ไขสต็อกสินค้า',
    confirmOrNot: 'ยืนยันหรือไม่',
    theCurrentRateExceedsTheThresholdSetByTheHotel5: 'ราคาปัจจุบันเกินกว่าค่าที่โรงแรมกำหนด',
    areYouSureYouWantToContinue: 'ต้องการดำเนินการต่อหรือไม่',
    definiteModification: 'ยืนยันการแก้ไข',
    ebChannel: 'ช่องทาง EB',
    ebMeituan: 'EB Meituan',
    ebCtrip: 'EB Ctrip',
    ebFeizhu: 'EB Fliggy',
  },
  productPriceAudit: {
    allRejectedSuccessfully: 'ปฏิเสธทั้งหมดสำเร็จ',
    pass: 'ผ่าน',
    turnDown: 'ปฏิเสธ',
    revisedPrice: 'ราคาที่แก้ไขแล้ว',
    rangeOfVariation: 'ช่วงการเปลี่ยนแปลงราคา',
    priceChanger: 'ผู้แก้ไขราคา',
    auditor: 'ผู้ตรวจสอบ',
    auditTime: 'เวลาตรวจสอบ',
    toBeReviewed: 'รอตรวจสอบ',
    passTheExamination: 'ตรวจสอบผ่าน',
    expired: 'หมดอายุ',
    successfulAudit: 'ตรวจสอบสำเร็จ',
  },
  pcncomponentDataexplain: {
    totalAvailableRooms: 'ห้องขายได้ทั้งหมด 10 ห้อง/(รวมขายเกิน 3 ห้อง)',
    ebPriceSoldRemaining: 'ราคา EB / ห้องที่ขาย / ห้องที่เหลือ',
    ebPriceSoldCloseStatus: 'ราคา EB / ห้องที่ขาย / สถานะปิดห้อง',
    ebBasePriceReservedUnlimited:
      'ราคา EB พื้นฐาน / ห้องสำรองที่เหลือ (รวมสำรองตามสัญญาและสำรองชั่วคราว) / ไม่จำกัดขาย',
    hourRoomProductsShowHourRoomIdentification: 'สินค้าห้องรายชั่วโมงจะแสดงสัญลักษณ์ห้องรายชั่วโมง',
    whenTheProductPriceIsChangedOrTheHousingStatusIsNotImmediatelyEffectiveInTheAuditTheIdentificationInTheAuditIsDisplayedAndTheIdentificationInTheAuditIsHiddenAfterTheAuditPassesTheModificationAndBecomesEffective:
      'เมื่อเปลี่ยนราคา/สถานะห้อง และยังไม่มีผล ระบบจะแสดงสถานะ “รอตรวจสอบ” หลังตรวจสอบผ่านจะซ่อนสถานะนี้',
    underRevision: 'กำลังแก้ไข',
    thePriceOrInventoryHasDataThatIsBeingModifiedTheIdentifierIsDisplayedWhenTheModificationResultIsNotObtainedTheIdentifierIsHiddenOnlyAfterSuccessOrFailure:
      'เมื่อราคา/สต็อกกำลังแก้ไขและยังไม่ทราบผล จะแสดงสถานะ จนกว่าจะสำเร็จหรือไม่สำเร็จจึงจะซ่อน',
    ifTheProductFailsToChangeThePriceOrChangeTheRoomStatusTheFailureIdentifierWillBeDisplayedAndTheIdentifierWillBeHiddenOnlyAfterTheNextOperationSucceedsInChangingThePriceOrChangingTheRoomStatus:
      'หากแก้ไขราคา/สถานะล้มเหลว จะแสดงสถานะล้มเหลว และจะซ่อนก็ต่อเมื่อการแก้ไขครั้งถัดไปสำเร็จ',
    theProductFailsToBeObtainedContactTheOperationManagerToCheckWhetherTheProductHasBeenChanged:
      'ไม่สามารถดึงข้อมูลสินค้าได้ โปรดติดต่อผู้จัดการฝ่ายปฏิบัติการเพื่อตรวจสอบ',
    statusDeclaration: 'คำอธิบายสถานะ',
    whenTheLimitedNumberOfSalesIs0TheRoomIsFullAndItCannotBeSoldAfterClosingTheRoomOnlyTheRelevantRoomWillStopSellingInTheUnlimitedNumberState:
      'จำกัดขายเป็น 0 = เต็มแล้ว เมื่อปิดห้องจะไม่จำหน่าย ในโหมดไม่จำกัดขายจะหยุดขายก็ต่อเมื่อปิดห้อง',
    ctripEbPrepaidProductsShowThePrepaidLogo:
      'สินค้า EB แบบชำระล่วงหน้าของ Ctrip จะแสดงสัญลักษณ์ Prepaid',
    ctripEbCashProductsShowTheCashLogo:
      'สินค้า EB แบบชำระเงินปลายทางของ Ctrip จะแสดงสัญลักษณ์ Cash',
  },
  pcncomponentBatchUpdateStock: {
    cannotCloseRoomTip: 'ไม่สามารถปิดห้องได้เมื่อสินค้า EB มีห้องสำรองคงเหลือไม่ใช่ 0',
    roomSettingTip: 'การตั้งค่าห้องจะปรับจำนวนจำกัดขาย ซึ่งมีผลต่อสินค้าทั้งหมดในประเภทห้องนั้น',
    infiniteQuantityTip:
      'ปริมาณไม่จำกัดสอดคล้องกับ Unlimited ของ EB Meituan, Unlimited ของ Fliggy และ Freesale ของ Ctrip ช่องทาง Direct ไม่จำกัดการขาย',
    notModify: 'ไม่แก้ไข',
    roomSetting: 'ตั้งค่าห้อง',
    restrictedSalesIncrease: 'เพิ่มจำนวนจำกัดขาย',
    restrictedSalesReduction: 'ลดจำนวนจำกัดขาย',
    directlyConnectedProductsOnlySupportToModifyTheSwitchingRoomStatusDoNotSupportToModifyTheInventory:
      'สินค้าที่เชื่อมตรงรองรับแค่เปิด/ปิดห้อง ไม่รองรับการแก้ไขสต็อก',
    batchChangeInventory: 'แก้ไขสต็อกแบบกลุ่ม',
    productSelection: 'เลือกสินค้า',
    whetherToDisplayPreSaleProducts: 'แสดงสินค้าพรีเซลหรือไม่',
    channelSelection: 'เลือกช่องทาง',
    paymentType: 'ประเภทการชำระเงิน',
    selectionWeek2: 'เลือกวันในสัปดาห์',
    switchRoomSetup: 'ตั้งค่าการเปิด/ปิดห้อง',
    open: 'เปิดแล้ว',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2:
      'มีสินค้าที่แก้ไขล้มเหลว โปรดอัปเดตราคา/สต็อกล่าสุด แล้วแก้ไขอีกครั้ง',
    pleaseSelectADateRange2: 'โปรดเลือกช่วงวันที่',
    pleaseSelectAWeek2: 'โปรดเลือกวันในสัปดาห์',
    pleaseEnterTheNumberOfRestrictedRooms: 'โปรดกรอกจำนวนจำกัดขาย',
    pleaseEnterTheNumberOfRestrictedAdditionalRooms: 'โปรดกรอกจำนวนที่ต้องการเพิ่ม',
    pleaseEnterTheNumberOfRestrictedReducedRooms: 'โปรดกรอกจำนวนที่ต้องการลด',
  },
  pcncomponentPriceunified: {
    weekend: 'วันหยุดสุดสัปดาห์',
    officialWebsiteDirect: 'เว็บทางการ',
    dateCannotRepeat: 'ไม่สามารถเลือกวันที่ซ้ำได้',
    displayNextPage: 'แสดงหน้าถัดไป',
    priceCannotBeLessThan20: 'ราคาขายต้องไม่ต่ำกว่า 20',
    lowSellingPriceTip: 'สินค้าต่อไปนี้มีราคาขายต่ำเกินไป โปรดยืนยันว่าจะดำเนินการต่อหรือไม่',
    priceExceedsThresholdTip:
      'การแก้ไขราคาครั้งนี้เกินช่วงที่กำหนด โปรดติดต่อผู้จัดการเพื่อขออนุมัติ',
    selectProduct: 'เลือกสินค้า',
    weekdays: 'วันธรรมดา',
    noDifference: 'ไม่แยก',
    distinguish: 'แยก',
    bulkAdjustment: 'ปรับแบบกลุ่ม',
    increase: 'เพิ่ม',
    reduce: 'ลด',
    weekdayWeekend: 'วันธรรมดา/สุดสัปดาห์',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2:
      'มีสินค้าที่แก้ไขล้มเหลว โปรดอัปเดตราคา/สต็อกล่าสุด แล้วแก้ไขอีกครั้ง',
    weekendPrice: 'แยกราคาวันหยุดสุดสัปดาห์',
    repricingDate: 'วันที่แก้ไขราคา',
    effectiveWeek: 'สัปดาห์ที่มีผล',
    maxFiveDates: 'เลือกได้สูงสุด 5 วันที่',
    priceChangeModeTip:
      'โหมดแก้ไขราคา: สามารถเลือกแก้ไข “ราคาขาย+ค่าคอมมิชชั่น” หรือ “ราคาพื้นฐาน” โดย 携程 (专有名词无法翻译) รองรับการแก้ไขค่าคอมแบบเพิ่มขึ้นเท่านั้น ส่วนโหมดราคาพื้นฐานรองรับเฉพาะ 携程',
    sellPriceCommission: 'ราคาขาย+ค่าคอมมิชชั่น',
    ebChannel: 'ช่องทาง EB',
    ebMeituan: 'EB Meituan',
    ebCtrip: 'EB Ctrip',
    ebFeizhu: 'EB Fliggy',
    splitPricing: 'แก้ไขราคาทีละรายการ',
    uniformPriceChange: 'แก้ไขราคาแบบรวม',
    productSelection: 'เลือกสินค้า',
    paymentType: 'ประเภทการชำระเงิน',
    selectionWeek2: 'เลือกวันในสัปดาห์',
    thePreviousStepReselectTheProduct: 'ย้อนกลับ เลือกสินค้าใหม่',
    methodOfRepricing: 'วิธีการแก้ไขราคา',
    separatePriceChangesCanSetThePriceOfEachProductAndUnifiedPriceChangesCanBeAddedAndReducedInBatches:
      'การแก้ไขแยกรายการสามารถตั้งราคาของแต่ละสินค้า ส่วนการแก้ไขรวมสามารถเพิ่ม/ลดราคาแบบกลุ่มได้',
    priceModel: 'โมเดลราคา',
    priceBeforeModification: 'ราคาก่อนแก้ไข',
    extraChargeAfterOneHour: 'ค่าบริการเกิน 1 ชั่วโมง',
    commission: 'ค่าคอมมิชชั่น',
    directChannel4: 'ช่องทางเชื่อมตรง',
    goWhereTheDirectConnection: 'Qunar Direct Connect',
    value: 'ค่า',
  },
  pcncomponentTable: {
    passTheVerification: 'ตรวจสอบผ่าน',
    verificationFail: 'ตรวจสอบไม่ผ่าน',
  },
  pcncomponentLog: {
    revisedPrice3: 'ราคาที่แก้ไขแล้ว',
    pleaseEnterTheRevisedPrice: 'โปรดกรอกราคาที่แก้ไขแล้ว',
    pleaseSelectAStandardProduct: 'โปรดเลือกสินค้ามาตรฐาน',
    straight: 'ตรง',
  },
  giftPro: {
    bindUnbind: 'ผูก/ยกเลิกการผูก',
    giftValueInfo: 'มูลค่ากิฟต์แพ็กใช้เพื่อแสดงผลเท่านั้น ไม่คิดค่าใช้จ่ายจริง',
    thePackageCanOnlyBeConfiguredWithAllDayRoomProducts: 'กิฟต์แพ็กใช้ได้เฉพาะสินค้าห้องเต็มวัน',
    eachProductCanBeConfiguredWithOnlyOnePackage: 'แต่ละสินค้ากำหนดกิฟต์แพ็กได้เพียงหนึ่งประเภท',
    theGiftPackageIsOnlyValidForMeituanDirectConnectionProducts:
      'แพ็กเกจของขวัญใช้ได้เฉพาะกับสินค้า Meituan Direct Connect',
    packageDescription: 'คำอธิบายกิฟต์แพ็ก',
    allProducts2: 'สินค้าทั้งหมด',
    modifiedGiftPack: 'แก้ไขกิฟต์แพ็ก',
    packageName: 'ชื่อกิฟต์แพ็ก',
    giftPackageGiving: 'วิธีการมอบกิฟต์แพ็ก',
    packageType: 'ประเภทกิฟต์แพ็ก',
    packageStatus: 'สถานะกิฟต์แพ็ก',
    activeProduct: 'สินค้าที่มีผล',
    createPackage: 'สร้างกิฟต์แพ็ก',
    packageValue: 'มูลค่ากิฟต์แพ็ก',
    packageEffectiveDate: 'วันที่มีผลของกิฟต์แพ็ก',
    upperLimit1500: 'สูงสุด 1500',
    upperLimit: 'ขีดสูงสุด',
    packageDetails: 'รายละเอียดกิฟต์แพ็ก',
    maximum80Characters: 'ยาวได้สูงสุด 80 ตัวอักษร',
    wayOfGiving: 'วิธีการมอบ',
    thePackageValueCannotBeEmpty: 'มูลค่ากิฟต์แพ็กห้ามเว้นว่าง',
    oneDeliveryPerRoom: 'มอบหนึ่งครั้งต่อหนึ่งห้อง',
    complimentaryOnceADayPerRoom: 'มอบหนึ่งครั้งต่อห้องต่อวัน',
    pleaseEnterThePackageName: 'โปรดกรอกชื่อกิฟต์แพ็ก',
    pleaseSelectTheGiftMethod: 'โปรดเลือกวิธีการมอบ',
    // Part 23, lines 4401 to 4600
    pleaseSelectAPackageType: 'กรุณาเลือกประเภทกิฟต์แพ็ก',
    pleaseSelectPackageDetails: 'กรุณาเลือกรายละเอียดกิฟต์แพ็ก',
    pleaseSelectAnEffectiveProduct: 'กรุณาเลือกสินค้าที่มีผล',
    pleaseSelectAnEffectiveDate: 'กรุณาเลือกวันที่มีผล',
    whetherToDropTheGiftPackage: 'ต้องการนำกิฟต์แพ็กลงจากระบบหรือไม่',
    giftBagOffLine: 'กิฟต์แพ็กออฟไลน์',
    offlineSuccess: 'นำออกจากระบบสำเร็จ',
    offlineFailure: 'นำออกจากระบบล้มเหลว',
    methodOfCancellation: 'วิธีการยกเลิก',
    createdSuccessfully: 'สร้างสำเร็จ',
    creationFailure: 'สร้างล้มเหลว',
  },
  giftLog: {
    packageOperationLog: 'บันทึกการดำเนินงานกิฟต์แพ็ก',
  },
  pullnewMember: {
    memberInformationEntry: 'กรอกข้อมูลสมาชิก',
    areRequiredFieldsOtherFieldsAreNotRequired: 'เป็นช่องที่จำเป็นต้องกรอก ช่องอื่นไม่จำเป็น',
    idNumber: 'หมายเลขเอกสาร',
    inputResult: 'ผลการกรอก',
    recordSuccessfully: 'บันทึกสำเร็จ',
    entryFailure: 'บันทึกล้มเหลว',
    memberSale: 'สมาชิกขายพิเศษ',
    enter: 'บันทึก',
    passport: 'หนังสือเดินทาง',
    pleaseEnterTheIdNumber: 'กรุณากรอกหมายเลขเอกสาร',
    theNameFormatIsIncorrect: 'รูปแบบชื่อไม่ถูกต้อง',
    theMobilePhoneNumberCannotBeEmpty: 'หมายเลขโทรศัพท์ต้องไม่เว้นว่าง',
    theMobilePhoneNumberFormatIsIncorrect: 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง',
    theFormatOfTheIdCardNumberIsIncorrect: 'รูปแบบหมายเลขบัตรประชาชนไม่ถูกต้อง',
    memberInformationEnteredSuccessfully: 'บันทึกข้อมูลสมาชิกสำเร็จ',
  },
  pullnewNewlist: {
    promoter: 'ผู้โปรโมต',
    pullTime: 'เวลาการดึงสมาชิกใหม่',
    pleaseEnterYourPromoterName: 'กรุณากรอกชื่อผู้โปรโมต',
    memberNickname: 'ชื่อเล่นสมาชิก',
    pulsingType: 'ประเภทการดึงสมาชิกใหม่',
  },
  pullnewQrcode: {
    aboutHalfA4: 'ประมาณครึ่งกระดาษ A4',
    sizeLarge: 'ใหญ่',
    sizeSmall: 'เล็ก',
    sizeMedium: 'กลาง',
    lShapedStand: 'ป้ายตั้งรูปตัว L',
    paperSize: 'ขนาดกระดาษ',
    downloadPicture: 'ดาวน์โหลดรูปภาพ',
    memberPullNewCodeGenerationPleaseWait: 'กำลังสร้างคิวอาร์โค้ดดึงสมาชิกใหม่ กรุณารอสักครู่',
    memberPoster: 'โปสเตอร์สมาชิก',
    frontDeskStaff: 'พนักงานหน้าเคาน์เตอร์',
    foreground: 'หน้าเคาน์เตอร์',
    commonArea: 'พื้นที่ส่วนกลาง',
    corridor: 'โถงทางเดิน',
    elevator: 'ลิฟต์',
    displayStand: 'แท่นแสดง',
  },
  tiktokpresalecouponDetail: {
    name: 'ชื่อ',
    totalGoodsPrice: 'ราคารวมสินค้า (ราคาขีดฆ่า)',
    uploadImageTips: 'อัปโหลด 1-5 รูป ขนาดไม่เกิน 5MB; แนะนำความละเอียด 375*280px; อัตราส่วน 4:3',
    unavailableCheckInDates: 'วันที่ไม่สามารถเข้าพักได้:',
    otherInStoreOffers: 'สามารถใช้ร่วมกับโปรอื่นในร้าน (สอบถามร้านค้า)',
    createACoupon: 'สร้างคูปองพรีเซล',
    support: 'รองรับ',
    nonsupport: 'ไม่รองรับ',
    putUp: 'ที่พัก',
    bindAvailableProducts: 'ผูกสินค้าที่ใช้ได้',
    bindAtLeastOneProduct: 'ต้องผูกอย่างน้อย 1 สินค้า',
    meal: 'มื้ออาหาร',
    addMeal: 'เพิ่มรายการอาหาร',
    courteousReception: 'สิทธิประโยชน์',
    addItem: 'เพิ่มรายการ',
    unlimitedInventory: 'ไม่จำกัดสต็อก',
    stockLimit: 'จำกัดสต็อก',
    whenAutomaticExtensionIsEnabledTheProductWillBeAutomaticallyExtendedFor30DaysAfterTheExpirationDate:
      'เมื่อเปิดใช้งานการขยายอายุอัตโนมัติ สินค้าจะขยายเวลาขายอีก 30 วันหลังหมดอายุ',
    namedDate: 'วันที่เฉพาะเจาะจง',
    specifiedDays: 'จำนวนวันที่กำหนด',
    fromTheDateOfPurchase: 'นับจากวันที่ซื้อ',
    availableWithinDays: 'ใช้ได้ภายใน ... วัน',
    unavailableWeek: 'วันในสัปดาห์ที่ไม่สามารถใช้ได้',
    unavailableHolidays: 'วันหยุดที่ไม่สามารถใช้ได้',
    unavailableDate: 'วันที่ไม่สามารถใช้ได้',
    subjectToAMarkup: 'ต้องบวกเพิ่ม',
    noMarkup: 'ไม่ต้องบวกเพิ่ม',
    allStores: 'ทุกสาขา',
    addMarkupRules: 'เพิ่มกฎบวกเพิ่ม',
    limitOnePurchasePerOrder: 'จำกัด 1 ใบต่อออเดอร์',
    purchaseLimitPerPerson: 'จำกัดจำนวนต่อคน',
    maximumPurchasePerPerson: 'แต่ละคนซื้อได้สูงสุด',
    zhang: 'ใบ',
    noAdvanceReservationRequired: 'ไม่ต้องจองล่วงหน้า',
    advanceReservationRequired: 'ต้องจองล่วงหน้า',
    aheadOfSchedule: 'ล่วงหน้า',
    dailyReservation: 'วันก่อนเข้าพัก',
    beforeCheckIn: 'ก่อนเข้าพัก',
    cannotBeCombinedWithOtherInStoreOffers: 'ไม่สามารถใช้ร่วมกับโปรอื่นภายในร้าน',
    theMealTypeCannotBeEmpty: 'ต้องระบุประเภทอาหาร',
    theNameOfTheOfferCannotBeEmpty: 'ต้องระบุชื่อสิทธิประโยชน์',
    ticketName: 'ชื่อคูปองพรีเซล',
    pleaseEnterTicketNamemaximum24Words: 'กรุณากรอกชื่อคูปอง (สูงสุด 60 ตัวอักษร)',
    fractionalAppointment: 'จองแบบแบ่งรอบ',
    commodityContent: 'เนื้อหาสินค้า',
    lunch: 'อาหารกลางวัน',
    automaticExtension: 'ขยายอัตโนมัติ',
    availabilityDate: 'วันที่สามารถเข้าพักได้',
    markUpPolicy: 'นโยบายบวกเพิ่ม',
    additionalChargesApply: 'รายการที่ต้องชำระเพิ่ม',
    purchaseRestrictionRule: 'กฎการจำกัดการซื้อ',
    reservationRule: 'กฎการจอง',
    upload110PicturesImageSize5mOrLessRecommendedResolution375280pxImageRatio:
      'อัปโหลด 1-10 รูป ขนาดไม่เกิน 5MB; แนะนำ 375*280px; อัตราส่วนภาพ:',
    preSaleTicketHeadChart: 'ภาพหัวของคูปองพรีเซล',
    longMapOfAdvanceTickets: 'ภาพยาวของคูปองพรีเซล',
    reservationValidity: 'อายุการจอง',
    markupStore: 'สาขาที่ต้องบวกเพิ่ม',
    markupSession: 'ช่วงเวลาที่ต้องบวกเพิ่ม',
    unit: 'หน่วย',
    pleaseEnterTheUnit: 'กรุณากรอกหน่วย',
    priceyuan: 'ราคา ',
    cancellationRules: 'กฎการยกเลิก',
    rulesOfUse: 'กฎการใช้',
    otherDescriptiveInformation: 'ข้อมูลเพิ่มเติม',
    pleaseEnterAdditionalExplanatoryInformation: 'กรุณากรอกข้อมูลเพิ่มเติม',
    found: 'สร้าง',
    picturePreview: 'พรีวิวรูปภาพ',
    theNameOfTheVoucherCannotBeEmpty: 'ชื่อคูปองต้องไม่เว้นว่าง',
    theNameOfTheVoucherCannotExceed24Characters: 'ชื่อคูปองยาวเกิน 60 ตัวอักษร',
    pleaseSelectASaleDate: 'กรุณาเลือกวันที่ขาย',
    pleaseSelectTheReservationValidityPeriod: 'กรุณาเลือกอายุการจอง',
    pleaseSelectTheHeaderDiagram: 'กรุณาเลือกรูปหัว',
    pleaseSelectALongMap: 'กรุณาเลือกรูปยาว',
    thePurchaseLimitPerPersonCanOnlyBeANumber: 'จำนวนจำกัดต่อคนต้องเป็นตัวเลขเท่านั้น',
    pleaseFillInTheLengthOfStay: 'กรุณากรอกระยะเวลาการเข้าพัก',
    mealPriceMustBeGreaterThan: 'ราคาอาหารต้องมากกว่า',
    theCourtesyPriceMustBeGreaterThan: 'ราคาสิทธิประโยชน์ต้องมากกว่า',
    theTotalPriceOfTheGoodsCannotBeEmpty: 'ราคารวมสินค้าต้องไม่เว้นว่าง',
    theTotalPriceOfTheGoodsMustBeGreaterThan: 'ราคารวมสินค้าต้องมากกว่า',
    pleaseFillInTheActualPricePaidByTheGuest: 'กรุณากรอกราคาที่ลูกค้าจ่ายจริง',
    theActualPricePaidMustBeGreaterThan: 'ราคาที่จ่ายจริงต้องมากกว่า',
    theActualPricePaidByTheGuestCannotBeGreaterThanTheTotalPriceOfTheProduct:
      'ราคาที่ลูกค้าจ่ายจริงต้องไม่เกินราคารวมสินค้า',
    youCanOnlyUploadPictureFiles: 'อัปโหลดได้เฉพาะไฟล์รูปภาพ',
    pleaseUploadAtLeast1HeaderImage: 'กรุณาอัปโหลดรูปหัวอย่างน้อย 1 รูป',
    pleaseUploadAtLeast1LongPicture: 'กรุณาอัปโหลดรูปยาวอย่างน้อย 1 รูป',
    pleaseEnterTheMaximumPurchasePerPerson: 'กรุณากรอกจำนวนสูงสุดต่อคน',
    pleaseFillInTheDailyLimit: 'กรุณากรอกจำนวนจำกัดรายวัน',
    confirmTheDateToDeleteThis: 'ยืนยันลบวันที่นี้หรือไม่',
    confirmToDeleteThisProduct: 'ยืนยันลบสินค้านี้หรือไม่',
    confirmToDeleteThisMeal: 'ยืนยันลบอาหารนี้หรือไม่',
    removeMarkupRules: 'ลบกฎบวกเพิ่ม',
    confirmToRemoveThisMarkupPolicy: 'ยืนยันลบนโยบายบวกเพิ่มนี้หรือไม่',
    newMarkupRules: 'เพิ่มกฎบวกเพิ่มใหม่',
    confirmToDeleteThisOffer: 'ยืนยันลบสิทธิประโยชน์นี้หรือไม่',
    addProjectData: 'เพิ่มข้อมูลรายการใหม่',
    popUpsAreClosed: 'ป๊อปอัปถูกปิดแล้ว',
    beSureToRemoveThisRestriction: 'ยืนยันลบข้อจำกัดนี้หรือไม่',
    imageUploadFailed: 'อัปโหลดรูปภาพล้มเหลว',
  },
  tiktokpresalecouponList: {
    deleteConfirm: 'ลบแล้วไม่สามารถกู้คืนได้ ยืนยันลบหรือไม่?',
    shelveConfirm: 'นำสินค้าลงจะไม่สามารถขายได้ ยืนยันหรือไม่?',
    unrestrictedInventory: 'ไม่จำกัดสต็อก',
    theRemovalHasBeenCancelled: 'ยกเลิกการลงสินค้าแล้ว',
    productId: 'รหัสสินค้า',
    product: 'สินค้า',
    createACoupon: 'สร้างคูปองพรีเซล',
    listing: 'วางขาย',
    delist: 'นำลง',
    auditFailure: 'ตรวจสอบไม่ผ่าน',
    soldInventory: 'สต็อกที่ขายแล้ว',
    modifiedPricePool: 'แก้ไขราคากลุ่ม',
    copy: 'คัดลอก',
    exportListOfPreSaleTickets: 'ส่งออกรายการคูปองพรีเซล',
    itemDeletion: 'ลบสินค้า',
    goodsOffTheProductionLine: 'สินค้าถูกนำลง',
    removedSuccessfully: 'นำลงสำเร็จ',
  },
  assemblyAddpriceruledialog: {
    allStores: 'ทุกสาขา',
    byDate: 'ตามวันที่',
    byHoliday: 'ตามวันหยุด',
    addMarkupRules: 'เพิ่มกฎบวกเพิ่ม',
    markupStore: 'สาขาที่บวกเพิ่ม',
    markUpPeriod: 'ช่วงเวลาที่บวกเพิ่ม',
    pleaseEnterTheAmountOfTheIncrease: 'กรุณากรอกจำนวนเงินที่บวกเพิ่ม',
    theIncreaseMustBeGreaterThan: 'จำนวนเงินที่บวกเพิ่มต้องมากกว่า',
    pleaseSelectTheIncreasePeriod: 'กรุณาเลือกช่วงเวลาที่บวกเพิ่ม',
    pleaseSelectAFestival: 'กรุณาเลือกเทศกาล',
    pleaseSelectTheWeekOfIncrease: 'กรุณาเลือกวันในสัปดาห์ที่บวกเพิ่ม',
  },
  assemblyAddmeals: {
    addMeal: 'เพิ่มรายการอาหาร',
    typeOfMeal: 'ประเภทอาหาร',
    pleaseSelectTheTypeOfMeal: 'กรุณาเลือกประเภทอาหาร',
    lunch: 'มื้อกลางวัน',
    dinner: 'มื้อเย็น',
    copies: 'จำนวนชุด',
    pleaseEnterTheNumberOfCopies: 'กรุณากรอกจำนวนชุด',
    theNumberOfCopiesMustBeGreaterThan: 'จำนวนชุดต้องมากกว่า',
  },
  // Part 24, lines 4601 to 4800
  settingHardware: {
    hardwareManagementToBeDeveloped: 'การจัดการฮาร์ดแวร์ อยู่ระหว่างการพัฒนา',
  },
  settingMessage: {
    messageManagementToBeDeveloped: 'การจัดการข้อความ อยู่ระหว่างการพัฒนา',
  },
  baseinfotabBase: {
    orientation: 'ตำแหน่งที่ตั้ง',
    china: 'จีน',
    province: 'มณฑล',
    hotelRating: 'ระดับดาวของโรงแรม',
    detailedAddress: 'ที่อยู่โดยละเอียด',
    city: 'เมือง',
    hotelPrice: 'ช่วงราคาโรงแรม',
    hotelReceptionCellPhone: 'มือถือหน้าเคาน์เตอร์โรงแรม',
    hotelFrontDesk: 'โทรศัพท์หน้าเคาน์เตอร์โรงแรม',
    areaCode: 'รหัสพื้นที่',
    landlineNumber: 'หมายเลขโทรศัพท์',
    extensionNumber: 'เบอร์ต่อ',
    serviceStatus: 'สถานะการให้บริการ',
    ctripHotelStars: 'ระดับดาวโรงแรม Ctrip',
    noStarLevel: 'ไม่มีระดับดาว',
    starLevel: '{num} ดาว',
    whetherToSellItOnTheInternet: 'ขายบนเว็บไซต์หรือไม่',
    currency: 'สกุลเงิน',
    longitude: 'ลองจิจูด',
    latitude: 'ละติจูด',
    baiduLatitudeAndLongitude: 'พิกัดเส้นรุ้งเส้นแวงของ Baidu',
    pleaseEnterTheCorrectPhoneNumberWithAMaximumOf11Digits:
      'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง สูงสุด 11 หลัก',
    theLengthIs78Characters: 'ความยาว 7-8 ตัวอักษร',
    theLengthIs34Characters: 'ความยาว 3-4 ตัวอักษร',
    pleaseEnterAnInteger: 'กรุณากรอกจำนวนเต็ม',
    pleaseEnterTheHotelName: 'กรุณากรอกชื่อโรงแรม',
    lengthOf250ChineseCharacters: 'ความยาว 2-50 ตัวอักษรจีน',
    theValueContains34Digits: 'ค่าตัวเลขยาว 3-4 หลัก',
    theValueContains78Characters: 'ค่าตัวเลขยาว 7-8 หลัก',
    pleaseEnterTheValue: 'กรุณากรอกตัวเลข',
    pleaseSelectAProvince: 'กรุณาเลือกมณฑล',
    pleaseSelectCity: 'กรุณาเลือกเมือง',
    pleaseSelectACounty: 'กรุณาเลือกอำเภอ/เขต',
    pleaseEnterTheFullAddress2: 'กรุณากรอกที่อยู่โดยละเอียด',
    theDetailedAddressDoesNotExceed50ChineseCharacters: 'ที่อยู่โดยละเอียดไม่เกิน 50 ตัวอักษรจีน',
    pleaseSelectHotelClass: 'กรุณาเลือกระดับดาวของโรงแรม',
    pleaseSelectACtripHotelStar: 'กรุณาเลือกระดับดาว Ctrip',
    selectWhetherTheExternalNetworkIsVisible: 'กรุณาเลือกว่าจะให้มองเห็นบนเว็บไซต์ภายนอกหรือไม่',
    pleaseSelectHotelServiceStatus: 'กรุณาเลือกสถานะการให้บริการของโรงแรม',
    economical: 'ประหยัด',
    quasi1Star: 'กึ่ง 1 ดาว',
    true1Star: 'จริง 1 ดาว',
    quasi2Star: 'กึ่ง 2 ดาว',
    true2Star: 'จริง 2 ดาว',
    quasi3Star: 'กึ่ง 3 ดาว',
    true3Star: 'จริง 3 ดาว',
    quasi4Star: 'กึ่ง 4 ดาว',
    true4Star: 'จริง 4 ดาว',
    quasi5Star: 'กึ่ง 5 ดาว',
    true5Star: 'จริง 5 ดาว',
    inOperation: 'เปิดให้บริการ',
    suspendBusiness: 'ปิดให้บริการชั่วคราว',
    tencentMapLatitudeAndLongitudeCanNotBeEmpty: 'พิกัด Tencent/แผนที่ Gaode ต้องไม่เว้นว่าง',
    theNameAndAddressOfTheHotelAreUnderReview: 'ชื่อและที่อยู่โรงแรมอยู่ระหว่างตรวจสอบ',
    districtcounty: 'เขต/อำเภอ',
    tencentamapLatitudeAndLongitude: 'พิกัด Tencent/แผนที่ Gaode',
    pleaseEnterTheCorrectPhoneNumberAndTheMaximumIs11Digits:
      'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง สูงสุด 11 หลัก',
  },
  baseinfotabFull: {
    hotelTimezone: 'เขตเวลาโรงแรม',
    fixedRoomNumber: 'กำหนดจำนวนห้องคงที่หรือไม่',
    businessCircle: 'ย่านธุรกิจหลัก',
    hotelBuildingHeight: 'ความสูงอาคารโรงแรม',
    subordinateBusinessCircle: 'ย่านธุรกิจรอง',
    totalNumberOfRooms: 'จำนวนห้องทั้งหมด',
    hotelOpeningHours: 'วันเปิดให้บริการโรงแรม',
    pleaseSelectADate5: 'กรุณาเลือกปีและเดือน',
    affiliatedGroup: 'เครือที่สังกัด',
    hotelRenovationTime: 'ปีที่ปรับปรุงโรงแรม',
    affiliatedBrand: 'แบรนด์ที่สังกัด',
    hotelTypeupToThree: 'ประเภทธุรกิจโรงแรม (เลือกได้สูงสุด 3 รายการ)',
    hotelThemeupToThreeCanBeSelected: 'ธีมโรงแรม (เลือกได้สูงสุด 3 รายการ)',
    settlementMethod: 'วิธีการชำระเงิน',
    hotelProfile: 'แนะนำโรงแรม',
    hotelTransportationLocation: 'ข้อมูลการเดินทางสู่โรงแรม',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits:
      'กรุณากรอกตัวเลข ≥ 0 และไม่เกิน 3 หลัก',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits:
      'กรุณากรอกตัวเลข ≥ 0 และไม่เกิน 2 หลัก',
    pleaseEnterADescriptionOfTheHotelWithAMaximumLengthOf800Characters:
      'กรุณากรอกข้อมูลโรงแรมไม่เกิน 800 ตัวอักษร',
    pleaseEnterTheHotelTransportationLocation: 'กรุณากรอกข้อมูลการเดินทาง',
    pleaseEnterTheHotelTransportationLocationInAMaximumOf800Characters:
      'ข้อมูลการเดินทางไม่เกิน 800 ตัวอักษร',
    pleaseEnterTheTotalNumberOfRooms: 'กรุณากรอกจำนวนห้องทั้งหมด',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits2:
      'กรุณากรอกตัวเลข ≥0 ไม่เกิน 3 หลัก',
    pleaseSelectYourBrand: 'กรุณาเลือกแบรนด์',
    pleaseEnterTheHotelBuildingHeight: 'กรุณากรอกความสูงอาคาร',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits2:
      'กรุณากรอกตัวเลข ≥0 ไม่เกิน 2 หลัก',
    pleaseEnterHotelRenovationTime: 'กรุณากรอกปีที่ปรับปรุงโรงแรม',
    pleaseEnterHotelOpeningHours: 'กรุณากรอกปีเปิดบริการของโรงแรม',
    pleaseEnterTheCheckoutSupportCardType: 'กรุณากรอกประเภทบัตรที่รองรับ',
    pleaseSelectHotelType: 'กรุณาเลือกประเภทโรงแรม',
    pleaseSelectAHotelTheme: 'กรุณาเลือกธีมโรงแรม',
    bizumi: 'Meizhu',
    theBusinessCircleIsUnderReview: 'ย่านธุรกิจอยู่ระหว่างตรวจสอบ',
    includesButNotLimitedToHotelAddressHotelFacilitiesHotelServicesProvidedHotelFeaturesAndAdvantages:
      'รวมถึงแต่ไม่จำกัดเฉพาะ: ที่อยู่โรงแรม สิ่งอำนวยความสะดวก บริการคุณลักษณะและจุดเด่น',
    includesButNotLimitedToTrafficFacilitiesNearTheHotelSuchAsDistanceFromTheBusStation100MetersDistanceFromTheHighSpeedTrainStation25Km:
      'รวมถึงแต่ไม่จำกัดเฉพาะ: สิ่งอำนวยความสะดวกด้านการเดินทาง เช่น ห่างจากป้ายรถเมล์ 100 เมตร ห่างจากสถานีรถไฟความเร็วสูง 2.5 กม.',
  },
  baseinfotabInfo: {
    commission2: 'ภาษีและค่าธรรมเนียม',
    bookingInstructions: 'ข้อมูลสำคัญก่อนการจอง',
    variousFaults: 'ประเภทความขัดข้อง',
    earliestCheckInTime: 'เวลาเช็กอินเร็วที่สุด',
    latestDepartureTime: 'เวลาเช็กเอาต์ช้าที่สุด',
    hourRoomEarliestCheckInTime: 'เวลาเช็กอิน (รายชั่วโมง)เร็วที่สุด',
    hourRoomLatestCheckOutTime: 'เวลาเช็กเอาต์ (รายชั่วโมง)ช้าที่สุด',
    aMaximumOf30Characters: 'สูงสุดไม่เกิน 30 ตัวอักษร',
    taxTitle: 'ชื่อภาษี',
    chargingStandard: 'อัตราค่าบริการ',
    reservationNotes: 'หมายเหตุการจอง',
    chineseDescription: 'คำอธิบายภาษาจีน',
    pleaseEnterYourEarliestCheckInTime: 'กรุณากรอกเวลาเช็กอินเร็วที่สุด',
    pleaseEnterTheLatestDepartureTime: 'กรุณากรอกเวลาเช็กเอาต์ช้าที่สุด',
    pleaseEnterTheEarliestCheckInTimeForTheHourRoom: 'กรุณากรอกเวลาเช็กอินรายชั่วโมง (เร็วที่สุด)',
    pleaseEnterTheLatestCheckOutTimeForTheHourRoom: 'กรุณากรอกเวลาเช็กเอาต์รายชั่วโมง (ช้าที่สุด)',
    pleaseSelectTheBookingInstructions: 'กรุณาเลือกข้อมูลสำคัญก่อนการจอง',
    noMoreThan10ChineseCharactersInLength: 'ความยาวไม่เกิน 10 ตัวอักษรจีน',
    theLengthCannotExceed20Characters: 'ความยาวไม่เกิน 20 ตัวอักษร',
    noMoreThan20ChineseCharactersInLength: 'ความยาวไม่เกิน 20 ตัวอักษรจีน',
    noMoreThan30ChineseCharactersInLength: 'ความยาวไม่เกิน 30 ตัวอักษรจีน',
    theLengthCannotExceed60Characters: 'ความยาวไม่เกิน 60 ตัวอักษร',
    cutOffTheWaterSupply: 'ตัดน้ำ',
    powerFailure: 'ไฟดับ',
    elevatorFailure: 'ลิฟต์ขัดข้อง',
    cantUseBankCard: 'ไม่สามารถใช้บัตรธนาคาร',
    networkFault: 'อินเทอร์เน็ตขัดข้อง',
    pleaseEnterTheStartTimeAndEndTime: 'กรุณากรอกเวลาเริ่มต้นและเวลาสิ้นสุด',
    theStartTimeMustBeYoungerThanTheEndTime: 'เวลาเริ่มต้องน้อยกว่าเวลาสิ้นสุด',
  },
  baseinfotabServer: {
    squareMeter: 'ตารางเมตร',
    parkingLot: 'ที่จอดรถ',
    elevator2: 'ลิฟต์',
    pleaseEnterArea: 'กรุณากรอกพื้นที่',
    internetAccessInPublicAreas: 'อินเทอร์เน็ตในพื้นที่สาธารณะ',
    hotelFacilities: 'สิ่งอำนวยความสะดวกในโรงแรม',
    otherFacilities: 'สิ่งอำนวยความสะดวกอื่นๆ',
    hotelService: 'บริการของโรงแรม',
    otherServices: 'บริการอื่นๆ',
    fallow: 'สันทนาการ',
    otherLeisure: 'สันทนาการอื่นๆ',
    pleaseEnterAMaximumOf10DigitsInEnglish: 'กรุณากรอกอักษรอังกฤษ/จีน/ตัวเลข ไม่เกิน 10 ตัวอักษร',
    pleaseSelectParking: 'กรุณาเลือกที่จอดรถ',
    pleaseSelectTheHall: 'กรุณาเลือกล็อบบี้',
    pleaseEnterTheHallArea: 'กรุณากรอกพื้นที่ล็อบบี้',
    pleaseSelectElevator: 'กรุณาเลือกลิฟต์',
    pleaseSelectPublicAreasToAccessTheInternet: 'กรุณาเลือกการใช้อินเทอร์เน็ตในพื้นที่สาธารณะ',
    pleaseSelectHotelFacilities: 'กรุณาเลือกสิ่งอำนวยความสะดวก',
    pleaseSelectHotelServices: 'กรุณาเลือกบริการของโรงแรม',
    pleaseSelectLeisure: 'กรุณาเลือกกิจกรรมสันทนาการ',
    oneToFiveStars: 'กึ่ง 1-5 ดาว',
    true15Stars: 'จริง 1-5 ดาว',
    walkUp: 'ไม่มีลิฟต์',
    thereIsAnElevator: 'มีลิฟต์',
    lobbyless: 'ไม่มีล็อบบี้',
    haveALobby: 'มีล็อบบี้',
    noInternetAccess: 'ไม่มีอินเทอร์เน็ต',
    freeParking: 'จอดรถฟรี',
    noParking: 'ไม่มีที่จอดรถ',
    parkingLotAvailable: 'มีที่จอดรถ',
    paidParking: 'จอดรถมีค่าใช้จ่าย',
    charge: 'คิดค่าบริการ',
  },
  borrowBorrowrecord: {
    loanDate2: 'วันที่ยืม',
    newBorrowing: 'เพิ่มรายการยืม',
    return: 'คืน',
    cannotBeGreaterThanTheAvailableAmount: 'ต้องไม่เกินจำนวนที่มีอยู่',
    enterItemNameAndRoomNumber: 'กรอกชื่อสิ่งของ/หมายเลขห้อง',
    unitPriceOfGoods2: 'ราคาต่อหน่วย',
    quantityBorrowed: 'จำนวนที่ยืม',
    borrowARoom: 'ห้องที่ยืม',
    dateOfReturn: 'วันที่คืน',
    returnQuantity: 'จำนวนที่คืน',
    borrowedState: 'สถานะการยืม',
    amountOfCompensation: 'จำนวนเงินชดเชย',
    serviceSuccess: 'ดำเนินการสำเร็จ',
    serviceFailure: 'ดำเนินการล้มเหลว',
    reasonForRefusal: 'เหตุผลการปฏิเสธ',
    enterAMaximumOf30Characters: 'กรอกได้สูงสุด 30 ตัวอักษร',
    returnOrNot: 'คืนหรือไม่',
    hasItBeenReturned: 'คืนแล้วหรือไม่',
    onlyNumbersGreaterThan0CanBeEntered: 'กรอกได้เฉพาะตัวเลข > 0',
    theAmountReturnedCannotBeGreaterThanOrEqualToTheAmountBorrowed:
      'จำนวนคืนต้องน้อยกว่าจำนวนที่ยืม',
    upTo20Characters: 'ไม่เกิน 20 ตัวอักษร',
    pleaseEnterTheReturnQuantity: 'กรุณากรอกจำนวนคืน',
    onLoan: 'กำลังยืมอยู่',
    theRoomRequestHasBeenServiced: 'คำขอบริการห้องพักดำเนินการเสร็จแล้ว',
    serviceCompletion: 'บริการเสร็จสมบูรณ์',
    returned: 'คืนแล้ว',
    noReturn: 'ยังไม่คืน',
    enterAMaximumOf9Characters: 'กรอกได้สูงสุด 9 ตัวอักษร',
    chooseToBorrowRoom: 'เลือกห้องที่จะยืม',
  },
  borrowBorrowset: {
    newItem: 'เพิ่มสิ่งของใหม่',
    usable: 'ใช้งานได้',
    // Part 25, lines 4801 to 5000
    notAvailable: 'ไม่สามารถใช้งานได้',
    alreadyRemoved: 'ลบแล้ว',
    enterItemName: 'กรอกชื่อสิ่งของ',
    unitPriceOfGoods2: 'ราคาต่อหน่วยของสิ่งของ',
    inventory: 'สต็อก',
    amountBorrowed: 'จำนวนที่ยืมแล้ว',
    loanableQuantity: 'จำนวนที่สามารถยืมได้',
    theNameCannotExceed9CharactersPleaseEnterANewName: 'ชื่อต้องไม่เกิน 9 ตัวอักษร กรุณากรอกใหม่',
    priceCannotBeLessThan0PleaseReEnter: 'ราคาต้องไม่ต่ำกว่า 0 กรุณากรอกใหม่',
    priceCannotBeGreaterThan9999PleaseReEnter: 'ราคาต้องไม่เกิน 9999 กรุณากรอกใหม่',
    theInventoryCannotBeLessThan0PleaseReEnter: 'สต็อกต้องไม่ต่ำกว่า 0 กรุณากรอกใหม่',
    inventoryCannotBeLessThanTheBorrowedAmountPleaseReEnter:
      'สต็อกต้องไม่ต่ำกว่าจำนวนที่ยืม กรุณากรอกใหม่',
    areYouSureYouWantToDeleteThisItem: 'ยืนยันลบสิ่งของนี้หรือไม่',
    areYouSureYouWantToDisableThisItem: 'ยืนยันปิดการใช้งานสิ่งของนี้หรือไม่',
    thisItemHasNotBeenReturnedConfirmToDelete: 'รายการนี้ยังมีของที่ยังไม่คืน ยืนยันลบหรือไม่？',
  },
  businessCardIndex: {
    pleaseUploadPictures: 'กรุณาอัปโหลดรูปภาพ',
    pleaseEnterRoomType: 'กรุณากรอกประเภทห้อง',
    uploadBackground: 'อัปโหลดพื้นหลัง',
    saveOperation: 'บันทึกการทำงาน',
    uploadProfilePicture: 'อัปโหลดรูปโปรไฟล์',
    pleaseEnterAValidNumber: 'กรุณากรอกตัวเลขที่ถูกต้อง',
    businessCardType: 'ประเภมนามบัตร',
    currentPriceOfRoomType: 'ราคาปัจจุบันของประเภทห้อง',
    roomTypeOriginalPrice: 'ราคาเดิมของประเภทห้อง',
    backgroundImage: 'ภาพพื้นหลัง',
    avatar: 'รูปโปรไฟล์',
    hotelRecommendation: 'คำแนะนำโรงแรม',
    roomTypeRecommendation: 'คำแนะนำประเภทห้อง',
    theNameCannotBeBlank2: 'ชื่อห้ามว่าง',
    thePhoneNumberCannotBeEmpty: 'เบอร์โทรห้ามว่าง',
    pleaseEnterAValidPhoneNumber: 'กรุณากรอกเบอร์โทรที่ถูกต้อง',
    roomTypeNameCannotBeEmpty: 'ชื่อประเภทห้องห้ามว่าง',
    theCurrentPriceOfTheRoomTypeCannotBeEmpty: 'ราคาปัจจุบันของประเภทห้องห้ามว่าง',
    roomTypeOriginalPriceCannotBeEmpty: 'ราคาเดิมของประเภทห้องห้ามว่าง',
    pleaseUploadTheBackgroundImage: 'กรุณาอัปโหลดภาพพื้นหลัง',
    pleaseUploadPhoto: 'กรุณาอัปโหลดรูปภาพ',
    areYouSureYouWantToLeaveTheCurrentPage: 'ยืนยันออกจากหน้านี้หรือไม่',
    pleaseSelectImageUpload: 'กรุณาเลือกรูปภาพเพื่ออัปโหลด',
    theCurrentPriceOfTheRoomTypeShallNotBeLessThan: 'ราคาปัจจุบันของประเภทห้องต้องไม่ต่ำกว่า',
    roomTypeOriginalPriceMustNotBeLessThan: 'ราคาเดิมของประเภทห้องต้องไม่ต่ำกว่า',
  },

  businessCardUploadavatar: {
    selectPicture: 'เลือกรูปภาพ',
    uploadProfilePicture: 'อัปโหลดรูปโปรไฟล์',
    pleaseSelectImageUpload: 'กรุณาเลือกรูปภาพเพื่ออัปโหลด',
    onlyJpgAndPngImagesAreSupportedAndTheSizeOfTheImageDoesNotExceed5m:
      'รองรับเฉพาะไฟล์ JPG และ PNG ขนาดไม่เกิน 5MB',
  },

  ctnhotelHotelserver: {
    applicationTime2: 'เวลาที่สมัคร',
    toDealWith: 'ไปดำเนินการ',
    pleaseRenewYourStayOnTheDayOfDeparture: 'กรุณาทำรายการต่ออายุในวันออกจากที่พัก',
    applicant: 'ผู้สมัคร',
    originalExpectedArrivalDate: 'วันคาดว่าจะเข้าพักเดิม',
    originalDepartureDate: 'วันคาดว่าจะออกเดิม',
    applicationType: 'ประเภทคำขอ',
    renewTheNewOrderNumber: 'หมายเลขคำสั่งซื้อต่ออายุใหม่',
    renewalDate: 'วันที่ต่ออายุ',
  },

  ebaccountLogin: {
    accountLogin: 'เข้าสู่ระบบบัญชี',
    gotTheMessage: 'ได้รับข้อความแล้ว',
  },

  ebaccountSetting: {
    accountBinding: 'ผูกบัญชี',
    goToMaintain: 'ไปตั้งค่า',
    priceModel: 'โมเดลราคา',
    automaticOrder: 'โอนออเดอร์อัตโนมัติ',
    comingSoon: 'จะเปิดให้ใช้งานเร็วๆ นี้',
    hourlyRoomOrder: 'ออเดอร์ห้องรายชั่วโมง',
    orderCancellation: 'ยกเลิกคำสั่งซื้อ',
    bound: 'ผูกแล้ว',
    roomTypeSetting: 'ตั้งค่าประเภทห้อง',
    goToSettings: 'ไปตั้งค่า',
    lastStep: 'ขั้นตอนก่อนหน้า',
    correlationState: 'สถานะการเชื่อมโยง',
    bindAccount: 'ผูกบัญชี',
    synchronizationTime: 'เวลาซิงโครไนซ์',
    onSale: 'กำลังขาย',
    associated: 'เชื่อมโยงแล้ว',
    uncorrelated: 'ยังไม่เชื่อมโยง',
    bind: 'เชื่อมโยง',
    noDataIsQueried: 'ไม่พบข้อมูล',
    whetherToUnbindTheAccount: 'ต้องการยกเลิกการผูกบัญชีหรือไม่',
    pleaseEnterTheCommissionRate: 'กรุณากรอกอัตราค่าคอมมิชชั่น',
    channelSetting: 'ตั้งค่าช่องทาง',
    floorPriceModel: 'โมเดลราคาต้นทุน',
    sellingPriceModel: 'โมเดลราคาขาย',
    viewSettings: 'ดูการตั้งค่า',
    orderSetup: 'ตั้งค่าคำสั่งซื้อ',
    pleaseSelectAPriceModel: 'กรุณาเลือกโมเดลราคา',
    pleaseSelectHourRoomPickUp: 'กรุณาเลือกการรับออเดอร์ห้องรายชั่วโมง',
    dataSynchronization: 'การซิงค์ข้อมูล',
    ctripRoomType: 'ประเภทห้อง Ctrip',
    usGroupRoomType: 'ประเภทห้อง Meituan',
    lightWinTreasureRoomTypeName: 'ชื่อประเภทห้อง Qing Ying Bao',
    commissionRate: 'อัตราค่าคอมมิชชั่น',
    pleaseEnterTheSmsVerificationCode: 'กรุณากรอกรหัสยืนยัน SMS',
    pleaseEnterTheContentInThePicture: 'กรุณากรอกตัวอักษรในภาพ',
    groggery: 'โรงแรม',
    ctripProductName: 'ชื่อสินค้า Ctrip',
    meituanProductName: 'ชื่อสินค้า Meituan',
    ctripProducts: 'สินค้า Ctrip',
    meituanProducts: 'สินค้า Meituan',
    lightWinTreasureProductName: 'ชื่อสินค้า Qing Ying Bao',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100: 'อัตราคอมมิชชั่นต้อง ≥0 และ <100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
      'อัตราคอมมิชชั่นเป็นตัวเลข และทศนิยม 2 ตำแหน่ง',
    pleaseSelectTheHourlyOrderSetting: 'กรุณาเลือกการตั้งค่าออเดอร์รายชั่วโมง',
    automaticCancellation: 'ยกเลิกอัตโนมัติ',
    manualCancellation: 'ยกเลิกด้วยตนเอง',
    automaticConfirmation: 'ยืนยันอัตโนมัติ',
    manualValidation: 'ตรวจสอบด้วยตนเอง',
    meituancom: 'Meituan เว็บไซต์',
    ctrip: 'Ctrip Travel',
    pleaseEnterTheImageVerificationCode: 'กรุณากรอกรหัสภาพ',
    pleaseSelectHotel: 'กรุณาเลือกโรงแรม',
    theDataSynchronizationIsSuccessfulQueryTheDataAgain10MinutesLater:
      'ซิงค์ข้อมูลสำเร็จ กรุณาตรวจสอบอีกครั้งใน 10 นาที',
    unbind: 'ยกเลิกผูกบัญชี',
    whetherToUnbindTheProduct: 'ต้องการยกเลิกการผูกสินค้าหรือไม่',
    pleaseSelectTheProductName: 'กรุณาเลือกชื่อสินค้า Qing Ying Bao',
    unbindSuccessfully: 'ยกเลิกการผูกสำเร็จ',
    whetherToUnbindTheBindingRelationshipOfTheHouseType: 'ต้องการยกเลิกการผูกประเภทห้องหรือไม่',
    pleaseSelectLightWinTreasureRoomTypeName: 'กรุณาเลือกประเภทห้อง Qing Ying Bao',
    feizhu: 'Fliggy เว็บไซต์',
    notYetUnlocked: 'ยังไม่เปิดใช้งาน',
    pleaseBindTheAccountFirst: 'กรุณาผูกบัญชีก่อน',
    areYouSureYouWantToUnbindTheAccount: 'ยืนยันยกเลิกการผูกบัญชีหรือไม่',
    notYetBound: 'ยังไม่ผูกบัญชี',
    pleaseConfirmTheHotelYouWantToBindTo: 'กรุณายืนยันโรงแรมที่ต้องการผูก',
    ctripEbAccount: 'บัญชี Ctrip EB',
    meituanEbAccount: 'บัญชี Meituan EB',
    pleaseContactYourHotelOperationsManagerToSetUpACtripHotelid:
      'กรุณาติดต่อผู้จัดการเพื่อกำหนด Ctrip HotelID',
    useEbOrderInformation: 'ใช้ข้อมูลออเดอร์ EB',
    pleaseSelectEbOrderCancellation: 'กรุณาเลือกการยกเลิกออเดอร์ EB',
    meituanEbRoomType: 'ประเภทห้อง Meituan EB',
    lightWinTreasureRoomTypeId: 'ID ประเภทห้อง Qing Ying Bao',
    lightWinTreasureProductId: 'ID สินค้า Qing Ying Bao',
    pleaseSelectTheEbOrderCancellationSettings: 'กรุณาเลือกการตั้งค่าการยกเลิกออเดอร์ EB',
    whenYouAutomaticallyMoveTheOrderIfYouDoNotSetTheRoomTypeYouWillMoveTheOrderManually:
      'เมื่อโอนออเดอร์อัตโนมัติ หากไม่ได้ตั้งค่าประเภทห้องจะเปลี่ยนเป็นโอนด้วยตนเอง',
    whenYouManuallyMoveTheOrderYouWillBeGivenPriorityToMatchTheRoomTypeSetSavingTheTimeOfMovingTheOrder:
      'เมื่อโอนออเดอร์ด้วยตนเอง ระบบจะจับคู่ประเภทห้องที่ตั้งไว้เพื่อลดเวลาในการโอนงาน',
    thisEbOrderSetupCompletedPleaseProceedAsSoonAsPossible:
      'ตั้งค่าออเดอร์ EB สำเร็จ กรุณาดำเนินการต่อโดยเร็ว',
    reminderIfYouNeedToSetOrAddARoomTypePleaseContactYourOperationalManager:
      'หากต้องการเพิ่ม/ตั้งค่าประเภทห้อง กรุณาติดต่อผู้จัดการฝ่ายปฏิบัติการ',
    orderSetupCompletedPleaseProceedAsSoonAsPossible:
      'ตั้งค่าคำสั่งซื้อสำเร็จ กรุณาดำเนินการต่อโดยเร็ว',
    yourctripTravelEbkAccountisNotBoundAndYouWillNotBeAbleTo:
      'บัญชี EBK ของ “Ctrip Travel” ของคุณยังไม่ได้เชื่อมต่อ จะไม่สามารถดำเนินการได้',
    associationToAvoidAffectingEbMovingOrdersPleaseBindAsSoonAsPossible:
      'เชื่อมโยงได้ เพื่อไม่ให้กระทบการโอนออเดอร์ EB กรุณาผูกบัญชีโดยเร็ว',
    yourctripTravelEbkAccounthasExpiredAndYouWillNotBeAbleTo:
      'บัญชี EBK ของ “Ctrip Travel” ของคุณหมดอายุแล้ว จะไม่สามารถดำเนินการได้',
    associationToAvoidAffectingEbMovingOrdersPleaseunbindAndReBindAfterThe:
      'เชื่อมโยงได้ กรุณายกเลิกการผูกและผูกใหม่เพื่อไม่ให้กระทบการโอนออเดอร์ EB',
    yourmeituanEbkAccountisNotBoundAndYouWillNotBeAbleTo:
      'บัญชี EBK ของ “Meituan” ของคุณยังไม่ได้เชื่อมต่อ จะไม่สามารถดำเนินการได้',
    automaticallyCreditedToArAccount: 'บันทึกเข้าบัญชี AR โดยอัตโนมัติ',
    noticeOfMovingOrderEb: 'EB จะรับงานโดยอัตโนมัติหลังจากย้ายออเดอร์สำเร็จ',
    checkInSuccessNoticeEb: 'การแจ้งเตือนการเช็กอิน',
    meituanMovingOrderDeductsPublicGoods: 'การลดค่า公益金จากการโอนออเดอร์ Meituan',
    meituanMovingOrderServiceRate: 'อัตราค่าบริการปฏิบัติการ Meituan %',
    yourctripTravelEbkAccounthasExpired:
      'บัญชี EBK ของ “Ctrip Travel” ของคุณหมดอายุแล้ว จะไม่สามารถดำเนินการได้',
    yourmeituanEbkAccounthasExpired:
      'บัญชี EBK ของ “Meituan” ของคุณหมดอายุแล้ว จะไม่สามารถดำเนินการได้',
  },

  ebmanagementIndex: {
    accountBinding: 'ผูกบัญชี',
    commissionRate: 'อัตราค่าคอมมิชชั่น',
    theAccountIsBoundSuccessfullyAndTheInDepthOperationIsStartedSimultaneously:
      'ผูกบัญชีสำเร็จ และเริ่มต้นการดำเนินงานเชิงลึกพร้อมกัน',
    whetherToUnbindTheAccount: 'ต้องการยกเลิกการผูกบัญชีหรือไม่',
    pleaseEnterTheCommissionRate: 'กรุณากรอกอัตราค่าคอมมิชชั่น',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
      'มิติเวลาสอดคล้องกับวันที่คัดกรอง จำนวนเงินจองคำนวณจากจำนวนที่ผู้เข้าพักชำระจริง',
    pleaseEnterTheSmsVerificationCode: 'กรุณากรอกรหัสยืนยัน SMS',
    pleaseEnterTheContentInThePicture: 'กรุณากรอกตัวอักษรในภาพ',
    groggery: 'โรงแรม',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100: 'อัตราคอมมิชชั่นต้อง ≥0 และ <100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
      'อัตราคอมมิชชั่นเป็นตัวเลข และทศนิยม 2 ตำแหน่ง',
    pleaseSelectHotel: 'กรุณาเลือกโรงแรม',
    pleaseEnterTheImageVerificationCode: 'กรุณากรอกรหัสภาพ',
    accountUntying: 'ยกเลิกผูกบัญชี',
    unbindSuccessfully: 'ยกเลิกการผูกสำเร็จ',
    pleaseConfirmTheHotelYouWantToBindTo: 'กรุณายืนยันโรงแรมที่ต้องการผูกบัญชี',
    noEbAccountHasBeenBound: 'ยังไม่มีบัญชี EB ถูกผูก',
    ebAccountLogin: 'เข้าสู่ระบบบัญชี EB',
  },

  hardwareBluetoothlock: {
    smartDoorLock: 'ประตูดิจิทัล',
    configurationFailure: 'ตั้งค่าล้มเหลว',
    thisFunctionSpecificallyRefersToTheConnectionOfSmartDoorLocksSuchAsPasswordAndBluetoothWhichCanBeOpenedByUsingPasswordAndBluetoothThroughSmallProgramsAndAppsToImproveTheCustomersCheckInExperience:
      'ฟังก์ชันนี้หมายถึงการเชื่อมต่อกับประตูดิจิทัล เช่น การใช้รหัสผ่านหรือบลูทูธ โดยสามารถใช้ผ่านมินิโปรแกรมและแอปเพื่อเปิดประตู เพิ่มประสบการณ์ของผู้เข้าพัก',
  },

  hardwareChoseroom: {
    selectARoom2: 'เลือกห้องพัก',
  },

  hardwareCreatepassworddialog: {
    createPassword: 'สร้างรหัสผ่าน',
    selectType: 'เลือกประเภท',
    pleaseEnterAgain: 'กรุณากรอกอีกครั้ง',
    validUntil: 'ใช้ได้จนถึง',
    pleaseEnterA6DigitPassword: 'กรุณากรอกรหัสผ่าน 6 หลัก',
    passwordIsDifferentPleaseReEnter: 'รหัสผ่านไม่ตรงกัน กรุณากรอกใหม่',
    oneTimePassword: 'รหัสผ่านครั้งเดียว',
    timePeriodCipher: 'รหัสผ่านช่วงเวลา',
    offlinePassword: 'รหัสผ่านออฟไลน์',
    longAgingOfflinePassword: 'รหัสผ่านออฟไลน์แบบยาว',
  },

  hardwareEditpassworddialog: {
    oneTimePassword: 'รหัสผ่านครั้งเดียว',
    timePeriodCipher: 'รหัสผ่านช่วงเวลา',
    offlinePasswordForALongTime: 'รหัสผ่านออฟไลน์ระยะยาว',
    offlinePassword: 'รหัสผ่านออฟไลน์',
    // Part 26, lines 5001 to 5200
    recover2: 'กู้คืน',
    currentPassword: 'รหัสผ่านปัจจุบัน',
    pleaseEnterAgain: 'กรุณากรอกอีกครั้ง',
    validUntil: 'ใช้ได้จนถึง',
    pleaseEnterA6DigitPassword: 'กรุณากรอกรหัสผ่าน 6 หลัก',
    passwordIsDifferentPleaseReEnter: 'รหัสผ่านไม่ตรงกัน กรุณากรอกใหม่',
    longAgingOfflinePassword: 'รหัสผ่านออฟไลน์แบบยาว',
  },
  hardwareHousepricecard: {
    memberRightsShowStoreActivitiesShow: 'แสดงสิทธิ์สมาชิก แสดงกิจกรรมของร้าน',
    openThePriceBoard: 'เปิดป้ายราคา',
    downloadRateBoard: 'ดาวน์โหลดป้ายราคา',
    failedToConfigureElectronicPriceBoard: 'ตั้งค่าป้ายราคาอิเล็กทรอนิกส์ล้มเหลว',
  },

  hardwareIdcard: {
    whenTheIdCardTypeIsIdCardTheIdCardInformationCanBeReadByTheIdCardReaderAndAutomaticallyFilledIntoTheTextBox:
      'เมื่อประเภทเอกสารเป็นบัตรประชาชน สามารถอ่านข้อมูลจากเครื่องอ่านบัตรและกรอกลงในช่องข้อความโดยอัตโนมัติ',
    idCardReader: 'เครื่องอ่านบัตรประชาชน',
    failedToConfigureTheIdCardReader: 'ตั้งค่าเครื่องอ่านบัตรประชาชนล้มเหลว',
  },

  hardwareLock: {
    doorLockType: 'ประเภทประตูล็อก',
    selectiveLock: 'เลือกประตูล็อก',
    areYouSureYouWantToDeleteTheDoorLockConfigurationForThisRoom:
      'ยืนยันลบการตั้งค่าประตูล็อกของห้องนี้หรือไม่',
    pleaseEnterRoomNumberAndEquipmentModel: 'กรุณากรอกหมายเลขห้องและรุ่นอุปกรณ์',
    doorLockCardPrintingRecord: 'บันทึกการทำบัตรประตู',
    roomDoorLockConfiguration2: 'การตั้งค่าประตูล็อกห้อง',
    passwordSetting2: 'ตั้งค่ารหัสผ่าน',
    deviceType: 'ประเภทอุปกรณ์',
    equipmentBrand: 'ยี่ห้ออุปกรณ์',
    equipmentType: 'รุ่นอุปกรณ์',
    versionNumber: 'เวอร์ชัน',
    roomLockNumber: 'หมายเลขล็อกของห้อง',
    doorLock: 'ประตูล็อก',
    doorLockPower: 'พลังงานของประตูล็อก',
    editDoorLockConfiguration: 'แก้ไขการตั้งค่าประตูล็อก',
    selectDevice: 'เลือกอุปกรณ์',
    setTheDoorLock: 'ตั้งค่าประตูล็อก',
    setTheRoomLockNumber: 'ตั้งค่าหมายเลขล็อกของห้อง',
    pleaseEnterDoorLock: 'กรุณากรอกประตูล็อก',
    settingNmsParameters: 'ตั้งค่าพารามิเตอร์ NMS',
    pleaseEnterNetworkManagementParameters: 'กรุณากรอกพารามิเตอร์ระบบจัดการเครือข่าย',
    traditionalDoorLock: 'ประตูล็อกแบบดั้งเดิม',
    smartDoorLock: 'ประตูล็อกอัจฉริยะ',
    pleaseEnterTheLockId: 'กรุณากรอก ID ประตูล็อก',
    pleaseEnterLockmac: 'กรุณากรอก lockMac',
    batchDelete: 'ลบเป็นชุด',
    confirmBatchDeleteText: 'ยืนยันลบการตั้งค่าประตูล็อกของห้องที่เลือกทั้งหมดหรือไม่？',
    pleaseSelectRecordsToDelete: 'กรุณาเลือกรายการที่จะลบก่อน',
    batchDeleteSuccess: 'ลบเป็นชุดสำเร็จ',
    batchDeleteFail: 'ลบเป็นชุดล้มเหลว',
  },

  hardwareLockpassword: {
    createPassword: 'สร้างรหัสผ่าน',
    comeIntoForce: 'มีผลบังคับใช้',
    activationCode: 'รหัสเปิดใช้งาน',
    applicableRoom: 'ห้องที่ใช้ได้',
    expirationDate3: 'วันหมดอายุ',
    theDoorLockThatSupportsThePasswordIsNotEnabled:
      'ประตูล็อกที่รองรับการใช้รหัสผ่านยังไม่เปิดใช้งาน',
    passwordSetting: 'ตั้งรหัสผ่าน',
    invalidate: 'ทำให้ใช้ไม่ได้',
    restore: 'กู้คืน',
    confirmInvalidatePassword: 'ยืนยันทำให้รหัสผ่านนี้ใช้ไม่ได้หรือไม่？',
  },

  hardwareLockroom: {
    importTemplateFileName: 'เทมเพลตนำเข้ากุญแจ.xlsx',
    downloadSuccess: 'ดาวน์โหลดเทมเพลตนำเข้ากุญแจสำเร็จ',
    downloadFail: 'ดาวน์โหลดเทมเพลตนำเข้ากุญแจล้มเหลว',
    importDialogTitle: 'นำเข้ากุญแจประตูแบบกลุ่ม',
    roomDoorLockConfiguration: 'การตั้งค่าประตูล็อกของห้อง',
    customRule: 'กฎกำหนดเอง',
    rule: 'กฎ',
    deviceType: 'ประเภทอุปกรณ์',
    selectDevice: 'เลือกอุปกรณ์',
    empty: 'ว่าง',
    selectLock: 'เลือกประตูล็อก',
    deviceBrand: 'ยี่ห้ออุปกรณ์',
    deviceModel: 'รุ่นอุปกรณ์',
    version: 'เวอร์ชัน',
    configurationInfo: 'ข้อมูลการตั้งค่า',
    selectRoom: 'เลือกห้อง',
    lockDeviceId: 'ID อุปกรณ์ประตูล็อก',
    remainingPower: 'พลังงานที่เหลือ',
    remoteOpenDoorType: 'รูปแบบการเปิดประตูจากระยะไกล',
    gatewayOpen: 'เปิดด้วยเกตเวย์',
    bluetoothOpen: 'เปิดด้วยบลูทูธ',
    rule1: 'เลขล็อก = เลขห้อง',
    rule2Prefix: 'เลขล็อก =',
    rule3Prefix: 'เลขล็อก =',
    trimRoomNumber: 'ตัดเลขตัวหน้าออกจากเลขห้อง',
    import: 'นำเข้า',
    clickUpload: 'คลิกอัปโหลด',
    imported: 'นำเข้าแล้ว',
    rulePrefix: 'กฎ：',
    generateLockId: 'สร้างหมายเลขล็อก',
    lockIdLabel: 'ID ประตูล็อก',
    roomLockNumberLabel: 'หมายเลขล็อกของห้อง',
    enterRoomLockNumber: 'กรุณากรอกหมายเลขล็อกของห้อง',
    enterLockId: 'กรุณากรอก ID ประตูล็อก',
    gatewayParams: 'พารามิเตอร์เกตเวย์',
    enterGatewayParams: 'กรุณากรอกพารามิเตอร์เกตเวย์',
    enterLockMac: 'กรุณากรอก lockMac',
    getFreeGoLock: 'รับข้อมูลประตูล็อก FreeGo',
  },

  hardwareNfclock: {
    thisFunctionRefersToTheDockingOfCarmenLockWhichCanImproveTheEfficiencyOfCheckInByMakingTheGuestsRoomCardThroughLightWinTreasure:
      'ฟังก์ชันนี้หมายถึงการเชื่อมต่อกับระบบประตูล็อกแบบ碰卡 สามารถทำบัตรเข้าห้องผ่าน 轻赢宝 (专有名词无法翻译) เพื่อเพิ่มประสิทธิภาพการเช็คอิน',
    traditionalDoorLock: 'ประตูล็อกแบบดั้งเดิม',
    doorLockInformationConfiguration2: 'ตั้งค่าข้อมูลประตูล็อก',
    functionCardManagement2: 'จัดการบัตรฟังก์ชัน',
    failedToConfigureATraditionalDoorLock: 'ตั้งค่าประตูล็อกแบบดั้งเดิมล้มเหลว',
  },

  hardwarePricecard: {
    full: 'เต็ม',
    serviceHotline: 'สายด่วนบริการ',
    downloadRateBoard: 'ดาวน์โหลดป้ายราคา',
  },

  hardwareSelfdevicedialog: {
    selfServiceMachinePaymentConfiguration: 'ตั้งค่าการชำระเงินของเครื่องบริการตนเอง',
    depositAllocationCollection: 'การตั้งค่าการเก็บเงินมัดจำ',
    orderRetentionTimeConfiguration: 'ตั้งค่าเวลาการเก็บออเดอร์',
    whetherTheUnpaidOrderIsCancelledImmediately: 'ยกเลิกออเดอร์ที่ยังไม่ชำระทันทีหรือไม่',
    minutes: 'นาที',
    checkOutArrangement: 'ตั้งค่าการเช็คเอาต์',
    checkOutAccountingConfiguration: 'ตั้งค่าบัญชีในขั้นตอนเช็คเอาต์',
    temporaryCheckOut: 'เช็คเอาต์แบบค้างชำระ',
    checkOut2: 'เช็คเอาต์',
    autoAddRoomFeeConfig: 'ตั้งค่าการเพิ่มค่าห้องอัตโนมัติ',
    whetherToEnableAutoAddRoomFee: 'เปิดใช้งานการเพิ่มค่าห้องอัตโนมัติหรือไม่',
    occupancyConfiguration: 'ตั้งค่าการเข้าพัก',
    whetherToSupportHourRoomWithoutReservation:
      'รองรับการเข้าพักห้องรายชั่วโมงโดยไม่ต้องจองหรือไม่',
    supportForTimePeriodsWithoutReservation: 'ช่วงเวลาเข้าพักห้องรายชั่วโมงแบบไม่ต้องจอง',
    theSelfServiceMachineIsSuccessfullyConfigured: 'ตั้งค่าเครื่องบริการตนเองสำเร็จ',
    selfServiceMachineConfiguration2: 'ตั้งค่าเครื่องบริการตนเอง',
    pleaseFillInTheDepositConfiguration: 'กรุณากรอกข้อมูลตั้งค่ามัดจำ',
    pleaseSelectTheTimePeriodWhenTheHourRoomIsNotBooked:
      'กรุณาเลือกช่วงเวลาที่ห้องรายชั่วโมงไม่ต้องจอง',
  },

  hardwareSelfservice: {
    selfServiceMachine: 'เครื่องบริการตนเอง',
    selfServiceMachineConfiguration2: 'ตั้งค่าเครื่องบริการตนเอง',
    failedToConfigureTheSelfServiceMachine: 'ตั้งค่าเครื่องบริการตนเองล้มเหลว',
    thereIsNoSelfServiceMachineInTheHotel: 'โรงแรมยังไม่ได้ติดตั้งเครื่องบริการตนเอง',
    thisSwitchIsToOpenTheSelfServiceMachineAndPmsSystemInterfaceSwitchIfTheHotelNeedsToConnectToTheSelfServiceCheckInMachineYouNeedToTurnOnTheSwitch:
      'สวิตช์นี้ใช้เปิดการเชื่อมต่อระหว่างเครื่องบริการตนเองและระบบ PMS หากโรงแรมต้องการเชื่อมต่อเครื่องเช็คอินอัตโนมัติ ต้องเปิดสวิตช์นี้',
  },

  "hardwareSetWitness": {
    "title": "อุปกรณ์จดจำใบหน้า",
    "desc": "การจดจำใบหน้า เช็คอินด้วยตนเอง",
    "setting": "ตั้งค่า",
    "configSuccess": "เปิดใช้งานการตั้งค่าจดจำใบหน้าสำเร็จ",
    "configClose": "ปิดใช้งานการตั้งค่าจดจำใบหน้าสำเร็จ",
    "configFailed": "การตั้งค่าล้มเหลว"
  },
  "hardwareWitness": {
    "deviceSnSetting": "ตั้งค่ารหัสอุปกรณ์",
    "deviceSn": "SN ของอุปกรณ์",
    "addSn": "เพิ่ม SN",
    "enterSn": "โปรดป้อน SN",
    "addSnBtn": "+ เพิ่ม SN",
    "saveSuccess": "บันทึกสำเร็จ",
    "deleteSuccess": "ลบสำเร็จ",
    "snRepeatError": "SN ห้ามซ้ำกัน",
    "deleteConfirmMsg": "ยืนยันการลบ SN ของอุปกรณ์นี้หรือไม่?",
    "deleteConfirmTitle": "คำแนะนำ"
  },

  hardwareSethouserpricecard: {
    transversePlate: 'แผ่นแนวนอน',
    verticalVersion: 'แผ่นแนวตั้ง',
    addPictureUpload: 'เพิ่มรูปภาพสำหรับอัปโหลด',
    show: 'แสดง',
    doNotShow: 'ไม่แสดง',
    format: 'รูปแบบ',
    storePicture: 'รูปภาพของร้าน',
    pleaseEnterADescription: 'กรุณากรอกรายละเอียด',
    hourRoomRates: 'ราคาห้องรายชั่วโมง',
    pleaseSelectTheNumberOfHours: 'กรุณาเลือกจำนวนชั่วโมง',
    whetherToDisplayMemberPrices: 'แสดงราคาสมาชิกหรือไม่',
    roomReservationPhone: 'เบอร์โทรสำหรับจองห้อง',
    pleaseEnterTheReservationNumber: 'กรุณากรอกเบอร์สำหรับจองห้อง',
    bookingGuide: 'ข้อความแนะนำการจอง',
    pleaseEnterThePreOrderGuideCopy: 'กรุณากรอกข้อความแนะนำการจอง',
    hotelAnnouncement: 'ประกาศของโรงแรม',
    pleaseEnterTheHotelBulletin: 'กรุณากรอกประกาศของโรงแรม',
    uploadedPictures: 'รูปภาพที่อัปโหลดแล้ว',
    storePicturesMustBeUploaded: 'ต้องอัปโหลดรูปภาพของร้าน',
    onlyJpgjepgpngFormatIsSupported: 'รองรับเฉพาะไฟล์ jpg jpeg png เท่านั้น!',
  },

  functionalcardAuthorizationcard: {
    authorizationCardBeforeReportingTheLoss: 'บัตรอนุญาตก่อนแจ้งทำหาย',
    authorizationCard: 'บัตรอนุญาต',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
      "โดยทั่วไป เพียงแตะบัตรอนุญาตหนึ่งครั้งที่ประตูล็อก ประตูจะส่งเสียง 'ติ๊ดติ๊ด' สองครั้งเพื่อแสดงว่าตั้งค่าสำเร็จ",
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
      'เมื่อหมายเลขห้องหรือข้อมูลเวลาในประตูล็อกหายไป สามารถใช้บัตรตั้งค่าหมายเลขห้องหรือบัตรตั้งค่าเวลาเพื่อตั้งค่าใหม่; หรือแตะบัตรอนุญาต 3 ครั้งติดต่อกัน แล้วใช้บัตรผู้เข้าพักเปิดประตูได้',
  },

  functionalcardExtendssetting: {
    after: 'หลัง',
    inMinutes: 'ภายในนาที',
    findRoomNumber: 'ค้นหาหมายเลขห้อง',
    timeDeviation: 'ความคลาดเคลื่อนของเวลา',
    roomNumberRequired: 'ต้องกรอกหมายเลขห้อง',
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
      'เมื่อหมายเลขห้องหรือข้อมูลเวลาในประตูล็อกหายไป สามารถใช้บัตรตั้งค่าหมายเลขห้องหรือบัตรตั้งค่าเวลาเพื่อตั้งค่าใหม่; หรือแตะบัตรอนุญาต 3 ครั้ง แล้วใช้บัตรผู้เข้าพักเปิดประตูได้',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
      "โดยทั่วไป เพียงแตะบัตรอนุญาตหนึ่งครั้งที่ประตูล็อก ประตูจะส่งเสียง 'ติ๊ดติ๊ด' สองครั้งเพื่อแสดงว่าตั้งค่าสำเร็จ",
  },

  functionalcardIndex: {
    selectiveClassification: 'เลือกหมวดหมู่',
    functionCardManagement2: 'จัดการบัตรฟังก์ชัน',
    authorizationCard: 'บัตรอนุญาต',
    extendedSettingsClass: 'หมวดการตั้งค่าเพิ่มเติม',
    openCategory: 'หมวดเปิดประตู',
    specificFunctionClass: 'หมวดฟังก์ชันเฉพาะ',
    businessCardFailure: 'ทำบัตรล้มเหลว',
  },

  functionalcardOpendoor: {
    beforeTheLossWasReported: 'ก่อนแจ้งทำหาย',
    publicDoorsCanBeOpened: 'สามารถเปิดประตูสาธารณะได้',
    canOpenTheLock: 'สามารถเปิดประตูที่ล็อกอยู่ได้',
    availablePeriod: 'ช่วงเวลาที่ใช้ได้',
    startTimeRequired: 'ต้องกรอกเวลาเริ่มต้น',
    theEndTimeIsRequired: 'ต้องกรอกเวลาสิ้นสุด',
    floorFill: 'ต้องกรอกชั้น',
    theFloorMustConsistOf4PureDigits: 'หมายเลขชั้นต้องเป็นตัวเลข 4 หลัก',
    layerControlCardUsedToOpenAllLocksInASpecificLayerOfABuilding:
      'บัตรควบคุมชั้น: ใช้เปิดประตูทุกบานบนชั้นใดชั้นหนึ่งของอาคาร',
    totalCardCanOpenAllLocksInThisSystem: 'บัตรรวม: สามารถเปิดประตูทั้งหมดในระบบนี้',
    // Part 27, lines 5201 to 5400
  },
  functionalcardParticularfeature: {
    checkOutCardBeforeTheLossWasReported: 'บัตรเช็คเอาต์ก่อนแจ้งทำหาย',
    theMissingCardNumber: 'หมายเลขบัตรที่หาย',
    pleaseEnterTheCardNumberToFind: 'กรุณากรอกหมายเลขบัตรเพื่อค้นหา',
    theLostCardNumberIsRequired: 'ต้องกรอกหมายเลขบัตรที่หาย',
    lostCardIfACardIsLostItCanBeReportedEnterTheNumberOfTheLostCardMakeALostCardAndBrushItOnceOnTheDoorThatCanOpenTheLostCard:
      'บัตรแจ้งทำหาย: หากบัตรหาย สามารถแจ้งทำหายได้ กรอกหมายเลขบัตรที่หาย ทำบัตรแจ้งทำหาย แล้วนำไปแตะที่ประตูที่บัตรเดิมสามารถเปิดได้หนึ่งครั้ง',
    checkOutCardUsedByTheWaiterGenerallyTheWaiterHasTwoCardsOneIsTheLayerControlCardUsedToOpenTheDoorAndTheOtherIsTheCheckOutCardWhenTheGuestNotifiesTheCheckOutTheWaiterChecksTheRoomAndTheCheckOutCardIsBrushedOnceOnTheDoorThatCanOpenTheCheckOutCardThePreviousGuestCardCannotBeOpenedAndDoesNotAffectTheNewGuestCard:
      'บัตรเช็คเอาต์: สำหรับพนักงานใช้ โดยทั่วไปพนักงานจะมี 2 ใบ ใบหนึ่งคือบัตรควบคุมชั้นสำหรับเปิดประตู อีกใบคือบัตรเช็คเอาต์ เมื่อแขกจะแจ้งเช็คเอาต์ พนักงานตรวจห้องเสร็จแล้วแตะบัตรเช็คเอาต์บนประตูหนึ่งครั้ง บัตรของแขกเก่าจะไม่สามารถเปิดประตูได้ แต่ไม่กระทบต่อบัตรแขกใหม่',
  },

  sdkinitIndex: {
    theLockInformationIsInitializedSuccessfullyProcedure: 'เริ่มต้นข้อมูลประตูล็อกสำเร็จ',
    afterEnteringTheCardManagement: 'จากนั้นเข้าสู่การจัดการบัตร',
    performTheInitialConfigurationOfDoorLockInformationFirst:
      'กรุณาตั้งค่าข้อมูลประตูล็อกเริ่มต้นก่อน',
    hardwareDeviceType: 'ประเภทอุปกรณ์ฮาร์ดแวร์',
    hardwareBrand: 'ยี่ห้อฮาร์ดแวร์',
    configurationInformation: 'ข้อมูลการตั้งค่า',
    thisParameterIsMandatory: 'ข้อมูลตั้งค่าต้องกรอก',
    initialConfiguration: 'การตั้งค่าเริ่มต้น',
    doorLockInformationConfiguration2: 'ตั้งค่าข้อมูลประตูล็อก',
    theDoorLockInformationIsConfiguredSuccessfully: 'ตั้งค่าข้อมูลประตูล็อกสำเร็จ',
    configurationFailure: 'ตั้งค่าล้มเหลว',
  },

  hotelBaseInfo: {
    basicInformation3: 'ข้อมูลพื้นฐาน',
    detailedInformation: 'ข้อมูลละเอียด',
    hotelFacilitiesAndServices: 'สิ่งอำนวยความสะดวกและบริการของโรงแรม',
    hotelPoliciesAndNotices: 'นโยบายและประกาศของโรงแรม',
  },

  hotelFloor: {
    floorInformationToBeDeveloped: 'ข้อมูลชั้นอาคาร อยู่ระหว่างพัฒนา',
  },

  hotelPicture: {
    acquiesce: 'ค่าเริ่มต้น',
    theLatestTime: 'เวลาใหม่สุด',
    theFarthestTime: 'เวลาเก่าสุด',
    batchDeletion: 'ลบเป็นชุด',
    undelete: 'ยกเลิกการลบ',
    cover: 'ภาพปก',
    firstMap: 'ภาพแรก',
    setAsHotelCover: 'ตั้งเป็นภาพปกโรงแรม',
    noPictureInformationIsAvailable: 'ไม่มีข้อมูลภาพ',
    submit2: 'ส่ง',
    photoEditor: 'แก้ไขรูปภาพ',
    setAsTheFirstPictureOfTheRoomType: 'ตั้งเป็นภาพแรกของประเภทห้อง',
    recentRevision: 'แก้ไขล่าสุด',
    appearance: 'รูปลักษณ์ภายนอก',
    guestRoom: 'ห้องพัก',
    publicFacilities: 'สิ่งอำนวยความสะดวกสาธารณะ',
    catering: 'อาหารและเครื่องดื่ม',
    surroundingEnvironment: 'สภาพแวดล้อมรอบข้าง',
    theCoverImageAndFirstImageCannotBeDeletedDirectly: 'ภาพปกและภาพแรกไม่สามารถลบได้โดยตรง',
    areYouSureToDeleteThePicture: 'ยืนยันลบรูปภาพหรือไม่',
    operate: 'ปฏิบัติการ',
    pleaseSelectAtLeastOnePicture: 'กรุณาเลือกรูปภาพอย่างน้อย 1 รูป',
    pleaseSelectCategory: 'กรุณาเลือกหมวดหมู่',
    pleaseUploadThePictureSuccessfullyBeforeSubmitting: 'กรุณาอัปโหลดภาพสำเร็จก่อนส่ง',
    imagesCannotBeUploadedInBatchEditingMode: 'ไม่สามารถอัปโหลดภาพขณะแก้ไขแบบชุดได้',
    logoOnlyOne: 'สามารถอัปโหลดรูป Logo ได้เพียง 1 รูปเท่านั้น',
    logoSizeLimit: 'ขนาดรูป Logo ต้องไม่เกิน 500KB',
    logoRatioError: 'Logo ต้องเป็นรูปสี่เหลี่ยมจัตุรัสอัตราส่วน 1:1 ขนาดปัจจุบัน {width}×{height}',
  },

  assemblyModifyinventoryprice: {
    unlimitedInventory: 'ไม่จำกัดสต็อก',
    stockLimit: 'จำกัดสต็อก',
    modifiedPricePool: 'แก้ไขคลังราคา',
    soldInventory: 'สต็อกที่ขายไปแล้ว',
  },

  hotelPreview: {
    viewPicture: 'ดูภาพ',
  },

  hotelRoomType: {
    batchImportRoomType: 'นำเข้าประเภทห้องแบบกลุ่ม',
    importTemplateFileName: 'เทมเพลตนำเข้าประเภทห้อง.xlsx',
    downloadSuccess: 'ดาวน์โหลดเทมเพลตนำเข้าประเภทห้องสำเร็จ',
    downloadFail: 'ดาวน์โหลดเทมเพลตนำเข้าประเภทห้องล้มเหลว',

    newHousingType: 'สร้างประเภทห้องใหม่',
    partialWindow: 'มีหน้าต่างบางส่วน',
    skylight: 'หน้าต่างสกายไลท์',
    closedWindow: 'หน้าต่างปิดทึบ',
    bayWindow: 'หน้าต่างยื่น',
    hotelCode: 'รหัสโรงแรม',
    roomTypeCode: 'รหัสประเภทห้อง',
    externalRoomTypeCode2: 'รหัสประเภทห้องภายนอก',
    whetherToSellOnline: 'ขายออนไลน์หรือไม่',
    bedType2: 'ประเภทเตียง',
  },

  hotelRoom: {
    newRoom: 'สร้างห้องใหม่',
    pleaseArrangeTheRoomInformationAccordingToTheRequirementsInTheTemplate:
      'กรุณาจัดข้อมูลห้องตามข้อกำหนดในเทมเพลต',
    downloadTemplate: 'ดาวน์โหลดเทมเพลต',
    downloadFailureData: 'ดาวน์โหลดข้อมูลที่ล้มเหลว',
    batchImport: 'นำเข้าแบบชุด',
    floor2: 'ชั้นที่ตั้งอยู่',
    building: 'อาคารที่ตั้งอยู่',
    housingType: 'ประเภทห้อง',
    faceEast: 'หันหน้าไปทางตะวันออก',
    faceWest: 'หันหน้าไปทางตะวันตก',
    faceSouth: 'หันหน้าไปทางทิศใต้',
    faceNorth: 'หันหน้าไปทางทิศเหนือ',
    stayAwayFromElevators: 'อยู่ห่างจากลิฟต์',
    nearTheStairs: 'ใกล้บันได',
    closeToTheRoad: 'ใกล้ถนน',
    windowWall: 'ผนังด้านนอกเป็นหน้าต่าง',
    decorativeFalseWindow: 'หน้าต่างตกแต่งปลอม',
    theRoomNumberCannotBeEmpty: 'หมายเลขห้องต้องไม่ว่าง',
    theFloorOnWhichTheRoomIsLocatedCannotBeEmpty: 'ชั้นที่ห้องตั้งอยู่ต้องไม่ว่าง',
    theRoomTypeCannotBeEmpty: 'ประเภทห้องต้องไม่ว่าง',
    editSuccessfully: 'แก้ไขสำเร็จ',
    newSuccess: 'เพิ่มใหม่สำเร็จ',
    theHouseTypeAndNameCannotBeEmptyTheFloorWhereTheHouseResidesCannotBeEmpty:
      'ประเภทห้องและชื่อไม่สามารถว่างได้ ชั้นที่ตั้งห้องต้องไม่ว่าง',
    currentLimitSelect1FilePleaseRemoveAndAdd: 'จำกัดเลือกได้ 1 ไฟล์ กรุณาลบออกก่อนเพิ่มใหม่',
    definitiveRemoval: 'ยืนยันลบ',
    abnormalDataInformationTemplate: 'เทมเพลตข้อมูลผิดปกติ',
    xlsFormatOnly: 'รองรับเฉพาะไฟล์ XLS',
    dataCannotBeRecoveredAfterDeletingTheRoomAreYouSureToDeleteIt:
      'ข้อมูลจะไม่สามารถกู้คืนได้หลังลบห้อง ยืนยันลบหรือไม่',
  },

  hotelTypedetail: {
    newHousingType: 'สร้างประเภทห้องใหม่',
    editRoomType: 'แก้ไขประเภทห้อง',
    viewRoomType: 'ดูประเภทห้อง',
    basicInformation3: 'ข้อมูลพื้นฐาน',
    squareMeter: 'ตารางเมตร',
    bedSize: 'ขนาดเตียง',
    extraBedCondition: 'เงื่อนไขเตียงเสริม',
    internetAccess: 'การใช้อินเทอร์เน็ต',
    roomTypeFacilities: 'สิ่งอำนวยความสะดวกในห้อง',
    roomTypeStatus: 'สถานะประเภทห้อง',
    saveAndSubmit: 'บันทึกและส่ง',
    roomTypeNameAMaximumOf50Characters: 'ชื่อประเภทห้องสูงสุด 50 ตัวอักษร',
    floorArea: 'พื้นที่อาคาร',
    roomTypeEnglishName: 'ชื่อประเภทห้อง (อังกฤษ)',
    floorType: 'ประเภทชั้น',
    floor2: 'ชั้น',
    pleaseEnter1511: 'กรุณากรอก -1, 5, 11',
    chineseRemarks: 'หมายเหตุ (จีน)',
    capacity: 'ความจุจำนวนคน',
    englishRemarks: 'หมายเหตุ (อังกฤษ)',
    externalRoomTypeCode2: 'รหัสประเภทห้องภายนอก',
    extraBed: 'เตียงเสริม',
    internetAccess2: 'ใช้อินเทอร์เน็ตได้หรือไม่',
    roomInternetInformation: 'ข้อมูลอินเทอร์เน็ตภายในห้อง',
    broadbandTariff: 'ค่าบรอดแบนด์',
    disposableToiletries: 'ของใช้ในห้องน้ำแบบใช้ครั้งเดียว',
    bathroomType: 'ประเภทห้องน้ำ',
    numberOfToilets: 'จำนวนห้องน้ำ',
    computer: 'คอมพิวเตอร์',
    showerRoom: 'ห้องอาบน้ำ',
    smokeFreeInformation: 'ข้อมูลปลอดบุหรี่',
    bathroom: 'ห้องน้ำ',
    pleaseEnterAnIntegerWithNoMoreThanTwoDigits: 'กรุณากรอกจำนวนเต็มไม่เกิน 2 หลัก',
    pleaseEnterAnIntegerGreaterThan0: 'กรุณากรอกจำนวนเต็มที่มากกว่า 0',
    dataDuplicationPleaseConfirm: 'ข้อมูลซ้ำ กรุณายืนยัน',
    pleaseEnterAValueOfAThreeDigitIntegerUpTo500: 'กรุณากรอกจำนวนเต็ม 3 หลัก ไม่เกิน 500',
    enterAMaximumOfTwoDecimalsAndAMaximumOf6Characters:
      'กรอกทศนิยมสูงสุด 2 ตำแหน่ง ไม่เกิน 6 ตัวอักษร',
    pleaseEnterBuildingArea: 'กรุณากรอกพื้นที่อาคาร',
    pleaseEnterTheCapacity: 'กรุณากรอกความจุคน',
    pleaseEnterAnIntegerOfUpToTwoDigits: 'กรุณากรอกจำนวนเต็มไม่เกิน 2 หลัก',
    roomTypeNameCannotBeEmpty: 'ชื่อประเภทห้องต้องไม่ว่าง',
    roomTypeNameCannotExceed50Characters: 'ชื่อประเภทห้องต้องไม่เกิน 50 ตัวอักษร',
    theLengthCannotExceed30Characters: 'ความยาวต้องไม่เกิน 30 ตัวอักษร',
    theTotalNumberOfRoomsCannotBeEmpty: 'จำนวนห้องทั้งหมดต้องไม่ว่าง',
    theLengthCannotExceed60Characters: 'ความยาวต้องไม่เกิน 60 ตัวอักษร',
    pleaseSelectBedSize: 'กรุณาเลือกขนาดเตียง',
    pleaseSelectWindowType: 'กรุณาเลือกประเภทหน้าต่าง',
    pleaseSelectRoomTypeStatus: 'กรุณาเลือกสถานะประเภทห้อง',
    pleaseSelectExtraBedCondition: 'กรุณาเลือกเงื่อนไขเตียงเสริม',
    pleaseSelectWhetherYouCanAccessTheInternet: 'กรุณาเลือกว่าสามารถใช้อินเทอร์เน็ตได้หรือไม่',
    pleaseSelectAPhone: 'กรุณาเลือกโทรศัพท์',
    pleaseSelectDisposableToiletries: 'กรุณาเลือกของใช้ในห้องน้ำแบบใช้ครั้งเดียว',
    pleaseSelectABathroomType: 'กรุณาเลือกประเภทห้องน้ำ',
    pleaseSelectTheNumberOfBathrooms: 'กรุณาเลือกจำนวนห้องน้ำ',
    pleaseSelectComputer: 'กรุณาเลือกคอมพิวเตอร์',
    pleaseSelectABathRoom: 'กรุณาเลือกห้องอาบน้ำ',
    pleaseSelectSmokeFreeInformation: 'กรุณาเลือกข้อมูลปลอดบุหรี่',
    pleaseSelectOther: 'กรุณาเลือกอื่น ๆ',
    pleaseSelectBathroom: 'กรุณาเลือกห้องน้ำ',
    commonFloor: 'ชั้นทั่วไป',
    executiveFloor: 'ชั้นเอ็กเซกคิวทีฟ',
    businessFloor: 'ชั้นธุรกิจ',
    noExtraBed: 'ไม่มีเตียงเสริม',
    freeExtraBed: 'เตียงเสริมฟรี',
    payExtraBed: 'เตียงเสริมมีค่าใช้จ่าย',
    haveInternetAccess: 'ใช้อินเทอร์เน็ตได้',
    someInternetAccess: 'บางห้องใช้อินเทอร์เน็ตได้',
    noInternetAccess: 'ไม่สามารถใช้อินเทอร์เน็ตได้',
    freeWireless: 'ไวไฟฟรี',
    tollWireless: 'ไวไฟมีค่าใช้จ่าย',
    freeWire: 'อินเทอร์เน็ตแบบสายฟรี',
    tollWire: 'อินเทอร์เน็ตแบบสายมีค่าใช้จ่าย',
    nationalTollCall: 'โทรศัพท์ภายในประเทศแบบมีค่าใช้จ่าย',
    internationalCall: 'โทรศัพท์ต่างประเทศ',
    freeDomesticLongDistanceCalls: 'โทรทางไกลภายในประเทศฟรี',
    disposableToiletriesAreNotProvided: 'ไม่จัดของใช้ในห้องน้ำแบบใช้ครั้งเดียว',
    disposableToiletriesAreProvidedForFree: 'มีของใช้ในห้องน้ำแบบใช้ครั้งเดียวให้ฟรี',
    disposableToiletriesAreProvidedForAFee: 'จัดของใช้ในห้องน้ำแบบใช้ครั้งเดียวแบบมีค่าใช้จ่าย',
    indoor: 'ภายใน',
    commonality: 'สาธารณะ',
    aroom: 'หนึ่งห้อง',
    twoRooms: 'สองห้อง',
    moreThanTwoRooms: 'มากกว่าสองห้อง',
    allRoomsChargeComputers: 'ทุกห้องมีคอมพิวเตอร์แบบเสียเงิน',
    freeComputersInAllRooms: 'ทุกห้องมีคอมพิวเตอร์ฟรี',
    freeComputersInSomeRooms: 'บางห้องมีคอมพิวเตอร์ฟรี',
    nonSmokingRoomsAreNotAvailable: 'ไม่มีบริการห้องปลอดบุหรี่',
    nonSmokingRoomsAvailable: 'มีบริการห้องปลอดบุหรี่',
    // Part 28, lines 5401 to 5600
    noSmoking: 'ห้ามสูบบุหรี่',
    partialWindow: 'หน้าต่างบางส่วน',
    skylight: 'สกายไลท์',
    closedWindow: 'หน้าต่างปิดทึบ',
    bayWindow: 'หน้าต่างยื่น',
    roomTypeNameAndBedSizeAreUnderReview: 'ชื่อประเภทห้องและขนาดเตียงอยู่ระหว่างตรวจสอบ',
    roomTypeAddedSuccessfully: 'เพิ่มประเภทห้องสำเร็จ',
    containsAMaximumOf7CharactersOnlyDigitsCanBeEntered:
      'ความยาวไม่เกิน 7 ตัวอักษร อนุญาตเฉพาะตัวเลข . -',
    pleaseEnterAnIntegerAndEnsureItsLegalitySuchAs3SquareMeters5SquareMeters:
      'กรุณากรอกจำนวนเต็ม และให้ถูกต้องตามรูปแบบ เช่น 3 ตารางเมตร - 5 ตารางเมตร',
    personbed: 'คน/ห้อง',
  },
  managementAccountList: {
    searchAccountAndEmployeeName: 'ค้นหาบัญชีหรือชื่อพนักงาน',
    staffPosition: 'ตำแหน่งงาน',
    createAnAccount: 'สร้างบัญชีใหม่',
    employeeName: 'ชื่อพนักงาน',
    employeeRole: 'บทบาทพนักงาน',
    confirmTo: 'ยืนยันที่จะ',
    user: 'ผู้ใช้',
    areYouSureYouWantToDeleteThisUser: 'ยืนยันลบผู้ใช้นี้หรือไม่',
    isThisMaterial: 'วัสดุนี้หรือไม่',
  },
  managementRoleList: {
    enterARoleName: 'กรอกชื่อบทบาท',
    newRole: 'เพิ่มบทบาทใหม่',
    roleName: 'ชื่อบทบาท',
    roleDescription: 'คำอธิบายบทบาท',
    editorRole: 'แก้ไขบทบาท',
    modifyPermission: 'แก้ไขสิทธิ์',
    deletingARole: 'ลบบทบาท',
    areYouSureYouWantToDeleteThisRole: 'ยืนยันลบบทบาทนี้หรือไม่',
  },
  componentsCreateaneditingrole: {
    roleName: 'ชื่อบทบาท',
    roleDescription: 'คำอธิบายบทบาท',
    standardPostBased: 'อ้างอิงจากตำแหน่งมาตรฐาน',
    limitsOfAuthority: 'สิทธิ์',
    pleaseEnterARoleName: 'กรุณากรอกชื่อบทบาท',
    modifyRole: 'แก้ไขบทบาท',
    newRole: 'เพิ่มบทบาทใหม่',
    succeededInModifyingTheRole: 'แก้ไขบทบาทสำเร็จ',
    creatingTheRoleSucceeded: 'สร้างบทบาทสำเร็จ',
  },
  componentsPopupeditingpermission: {
    editPermission: 'แก้ไขสิทธิ์',
  },
  componentsUpdatematerial: {
    staffPosition: 'ตำแหน่งงาน',
    employeeRole: 'บทบาทพนักงาน',
    thePhoneNumberCannotBeEmpty: 'เบอร์โทรต้องไม่ว่าง',
    pleaseEnterYourConfirmationPassword: 'กรุณากรอกรหัสผ่านยืนยัน',
    pleaseEnterEmployeeName: 'กรุณากรอกชื่อพนักงาน',
    pleaseSelectEmployeeStatus: 'กรุณาเลือกสถานะพนักงาน',
    pleaseSelectAnEmployeePosition: 'กรุณาเลือกตำแหน่งพนักงาน',
    modifyAccount: 'แก้ไขบัญชี',
    viewInformation: 'ดูข้อมูล',
    addAnAccount: 'เพิ่มบัญชี',
    theTwoPasswordEntriesAreDifferent: 'รหัสผ่านทั้งสองครั้งไม่ตรงกัน',
    modifyingTheMaterialInformationMayAffectTheInformationAboutStoredGoodsExerciseCautionWhenPerformingThisOperation:
      'การแก้ไขข้อมูลวัสดุอาจกระทบข้อมูลสินค้าที่จัดเก็บไว้ กรุณาดำเนินการด้วยความระมัดระวัง',
    materialUnit: 'หน่วยวัสดุ',
    pleaseSelectTheMaterialType: 'กรุณาเลือกประเภทวัสดุ',
    pleaseFillInTheMaterialName: 'กรุณากรอกชื่อวัสดุ',
    pleaseSelectMaterialUnit: 'กรุณาเลือกหน่วยวัสดุ',
    modifyMaterial: 'แก้ไขวัสดุ',
    newMaterial2: 'เพิ่มวัสดุใหม่',
    materialModificationSucceeded: 'แก้ไขวัสดุสำเร็จ',
    newMaterialSuccessfully: 'เพิ่มวัสดุใหม่สำเร็จ',
    pleaseEnterTheCorrectPhoneNumber3: 'กรุณากรอกบัญชีพนักงานให้ถูกต้อง',
  },
  smallwareMaterial: {
    confirmEnable: 'ต้องการเปิดใช้งานสิ่งของนี้หรือไม่?',
    confirmDisable: 'ต้องการปิดใช้งานสิ่งของนี้หรือไม่?',
    enableSuccess: 'เปิดใช้งานสิ่งของสำเร็จ',
    disableSuccess: 'ปิดใช้งานสิ่งของสำเร็จ',
    newMaterial: 'เพิ่มวัสดุใหม่',
    thereIsInventoryUnderTheCurrentMaterialDoNotSupportToDeleteTheMaterialPleaseDeleteAfterTheWarehouse:
      'มีสต็อกคงเหลืออยู่ ไม่สามารถลบวัสดุนี้ได้ กรุณาเบิกออกก่อนแล้วจึงลบ',
    areYouSureYouWantToDeleteThisMaterial: 'ยืนยันลบวัสดุนี้หรือไม่',
    confirmTo: 'ยืนยันที่จะ',
    isThisMaterial: 'วัสดุนี้หรือไม่',
  },
  smallwareRealtimestock: {
    saleStatus: 'สถานะการขาย',
    exportedInventory: 'ส่งออกสต็อกรายการ',
    resumptionOfSale: 'กลับมาขาย',
    banOnSale: 'ห้ามขาย',
    averagePurchasePriceyuan: 'ราคาซื้อเฉลี่ย ',
    sellingPriceyuan: 'ราคาขายต่อหน่วย ',
    unmarketable: 'ขายไม่ได้',
    vendibility: 'ขายได้',
    exportFileName: 'รายการสต็อกแบบเรียลไทม์',
    areYouSureYouWantToStopSellingThisMaterial: 'ยืนยันหยุดขายวัสดุนี้หรือไม่',
    successfulClosure: 'หยุดขายสำเร็จ',
    successfulResumptionOfSale: 'กลับมาขายสำเร็จ',
  },
  smallwareStockshift: {
    undoSuccessfully: 'ยกเลิกสำเร็จ',
    outboundTime: 'เวลาออกสต็อก',
    newDelivery2: 'เพิ่มการออกสต็อก',
    outboundMode: 'วิธีการออกสต็อก',
    theNumberOfTheWarehouseReceipt: 'รหัสใบออกสต็อก',
    deliveryFromStorage: 'ออกสต็อก',
    cancel: 'ยกเลิก',
    exportFileList: 'รายการไฟล์ส่งออกการออกสต็อก',
    doYouConfirmTheCancellation: 'ยืนยันการยกเลิกหรือไม่',
  },
  smallwareStockunshift: {
    warehousingTime: 'เวลาเข้าคลัง',
    newStorage: 'เพิ่มการเข้าคลัง',
    theCodeOfTheEntrySlip: 'รหัสใบเข้าคลัง',
    purchasePriceyuan: 'ราคาซื้อ ',
    importFileExportList: 'รายการไฟล์ส่งออกการเข้าคลัง',
  },
  componentsAddnewstock: {
    adjustableQuantity: 'จำนวนที่ปรับได้',
    purchasePrice: 'ราคาซื้อ',
    whetherToSell: 'ขายหรือไม่',
    unitSellingPrice: 'ราคาขายต่อหน่วย',
    pleaseFillInTheUnitPrice: 'กรุณากรอกราคาขายต่อหน่วย',
    pleaseFillInTheQuantityOfStorage: 'กรุณากรอกจำนวนเข้าคลัง',
    pleaseSelectTheMaterialType: 'กรุณาเลือกประเภทวัสดุ',
    pleaseSelectAMaterialName: 'กรุณาเลือกชื่อวัสดุ',
    modifiedEntry: 'แก้ไขรายการเข้าคลัง',
    newStorage: 'เพิ่มเข้าคลัง',
    createdSuccessfully2: 'สร้างสำเร็จ',
    theStorageQuantityCannotBe: 'จำนวนเข้าคลังต้องไม่เป็น',
    theModifiedQuantityCannotBeSmallerThanTheConsumedQuantity:
      'จำนวนที่แก้ไขต้องไม่ต่ำกว่าจำนวนที่ใช้ไปแล้ว',
  },
  componentsAddoutstock: {
    selected: 'เลือกแล้ว',
    newDelivery2: 'เพิ่มการออกสต็อก',
    pleaseSelectOutgoingMaterials: 'กรุณาเลือกวัสดุที่ต้องการออกสต็อก',
    pleaseSelectTheMaterialToBeShippedOut: 'กรุณาเลือกวัสดุที่จะออกสต็อก',
    successfulDelivery: 'ออกสต็อกสำเร็จ',
  },
  componentsSellricedialog: {
    unitSellingPrice: 'ราคาขายต่อหน่วย',
    pleaseFillInThePrice: 'กรุณากรอกราคา',
  },
  systemsetBase: {
    requireIdNumberEnabled: 'เปิดใช้งานฟังก์ชัน “ต้องกรอกหมายเลขเอกสาร” สำเร็จ',
    requireIdNumberDisabled: 'ปิดฟังก์ชัน “ต้องกรอกหมายเลขเอกสาร” สำเร็จ',
    requireIdNumberForCheckin: 'การเช็คอินต้องกรอกหมายเลขเอกสารหรือไม่',
    enableAutomaticDepositRefund: 'เปิดใช้การคืนเงินมัดจำอัตโนมัติ',
    refundImmediatelyAfterCheckOut: 'คืนทันทีเมื่อแขกทำการเช็คเอาต์',
    refundAfter: 'คืนหลังแขกเช็คเอาต์',
    hoursAutoRefund: 'ชั่วโมงคืนอัตโนมัติ',
    pleaseEnterDelayRefundHours: 'กรุณากรอกเวลาหน่วงการคืนมัดจำ',
    delayRefundHoursRangeError: 'เวลาหน่วงต้องไม่น้อยกว่า 1 ชั่วโมง และไม่มากกว่า 48 ชั่วโมง',
    depositConfigSuccess: 'ตั้งค่ามัดจำสำเร็จ',
    tempMakeCardEnabled: 'เปิดใช้งานการออกบัตรชั่วคราวหรือไม่',
    tempMakeCardEnabledSuccess: 'เปิดใช้งานการออกบัตรชั่วคราวแล้ว',
    tempMakeCardDisabledSuccess: 'ปิดใช้งานการออกบัตรชั่วคราวแล้ว',
    hideCheckInRegisterRoomPrice: 'ซ่อนราคาห้องในแบบฟอร์มลงทะเบียนเข้าพัก',
    hideCheckInRegisterRoomPriceEnabledSuccess: 'ซ่อนราคาห้องในแบบฟอร์มลงทะเบียนเข้าพักแล้ว',
    hideCheckInRegisterRoomPriceDisabledSuccess: 'แสดงราคาห้องในแบบฟอร์มลงทะเบียนเข้าพักแล้ว',
    weeHours: 'ช่วงดึก',
    shiftPattern: 'รูปแบบกะทำงาน',
    messageVoiceReminder: 'แจ้งเตือนเสียงข้อความ',
    directConnectionSingleSettings: 'การตั้งค่ารับออเดอร์แบบเชื่อมตรง',
    automaticHouseSetting: 'ตั้งค่าการจัดห้องอัตโนมัติ',
    sameDayAdvanceOrders: 'ออเดอร์ที่มีกำหนดถึงวันนี้',
    allOrders: 'ออเดอร์ทั้งหมด',
    unreservedRoomOrderAutomaticRoomSchedulingPeriod:
      'ช่วงเวลาการจัดห้องอัตโนมัติสำหรับออเดอร์ที่ยังไม่จัดห้อง',
    inThisTimePeriodTheUnreservedRoomOrderWillBeAutomaticallyExecuted:
      'ในช่วงเวลานี้ ระบบจะทำการจัดห้องให้อัตโนมัติสำหรับออเดอร์ที่ยังไม่จัดห้อง',
    inventorySyncSetup: 'ตั้งค่าซิงค์สต็อก',
    orderSynchronizationSettings: 'ตั้งค่าซิงค์ออเดอร์',
    nightAuditSetup: 'ตั้งค่าการตรวจสอบกลางคืน',
    nightTrialMethod: 'วิธีดำเนินการตรวจสอบกลางคืน',
    manualOperation: 'ทำด้วยมือ',
    auto: 'อัตโนมัติ',
    storeOrdersHaveNotArrived: 'ออเดอร์ร้านที่ยังไม่ถึงกำหนด',
    preArrivalDepartureHandle: 'Pre-arrival & Pre-departure Order Handling',
    preArrivalDepartureHandleTip: 'Configure automatic handling for pre-arrival and pre-departure orders. The system will automatically execute the corresponding operations during night audit',
    preArrivalHandle: 'Pre-arrival Order Handling',
    preDepartureHandle: 'Pre-departure Order Handling',
    noHandle: 'No handling',
    autoCheckIn: 'Auto check-in',
    autoNoshow: 'Auto no-show',
    autoCheckOut: 'Auto check-out',
    autoExtendStay: 'Auto extend stay',
    autoSkip: 'Auto skip',
    shiftSetting: 'ตั้งค่ากะทำงาน',
    noOverlapIsAllowedAndTheTotalTimeIntervalMustCover24HoursOfTheDay:
      'เวลาของกะต้องไม่ทับซ้อนกัน และต้องครอบคลุม 24 ชั่วโมงเต็ม',
    morningShiftSetting: 'ตั้งค่ากะช่วงเช้ามืด',
    shiftReportimprestMode: 'รายงานเปลี่ยนกะ (โหมดเงินสำรอง)',
    hourRoomCheckOutMessage: 'ข้อความแจ้งเตือนเช็คเอาต์ห้องรายชั่วโมง',
    fullDayCheckOutMessage: 'ข้อความแจ้งเตือนเช็คเอาต์ห้องเต็มวัน',
    onlineChannelNewOrderAlerts: 'การแจ้งเตือนออเดอร์ใหม่จากช่องทางออนไลน์',
    onlineChannelOrderCancellationAlerts: 'การแจ้งเตือนยกเลิกออเดอร์จากช่องทางออนไลน์',
    hourCheckOutReminder: 'แจ้งเตือนเช็คเอาต์ห้องรายชั่วโมง',
    fullDayCheckOutReminder: 'แจ้งเตือนเช็คเอาต์ห้องเต็มวัน',
    automaticOrderSettingWhenOversold: 'ตั้งค่ารับออเดอร์อัตโนมัติเมื่อโอเวอร์โซลด์',
    hourRoomAutomaticOrderSetting: 'ตั้งค่ารับออเดอร์อัตโนมัติสำหรับห้องรายชั่วโมง',
    automaticRowHouseConfiguration: 'ตั้งค่าสถานะห้องอัตโนมัติ',
    automaticHouseRules: 'กฎการจัดห้องอัตโนมัติ',
    supportBillingTypes: 'ประเภทใบกำกับภาษีที่รองรับ',
    '30MinutesBeforeCheckOut': '30 นาทีก่อนเช็คเอาต์',
    '15MinutesBeforeCheckOut': '15 นาทีก่อนเช็คเอาต์',
    atCheckOut: 'ขณะเช็คเอาต์',
    pleaseEnterTheTime: 'กรุณากรอกเวลา',
    automaticCancellation: 'ยกเลิกอัตโนมัติ',
    manualCancellation3: 'ยกเลิกด้วยมือ',
    automaticOverbookingSetReminders: 'แจ้งเตือนการตั้งค่าโอเวอร์บุ๊คอัตโนมัติ',
    hourRoomAutomaticOrderSettingReminder:
      'แจ้งเตือนการตั้งค่ารับออเดอร์อัตโนมัติสำหรับห้องรายชั่วโมง',
    autoEnterArAccountText: 'บันทึกคำสั่งซื้อแบบเชื่อมต่อโดยตรงเข้า AR อัตโนมัติ',
    pleaseSelectABusinessDay: 'กรุณาเลือกวันทำการ',
    operationSuccessfulPleaseManuallyTriggerTheNightAudit:
      'ดำเนินการสำเร็จ กรุณาเรียกตรวจสอบกลางคืนด้วยมือ',
    theStartTimeAndEndTimeOfTheMorningShiftCannotBeTheSame:
      'เวลาเริ่มและสิ้นสุดกะเช้ามืดต้องไม่เท่ากัน',
    earlyMorningWatch: 'กะเช้ามืด',
    theAutomaticRowHouseIsSetSuccessfully: 'ตั้งค่าจัดห้องอัตโนมัติสำเร็จ',
    theEbRoomStatusIsAutomaticallyClosedWhenTheRoomIsFull: 'ปิดสถานะห้อง EB อัตโนมัติเมื่อห้องเต็ม',
    supportSwitchOrderSynchronization: 'สนับสนุนการซิงค์ออเดอร์แบบ switch',
    inventoryAutomaticSynchronizationSystemInventory: 'ซิงค์สต็อกระบบอัตโนมัติ',
    whenTheStoreOrderIsSetToautoCancelTheSystemWillAutomaticallyCancelTheStoreOrderForUnpaidOrdersAtNightAuditPleaseHandleTheCheckInInAdvanceToAvoidCancellation:
      'การต่ออายุการเข้าพักของคำสั่งจองก่อนออกมีลำดับความสำคัญสูงกว่าการเช็คอินของคำสั่งจองก่อนเข้าพัก หากไม่มีห้องว่างเมื่อระบบดำเนินการเช็คอินอัตโนมัติ ระบบจะทำ NoShow อัตโนมัติ หากไม่มีห้องว่างเมื่อระบบดำเนินการต่ออายุการเข้าพักอัตโนมัติ ระบบจะเช็คเอาท์อัตโนมัติ',
    whenTheStoreOrderIsSetTomanualCancelPleaseHandleTheCheckInOrCancelTheStorePreArrivalOrderInAdvanceToAvoidTheNightAuditNotPassing:
      'การต่ออายุการเข้าพักของคำสั่งจองก่อนออกมีลำดับความสำคัญสูงกว่าการเช็คอินของคำสั่งจองก่อนเข้าพัก หากไม่มีห้องว่างเมื่อระบบดำเนินการเช็คอินอัตโนมัติ ระบบจะทำ NoShow อัตโนมัติ หากไม่มีห้องว่างเมื่อระบบดำเนินการต่ออายุการเข้าพักอัตโนมัติ ระบบจะเช็คเอาท์อัตโนมัติ',
    whenTheRoomIsFullTheEbRoomStatusSwitchIsAutomaticallyTurnedOff:
      'บันทึกการตั้งค่าปิดสถานะห้อง EB อัตโนมัติเมื่อห้องเต็ม',
    // Part 29, lines 5601 to 5800
    inventoryAutomaticSynchronizationSystemInventorySwitchSettingsSaved:
      'บันทึกการตั้งค่าสวิตช์ซิงค์สต็อกอัตโนมัติเรียบร้อยแล้ว',
    atLeastOneMessageReminderSettingMustBeSelected:
      'ต้องเลือกการตั้งค่าการแจ้งเตือนอย่างน้อยหนึ่งรายการ',
    closeturnOnToAutomaticallySortRoomsAtNight:
      'ปิด (เปิดแล้วจะจัดห้องอัตโนมัติทั้งวันสำหรับออเดอร์ใหม่)',
    crossBusinessDayShiftsYouCanSetTheNightShiftSeparatelyForAccountingPurposesTheNightShiftDoesNotParticipateInNormalShiftTimeCalculations:
      'กะงานข้ามวัน สามารถตั้งค่ากะกลางคืนแยกต่างหากเพื่อความสะดวกในการคำนวณบัญชีกะ โดยกะกลางคืนจะไม่นับรวมกับเวลาในกะปกติ',
    dailyPredeparture: 'กำหนดออกวันนี้',
    theHotelSupportsSynchronousSwitchOrderChannelSettingsSaving:
      'โรงแรมรองรับการบันทึกการตั้งค่าช่องทางออเดอร์ switch แบบซิงค์',
    theNightAuditTimeMustBeBetween2100And0800TheNextDay:
      'เวลาตรวจสอบกลางคืนต้องอยู่ระหว่าง 21:00 ถึง 08:00 ของวันถัดไป',
    theScheduleNeedsToCover24HoursADayPleaseReset:
      'ช่วงเวลากะต้องครอบคลุม 24 ชั่วโมง กรุณาตั้งค่าใหม่',
    showMemberRechargeAmount: 'รายงานกะต้องแสดงจำนวนเงินเติมของสมาชิกหรือไม่',
    splitDeposit: 'รายงานกะแยกมัดจำหรือไม่',
    splitArAccount: 'รายงานกะแยกบัญชี AR หรือไม่',
    allowTimeConflict: 'อนุญาตให้เวลาจัดห้องซ้อนทับกันได้',
    selfCheckInDepositSetting: 'ตั้งค่ามัดจำสำหรับเช็คอินด้วยตนเอง',
    depositConfig: 'ตั้งค่ารับมัดจำ',
    defaultDepositAmount: 'จำนวนมัดจำเริ่มต้น',
    defaultDepositError: 'ค่ามัดจำเริ่มต้นไม่ถูกต้อง กรุณากรอกใหม่',
    roomDepositError: 'การตั้งค่ามัดจำของประเภทห้อง "{roomName}" ไม่ถูกต้อง กรุณาตั้งค่าใหม่',
    additionalRoomFeeSetting: 'ตั้งค่าค่าห้องเพิ่มเติม',
    fulldayAddFeeRule: 'กฎการคิดค่าห้องเพิ่มเติมแบบเต็มวัน',
    fulldayAddFeeType: 'ประเภทค่าห้องเพิ่มเติมแบบเต็มวัน',
    memberRechargeSetting: 'ตั้งค่าการรับเงินเติมสมาชิก',
    noVerificationPayment: 'ชำระเงินโดยไม่ต้องยืนยันรหัส',
    enforceAdditionalRoomCharge: 'คิดค่าห้องเพิ่มเติมแบบบังคับหลังเวลา',
    manualAdditionalRoomFee: 'คิดค่าห้องเพิ่มเติมแบบทำมือ',
    halfDayAdditionalRoomFee: 'คิดค่าห้องเพิ่มครึ่งวัน',
    fullDayAdditionalRoomFee: 'คิดค่าห้องเพิ่มเต็มวัน',
    morningOrderCheckInAddFee: 'คิดค่าห้องเพิ่มเติมสำหรับการเช็คอินช่วงเช้าตรู่หรือไม่',
    morningOrderAddFeeEnabled: 'เปิดใช้งานการคิดค่าห้องเพิ่มเติมสำหรับการเช็คอินช่วงเช้าตรู่แล้ว',
    morningOrderAddFeeDisabled: 'ปิดการคิดค่าห้องเพิ่มเติมสำหรับการเช็คอินช่วงเช้าตรู่แล้ว',

    popUpMethodSetting: 'การตั้งค่าวิธีการโต้ตอบ',
    newTab: 'แท็บใหม่',
    originalTabRedirection: 'เปลี่ยนแท็บเดิม',
    popupNotification: 'หน้าต่างป๊อปอัป',
    sidebar: 'แผงด้านขวา',
    breakfastReportCtrl: 'กฎการสถิติรายงานอาหารเช้า',
    repotShowByUserNums: 'สถิติตามจำนวนผู้เข้าพักจริง',
    repotShowByProductNums: 'สถิติตามจำนวนอาหารเช้าที่รวมในห้องพัก',
    breakfastReportCtrlSuccessByUserNums: 'กฎการสถิติรายงานอาหารเช้าถูกตั้งค่าเป็น "สถิติตามจำนวนผู้เข้าพักจริง"',
    breakfastReportCtrlSuccessByProductNums: 'กฎการสถิติรายงานอาหารเช้าถูกตั้งค่าเป็น "สถิติตามจำนวนอาหารเช้าที่รวมในห้องพัก"'
  },
  systemsetConditionConfig: {
    unspaced: 'จัดเรียงไม่แยกบรรทัด',
    arrangeByFloorBranch: 'จัดเรียงแบ่งบรรทัดตามชั้น',
    lineUpByRoomType: 'จัดเรียงแบ่งบรรทัดตามประเภทห้อง',
    theSizeOfTheCell: 'ขนาดช่องแสดงสถานะห้อง',
    small: 'เล็ก',
    inThe: 'กลาง',
    big: 'ใหญ่',
    wide: 'กว้าง',
    high: 'สูง',
    custom: 'กำหนดเอง',
    roomTypeFont: 'ฟอนต์ชื่อประเภทห้อง',
    size: 'ขนาด',
    colour: 'สี',
    roomNumberFont: 'ฟอนต์หมายเลขห้อง',
    whetherFullGuestNamesAreDisplayed: 'แสดงชื่อแขกเต็มหรือไม่',
    alreadyRowHouseStatusDisplayContent: 'เนื้อหาที่แสดงเมื่อจัดห้องแล้ว',
    alreadyRowHouseStatusDetailsDisplayContent: 'รายละเอียดสถานะห้องที่จัดแล้ว',
    noRowRoomStatusDetailsDisplayContent: 'รายละเอียดสถานะห้องที่ยังไม่จัด',
    arrearsIncludeToday: 'หนี้ค้างชำระจะคำนวณรวมค่าห้องที่รอสร้างในวันปัจจุบันหรือไม่',
    bedType2: 'ประเภทเตียง',
    restoreDefault: 'คืนค่าเริ่มต้น',
    roomDiagramArrangement: 'รูปแบบการจัดเรียง sơผังห้อง',
    theAppletTakesEffectAtTheSameTime: 'มีผลพร้อมกันบนมินิโปรแกรม',
    cellColor: 'สีของช่องสถานะห้อง',
    unarrangedRoomStatusContent: 'เนื้อหาสถานะห้องที่ยังไม่จัด',
    powerSwitch: 'ตัวจ่ายไฟ',
    roomBalance: 'ยอดคงเหลือของห้อง',
    depositAmount: 'จำนวนมัดจำ',
  },
  systemsetConfiguration: {
    changePriceRangeSettings: 'ตั้งค่าช่วงการปรับราคา',
    revaluationRange: 'ช่วงการปรับราคา',
    theSystemWillJudgeWhetherTheAveragePriceOfEachRoomTypeInThePast30DaysExceedsTheChangePriceRangeIfSoTheChangePriceWillBeEnteredIntoTheChangePriceAuditAndThePriceWillBeEffectiveAfterTheAuditTheChangePriceWillBeAutomaticallyRejectedAfter1HourIfItIsNotProcessed:
      'ระบบจะตรวจสอบว่าราคาเฉลี่ย 30 วันของแต่ละประเภทห้องเกินช่วงปรับราคาหรือไม่ หากเกินจะเข้าสู่ขั้นตอนตรวจสอบการปรับราคา และจะมีผลหลังตรวจสอบผ่าน หากไม่ดำเนินการภายใน 1 ชั่วโมง ระบบจะปฏิเสธการปรับราคาโดยอัตโนมัติ',
  },
  systemsetLog: {
    operationRecord: 'บันทึกการดำเนินงาน',
  },
  systemsetPrint: {
    documentType: 'ประเภทเอกสาร',
    paperSize: 'ขนาดกระดาษ',
    typeSize: 'ขนาดตัวอักษร',
    printingMode: 'โหมดการพิมพ์',
    noticeToGuests: 'ประกาศสำหรับแขก',
  },
  systemsetTarget: {
    monthlyGoalSetting: 'ตั้งค่าเป้าหมายรายเดือน',
    goal: 'เป้าหมาย',
    goalAchievementRate: 'อัตราการบรรลุเป้าหมาย',
    intertargetNight: 'เป้าหมายจำนวนคืน',
    targetOccupancyRate: 'อัตราการเข้าพักเป้าหมาย',
    recommendedTargetValue: 'ค่าเป้าหมายที่แนะนำ',
    actualAchievement: 'ผลลัพธ์ที่ทำได้จริง',
    reachedLastMonth: 'ทำได้ในเดือนที่แล้ว',
    theSamePeriodLastYear: 'ช่วงเวลาเดียวกันของปีก่อน',
    commitFailure: 'ส่งข้อมูลล้มเหลว',
  },
  systemsetWarning: {
    earningsWarning: 'แจ้งเตือนรายได้',
    dailyWarning: 'แจ้งเตือนรายวัน',
  },
  systemsetWifi: {
    commonality: 'พื้นที่สาธารณะ',
    batchModification: 'แก้ไขแบบกลุ่ม',
    pleaseCompleteTheWiFiAccountPassword: 'กรุณากรอกบัญชีและรหัสผ่าน Wi-Fi ให้ครบถ้วน',
    pleaseEnterAValidWifiName: 'กรุณากรอกชื่อ Wi-Fi ที่ถูกต้อง',
    noPasswordOrMobilePhoneAuthenticationOfTheWifiDoNotNeedToFillIn:
      'Wi-Fi ที่ไม่มีรหัสผ่านหรือยืนยันด้วยมือถือไม่ต้องกรอก',
    pleaseFillInTheWiFiAccount: 'กรุณากรอกบัญชี Wi-Fi',
    roomWifiSettings: 'การตั้งค่า Wi-Fi ห้องพัก',
    wifiName: 'ชื่อ Wi-Fi',
    wifiPassword: 'รหัสผ่าน Wi-Fi',
  },
  assemblyBindavailableproducts: {
    bindAvailableProducts: 'ผูกผลิตภัณฑ์ที่ใช้ได้',
    bindAtLeastOneProduct: 'ต้องผูกอย่างน้อยหนึ่งผลิตภัณฑ์',
  },
  componentsWarning: {
    byTheMonth: 'รายเดือน',
    achievedOnDays: 'วัน บรรลุแล้ว',
    below: 'ต่ำกว่า',
    viewRemainingConditions: 'ดูเงื่อนไขที่เหลือ',
    newEarlyWarningItems: 'เพิ่มรายการแจ้งเตือนใหม่',
    achieved: 'บรรลุแล้ว',
    additionalCondition: 'เพิ่มเงื่อนไข',
    internightMoonTargetReachWarning: 'แจ้งเตือนบรรลุเป้าหมายจำนวนคืนรายเดือน',
    earlyWarningOfMonthlyTargetOfRentalRate: 'แจ้งเตือนบรรลุเป้าหมายอัตราการเข้าพักรายเดือน',
    surplusRoom: 'จำนวนห้องคงเหลือ',
    pointScoring: 'คะแนนรีวิว',
    gmvMonthlyTargetWarning: 'แจ้งเตือน GMV รายเดือน',
    revparMonthlyTargetWarning: 'แจ้งเตือน RevPAR รายเดือน',
  },
  componentsWarningday: {
    overallHotel: 'ภาพรวมโรงแรม',
    everyday: 'รายวัน',
    theDayBefore: 'วันก่อนหน้า',
    viewRemainingConditions: 'ดูเงื่อนไขที่เหลือ',
    newEarlyWarningItems: 'เพิ่มรายการแจ้งเตือนใหม่',
    additionalCondition: 'เพิ่มเงื่อนไข',
    lessThan: 'น้อยกว่า',
    greaterThan: 'มากกว่า',
    pointScoring: 'คะแนนรีวิว',
    surplusRoom: 'จำนวนห้องคงเหลือ',
  },
  payLehuipaySetting: {
    youHaveNotOpenedOnlinePayment: 'คุณยังไม่ได้เปิดใช้การชำระเงินออนไลน์',
    contactOperationOrTechnicalSupportToEnableTheService:
      'กรุณาติดต่อฝ่ายปฏิบัติการหรือฝ่ายเทคนิคเพื่อเปิดใช้งาน',
    lehuiPay: 'Lehui Pay',
    download: 'ดาวน์โหลด',
    inquire: 'ตรวจสอบ',
    withdraw: 'ถอนเงิน',
    withdrawalRecord: 'บันทึกการถอนเงิน',
    billDownload: 'ดาวน์โหลดบิล',
    accountBalanceInquiry: 'ตรวจสอบยอดคงเหลือบัญชี',
    theWithdrawalAmountIsRequired: 'ต้องกรอกจำนวนเงินที่จะถอน',
    theAmountRangeIs: 'ช่วงจำนวนเงินคือ',
    doYouWantToChangeThePaymentMethod: 'ยืนยันแก้ไขวิธีชำระเงินหรือไม่',
    modifyingThePaymentModeSucceeded: 'แก้ไขวิธีชำระเงินสำเร็จ',
    pleaseFillInTheWithdrawalAmount: 'กรุณากรอกจำนวนเงินที่จะถอน',
    ifTheWithdrawalFailsTheWithdrawalAmountCannotBeLessThan10Yuan:
      'ถอนเงินล้มเหลว จำนวนเงินถอนต้องไม่ต่ำกว่า 10',
  },
  foodLogin: {
    cashierSystem: 'ระบบแคชเชียร์ร้านอาหาร',
    shopSystem: 'ระบบผู้ประกอบการร้านอาหาร',
    pleaseEnterYourAccount: 'กรุณากรอกบัญชีผู้ใช้',
    noFoodSystemPermission: 'คุณไม่มีสิทธิ์เข้าถึง {system}',
    systemConfigurationError: 'ข้อผิดพลาดในการกำหนดค่าระบบ โปรดติดต่อฝ่ายสนับสนุนทางเทคนิค',
    loginFailed: 'เข้าสู่ระบบล้มเหลว โปรดลองอีกครั้งในภายหลัง',
  },
  loginIndex: {
    hotelManagementSystem: 'ระบบบริหารโรงแรม',
    qrCodeExpired: 'คิวอาร์โค้ดหมดอายุ',
    pleaseClickRefresh: 'กรุณาคลิกรีเฟรช',
    openWechatScanTheQrCode: 'เปิด WeChat และสแกนคิวอาร์โค้ด',
    customerServiceNumber: 'เบอร์บริการลูกค้า',
    theAccountOrPasswordYouEnteredIsIncorrect: 'บัญชีหรือรหัสผ่านไม่ถูกต้อง',
    forgotPassword: 'ลืมรหัสผ่าน',
    verificationCodeSentToYourMobilePhoneValidFor5Minutes:
      'ส่งรหัสยืนยันไปยังมือถือของคุณแล้ว ใช้ได้ภายใน 5 นาที',
    enter820CharactersIncludingLettersNumbersAndSymbolsOfTwoOrMoreTypes:
      'กรอก 8-20 ตัวอักษร รวมตัวอักษร ตัวเลข และสัญลักษณ์อย่างน้อยสองชนิด',
    submit2: 'ส่ง',
    loginPasswordUpdateSuccessful: 'อัปเดตรหัสผ่านเข้าใช้งานสำเร็จ',
    reLogin: 'เข้าสู่ระบบใหม่',
    bind: 'ผูกบัญชี',
    findPassword: 'กู้คืนรหัสผ่าน',
    pleaseEnterTheVerificationCode: 'กรุณากรอกรหัสยืนยัน',
    mobilePhoneSmsVerificationCode: 'รหัส SMS',
    pleaseEnterTheMobilePhoneVerificationCode: 'กรุณากรอกรหัส SMS',
    pleaseVerifyTheNewPassword: 'กรุณายืนยันรหัสผ่านใหม่',
    bindWechat: 'ผูก WeChat',
    pleaseEnterTheLoginPassword: 'กรุณากรอกรหัสผ่านเข้าใช้งาน',
    theTwoPasswordsEnteredAreInconsistent: 'รหัสผ่านทั้งสองครั้งไม่ตรงกัน',
    pleaseEnterTheVerificationCode3: 'กรุณากรอกรหัสภาพ',
    loggingIn: 'กำลังเข้าสู่ระบบ',
    acquire: 'ขอรับ',
    resendVerificationCode: 'ส่งรหัสอีกครั้ง',
    loginNow: 'เข้าสู่ระบบทันที',
    currentPhoneNumber: 'หมายเลขโทรศัพท์ปัจจุบัน',
    changeSuccessful: 'เปลี่ยนสำเร็จ',
    afterReGetting: 'หลังจากนั้นขอรับใหม่',
    pleaseEnterCorrectAccount: 'กรุณากรอกบัญชีให้ถูกต้อง',
  },
  accountIndex: {
    scope: 'ขอบเขตการใช้งาน',
    confirmDelete: 'ยืนยันลบบัญชีชุดนี้หรือไม่?',
    onlyDeleteDisabled: 'ลบได้เฉพาะบัญชีชุดที่ถูกปิดใช้งานแล้วเท่านั้น',
    cancelDelete: 'ยกเลิกการลบแล้ว',
  },
  accountsetMember: {
    accountSubject: 'บัญชีรายการ',
    addCash: 'เพิ่มบัญชีเงินสด',
    roomAccount: 'บันทึกค่าใช้จ่ายเข้าห้อง',
    pleaseEnterTheExternalOrderNumber: 'กรุณากรอกรหัสคำสั่งซื้อภายนอก',
    consumptionStatement: 'ใบสรุปค่าใช้จ่าย',
    submitted: 'ส่งแล้ว',
    pleaseFillInTheAmountSpent: 'กรุณากรอกจำนวนเงินที่ใช้',
    theAmountSpentMustBeGreaterThan: 'จำนวนเงินที่ใช้ต้องมากกว่า',
    blanked: 'เคลียร์แล้ว',
    pleaseFillInTheRoomAccount: 'กรุณาเลือกว่าจะบันทึกค่าใช้จ่ายเข้าห้องหรือไม่',
    pleaseSelectAnAccount: 'กรุณาเลือกบัญชี',
    pleaseSelectASmallItem: 'กรุณาเลือกสินค้า',
    newSuccess: 'เพิ่มใหม่สำเร็จ',
    // Part 30, lines 5801 to 6000
    goAndCheck: 'ไปตรวจสอบ',
  },
  pcncomponentRoomtypesortingcomponent: {
    roomTypeRanking: 'การจัดลำดับประเภทห้อง',
  },
  activitySelfHelp: {
    selfHelpPromotionDescription: 'คำอธิบายโปรโมชั่นแบบบริการตนเอง',
    promotionalOffersAreAllBorneByTheMerchantDifferentChannelsOfSettlementMethodsAreDifferent:
      'ส่วนลดโปรโมชั่นทั้งหมดรับผิดชอบโดยผู้ค้า วิธีการชำระเงินของแต่ละช่องทางจะแตกต่างกัน',
    inCaseOfFalsePromotionTheConsequencesShallBeBorneByTheMerchant:
      'หากเกิดการโปรโมทเท็จ ผู้ค้าต้องรับผิดชอบผลที่ตามมา',
    onceCreatedThePromotionWillTakeEffectAcrossAllChannels:
      'เมื่อสร้างโปรโมชั่นแล้ว จะมีผลในทุกช่องทาง',
    promotionType: 'ประเภทโปรโมชั่น',
    promotionalProduct: 'ผลิตภัณฑ์โปรโมชั่น',
    effectiveChannel: 'ช่องทางที่มีผล',
    promotionStatus: 'สถานะโปรโมชั่น',
    noRegistrationIsAvailable: 'ยังไม่มีกิจกรรมให้ลงทะเบียน',
    dailySpecial: 'ดีลพิเศษประจำวัน',
    tonightSpecial: 'ดีลพิเศษสำหรับคืนนี้',
    firstStayDiscount: 'ส่วนลดเข้าพักครั้งแรก',
    travelSpecial: 'ดีลพิเศษการเดินทาง',
    festivalCoverage: 'โปรวันเทศกาล',
    studentOnly: 'เฉพาะนักศึกษา',
    batchOffLine: 'ปิดการใช้งานแบบกลุ่ม',
    thereAreNoRegisteredActivities: 'ยังไม่มีกิจกรรมที่ลงทะเบียน',
    thereAreNoCanceledEvents: 'ยังไม่มีกิจกรรมที่ถูกยกเลิก',
    pleaseSelectThePostPromotionOperationBatchOfflineFeature:
      'กรุณาเลือกฟังก์ชันปิดการใช้งานแบบกลุ่มหลังโปรโมชั่น',
    massMerchantsSelfPromotionOffline: 'ผู้ค้าปิดการโปรโมทแบบกลุ่ม',
    allChannels: 'ทุกช่องทาง',
  },
  componentsPrintsettingdialog: {
    previewEditing: 'แก้ไขตัวอย่างก่อนพิมพ์',
    printTheFullIdNumber: 'พิมพ์หมายเลขบัตรประชาชนเต็มรูปแบบ',
    printGuestAddress: 'พิมพ์ที่อยู่ของแขก',
    printPaymentInformation: 'พิมพ์ข้อมูลการชำระเงิน',
    modifySettings: 'แก้ไขการตั้งค่า',
    documentType: 'ประเภทเอกสาร',
    paperSize: 'ขนาดกระดาษ',
    typeSize: 'ขนาดตัวอักษร',
    printingMode: 'โหมดการพิมพ์',
    noticeToGuests: 'ข้อควรทราบสำหรับแขก',
    thisContentWillBeDisplayedOnTheDocumentWhenPrintingPleaseBeSureToPrintATestAfterFillingInTheDocumentToAvoidTheDisplayEffectAffectedByTheNumberOfLinesOrExcessiveWords:
      'ข้อความนี้จะแสดงบนเอกสารเมื่อพิมพ์ กรุณาทดสอบการพิมพ์หลังจากกรอกเพื่อตรวจสอบว่าจำนวนบรรทัดและตัวอักษรไม่มากจนเกินไป',
    defaultPrint: 'พิมพ์ค่าเริ่มต้น',
    manualSelection: 'เลือกด้วยตนเอง',
    standard: 'มาตรฐาน',
    larger: 'ใหญ่กว่า',
    pleaseSelectPaperSize: 'กรุณาเลือกขนาดกระดาษ',
    pleaseSelectAPrintingMethod: 'กรุณาเลือกวิธีการพิมพ์',
    pleaseSelectTheSize: 'กรุณาเลือกขนาดตัวอักษร',
  },
  assemblyAddprojectdialog: {
    addItem: 'เพิ่มรายการ',
    projectName: 'ชื่อโครงการ',
    pleaseEnterAProjectName: 'กรุณากรอกชื่อโครงการ',
    copies: 'จำนวนชุด',
    pleaseEnterTheNumberOfCopies: 'กรุณากรอกจำนวนชุด',
    pleaseEnterTheNameOfTheOffer: 'กรุณากรอกชื่อสิทธิพิเศษ',
    theNumberOfCopiesMustBeGreaterThan: 'จำนวนชุดต้องมากกว่า',
  },
  viewsHomePageIndex: {
    commonFunctions: 'ฟังก์ชันใช้งานบ่อย',
    roomStatusOverview: 'ภาพรวมสถานะห้อง',
    todayData: 'ข้อมูลวันนี้',
    thisMonthData: 'ข้อมูลเดือนนี้',
    dataAsOf: 'ข้อมูลถึงวันที่：',
    todoList: 'รายการที่ต้องทำ',
    allRead: 'อ่านทั้งหมด',
    noTodos: 'คุณได้จัดการงานที่ต้องทำทั้งหมดแล้ว',
    efficientDay: 'วันนี้มีประสิทธิภาพมาก!',
    logUpdates: 'อัปเดตบันทึก',
    selectedFunctionsTitle: 'ฟังก์ชันที่เลือก',
    selectedFunctionsTip: 'ลากเพื่อปรับลำดับ ต้องเลือกอย่างน้อย 1 ฟังก์ชัน',
    maxSix: 'เลือกได้มากสุด 6 ฟังก์ชัน',
    allReadSuccess: 'ทำเครื่องหมายอ่านทั้งหมดสำเร็จ',
  },
  viewsReportFinanceOnlinePaymentReconciliation: {
    tradeDate: 'วันที่ทำรายการ',
    billType: 'ประเภทบิล',
    platform: 'แพลตฟอร์มชำระเงิน',
    qzTradeNo: 'หมายเลขธุรกรรม',
    qzTradeNoPlaceholder: 'กรุณากรอกหมายเลขธุรกรรม',
    amountTotal: 'ยอดรวม',
    feeTotal: 'ค่าธรรมเนียมรวม',
    reportName: 'รายงานกระทบยอดการชำระเงินออนไลน์',
    pleaseSelectAtLeastOneDateType: 'กรุณาเลือกประเภทวันที่อย่างน้อยหนึ่งรายการ',
    income: 'รายรับ',
    alipay: 'Alipay',
    wechat: 'WeChat Pay',
    merchantCode: 'รหัสร้านค้า',
    merchantName: 'ชื่อร้านค้า',
    qzTradeNoColumn: 'หมายเลขธุรกรรม',
    externalOrderNo: 'หมายเลขคำสั่งซื้อภายนอก',
    orderAmount: 'ยอดคำสั่งซื้อ',
    merchantRate: 'อัตราค่าธรรมเนียมร้านค้า',
    commission: 'ค่าธรรมเนียม',
    billTypeColumn: 'ประเภทบิล',
    finishTime: 'เวลาที่เสร็จสิ้น',
    oriQzTradeNo: 'หมายเลขรายการเดิม',
    platformColumn: 'แพลตฟอร์มชำระเงิน',
  },
  appShop: {
    label1: '🔥「ลดต้นทุนค่าคอมมิชชั่น 25%」',
    label2: '💰「ผู้ค้าต้องดู! เคล็ดลับประหยัดค่าคอมพันบาท/เดือน」',
    label3: '⚠「ยังปวดหัวกับค่าธรรมเนียมถอนเงินสูงอยู่ไหม？」',
    label4: '⏳「100 คนแรก รับกล่องสแกนจ่าย」',
    label5: '❓「ทำไมแบรนด์ใหญ่ถึงใช้ระบบนี้？」',
    label6: '🛡「ความปลอดภัยระดับธนาคาร｜ร้านค้าหลายพันเลือกใช้」',
    label7: '📞「สมัครทันที｜ลดค่าธรรมเนียม 25%」',
    label8: '💼「เจ้าของโรงแรมเล่าว่า：มันช่วยเพิ่มรายได้ 3,000 บาท/เดือน」',
  },
  settleDialog: {
    entryRoom: 'ห้องลงบัญชี',
    selectEntryRoom: 'กรุณาเลือกห้องลงบัญชี',
    confirmTotalRoomRate: 'ยืนยันค่าห้องทั้งหมด',
    preAuthorizationSettlement: 'ชำระด้วยวงเงินค้ำประกัน',
    completeCheckout: 'เสร็จสิ้นการชำระเงิน',
    additionalChargeAmount: 'จำนวนเงินที่คิดเพิ่ม',
    hourlyRoomTip: 'ห้องรายชั่วโมง: กรุณายืนยันค่าห้องที่ต้องเรียกเก็บจริง',
    fullDayRoomTip: 'ห้องเต็มวัน: กรุณากรอกค่าห้องเพิ่มเติมที่ต้องเรียกเก็บ',
    noAdditionalCharge: 'ไม่คิดค่าบริการเพิ่ม',
    generateRoomFee: 'สร้างค่าห้อง',
    hangAccount: 'บันทึกค้างชำระ',
    hangToMaster: 'บันทึกเข้าเอกสารหลัก',
    hangAccountReason: 'เหตุผลในการบันทึกค้างชำระ',
    hangAccountTip: 'การบันทึกค้างชำระจะถูกบันทึกในบัญชีเอกสารหลัก',
    inputAdditionalAmount: 'กรุณากรอกจำนวนเงินเพิ่มเติม',
    detail: 'รายละเอียด',
    selectAtLeastOneRoom: 'กรุณาเลือกอย่างน้อยหนึ่งห้อง',
    transferBeforeHangAccount: 'กรุณาโอนย้ายห้องที่อยู่ในสถานะ “รอเข้าพัก” ก่อนบันทึกค้างชำระ',
    pleaseAddRoomFee: 'กรุณาเพิ่มค่าห้องก่อน',
    noRoomOrderFound: 'ไม่พบหมายเลขคำสั่งห้อง กรุณารีเฟรชหน้าแล้วลองใหม่',
  },
  notUploadList: {
    searchPlaceholder: 'กรอกชื่อหรือหมายเลขห้อง',
    uploadStatus: 'สถานะการอัปโหลด',
    notUploaded: 'ยังไม่อัปโหลด',
    uploaded: 'อัปโหลดแล้ว',
    loggedOut: 'ออกจากระบบแล้ว',
    downloadAllGuestInfo: 'ดาวน์โหลดข้อมูลแขกทั้งหมด',
    idAddress: 'ที่อยู่ตามบัตร',
    uploadStatusColumn: 'อัปโหลดให้ตำรวจหรือไม่',
    downloadInfo: 'ดาวน์โหลดข้อมูล',
    finishUpload: 'อัปโหลดเสร็จสิ้น',
  },
  notification: {
    markAllRead: 'ทำเครื่องหมายว่าอ่านทั้งหมด',
    expand: 'ขยาย ({count})',
    collapse: 'ย่อ ({count})',
    ignore: 'ละเว้น',
  },
  adjustFinance: {
    title: 'ปรับปรุงบัญชีการเงิน',
    adjustAccount: 'ปรับบัญชี',
    balanceZeroWarning: 'ต้องทำให้ยอดคงเหลือเป็น 0 ก่อนจึงจะส่งได้',
    addOneRecordWarning: 'กรุณาเพิ่มรายการบันทึกอย่างน้อยหนึ่งรายการ',
  },
  roomStatusStatistics: {
    details: 'รายละเอียด',
  },
  hotelStateDialog: {
    title: 'สถิติสถานะห้อง',
    checkIn: 'เข้าพัก',
    prepareCheckIn: 'รอเข้าพัก',
    sold: 'ขายแล้ว',
    available: 'ว่าง',
    fetchError: 'ดึงข้อมูลประเภทห้องล้มเหลว',
  },
  futureRoomIndex: {
    quickSearch: 'ค้นหาอย่างรวดเร็ว',
    reEnable: 'เปิดใช้งานอีกครั้ง',
    confirmChangeRoomTitle: 'ต้องการย้ายห้องเดิมไปยังห้องใหม่หรือไม่?',
    originalRoom: 'ห้องเดิม',
    newRoom: 'ห้องใหม่',
    dragTargetInvalid: 'ลากไม่สำเร็จ: ไม่พบช่องเป้าหมาย',
    selectSameRoomTypeSameStayDate: 'โปรดเลือกห้องประเภทเดียวกันที่มีวันที่เข้าและออกตรงกัน',
    differentRoomTypeSwapNotSupported: 'ยังไม่รองรับการสลับกับคำสั่งห้องพักที่มีอยู่เมื่อเป็นคนละประเภทห้อง',
    yuAVL: 'คงเหลือ',
  },
  financePaymentIndex: {
    addPaymentSubject: 'เพิ่มรายการชำระเงิน',
    paymentSubjectName: 'ชื่อรายการชำระเงิน',
    symbol: 'สัญลักษณ์',
    confirmDelete: 'ยืนยันลบรายการนี้หรือไม่?',
  },
  financeAccountDialog: {
    pleaseEnterSubject: 'กรุณากรอกหมวด{type}',
    pleaseSelectCategoryType: 'กรุณาเลือกประเภทหมวด{type}',
    addTitle: 'เพิ่มหมวด{type}',
    editTitle: 'แก้ไขหมวด{type}',
    subjectName: 'ชื่อหมวด{type}',
    subjectCategory: 'ประเภทหมวด{type}',
    isEnabled: 'เปิดใช้งานหรือไม่',
  },
  financeConsumerAccount: {
    subjectCategory: 'ประเภทหมวดค่าใช้จ่าย',
    addSubject: 'เพิ่มหมวดค่าใช้จ่าย',
    subjectName: 'ชื่อหมวดค่าใช้จ่าย',
    symbol: 'สัญลักษณ์',
    confirmDelete: 'ยืนยันลบหมวดนี้หรือไม่?',
  },
  financeSubjectSorting: {
    consumeSortTitle: 'จัดลำดับหมวดค่าใช้จ่าย',
    paySortTitle: 'จัดลำดับหมวดการชำระเงิน',
    consumeSubjectName: 'ชื่อหมวดค่าใช้จ่าย',
    paySubjectName: 'ชื่อหมวดการชำระเงิน',
    sortSuccess: 'จัดลำดับสำเร็จ',
    // Part 31, lines 6001 to 6065
  },
  aiPms: {
    common: {
      aiDriven: 'ขับเคลื่อนด้วย AI',
      justNow: 'เมื่อสักครู่',
      minutesAgo: '{count} นาทีที่แล้ว',
      hoursAgo: '{count} ชั่วโมงที่แล้ว',
    },
    aiConfig: { pageTitle: 'AI Configuration', save: 'Save', hotelSection: 'Hotel Configuration', roomTypeSection: 'Room Type Configuration', priceGuard: 'Price Guardrail', enabled: 'Enabled', disabled: 'Disabled', hotelFloorPrice: 'Hotel Floor Price', hotelCeilingPrice: 'Hotel Ceiling Price', floorPrice: 'Floor Price (CNY)', ceilingPrice: 'Ceiling Price (CNY)', floorPricePlaceholder: 'Enter floor price', ceilingPricePlaceholder: 'Enter ceiling price', yuan: 'CNY', roomTypeName: 'Room Type Name', roomTypeCode: 'Room Type Code', amountNonNegative: ' amount must be greater than or equal to 0', floorGreaterThanCeiling: ' floor price cannot exceed ceiling price', hotelLabel: 'Hotel', roomTypeLabel: 'Room type “{name}”', noChanges: 'No configuration changes detected', saveSuccess: 'Saved successfully', pricingSelloutTimeTitle: 'Target Sellout Time Policy', pricingSelloutTimeTip: 'Used for same-day price increases, slow-selling price reductions, and peer-traffic urgency.', custom: 'Custom Policy', legalHoliday: 'Legal Holiday', weekend: 'Friday and Saturday', defaultDate: 'Other Dates (including Sunday)', selectTime: 'Select time', pricingSelloutTimeInvalid: 'The sellout time policy returned by the server is invalid. Explicitly handle it before saving.', pricingSelloutTimeRequired: 'All target sellout times must use HH:mm and be within 14:00–23:59 or 00:00–06:00.' },
    roomPricingReport: { reportTitle: 'Room Type Pricing Report', reportTip: 'AI recommendations, operating basis, and pricing factors', hotelInfo: 'Hotel Information', sellDate: 'Sale Date', metricDate: 'Metric Business Date', hotelOcc: 'Current Hotel OCC', hotelRevpar: 'Current Hotel RevPAR', currentPrice: 'Current Price', aiRecommendedPrice: 'AI Recommended Price', aiCurrentDelta: 'AI vs. Current Price', sameDayOcc: 'Same-day OCC', sameDayRevpar: 'Same-day RevPAR', confidence: 'AI Confidence', inventorySnapshot: 'ขายแล้ว / พร้อมขาย (ขายเกิน) / ปิดใช้งาน', operatingBasis: 'Room Type Operating Basis', aiDecision: 'AI Decision', tradeoff: 'Multi-factor Trade-off: ', aiFactors: 'AI Pricing Factors', historicalPrice: 'Historical Price', operation: 'Operating Data', market: 'Market Position', timeEvent: 'Time and Events', guardrailRisk: 'Guardrails and Risks', status: 'Status: ', priceImpact: 'Price Impact: ', conclusion: 'Conclusion: ', reason: 'Reason: ', evidence: 'Evidence: ', riskReminder: 'Risk Reminders', noRisk: 'No additional risk reminders', severity: 'Severity: ', suggestion: 'Suggested Action: ', used: 'Used', notUsed: 'Not Used', notAvailable: 'No Data Available', up: 'Supports Increase', hold: 'Hold', down: 'Supports Decrease', limit: 'Guardrail Limit', none: 'No Direct Impact', yes: 'Yes', no: 'No', yuan: 'CNY', priceAdjustment: 'ปรับราคาผลิตภัณฑ์', priceAdjustmentDialogTitle: 'การกำหนดราคาอัจฉริยะ: ปรับราคาผลิตภัณฑ์', noAdjustableProducts: 'ไม่มีผลิตภัณฑ์ที่ปรับราคาได้สำหรับประเภทห้องนี้', roomTypeName: 'ประเภทห้อง: ', roomTypeCode: 'รหัสประเภทห้อง: ', roomTypeCurrentPrice: 'ราคาปัจจุบันของประเภทห้อง', algorithmRecommendedPrice: 'ราคาที่แนะนำโดยอัลกอริทึม', aiAdjustmentDelta: 'การเปลี่ยนแปลงราคาโดย AI', currencySymbol: '¥', snapshotPriceNote: 'คำแนะนำของ AI อ้างอิงจากภาพรวมของการแจ้งเตือนกำหนดราคาอัจฉริยะนี้', product: 'ผลิตภัณฑ์: ', channel: 'ช่องทาง', channelId: 'รหัสช่องทาง: {id}', channelCurrentPrice: 'ราคาขายปัจจุบันของช่องทาง', aiAdjustedPrice: 'ราคาขายหลังปรับโดย AI', operationLabel: 'การดำเนินการ', oneClickAdjustment: 'ปรับราคา', confirmGroupAdjustment: 'ปรับราคาสำหรับ {count} ช่องทางของผลิตภัณฑ์นี้หรือไม่?', confirmChannelAdjustment: 'ปรับราคาสำหรับผลิตภัณฑ์ช่องทางนี้หรือไม่?', confirmAdjustmentTitle: 'ยืนยันการปรับราคา', confirm: 'ยืนยัน', cancel: 'ยกเลิก', adjustmentSuccess: 'ปรับราคาสำเร็จ', bookingHourPreference: 'ความต้องการจองตามช่วงเวลาใน 7 วันที่ผ่านมา', bookingHourNoData: 'ยังไม่มีข้อมูลการจองตามช่วงเวลา', bookingHourDateRange: '{start} ถึง {end}', bookingHourTooltip: 'เวลา {hour}:00<br/>สัดส่วนการจอง: {value}%' },
    roomPricingFeedback: { button: 'ยอมรับ', dialogTitle: 'ส่งข้อเสนอแนะ', accept: 'ยอมรับ', reject: 'ไม่ยอมรับ', rejectReasonPlaceholder: 'โปรดระบุเหตุผลที่ไม่ยอมรับ', actionRequired: 'โปรดเลือกผลการให้ข้อเสนอแนะ', rejectReasonRequired: 'โปรดระบุเหตุผลที่ไม่ยอมรับ', rejectReasonTooLong: 'เหตุผลที่ไม่ยอมรับต้องไม่เกิน 100 อักขระ', acceptSuccess: 'ยอมรับแล้ว', rejectSuccess: 'ส่งข้อเสนอแนะการไม่ยอมรับแล้ว' },
    roomPricing: {
      empty: 'ยังไม่มีผลลัพธ์การตั้งราคาที่แสดงได้',
      roomTypeFallback: 'ประเภทห้อง {index}',
      decisionTitle: 'คำอธิบายการตัดสินใจ',
      riskLabel: 'คำเตือนความเสี่ยง:',
      modeLabel: 'โหมด:',
      floorPriceLabel: 'ขอบเขตราคา:',
      confidenceLabel: 'ระดับความเชื่อมั่น:',
      directionFlat: 'แนะนำราคาเท่าเดิม',
      directionUp: 'แนะนำขึ้นราคา',
      directionDown: 'แนะนำลดราคา',
      priorityLow: 'ลำดับความสำคัญต่ำ',
      priorityMedium: 'ลำดับความสำคัญปานกลาง',
      priorityHigh: 'ลำดับความสำคัญสูง',
    },
    roomPricingCard: { pricingTime: 'เวลาตั้งราคา: ', expand: 'ขยาย', collapse: 'ยุบ' },
    noticeCenter: {
      unreadCount: 'ยังไม่อ่าน {count} รายการ',
      readAll: 'ทำเครื่องหมายว่าอ่านแล้วทั้งหมด',
      defaultTitle: 'การแจ้งเตือน AI',
      browserNotificationTitle: 'การแจ้งเตือน AI',
      browserNotificationBody: 'คุณได้รับการแจ้งเตือน AI ใหม่',
      browserPermissionGuide: 'เปิดใช้เพื่อรับการแจ้งเตือน AI ใหม่ในเบราว์เซอร์ขณะทำงานเบื้องหลัง',
      enableBrowserNotification: 'เปิดการแจ้งเตือนเบราว์เซอร์',
      skipBrowserNotification: 'ไว้ภายหลัง',
      statusRead: 'อ่านแล้ว',
      statusUnread: 'ยังไม่อ่าน',
      emptySummary: 'ไม่มีสรุปการแจ้งเตือน',
      like: 'ชอบ',
      dislike: 'ไม่ชอบ',
      viewDetail: 'ดูรายละเอียด',
      markRead: 'ทำเครื่องหมายว่าอ่านแล้ว',
      emptyList: 'ไม่มีการแจ้งเตือน',
      dislikeDialogTitle: 'ส่งเหตุผลที่ไม่ชอบ',
      dislikePlaceholder: 'กรุณาฝากข้อเสนอแนะของคุณ',
      categoryAll: 'ทั้งหมด',
      readAllSuccess: 'ทำเครื่องหมายว่าอ่านแล้วทั้งหมดสำเร็จ',
      markReadSuccess: 'ทำเครื่องหมายว่าอ่านแล้วสำเร็จ',
      likeSuccess: 'ขอบคุณสำหรับความคิดเห็นของคุณ',
      dislikeReasonRequired: 'กรุณากรอกเหตุผลที่ไม่ชอบ',
      dislikeSuccess: 'ส่งสำเร็จ',
      uncategorized: 'ยังไม่จัดหมวดหมู่',
    },
    noticeDetail: {
      back: 'กลับไปยังการแจ้งเตือน AI',
      sendTime: 'เวลาสร้าง: ',
      businessType: 'หมวดหมู่หลัก: ',
      businessSubType: 'หมวดหมู่ย่อย: ',
      sideLabel: 'รายละเอียดการแจ้งเตือน',
      contentTitle: 'เนื้อหาการแจ้งเตือน',
      contentTip: 'แสดงเนื้อหาต้นฉบับของการแจ้งเตือนในรูปแบบ markdown',
      badReviewTitle: 'รายละเอียดรีวิวเชิงลบ',
      badReviewTip: 'แสดงข้อความรีวิวและคำตอบที่ AI แนะนำ',
      badReviewContent: 'ข้อความรีวิว',
      badReviewReply: 'คำตอบที่แนะนำ',
      structuredTitle: 'ผลลัพธ์แบบมีโครงสร้าง',
      structuredTip: 'แสดงข้อมูลเชิงโครงสร้างและบทวิเคราะห์แยกตามส่วนของรายงาน AI',
      structuredEmptyTip: 'ยังไม่พบข้อมูลเชิงโครงสร้างที่สามารถแสดงได้จากเนื้อหานี้',
      missingNoticeNo: 'ขาด noticeNo',
    },
    smartPricing: {
      pageTitle: 'กำหนดราคาอัจฉริยะ',
      empty: 'ยังไม่มีการแจ้งเตือนการตั้งราคาอัจฉริยะล่าสุด',
      peerHotelMonitor: {
        title: 'ตรวจสอบราคาดึงดูดลูกค้าของคู่แข่ง',
        refresh: 'รีเฟรช',
        meituan: 'Meituan',
        empty: 'ไม่มีข้อมูลราคาดึงดูดลูกค้าของคู่แข่ง',
        unnamedHotel: 'โรงแรมคู่แข่งที่ไม่มีชื่อ',
        crawlSubmitted: 'โปรดรีเฟรชหน้าเว็บภายหลังเพื่อดูข้อมูล',
      },
    },
    futurePricing: { realtimeTab: 'รายงานกำหนดราคาแบบเรียลไทม์', futureTab: 'รายงานกำหนดราคาในอนาคต', reportTitle: 'รายงานกำหนดราคาประเภทห้องในอนาคต', reportTip: 'แสดงคำแนะนำและการวิเคราะห์ราคาที่ตรึงไว้สำหรับ 14 วันข้างหน้า', empty: 'ไม่มีรายงานกำหนดราคาในอนาคต', hotelOverview: 'ภาพรวมการกำหนดราคาในอนาคต', priceSource: 'แหล่งที่มาของราคา', pricingBusinessDate: 'วันธุรกิจที่กำหนดราคา', forecastDateRange: 'ช่วงวันที่คาดการณ์', to: 'ถึง', confidence: 'ความเชื่อมั่น 14 วัน', dailyEmpty: 'ไม่มีผลการกำหนดราคารายวัน', analysis: 'การวิเคราะห์', aiDecision: 'การตัดสินใจ AI', decisionSummary: 'สรุปการตัดสินใจ', pricingFactors: 'ปัจจัยราคา', noFactor: 'ไม่มีรายละเอียดปัจจัย', status: 'สถานะ', priceImpact: 'ผลกระทบต่อราคา', reason: 'เหตุผล', conclusion: 'ข้อสรุป', tradeoff: 'การชั่งน้ำหนัก', riskReminder: 'การแจ้งเตือนความเสี่ยง', noRisk: 'ไม่มีการแจ้งเตือนความเสี่ยง', severity: 'ความรุนแรง', suggestion: 'คำแนะนำ', sellDate: 'วันที่ขาย', algorithmReferencePrice: 'ราคาอ้างอิงอัลกอริทึม', aiRecommendedPrice: 'ราคาแนะนำ AI', historicalExpectedOcc: 'OCC คาดการณ์ตามประวัติ', historicalExpectedRevpar: 'RevPAR คาดการณ์ตามประวัติ', holidayEvent: 'วันหยุด / กิจกรรม', systemRisk: 'ความเสี่ยงระบบ', yes: 'ใช่', no: 'ไม่', legalHoliday: 'วันหยุดตามกฎหมาย', weekendPeak: 'ช่วงสุดสัปดาห์', normalDate: 'วันปกติ', reportGeneratedAt: 'เวลาสร้างรายงาน', listEmpty: 'ไม่มีรายงานกำหนดราคาในอนาคตที่เสร็จสิ้น', selectDate: 'เลือกวันที่', dailyAverageOrders: 'ยอดสั่งซื้อเฉลี่ยต่อวัน 7 วันล่าสุด', viewAllReports: 'ดูรายงานทั้งหมด', backToAllReports: 'กลับไปรายการรายงาน', realtimeListEmpty: 'ไม่มีรายงานกำหนดราคาประเภทห้องที่เสร็จสิ้น' },
    futurePricingCalendar: { calendarTitle: 'ปฏิทินการกำหนดราคาประเภทห้องในอนาคต', roomType: 'ประเภทห้อง', expectedOcc: 'OCC ที่คาดการณ์', expectedRevpar: 'RevPAR ที่คาดการณ์', pricingBasis: 'เกณฑ์การกำหนดราคา', dataIntegrityRisk: 'คำเตือนความครบถ้วนของข้อมูล / ความเสี่ยง', highRisk: 'ความเสี่ยงสูง', calendarEmpty: 'ไม่มีข้อมูลปฏิทินการกำหนดราคาในอนาคต', priceUp: 'ปรับขึ้น', priceDown: 'ปรับลง', priceHold: 'คงเดิม', overallPricingBasis: 'เกณฑ์การกำหนดราคาโดยรวม', roomOverallRisk: 'การแจ้งเตือนความเสี่ยงโดยรวมของประเภทห้อง', dailyRiskReminder: 'การแจ้งเตือนความเสี่ยงรายวัน' },
    storeManagerReport: {
      pageTitle: 'รายงานผู้จัดการร้าน',
      pageDesc: 'ดูผลรายงานล่าสุดแบบรายวัน รายสัปดาห์ และรายเดือน',
      dailyButton: 'รายวัน',
      weeklyButton: 'รายสัปดาห์',
      monthlyButton: 'รายเดือน',
      datePlaceholder: 'เลือกวันที่',
      empty: 'ไม่มีรายงานผู้จัดการร้านล่าสุดในช่วงเวลาที่เลือก',
      contentTitle: 'เนื้อหารายงาน',
      contentTip: 'แสดงเนื้อหารายงานล่าสุดตามต้นฉบับ',
      analysisTitle: 'การวิเคราะห์แบบมีโครงสร้าง',
      analysisTip: 'แสดงรายงานตามส่วนที่มีโครงสร้าง',
      monthLabel: '{year}-{month}',
      weekLabel: '{start} ถึง {end}',
      dailyTitle: 'รายงานร้านรายวัน',
      weeklyTitle: 'รายงานร้านรายสัปดาห์',
      monthlyTitle: 'รายงานร้านรายเดือน',
      periodLabel: 'ช่วงเวลา: {range}',
    },
    storeDiagnosis: {
      pageTitle: 'วิเคราะห์ร้าน',
      pageDesc: 'รายงานวิเคราะห์ร้านหนึ่งฉบับต่อวัน สร้างอัตโนมัติจากข้อมูลคงที่และรีวิว 31 วันล่าสุด สร้างได้วันละ 1 ครั้ง หน้านี้แสดงผลล่าสุด',
      refresh: 'รีเฟรช',
      generate: 'สร้างรายงานวิเคราะห์',
      hotelInfoIncomplete: 'ข้อมูลโรงแรมไม่ครบถ้วน กรุณายืนยันว่าเข้าสู่ระบบและเลือกโรงแรมแล้ว',
      emptyTitle: 'ยังไม่มีรายงานวิเคราะห์',
      emptyDesc: 'เมื่อโปรไฟล์โรงแรม ประเภทห้อง รูปภาพ และข้อมูลที่เกี่ยวข้องครบ ระบบจะเริ่มวิเคราะห์ด้วย AI อัตโนมัติ หลังสร้างแล้วไม่สามารถทำซ้ำได้',
      emptyMeta: 'รหัสโรงแรม {hotelCode}  ชุดข้อมูล {batchNo}',
      taskInfo: 'งาน',
      batch: 'ชุดข้อมูล',
      todayTask: 'งานวันนี้',
      preparingData: 'กำลังเตรียมข้อมูล',
      generating: 'กำลังสร้างรายงานวิเคราะห์',
      failedNoRetry: 'ล้มเหลว ไม่สามารถสร้างซ้ำได้',
      generated: 'สร้างแล้ว',
      notGenerated: 'ยังไม่สร้าง สามารถสร้างเองได้',
      noReport: 'ยังไม่มีรายงาน',
      latestDone: 'รายงานล่าสุดเสร็จแล้ว',
      latestFailed: 'รายงานล่าสุดล้มเหลว',
      done: 'เสร็จสิ้น',
      failed: 'สร้างไม่สำเร็จ',
      statusWait: '1 / รอตรวจสอบ',
      statusDiagnosing: '2 / กำลังวิเคราะห์',
      statusDone: '3 / เสร็จสิ้น',
      statusFailed: '4 / ล้มเหลว',
      metaStatus: 'สถานะ',
      failSummary: 'สรุปความล้มเหลว',
      currentStage: 'ขั้นตอนปัจจุบัน',
      crawlRetry: 'จำนวนลองรวมข้อมูล',
      diagnoseDone: 'วิเคราะห์เสร็จแล้ว',
      diagnosingStage: 'กำลังสร้างรายงานวิเคราะห์',
      generateFailedShort: 'สร้างไม่สำเร็จ',
      failTitle: 'การวิเคราะห์ยังไม่เสร็จ',
      failMessageToday: 'การรวมข้อมูลหรือการสร้างด้วย AI ล้มเหลว วันนี้ไม่สามารถสร้างซ้ำได้',
      failMessageLatest: 'การวิเคราะห์ล่าสุดล้มเหลว รายงานวันนี้ยังไม่ถูกสร้าง และสามารถสร้างเองได้',
      failHintToday: 'วันนี้ไม่สามารถสร้างซ้ำได้ ลองใหม่ในวันถัดไป หรือติดต่อฝ่ายปฏิบัติการ',
      failHintLatest: 'ด้านบนเป็นบันทึกความล้มเหลวล่าสุด รายงานวันนี้ยังไม่ถูกสร้าง กรุณากดสร้างรายงานวิเคราะห์',
      stepCrawl: '1. เริ่มรวมข้อมูล',
      stepSuccess: '2. รวมข้อมูลสำเร็จ',
      stepSync: '3. ซิงก์ข้อมูล',
      stepAdp: '4. เริ่มวิเคราะห์',
      progressDiagnosing: 'รวมและซิงก์ข้อมูลเสร็จแล้ว กำลังสร้างรายงานวิเคราะห์',
      progressWait: 'กำลังดึงโปรไฟล์ Meituan/Ctrip ประเภทห้อง และรูปภาพ จะเริ่มวิเคราะห์อัตโนมัติเมื่อข้อมูลครบ',
      reportPending: 'รายงานยังไม่พร้อม จะเริ่มวิเคราะห์อัตโนมัติเมื่อข้อมูลครบ สามารถออกจากหน้าแล้วกลับมาดูภายหลัง',
      reportGenerating: 'กำลังสร้างรายงานวิเคราะห์ กรุณารอสักครู่…',
      reportBody: 'เนื้อหารายงานวิเคราะห์',
      reportEmpty: 'เนื้อหารายงานว่างเปล่า',
      generateSuccess: 'สร้างงานวิเคราะห์แล้ว กำลังเตรียมข้อมูล',
      retryCount: '{count} / {max}',
    },
    structured: {
      channelAnalysis: 'การวิเคราะห์ช่องทาง',
      roomTypeAnalysis: 'การวิเคราะห์ประเภทห้อง',
      commentAnalysis: 'การวิเคราะห์ความคิดเห็น',
      marketAnalysis: 'ความนิยมตลาด / ย่านการค้า',
      momLabel: 'เทียบเดือนก่อน: ',
      yoyLabel: 'เทียบปีก่อน: ',
      dayMomLabel: 'เทียบช่วงก่อนหน้า: ',
      dayYoyLabel: 'เทียบรายสัปดาห์: ',
      weekMomLabel: 'เทียบช่วงก่อนหน้า: ',
      weekYoyLabel: 'เทียบรายเดือน: ',
      monthMomLabel: 'เทียบช่วงก่อนหน้า: ',
      monthYoyLabel: 'เทียบรายปี: ',
      channel: 'ช่องทาง',
      revenue: 'รายได้',
      roomNight: 'จำนวนคืนห้อง',
      channelShare: 'สัดส่วนช่องทาง',
      roomTypeName: 'ประเภทห้อง',
      totalRooms: 'จำนวนห้องทั้งหมด',
      soldRoomNights: 'จำนวนคืนห้องที่ขายได้',
      totalRoomRevenue: 'รายได้ค่าห้องรวม',
      occupancyRate: 'อัตราการเข้าพัก',
      averageRoomRate: 'ADR',
      disabledRooms: 'ห้องที่ปิดใช้งาน',
      commentType: 'ประเภทความคิดเห็น',
      count: 'จำนวน',
      share: 'สัดส่วน',
      goodMediumBad: 'ดี / กลาง / แย่',
      goodRate: 'สัดส่วนรีวิวเชิงบวก',
      eventName: 'ชื่อเหตุการณ์',
      eventFallback: 'เหตุการณ์',
      summaryAnalysis: 'การวิเคราะห์ภาพรวม',
      goodComment: 'รีวิวดี',
      mediumComment: 'รีวิวปานกลาง',
      badComment: 'รีวิวแย่',
      channelRevenueChart: 'รายได้ตามช่องทาง',
      roomTypeRevenueChart: 'รายได้ตามประเภทห้อง',
    },
    revenueManager: {
      pageTitle: 'ผู้จัดการรายได้',
      adviceTitle: 'คำแนะนำการดำเนินงานจาก AI',
      pendingCount: 'รอดำเนินการ {count} รายการ',
      trafficTitle: 'การติดตามทราฟฟิก',
      trafficSubtitle: 'AI คาดการณ์ · อัปเดตแบบเรียลไทม์',
      selectDate: 'เลือกวันที่',
      todayShortcut: 'วันนี้',
      allDay: 'ทั้งวัน',
      timeLabel: 'เวลา',
      storeTrafficLabel: 'ทราฟฟิกของโรงแรม',
      orderLabel: 'คำสั่งซื้อ',
      orderCount: '{count} ออเดอร์',
      summaryNote: 'ช่องทาง {channel} · อัปเดตเวลา {time}',
      forecastLabel: 'คาดการณ์ทั้งวัน (โมเดล AI)',
      meituanForecast: 'คาดการณ์ทราฟฟิก Meituan',
      ctripForecast: 'คาดการณ์ทราฟฟิก Ctrip',
      allDayVisit: 'จำนวนเข้าชมทั้งวัน',
      occLabel: 'อัตราการเข้าพัก',
      roomNightLabel: 'จำนวนคืนห้อง',
      revenueLabel: 'รายได้',
      analysisTag: 'การวิเคราะห์ AI',
      defaultStrategyTag: 'กลยุทธ์การตั้งราคา',
      collapse: 'ย่อ',
      expandMore: 'ดูเพิ่มเติม',
      badReviewLoading: 'กำลังโหลดคำตอบสำหรับรีวิวเชิงลบ...',
      badReviewReply: 'คำตอบ',
      badReviewEmpty: 'ไม่มีเนื้อหาคำตอบสำหรับรีวิวเชิงลบ',
      realtimeTitle: 'ภาพรวมแบบเรียลไทม์',
      revenueForecastTitle: 'คาดการณ์รายได้ ({range})',
      occForecastTitle: 'คาดการณ์อัตราการเข้าพัก ({range})',
      aiForecastBadge: 'AI Forecast',
      todayForecast: 'คาดการณ์วันนี้ {value}',
      peakLabel: 'จุดสูงสุด',
      channelMeituan: 'Meituan',
      channelCtrip: 'Ctrip',
      hours1: '1 ชั่วโมงล่าสุด',
      hours3: '3 ชั่วโมงล่าสุด',
      hours5: '5 ชั่วโมงล่าสุด',
      hours12: '12 ชั่วโมงล่าสุด',
      yesterdayValue: 'เมื่อวาน {value}',
      futureSevenDays: '7 วันข้างหน้า',
      dailyAdviceTitle: 'คำแนะนำ AI รายวัน {date}',
      allDayAdviceTitle: 'คำแนะนำ AI ตลอดวัน',
      hoursAdviceTitle: 'คำแนะนำ AI ช่วง {hours} ชั่วโมงล่าสุด',
      adrForecastLabel: 'คาดการณ์ ADR ',
      defaultAdviceDetail: 'แนะนำให้ปรับราคาห้องและกลยุทธ์การขายตามความต้องการปัจจุบัน',
      displayDate: '{year}-{month}-{day}',
      roomNightValue: '{count} ห้อง',
      revenueInsightCollapse: 'ยุบคำอธิบายการวิเคราะห์รายได้ AI',
      revenueInsightExpand: 'ขยายคำอธิบายการวิเคราะห์รายได้ AI',
      forecastForDate: 'คาดการณ์วันที่ {date}: {value}',
      revenueInsightTitle: 'คำอธิบายการวิเคราะห์รายได้ AI',
      revenueInsightJudgment: 'การประเมินรายได้',
      revenueInsightKeySteps: 'เหตุผลสำคัญ',
      revenueInsightRisks: 'การแจ้งเตือนความเสี่ยง',
      revenueInsightRecommendations: 'คำแนะนำการดำเนินงาน',
      metricTips: {
        traffic: {
          meituan: { title: 'คำอธิบายทราฟฟิก Meituan', p1: 'ทราฟฟิก Meituan แสดงการเข้าชมโรงแรมจากช่องทาง Meituan ในช่วงเวลาที่เลือก', p2: 'ระบบพิจารณาผลการดำเนินงานในอดีต แนวโน้มล่าสุด การเข้าชมที่เกิดขึ้นวันนี้ และวันหยุด', p3: 'เหมาะสำหรับดูแนวโน้มรายช่วงเวลาและความผันผวน ไม่ใช่ยอดสะสมสุดท้ายของทั้งวัน' },
          ctrip: { title: 'คำอธิบายทราฟฟิก Ctrip', p1: 'ทราฟฟิก Ctrip แสดงการเข้าชมโรงแรมจากช่องทาง Ctrip ในช่วงเวลาที่เลือก', p2: 'ระบบอ้างอิงวันในอดีตที่คล้ายกัน ผลการดำเนินงานของช่องทางล่าสุด การเปลี่ยนแปลงแบบเรียลไทม์ และวันหยุด', p3: 'ควรดูร่วมกับการเปลี่ยนแปลงของคำสั่งซื้อเพื่อประเมินการเปลี่ยนทราฟฟิกเป็นการจอง' },
          order: { title: 'คำอธิบายคำสั่งซื้อ', p1: 'คำสั่งซื้อแสดงการเปลี่ยนแปลงของการจองที่เกิดขึ้นตามช่องทาง วันที่ และช่วงเวลาปัจจุบัน', p2: 'ตัวชี้วัดนี้สะท้อนการเปลี่ยนเป็นการจองแบบเรียลไทม์ตามตัวกรองที่เลือก', p3: 'หากความผันผวนระยะสั้นสูง ควรดูร่วมกับการคาดการณ์ทั้งวันและผลการดำเนินงานในอดีต' },
        },
        hotelForecast: {
          meituan: { title: 'คำอธิบายคาดการณ์ทราฟฟิก Meituan', p1: 'เป็นการประมาณจำนวนการเข้าชมรวมของช่องทาง Meituan ในวันนี้', p2: 'ระบบใช้ข้อมูลทราฟฟิกในอดีต การเปลี่ยนแปลงของช่องทาง ผลงานวันนี้ วันหยุด และจังหวะการดำเนินงาน', p3: 'ใช้คาดการณ์ความร้อนแรงของความต้องการล่วงหน้าและช่วยวางแผนราคา จำนวนห้อง และการดำเนินงาน' },
          ctrip: { title: 'คำอธิบายคาดการณ์ทราฟฟิก Ctrip', p1: 'เป็นการประมาณจำนวนการเข้าชมรวมของช่องทาง Ctrip ในวันนี้', p2: 'ระบบใช้วันในอดีตที่คล้ายกัน แนวโน้มล่าสุด ผลงานแบบเรียลไทม์วันนี้ และวันหยุด', p3: 'ใช้ดูความต้องการที่อาจเกิดขึ้นและเปรียบเทียบกับการคาดการณ์ของ Meituan' },
          occ: { title: 'คำอธิบายอัตราการเข้าพัก', p1: 'อัตราการเข้าพักคือสัดส่วนห้องที่คาดว่าจะขายได้ในวันนี้', p2: 'ระบบพิจารณาอัตราการเข้าพักในอดีต จังหวะการจองล่าสุด ทราฟฟิกและคำสั่งซื้อวันนี้ และวันหยุด', p3: 'ใช้ประเมินแรงกดดันการเข้าพัก ความเสี่ยงห้องคงเหลือ และทิศทางการปรับราคาหรือโปรโมชัน' },
          roomNights: { title: 'คำอธิบายจำนวนคืนห้อง', p1: 'จำนวนคืนห้องคือจำนวนคืนห้องที่คาดว่าจะขายได้ในวันนี้', p2: 'ระบบอ้างอิงยอดขายในอดีต จังหวะการจองล่าสุด ทราฟฟิกและคำสั่งซื้อวันนี้ และวันหยุด', p3: 'ควรดูร่วมกับอัตราการเข้าพักเพื่อประเมินความเร็วในการขายห้อง' },
          adr: { title: 'คำอธิบาย ADR', p1: 'ADR คือราคาเฉลี่ยต่อห้องที่ขายได้ซึ่งคาดการณ์สำหรับวันนี้', p2: 'ระบบใช้ราคาในอดีต รายการขายล่าสุด ความต้องการวันนี้ และวันหยุด', p3: 'ควรดูร่วมกับอัตราการเข้าพักและรายได้ เพื่อหลีกเลี่ยงการมุ่งเฉพาะอัตราการเข้าพัก' },
          revenue: { title: 'คำอธิบายรายได้', p1: 'รายได้คือรายได้จากการขายห้องที่คาดการณ์สำหรับวันนี้', p2: 'ระบบรวมจำนวนคืนห้องและ ADR ที่คาดการณ์ ผลงานในอดีต ความต้องการล่าสุด และวันหยุด', p3: 'ใช้ประเมินว่าผลการดำเนินงานเป็นไปตามเป้าหมายและค้นหาโอกาสเพิ่มรายได้' },
        },
        futureRevenue: { title: 'คำอธิบายคาดการณ์รายได้', p1: 'คาดการณ์รายได้แสดงรายได้ห้องพักรายวันสำหรับ 7 วันข้างหน้า', p2: 'ระบบพิจารณาผลการดำเนินงานในอดีต การจองล่าสุด ทราฟฟิกและคำสั่งซื้อ ผลงานวันนี้ และวันหยุด', p3: 'ใช้ระบุวันความต้องการสูงและต่ำเพื่อวางแผนราคา จำนวนห้อง และการดำเนินงาน' },
        occRevenue: { title: 'คำอธิบายคาดการณ์อัตราการเข้าพัก', p1: 'คาดการณ์อัตราการเข้าพักแสดงสัดส่วนห้องที่คาดว่าจะขายได้ในแต่ละวันของ 7 วันข้างหน้า', p2: 'ระบบอ้างอิงอัตราการเข้าพักในอดีต การจองล่าสุด ทราฟฟิกช่องทาง คำสั่งซื้อ การเปลี่ยนแปลงวันนี้ และวันหยุด', p3: 'ใช้ระบุความเสี่ยงขายหมดหรือการเข้าพักไม่เพียงพอล่วงหน้า และวางแผนราคาและโปรโมชัน' },
      },
    },
  },
  route: {
    ai: 'AI',
    aiRevenueManager: 'ผู้จัดการรายได้',
    aiSmartPricing: 'กำหนดราคาอัจฉริยะ',
    aiNoticeCenter: 'ศูนย์การแจ้งเตือน',
    aiStoreManagerReport: 'รายงานผู้จัดการร้าน',
    aiStoreDiagnosis: 'วิเคราะห์ร้าน',
    aiNoticeDetail: 'รายละเอียดการแจ้งเตือน',
    aiConfig: 'AI Configuration',
    businessLog: 'บันทึกการเปลี่ยนวันดำเนินงาน',
    nightAuditLog: 'บันทึกการตรวจสอบกลางคืน',
    turnoverSubmit: 'รายได้จากการดำเนินธุรกิจ',
    channelConfig: 'การตั้งค่าช่องทาง',
  },
  systemsetNotice: {
    systemMessageReminder: 'การแจ้งเตือนข้อความระบบ',
    messageReminderSettingsAtLeastOneItem: 'การตั้งค่าการแจ้งเตือน (เลือกอย่างน้อยหนึ่งรายการ)',
    hourlyRoomCheckoutMessage: 'ข้อความแจ้งเตือนเช็คเอาท์ห้องรายชั่วโมง',
    fullDayCheckoutMessage: 'ข้อความแจ้งเตือนเช็คเอาท์ห้องเต็มวัน',
    messageVoiceReminder: 'การแจ้งเตือนด้วยเสียง',
    onlineChannelNewOrderReminder: 'แจ้งเตือนคำสั่งซื้อใหม่จากช่องทางออนไลน์',
    onlineChannelOrderCancellationReminder: 'แจ้งเตือนการยกเลิกคำสั่งซื้อจากช่องทางออนไลน์',
    hourlyRoomCheckoutReminder: 'การแจ้งเตือนเช็คเอาท์ห้องรายชั่วโมง',
    fullDayCheckoutReminder: 'การแจ้งเตือนเช็คเอาท์ห้องเต็มวัน',
    operationFailed: 'การดำเนินการล้มเหลว',
    thirtyMinutesBeforeCheckout: '30 นาทีก่อนเช็คเอาท์',
    fifteenMinutesBeforeCheckout: '15 นาทีก่อนเช็คเอาท์',
    atCheckoutTime: 'ขณะเช็คเอาท์',
    checkoutTimeUpdated: 'อัปเดตเวลาแจ้งเตือนเช็คเอาท์สำเร็จ',
    voiceSettingUpdated: 'อัปเดตสถานะการแจ้งเตือนด้วยเสียงสำเร็จ',
  },
  binding: {
    publicAccountMessageReminder: 'การแจ้งเตือนข้อความบัญชีสาธารณะ',
    scanToBindUser: 'สแกนเพื่อผูกผู้ใช้งาน',
    cancelEdit: 'ยกเลิกการแก้ไข',
    allMembers: 'สมาชิกทั้งหมด',
    scanToBindTitle: 'สแกนเพื่อผูกบัญชีสาธารณะ',
    scanWithWechat: 'กรุณาใช้ WeChat สแกนเพื่อผูกบัญชี',
    qrCodeGenerateFail: 'สร้างคิวอาร์โค้ดล้มเหลว กรุณาลองใหม่ภายหลัง',
    unbindSuccess: 'ยกเลิกการผูกสำเร็จ!',
    unbindFail: 'ยกเลิกการผูกล้มเหลว กรุณาลองใหม่',
    confirmCloseQrDialog: 'ต้องการปิดหน้าต่างคิวอาร์โค้ดหรือไม่?',
    orderCreate: 'คำสั่งซื้อใหม่',
    orderCancel: 'ยกเลิกคำสั่งซื้อ',
    orderConfirm: 'คำสั่งซื้อรอการยืนยัน',
    orderCheckOutTip: 'ก่อนเช็คเอาท์',
    orderCheckOut: 'เช็คเอาท์',
    orderCreateEbk: 'สร้างคำสั่ง EBK ใหม่',
    orderCancelEbk: 'ยกเลิกคำสั่ง EBK',
    roomCleanDone: 'ทำความสะอาดห้องเสร็จสิ้น',
    ebAccountOffline: 'บัญชี EB ออฟไลน์',
    computerHardwareOffline: 'ฮาร์ดแวร์คอมพิวเตอร์ออฟไลน์',
    ebWarnNotice: 'เตือนการจองห้องเกิน-capacity',
  },
  writeDoorCardIndex: {
    preIssuedDoorCard: 'บัตรประตูที่สร้างล่วงหน้า',
    effectiveTime: 'เวลาเริ่มมีผล',
    expiryTime: 'เวลาหมดอายุ',
    viewPassword: 'ดูรหัสผ่าน',
    passwordStatusNotSent: 'ยังไม่ได้ส่ง',
    passwordStatusSending: 'กำลังส่ง',
    passwordStatusSent: 'ส่งสำเร็จ',
    passwordStatusFailed: 'ส่งล้มเหลว',
    generatePasswordOnly: 'สร้างรหัสผ่านเท่านั้น',
    generateAndSendPassword: 'สร้างและส่งรหัสผ่าน',
    getLockInfoFailed: 'ดึงข้อมูลประตูห้องล้มเหลว',
    makeCardFailedPrefix: 'สร้างบัตรล้มเหลว：',
    deactivateFailedPrefix: 'ยกเลิกบัตรล้มเหลว：',
    pleaseEnterValidPhoneNumber: 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
    passwordSendSuccess: 'ส่งรหัสผ่านสำเร็จ',
    roomPasswordGeneratedAndSent: 'สร้างและส่งรหัสผ่านห้องให้แขกแล้ว กรุณาแจ้งแขกให้ตรวจสอบ SMS',
    roomPasswordGenerated: 'สร้างรหัสผ่านห้องสำเร็จ',
    invalidTimeString: 'รูปแบบเวลาไม่ถูกต้อง',
    temporaryMakeCard: 'ออกบัตรชั่วคราว',
    validDoorCard: 'บัตรประตูที่ยังใช้งานได้',
    makeCardLogTitle: 'บันทึกการทำบัตร',
    makeType: 'ประเภทบัตร',
    operationResult: 'ผลการดำเนินการ',
    createTime: 'เวลาที่สร้าง',
  },
  operating: {
    total: 'รวม',
    index: 'ลำดับ',
    businessDay: 'วันทำการ',
    totalAccount: 'บัญชีรวม',
    totalOcc: 'อัตราการเข้าพักรวม (%)',
    fullDayOcc: 'อัตราการเข้าพักเต็มวัน (%)',
    hourDayOcc: 'อัตราการเข้าพักรายชั่วโมง (%)',
    avgPrice: 'ราคาเฉลี่ยต่อคืน ',
    revPar: 'รายได้ต่อห้องพัก ',
    totalRoomNight: 'คืนห้องรวม (ห้อง)',
    fullDayRoomNight: 'คืนห้องเต็มวัน',
    busLongRoomNight: 'คืนห้องระยะยาว',
    hourRoomNight: 'คืนห้องรายชั่วโมง',
    teamRoomNight: 'คืนห้องกลุ่ม',
    freeRoomNight: 'คืนห้องฟรี',
    privateRoomNight: 'คืนห้องใช้ส่วนตัว',
    houseRent: 'รายได้จากค่าห้อง',
    smallGoods: 'สินค้าขายปลีก',
    meals: 'ค่าอาหาร',
    serviceFee: 'ค่าบริการ',
    memberFee: 'ค่าสมาชิก',
    otherFee: 'ค่าบริการอื่น ๆ',
    generalIncome: 'รายได้รวม',
    roomNight: 'จำนวนคืนห้อง',
    avgRoomPrice: 'ราคาเฉลี่ยต่อห้อง',
    totalHouseRent: 'ยอดรวมค่าห้อง',
    rentalRate: 'อัตราการเข้าพัก (%)',
    roomNightProportion: 'สัดส่วนคืนห้อง (%)',
    calcFormula: 'สูตรคำนวณ',
    known: 'รับทราบ',
  },
  incomeIncomesum: {
    pleaseCheckTheStartAndEndTimesOfTheSearch: 'กรุณาตรวจสอบวันเริ่มต้นและวันสิ้นสุดการค้นหา',
    roomRateIncome: 'รายได้จากราคาห้อง',
    smallwareIncome: 'รายได้จากสินค้าขายปลีก',
    mealFeeIncome: 'รายได้จากค่าอาหาร',
    reportTitle: 'รายงานสรุปรายได้',
    cooperationModel: 'การทำงาน',
    status: 'สถานะ',
    roomsCount: 'จำนวนห้องจริง',
    startBusiness: 'วันเริ่มต้นทำการ',
  },
  commonImportDialog: {
    tip: 'กรุณาจัดข้อมูลตามข้อกำหนดในแม่แบบ',
    downloadTemplate: 'ดาวน์โหลดแม่แบบ',
    removeFileConfirm: 'ยืนยันการลบ',
    limitOneFile: 'เลือกได้เพียง 1 ไฟล์ กรุณาลบไฟล์เก่าเพื่อเพิ่มใหม่',
    uploadError: 'อัปโหลดล้มเหลว กรุณาลองใหม่',
    reupload: 'อัปโหลดอีกครั้ง',
  },
  orderAntiflyRoom: {
    powerOnTime: 'เวลาจ่ายไฟ',
    powerOffTime: 'เวลาตัดไฟ',
    isAntifly: 'ตรวจสอบการขายห้องพักโดยไม่ลงบันทึก (Fly Room)',
    powerDuration: 'ระยะเวลาที่ใช้ไฟ',
  },
  roomOccupiedDetail: {
    title: 'รายละเอียดการเข้าพัก',
    unassigned: 'ยังไม่จัดห้อง',
    roomOrderNo: 'เลขที่ใบจองห้อง',
    roomCount: 'จำนวนห้อง',
    roomType: 'ประเภทห้อง',
    roomNo: 'เลขห้อง',
    contact: 'ผู้ติดต่อ',
    arrival: 'เช็คอิน',
    departure: 'เช็คเอาท์',
    orderAndPayStatus: 'สถานะคำสั่งซื้อ (การชำระเงิน)',
    unpaidOrderNotAllowed: 'ไม่สามารถดำเนินการคำสั่งซื้อที่ยังไม่ชำระเงิน',
    invalidRoomOrderOperation:
      'คำสั่งซื้อที่ยังไม่ชำระเงิน รอเช็คอิน หรือยังไม่จัดห้อง ไม่สามารถดำเนินการได้',
  },
  hardware: {
    smartRoomControl: 'ระบบควบคุมห้องอัจฉริยะ',
    smartRoomControlDesc: 'รองรับการควบคุมอุปกรณ์อัจฉริยะภายในห้องจากระยะไกล',
    smartRoomControlSetting: 'ตั้งค่าระบบควบคุมห้องอัจฉริยะ',
    appKey: 'App Key',
    appKeyPlaceholder: 'กรุณากรอก App Key',
    appSecret: 'App Secret',
    appSecretPlaceholder: 'กรุณากรอก App Secret',
    thirdHotel: 'โรงแรมบุคคลที่สาม',
    thirdHotelPlaceholder: 'กรุณากรอกโรงแรมบุคคลที่สาม',
    thirdGroup: 'กลุ่มบุคคลที่สาม',
    thirdGroupPlaceholder: 'กรุณากรอกกลุ่มบุคคลที่สาม',
    enable: 'เปิดใช้งาน',
    disable: 'ปิดใช้งาน',
    deviceType: 'ประเภทอุปกรณ์',
    fullDayAutoOff: 'ตั้งเวลาให้ห้องเต็มวันตัดไฟเมื่อถึงเวลา預離',
    hourAutoOff: 'ตั้งเวลาให้ห้องรายชั่วโมงตัดไฟเมื่อถึงเวลา預離',
  },
  lockpwd: {
    makeCardLogTitle: 'บันทึกการทำบัตรห้อง',
    operationType: 'ประเภทการดำเนินการ',
    operationTime: 'เวลาการดำเนินการ',
    makeCard: 'ทำบัตร',
    cancelCard: 'ยกเลิกบัตร',
    roomTypeCode: 'รหัสประเภทห้อง',
    roomTypeName: 'ชื่อประเภทห้อง',
    roomNumber: 'หมายเลขห้อง',
    lockBrandName: 'ยี่ห้อกุญแจประตู',
    lockId: 'รหัสกุญแจ',
    orderRoomNo: 'หมายเลขคำสั่งห้อง',
    operator: 'ผู้ดำเนินการ',
    makeType: 'ประเภทบัตร',
    validPeriod: 'ระยะเวลาที่บัตรใช้ได้',
    operationResult: 'ผลการดำเนินการ',
    errorMessage: 'ข้อมูลข้อผิดพลาด',
  },
  roomType: {
    createBundleRoomType: 'สร้างประเภทห้องแบบแพ็กเกจ',
    roomTypeName: 'ชื่อประเภทห้อง',
    relatedRoomTypes: 'ประเภทห้องที่เกี่ยวข้อง',
    relateRoom: 'เชื่อมโยงห้องพัก',
    selectedRooms: 'ห้องที่เลือกแล้ว',
  },

  turnoverSubmit: {
    summaryLoadFailed: 'โหลดข้อมูลการนำส่งรายได้ล้มเหลว หน้านี้ถูกปิดการใช้งานชั่วคราว',
    reload: 'โหลดใหม่',
    initBeforeUse: 'กรุณาตั้งค่ายอดคงเหลือในลิ้นชักเงินก่อนใช้งานครั้งแรก',
    initCashier: 'ตั้งค่าลิ้นชักเงิน',
    submitManage: 'จัดการการนำส่งรายได้',
    summaryTipPrefix: 'หมายเหตุ: ข้อมูลการใช้จ่ายและการชำระเงินที่นับที่นี่มาจาก',
    to: 'ถึง',
    summaryTipSuffix: '',
    consumeSubject: 'รายการการใช้จ่าย',
    paymentSubject: 'รายการการชำระเงิน',
    serialNumber: 'ลำดับ',
    subtotal: 'ยอดรวมย่อย',
    subject: 'รายการ',
    amount: 'จำนวนเงิน',
    dataSummary: 'สรุปข้อมูล',
    lastBalanceSummary: 'ยอดคงเหลือลิ้นชักเงินงวดก่อน: {total} = เงินสด({cash}) + บัตรธนาคาร({bankCard}) + อื่นๆ({other})',
    currentAmountSummary: 'ยอดเงินลิ้นชักเงินปัจจุบัน: {total} = เงินสด({cash}) + บัตรธนาคาร({bankCard}) + อื่นๆ({other})',
    currentCash: 'เงินสดในลิ้นชักปัจจุบัน:',
    currentBankCard: 'บัตรธนาคารในลิ้นชักปัจจุบัน:',
    currentOther: 'รายการอื่นในลิ้นชักปัจจุบัน:',
    submitCash: 'นำส่งเงินสด',
    submitBankCard: 'นำส่งบัตรธนาคาร',
    submitOther: 'นำส่งรายการอื่น',
    cashBalance: 'ยอดคงเหลือเงินสด:',
    bankCardBalance: 'ยอดคงเหลือบัตรธนาคาร:',
    otherBalance: 'ยอดคงเหลือรายการอื่น:',
    remark: 'หมายเหตุ:',
    submit: 'นำส่ง',
    submitHistory: 'ประวัติการนำส่ง',
    submitTime: 'เวลานำส่ง',
    startDate: 'วันที่เริ่มต้น',
    endDate: 'วันที่สิ้นสุด',
    operator: 'ผู้ดำเนินการ',
    pleaseEnter: 'กรุณากรอก',
    search: 'ค้นหา',
    export: 'ส่งออก',
    lastCashierBalance: 'ยอดลิ้นชักเงินงวดก่อน',
    cash: 'เงินสด',
    bankCard: 'บัตรธนาคาร',
    other: 'อื่นๆ',
    currentCashierAmount: 'ยอดลิ้นชักเงินงวดนี้',
    currentSubmitAmount: 'ยอดนำส่งงวดนี้',
    currentCashierBalance: 'ยอดคงเหลือลิ้นชักเงินงวดนี้',
    initTipLine1: 'กรุณากรอกยอดลิ้นชักเงินตามจริงในปัจจุบัน',
    initTipLine2: 'หลังตั้งค่า ระบบจะสร้างประวัติพร้อมหมายเหตุ [ข้อมูลตั้งต้น]',
    currentCashierCash: 'เงินสดในลิ้นชักปัจจุบัน',
    currentCashierBankCard: 'บัตรธนาคารในลิ้นชักปัจจุบัน',
    currentCashierOther: 'รายการอื่นในลิ้นชักปัจจุบัน',
    skipInit: 'ยังไม่ตั้งค่า',
    confirmInit: 'ยืนยันการตั้งค่า',
    pleaseEnterAmount: 'กรุณากรอกจำนวนเงิน',
    invalidAmountFormat: 'รูปแบบจำนวนเงินไม่ถูกต้อง รองรับทศนิยมไม่เกิน 2 ตำแหน่ง',
    notGreaterThanCurrentCash: 'ต้องไม่เกิน [เงินสดในลิ้นชักปัจจุบัน]',
    notGreaterThanCurrentBankCard: 'ต้องไม่เกิน [บัตรธนาคารในลิ้นชักปัจจุบัน]',
    notGreaterThanCurrentOther: 'ต้องไม่เกิน [รายการอื่นในลิ้นชักปัจจุบัน]',
    hotelHistoricalTotal: 'ยอดสะสมย้อนหลังของโรงแรม',
    currentTime: 'เวลาปัจจุบัน',
    initBalanceCannotBeNegative: 'ยอดตั้งต้นต้องไม่น้อยกว่า 0',
    cashierInitSuccess: 'ตั้งค่าลิ้นชักเงินสำเร็จ',
    exportFailed: 'ส่งออกล้มเหลว',
    checkSubmitAmount: 'กรุณาตรวจสอบยอดนำส่ง',
    confirmSubmitMessage: 'ยืนยันการนำส่งรายได้ครั้งนี้หรือไม่?',
    tip: 'แจ้งเตือน',
    submitSuccess: 'นำส่งสำเร็จ',
    submitFailed: 'นำส่งล้มเหลว',
    total: 'รวม',
    pushPriceLibrary: 'ส่งราคาและสต็อก',
    pushPriceLibrarySuccess: 'ส่งราคาและสต็อกสำเร็จ',
    pushPriceLibraryFail: 'ส่งราคาและสต็อกล้มเหลว',
  },
  channelConfig: {
    noChannelConfigData: 'ไม่มีข้อมูลการตั้งค่าช่องทาง',
    directConnected: 'เชื่อมต่อโดยตรงแล้ว',
    notDirectConnected: 'ยังไม่เชื่อมต่อโดยตรง',
    roomTypeMatch: 'จับคู่ประเภทห้อง',
    bindNewAccount: 'ผูกบัญชีใหม่',
    openDirectConnection: 'เปิดการเชื่อมต่อโดยตรง',
    meituanHomestayStore: 'ร้าน Meituan Homestay',
    tujiaHomestayAccount: 'บัญชี Tujia Homestay',
    deleteAccount: 'ลบบัญชี',
    noBoundAccount: 'ยังไม่มีบัญชีที่ผูกไว้',
    breakDirectConnection: 'ตัดการเชื่อมต่อ',
    directConnectionStatus: 'สถานะการเชื่อมต่อ',
    channelDiscount: 'ส่วนลดช่องทาง',
    channelCommission: 'ค่าคอมมิชชันช่องทาง',
    qzCommission: 'ค่าคอมมิชชัน Qingzhu',
    meituanRoomType: 'ประเภทห้อง Meituan',
    meituanRoomTypeId: 'รหัสประเภทห้อง Meituan',
    tujiaHouse: 'บ้าน Tujia',
    tujiaHouseId: 'รหัสบ้าน Tujia',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    homestay: 'โฮมสเตย์',
    goodsTypeNormal: 'ผลิตภัณฑ์มาตรฐาน',
    goodsTypeFree: 'ผลิตภัณฑ์ห้องฟรี',
    goodsTypeOnlineHour: 'ห้องรายชั่วโมงออนไลน์',
    goodsTypePresaleFullDay: 'พรีเซลห้องเต็มวัน',
    goodsTypePresaleHour: 'พรีเซลห้องรายชั่วโมง',
    fetchChannelConfigFail: 'ดึงข้อมูลการตั้งค่าช่องทางล้มเหลว',
    goodsTypePrefix: 'ประเภทผลิตภัณฑ์ {type}',
    openDirectSuccess: 'เปิดการเชื่อมต่อโดยตรงสำเร็จ',
    openDirectFail: 'เปิดการเชื่อมต่อโดยตรงล้มเหลว',
    channelNotSupportRoomMatch: 'ช่องทางนี้ยังไม่รองรับการจับคู่ประเภทห้อง',
    fetchRoomMatchFail: 'ดึงข้อมูลการจับคู่ประเภทห้องล้มเหลว',
    pleaseSelectRoomType: 'กรุณาเลือกประเภทห้อง Qingyingbao',
    pleaseSelectProduct: 'กรุณาเลือกผลิตภัณฑ์ Qingyingbao',
    bindFail: 'การผูกไม่สำเร็จ',
    confirmUnbindRoomType: 'ต้องการยกเลิกการผูกประเภทห้องนี้หรือไม่?',
    unbindFail: 'ยกเลิกการผูกไม่สำเร็จ',
    channelNotSupportAccountBind: 'ช่องทางนี้ยังไม่รองรับการผูกบัญชี',
    bindAccountSuccess: 'ผูกบัญชีสำเร็จ',
    bindAccountFail: 'ผูกบัญชีล้มเหลว',
    fetchAccountDetailFail: 'ดึงรายละเอียดบัญชีล้มเหลว',
    confirmDeleteAccount: 'ต้องการลบบัญชีนี้หรือไม่?',
    confirmBreakDirect: 'ต้องการตัดการเชื่อมต่อโดยตรงหรือไม่?',
    breakDirectSuccess: 'ตัดการเชื่อมต่อสำเร็จ',
    breakDirectFail: 'ตัดการเชื่อมต่อล้มเหลว',
    pushPriceLibrary: 'ส่งราคาและสต็อก 90 วัน',
    pushPriceLibrarySuccess: 'ส่งราคาและสต็อกสำเร็จ',
    pushPriceLibraryFail: 'ส่งราคาและสต็อกล้มเหลว',
    pushPriceLibrarySwitch: 'สวิตช์ส่งราคา',
    pushSwitchOnSuccess: 'เปิดสวิตช์ส่งข้อมูลแล้ว',
    pushSwitchOffSuccess: 'ปิดสวิตช์ส่งข้อมูลแล้ว',
    pushSwitchChangeFail: 'เปลี่ยนสวิตช์ส่งข้อมูลล้มเหลว',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: 'แหล่งที่มาของราคา', bookingHourOrderCountTitle: 'จำนวนคำสั่งจองรายชั่วโมง', bookingHourOrderCountNoData: 'ไม่มีข้อมูลคำสั่งจองรายชั่วโมง', bookingHourOrderCountDateRange: '7 วันที่ผ่านมา {start} ถึง {end} | วันนี้ {date}', bookingHourOrderCountDateOnly: 'วันนี้ {date}', bookingHourOrderCountSevenDay: 'คำสั่งจองสะสม 7 วัน', bookingHourOrderCountToday: 'คำสั่งจองวันนี้', bookingHourOrderUnit: 'รายการ', bookingHourOrderAxis: 'คำสั่งจอง', viewTodayReports: 'ดูรายงานวันนี้', backToTodayReports: 'กลับสู่รายงานวันนี้', backToLatestReport: 'กลับสู่รายงานล่าสุด', historyEmpty: 'ไม่มีรายงานการกำหนดราคาอัจฉริยะนี้', todayReportTitle: 'รายงานวันที่ {date}', pricingTime: 'เวลาตั้งราคา', reportTitle: 'ชื่อรายงาน', pricingChannel: 'ช่องทางการตั้งราคา', viewDetail: 'รายละเอียด', todayReportEmpty: 'ไม่มีรายงานการตั้งราคาประเภทห้องที่เสร็จสิ้นในวันนี้',
  },
  commonBook: {
    commonBooking: 'การจองแบบรวม', fitBooking: 'การจองรายบุคคล', longStayBooking: 'การจองระยะยาว', teamBooking: 'การจองแบบกลุ่ม', walkIn: 'ลูกค้า Walk-in', ebkManualMove: 'ย้ายรายการ EBK ด้วยตนเอง',
    sourceType: 'ประเภทแหล่งที่มา', externalChannel: 'ช่องทางภายนอก', channelOrderNo: 'เลขที่คำสั่งซื้อช่องทาง', arrivalTime: 'เวลาเข้าพัก', departureTime: 'เวลาออก', retentionTime: 'เวลาถือห้อง', stayDuration: 'ระยะเวลาพัก', days: 'จำนวนวัน', contact: 'ผู้ติดต่อ', contactPhone: 'โทรศัพท์ผู้ติดต่อ', teamType: 'ประเภทกลุ่ม', teamName: 'ชื่อกลุ่ม', contractNo: 'เลขที่สัญญา',
    paymentInfo: 'ข้อมูลการชำระเงิน', paymentMethod: 'วิธีชำระเงิน', amount: 'จำนวนเงิน', storedValueMember: 'สมาชิกแบบเติมเงิน', paymentCode: 'รหัสยืนยันการชำระเงิน', remark: 'หมายเหตุ', totalRooms: 'จำนวนห้อง', stayDays: 'จำนวนวันที่พัก', taxAmount: 'ภาษี', roomPrice: 'ราคาห้อง', totalPrice: 'ราคารวม', submitBooking: 'ยืนยันการจอง',
    addRoom: 'เพิ่มห้อง', addRoomType: 'เพิ่มประเภทห้อง', roomType: 'ประเภทห้อง', roomStatus: 'สถานะห้อง', room: 'ห้อง', loading: 'กำลังโหลด', noAvailableRoomType: 'ไม่มีประเภทห้องที่เลือกได้', noAvailableRoom: 'ไม่มีห้องว่าง โปรดปรับประเภทหรือสถานะห้อง', noValidRoomType: 'ไม่มีประเภทห้องที่ถูกต้อง', selectedRoomCount: 'เลือกแล้ว {count} ห้อง โปรดเลือกอย่างน้อย 1 ห้อง', emptyClean: 'ห้องว่างสะอาด', emptyDirty: 'ห้องว่างสกปรก', selectRoomType: 'เลือกประเภทห้อง',
    availableRooms: 'จำนวนที่จองได้', breakfast: 'อาหารเช้า', roomCount: 'จำนวนห้อง', bookedRoomCount: 'ห้องที่จอง', walkInRoomCount: 'จำนวนห้องเช็กอิน', arrangeRoom: 'จัดห้อง', dailyPrice: 'ราคารายวัน', unassignedRooms: 'ยังไม่จัด {count} ห้อง', assignedRoom: 'จัดแล้ว {room}', selectedRoom: 'เลือกแล้ว {room}', delete: 'ลบ', to: 'ถึง', addGuest: 'เพิ่มผู้เข้าพัก', channelRoomType: 'ประเภทห้องจากช่องทาง', currencyUnit: 'CNY', tax: 'ภาษี',
    pleaseSelect: 'โปรดเลือก', pleaseEnter: 'โปรดกรอก', enterChannelName: 'กรอกชื่อช่องทาง', cancel: 'ยกเลิก', confirm: 'ยืนยัน', close: 'ปิด', roomDetail: 'รายละเอียดบัญชีห้อง',
    selectSourceType: 'เลือกประเภทแหล่งที่มา', selectMemberInfo: 'เลือกข้อมูลสมาชิก', selectCompany: 'เลือกบริษัทคู่สัญญา', selectStayType: 'เลือกประเภทการเข้าพัก', selectArrivalTime: 'เลือกเวลาเข้าพัก', selectDepartureTime: 'เลือกเวลาออก', enterContact: 'กรอกผู้ติดต่อ', selectTeamType: 'เลือกประเภทกลุ่ม', enterTeamName: 'กรอกชื่อกลุ่ม',
    basePriceMode: 'โหมดราคาฐาน', sellingPriceMode: 'โหมดราคาขาย', useEbkOrderInfo: 'ใช้ข้อมูลคำสั่งซื้อ EB', initializationFailed: 'เริ่มต้นการจองแบบรวมไม่สำเร็จ โปรดปิดแล้วลองใหม่', dictionaryLoadFailed: 'โหลดข้อมูลการจองไม่สำเร็จ', companyNotFound: 'ไม่พบบริษัทคู่สัญญาที่ตรงกัน',
    minimumStayDays: 'สถานการณ์นี้ต้องพักอย่างน้อย {count} วัน', maximumStayDays: 'สถานการณ์นี้พักได้สูงสุด {count} วัน', retentionBeforeArrival: 'เวลาถือห้องต้องไม่ก่อนเวลาเข้าพัก', retentionTooLate: 'เวลาถือห้องเกินเวลาสูงสุดที่อนุญาต', retentionOutOfRange: 'เวลาถือห้องอยู่นอกช่วงที่อนุญาต',
    invalidBreakfast: 'จำนวนอาหารเช้าของ {roomType} ต้องเป็นจำนวนเต็ม 0–999 และห้ามเว้นว่าง', invalidRoomCount: 'จำนวนห้องของ {roomType} ต้องเป็นจำนวนเต็มไม่ติดลบและห้ามเว้นว่าง', enterExternalChannel: 'กรอกชื่อช่องทางภายนอก', invalidHourDuration: 'ระยะเวลาพักต้องเป็นจำนวนเต็ม 1–12 ชั่วโมง', invalidStayDays: 'จำนวนวันที่พักต้องเป็นจำนวนเต็ม {min}–{max}', incompleteStay: '{roomType} มีช่วงเข้าพักไม่สมบูรณ์', arrivalBeforeBusinessDate: 'วันเข้าพักของ {roomType} ต้องไม่ก่อนวันทำการปัจจุบัน', roomTypeStayRange: 'ช่วงพักของ {roomType} ต้องอยู่ระหว่าง 1 ถึง {max} วัน', roomTypeDuplicateStay: 'ไม่สามารถเพิ่มช่วงพักซ้ำสำหรับ {roomType}',
    selectAtLeastOneRoomType: 'เลือกประเภทห้องที่จองได้อย่างน้อยหนึ่งรายการ', selectMember: 'เลือกสมาชิก', missingProductOrPrice: 'ประเภทห้องที่เลือกไม่มีผลิตภัณฑ์หรือราคารายวัน', roomCountExceedsAvailability: 'จำนวนห้องที่จองเกินจำนวนที่ว่าง', walkInRequiresRoom: 'ลูกค้า Walk-in ต้องได้รับการจัดห้อง', guestRequiredPerRoom: 'กรอกผู้เข้าพักสำหรับทุกห้อง', completeGuestName: 'กรอกชื่อผู้เข้าพักให้ครบ', selectPaymentForDeposit: 'เลือกวิธีชำระเงินเมื่อรับเงินมัดจำ', selectMemberForStoredValue: 'เลือกสมาชิกสำหรับการชำระด้วยยอดคงเหลือ', insufficientMemberBalance: 'ยอดคงเหลือสมาชิก {balance} CNY โปรดเลือกวิธีอื่น', enterStoredValueCode: 'กรอกรหัสยืนยันสำหรับการชำระด้วยยอดคงเหลือ',
    bookingFailed: 'การจองไม่สำเร็จ โปรดแก้ไขแล้วลองใหม่', bookingSuccess: 'จองสำเร็จ', overOccupancyConfirmation: 'จำนวนผู้เข้าพักเกินจำนวนสูงสุดของห้อง ต้องการดำเนินการเช็กอินต่อหรือไม่?', overOccupancyPromptTitle: 'แจ้งเตือน', walkInMissingMasterRoom: 'เช็กอินสำเร็จ แต่ไม่ได้รับเลขบัญชีห้องหลัก', checkInSuccess: 'เช็กอินสำเร็จ', createdWithoutOrderNo: 'สร้างสำเร็จ แต่ไม่ได้รับเลขที่คำสั่งซื้อ โปรดบันทึกการรับเงินในหน้าการเงิน', walkInWithoutMasterRoomForPayment: 'เช็กอินสำเร็จ แต่ไม่ได้รับเลขบัญชีห้องหลัก โปรดบันทึกการรับเงินในหน้าการเงิน', onlinePaymentFailed: 'คำขอชำระเงินออนไลน์ล้มเหลว', paymentStatusFailed: 'ตรวจสอบสถานะการชำระเงินไม่สำเร็จ',
    sameStayExists: 'ประเภทห้องนี้มีช่วงเข้าพักเดียวกันแล้ว', departureAfterArrival: 'เวลาออกต้องช้ากว่าเวลาเข้าพัก', duplicateStayNotAllowed: 'ห้ามมีช่วงเข้าพักซ้ำในประเภทห้องเดียวกัน', selectUnaddedRoom: 'เลือกห้องที่ยังไม่ได้เพิ่ม', keepOneWalkInRoom: 'ลูกค้า Walk-in ต้องมีอย่างน้อยหนึ่งห้อง', ebkRoomCountMismatch: 'จำนวนห้องที่จองไม่ตรงกับคำสั่งซื้อจากช่องทาง ต้องการจองต่อหรือไม่?', continueBooking: 'จองต่อ', modify: 'แก้ไข',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: 'แหล่งที่มาของราคา', bookingHourOrderCountTitle: 'จำนวนคำสั่งจองรายชั่วโมง', bookingHourOrderCountNoData: 'ไม่มีข้อมูลคำสั่งจองรายชั่วโมง', bookingHourOrderCountDateRange: '7 วันที่ผ่านมา {start} ถึง {end} | วันนี้ {date}', bookingHourOrderCountDateOnly: 'วันนี้ {date}', bookingHourOrderCountSevenDay: 'คำสั่งจองสะสม 7 วัน', bookingHourOrderCountToday: 'คำสั่งจองวันนี้', bookingHourOrderUnit: 'รายการ', bookingHourOrderAxis: 'คำสั่งจอง', viewTodayReports: 'ดูรายงานวันนี้', backToTodayReports: 'กลับสู่รายงานวันนี้', backToLatestReport: 'กลับสู่รายงานล่าสุด', historyEmpty: 'ไม่มีรายงานการกำหนดราคาอัจฉริยะนี้', todayReportTitle: 'รายงานวันที่ {date}', pricingTime: 'เวลาตั้งราคา', reportTitle: 'ชื่อรายงาน', pricingChannel: 'ช่องทางการตั้งราคา', viewDetail: 'รายละเอียด', todayReportEmpty: 'ไม่มีรายงานการตั้งราคาประเภทห้องที่เสร็จสิ้นในวันนี้',
  },

  inventoryPhase1: {
    itemType: 'ประเภทสิ่งของ',
    itemSpec: 'ข้อมูลจำเพาะของสิ่งของ',
    itemTypeName: '物品类型名称',
    itemSpecName: '物品规格名称',
    itemName: 'ชื่อสิ่งของ',
    itemCode: 'รหัสสิ่งของ',
    enterItemName: 'กรอกชื่อสิ่งของ',
    itemUnit: 'หน่วย',
    itemSort: 'จัดลำดับสิ่งของ',
    enterItemTypeName: '输入物品类型名称',
    enterItemSpecName: '输入物品规格名称',
    newType: '新建类型',
    newSpec: '新建规格',
    newItem: 'เพิ่มสิ่งของ',
    modifyItem: 'แก้ไขสิ่งของ',
    warningQty: '预警数量',
    warningQtyLabel: 'จำนวนแจ้งเตือนสต็อก',
    salePoint: 'จุดขาย',
    scene: 'รูปแบบการใช้งาน',
    guestRoom: 'ห้องพัก',
    fnb: 'อาหารและเครื่องดื่ม',
    meeting: 'การประชุม',
    sceneSale: 'ขายได้',
    sceneClean: 'เพิ่มในการทำความสะอาดห้องได้',
    sceneBorrow: 'ให้ยืมได้',
    selectType: 'กรุณาเลือกประเภทสิ่งของ',
    selectSpec: 'กรุณาเลือกข้อมูลจำเพาะของสิ่งของ',
    fillItemName: 'กรุณากรอกชื่อสิ่งของ',
    selectSalePoint: 'กรุณาเลือกจุดขายอย่างน้อยหนึ่งแห่ง',
    warningCloseHint: 'ตั้งค่าเป็น 0 เพื่อปิดการแจ้งเตือน',
    inboundType: 'วิธีรับเข้าคลัง',
    outboundType: 'วิธีนำออกจากคลัง',
    manualInbound: 'รับเข้าคลังด้วยตนเอง',
    sale: 'การขายสินค้า',
    roomClean: 'สิ่งของสำหรับทำความสะอาดห้อง',
    roomBorrow: 'การยืมสิ่งของในห้องพัก',
    manualOutbound: 'นำออกจากคลังด้วยตนเอง',
    newOutbound: 'เพิ่มการออกสต็อก',
    selectOutboundType: 'เลือกวิธีออกสต็อก',
    createTime: '创建时间',
    catalogSource: '来源',
    groupCatalog: '集团底账',
    hotelCatalog: '本店',
    groupCatalogCannotEdit: '集团底账不能修改',
    groupCatalogCannotDelete: '集团底账不能删除',
    confirmDeleteType: '确认要删除该物品类型吗？',
    confirmDeleteSpec: '确认要删除该物品规格吗？',
    modifySuccess: '修改成功',
    createSuccess: '新建成功',
    filterSale: 'ขายได้',
    filterRoomClean: 'เพิ่มในการทำความสะอาดห้องได้',
    filterRoomBorrow: 'ให้ยืมได้',
    availableSalePoint: 'จุดขายที่ใช้ได้',
    borrowReturn: 'คืนสิ่งของที่ยืม',
    saleVoid: 'ยกเลิกรายการขาย',
    sortOrder: 'ลำดับ',
    fillWarningQty: 'กรุณากรอกจำนวนแจ้งเตือนสต็อก',
    warningQtyInvalid: 'จำนวนแจ้งเตือนสต็อกต้องเป็นจำนวนเต็มที่ไม่ติดลบ',
  },
  aiPmsCtripPeerSync: {
    ctrip: 'Ctrip',
    account: 'บัญชี',
    mobilePlaceholder: 'กรอกหมายเลขโทรศัพท์',
    code: 'รหัส SMS',
    codePlaceholder: 'กรอกรหัส SMS',
    login: 'เข้าสู่ระบบ',
    resend: 'ส่งอีกครั้ง',
    send: 'ส่งรหัส',
    collectFailed: 'รวบรวมราคาคู่แข่ง Ctrip ไม่สำเร็จ โปรดรีเฟรชภายหลัง',
    dataFailed: 'โหลดข้อมูลไม่สำเร็จ',
    relogin: 'เข้าสู่ระบบอีกครั้ง',
    unbind: 'ยกเลิกการผูกบัญชี',
    updatedAt: 'อัปเดต: {time}',
    hotelName: 'โรงแรม',
    price: 'ราคา',
    empty: 'ยังไม่มีราคาดึงดูดลูกค้าของคู่แข่งจาก {channel}',
    accountRequired: 'กรอกบัญชี Ctrip',
    codeRequired: 'กรอกรหัสยืนยัน SMS',
    loggingIn: 'กำลังเข้าสู่ระบบ จากนั้นจะรวบรวมราคาคู่แข่ง Ctrip',
    smsSent: 'ส่งรหัส SMS แล้ว โปรดกรอกรหัส',
    smsFailed: 'ส่งรหัส SMS ไม่สำเร็จ โปรดส่งอีกครั้ง',
    verifyFailed: 'ยืนยัน SMS ไม่สำเร็จ โปรดกรอกรหัสอีกครั้งเพื่อเข้าสู่ระบบ',
    loginFailed: 'เข้าสู่ระบบ Ctrip ไม่สำเร็จ โปรดส่งรหัสใหม่',
    deviceVerify: 'ทำการยืนยันอุปกรณ์ของบัญชี Ctrip แล้วส่งรหัสใหม่เพื่อเข้าสู่ระบบ',
    loginRequired: 'ส่งรหัส SMS เพื่อเข้าสู่ระบบ Ctrip อีกครั้ง',
    expired: 'บัญชี Ctrip หมดอายุ โปรดเข้าสู่ระบบ',
    sending: 'กำลังส่งรหัส SMS…',
    collecting: 'เข้าสู่ระบบแล้ว กำลังรวบรวมราคาคู่แข่ง Ctrip…',
    today: 'วันนี้ {time}',
    daysAgo: '{days} วันที่แล้ว',
    crawlSubmitted: 'ส่งงานรวบรวมโรงแรมโปรดใน Ctrip แล้ว',
    smsSubmitted: 'ส่งคำขอรหัส SMS แล้ว',
    unbindConfirm: 'ยกเลิกการผูกบัญชี Ctrip ปัจจุบันหรือไม่? ประวัติราคาจะยังคงอยู่',
    unbindTitle: 'ยกเลิกการผูกบัญชี Ctrip',
    unbound: 'ยกเลิกการผูกบัญชี Ctrip แล้ว',
  },
};
